import _get from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/get";
import _slicedToArray from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _assertThisInitialized from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/inherits";
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(getHosts);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import adapter from 'webrtc-adapter';
import EventEmitter from 'eventemitter3';
import remove from 'lodash.remove';
import Fingerprint2 from 'fingerprintjs2';
import localforage from 'localforage';
import pako from 'pako';
import md5 from 'blueimp-md5';
import groupBy from 'lodash.groupby';
import { detect } from 'detect-browser';
import * as semver from 'semver';
import MobileDetect from 'mobile-detect';
import uniqBy from 'lodash.uniqby';
import sdpTransform from 'sdp-transform';
var LogModel = /*#__PURE__*/function (_EventEmitter) {
  _inherits(LogModel, _EventEmitter);
  function LogModel(level) {
    var _this2;
    _classCallCheck(this, LogModel);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LogModel).call(this));
    _this2.level = level;
    return _this2;
  }
  _createClass(LogModel, [{
    key: "setLevel",
    value: function setLevel(level) {
      this.level = level;
    }
  }, {
    key: "log",
    value: function log() {
      var _console;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (this.savedLevel === "log") {
        this.emit("log", "log", args);
      }
      if (this.level !== "log") {
        return;
      }
      var pretitle = "".concat(getLogTimeString(), " %cLOG-QNRTC");
      var style = "color: #66ccff; font-weight: bold;";
      (_console = console).info.apply(_console, [pretitle, style].concat(args));
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (this.savedLevel === "log" || this.savedLevel === "debug") {
        this.emit("log", "debug", args);
      }
      if (this.level !== "log" && this.level !== "debug") {
        return;
      }
      var pretitle = "".concat(getLogTimeString(), " %cDEBUG-QNRTC");
      var style = "color: #A28148; font-weight: bold;";
      (_console2 = console).info.apply(_console2, [pretitle, style].concat(args));
    }
  }, {
    key: "warning",
    value: function warning() {
      var _console3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (this.savedLevel && this.savedLevel !== "disable") {
        this.emit("log", "warn", args);
      }
      if (this.level === "disable") {
        return;
      }
      var pretitle = "".concat(getLogTimeString(), " %cWARNING-QNRTC");
      var style = "color: #E44F44; font-weight: bold;";
      (_console3 = console).warn.apply(_console3, [pretitle, style].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      var _console4;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      if (this.savedLevel && this.savedLevel !== "disable") {
        this.emit("log", "error", args);
      }
      if (this.level === "disable") {
        return;
      }
      var pretitle = "".concat(getLogTimeString(), " %cERROR-QNRTC");
      var style = "color: #E44F44; font-weight: bold;";
      (_console4 = console).error.apply(_console4, [pretitle, style].concat(args));
    } /** 设置本地保存的日志登记 */
  }, {
    key: "setSavedLevel",
    value: function setSavedLevel(level) {
      this.savedLevel = level;
    }
  }]);
  return LogModel;
}(EventEmitter);
function getLogTimeString() {
  var date = new Date();
  function padingStart(num) {
    var str = num.toString();
    if (str.length < 2) {
      return "0" + str;
    }
    return str;
  }
  var hours = padingStart(date.getHours());
  var mins = padingStart(date.getMinutes());
  var secs = padingStart(date.getSeconds());
  var msecs = date.getMilliseconds();
  return "[".concat(hours, ":").concat(mins, ":").concat(secs, ".").concat(msecs, "]");
}
var log = new LogModel("log");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var REC_AUDIO_ENABLE = function REC_AUDIO_ENABLE(config) {
  return !!config && !!config.audio && config.audio.enabled;
};
var REC_VIDEO_ENABLE = function REC_VIDEO_ENABLE(config) {
  return !!config && !!config.video && config.video.enabled;
};
var REC_SCREEN_ENABLE = function REC_SCREEN_ENABLE(config) {
  return !!config && !!config.screen && config.screen.enabled;
};
/**
 * Note that "display-capture"(code value is 2) is the name for screen display permission,
 * but it is not supported now
 */
var PermissionNameCode;
(function (PermissionNameCode) {
  PermissionNameCode[PermissionNameCode["camera"] = 0] = "camera";
  PermissionNameCode[PermissionNameCode["microphone"] = 1] = "microphone";
})(PermissionNameCode || (PermissionNameCode = {}));
var PermissionStateCode;
(function (PermissionStateCode) {
  PermissionStateCode[PermissionStateCode["prompt"] = 1] = "prompt";
  PermissionStateCode[PermissionStateCode["denied"] = 2] = "denied";
  PermissionStateCode[PermissionStateCode["granted"] = 3] = "granted";
})(PermissionStateCode || (PermissionStateCode = {}));
function isDefined(argument) {
  return argument !== undefined;
}
/**
 * 网络质量等级枚举
 */
var NetworkGrade;
(function (NetworkGrade) {
  /**
   * 网络等级还未获取
   */
  NetworkGrade[NetworkGrade["INVALID"] = -1] = "INVALID";
  /**
   * 网络优
   */
  NetworkGrade[NetworkGrade["EXCELLENT"] = 1] = "EXCELLENT";
  /**
   * 网络良
   */
  NetworkGrade[NetworkGrade["GOOD"] = 2] = "GOOD";
  /**
   * 网络一般
   */
  NetworkGrade[NetworkGrade["FAIR"] = 3] = "FAIR";
  /**
   * 网络较差
   */
  NetworkGrade[NetworkGrade["POOR"] = 4] = "POOR";
})(NetworkGrade || (NetworkGrade = {}));
var TrackConnectStatus;
(function (TrackConnectStatus) {
  TrackConnectStatus[TrackConnectStatus["Idle"] = 0] = "Idle";
  TrackConnectStatus[TrackConnectStatus["Connecting"] = 1] = "Connecting";
  TrackConnectStatus[TrackConnectStatus["Connect"] = 2] = "Connect";
})(TrackConnectStatus || (TrackConnectStatus = {}));
var TrackSourceType;
(function (TrackSourceType) {
  TrackSourceType[TrackSourceType["NORMAL"] = 0] = "NORMAL";
  TrackSourceType[TrackSourceType["EXTERNAL"] = 1] = "EXTERNAL";
  TrackSourceType[TrackSourceType["MIXING"] = 2] = "MIXING";
})(TrackSourceType || (TrackSourceType = {}));
var defaultMergeJob = {
  publishUrl: "",
  height: 720,
  width: 1080,
  fps: 25,
  kbps: 1000,
  audioOnly: false,
  stretchMode: "aspectFill"
};
var AudioSourceState;
(function (AudioSourceState) {
  AudioSourceState["IDLE"] = "idle";
  AudioSourceState["LOADING"] = "loading";
  AudioSourceState["PLAY"] = "play";
  AudioSourceState["PAUSE"] = "pause";
  AudioSourceState["STOP"] = "stop";
  AudioSourceState["END"] = "end";
})(AudioSourceState || (AudioSourceState = {}));

// 类型根据这个页面来定：https://cf.qiniu.io/pages/viewpage.action?pageId=21006743
var QosEventType = {
  Init: 1,
  UnInit: 2,
  JoinRoom: 3,
  MCSAuth: 4,
  SignalAuth: 5,
  LeaveRoom: 6,
  PublisherPC: 7,
  PublishTracks: 8,
  UnPublishTracks: 9,
  SubscriberPC: 10,
  SubscribeTracks: 11,
  UnSubscribeTracks: 13,
  MuteTracks: 14,
  ICEConnectionState: 15,
  CallbackStatistics: 16,
  KickoutUser: 17,
  RoomStateChanged: 18,
  AudioDeviceInOut: 19,
  VideoDeviceInOut: 20,
  SDKError: 21,
  ApplicationState: 22,
  CreateMergeJob: 24,
  UpdateMergeTracks: 25,
  StopMerge: 26,
  AuthorizationStatus: 27,
  DeviceChanged: 28,
  DefaultSetting: 29,
  MediaStatistics: 30,
  AbnormalDisconnect: 31,
  CreateForwardJob: 36,
  StopForwardJob: 37,
  WebsocketConnect: 40,
  NetworkChange: 46,
  SystemRequirementsTest: 47,
  AutoplayFail: 49,
  TrackEnded: 50,
  WebSDKException: 51,
  VideoPlayQuality: 53,
  AudioPlayQuality: 54,
  JoinRoomResult: 55,
  SetClientRole: 56,
  StartMediaRelay: 57,
  UpdateMediaRelay: 58,
  StopMediaRelay: 59,
  MCURelayAuth: 60,
  SignalFired: 66
};
var name = "qnweb-rtc";
var type = "module";
var version$1 = "4.3.2";
var description = "七牛实时音视频 Web SDK";
var main = "build/index.js";
var types = "build/qnweb-rtc.d.ts";
var files = ["build/*.js", "build/qnweb-rtc.d.ts"];
var engines = {
  node: ">=18"
};
var scripts = {
  build: "rimraf build && rimraf lib && rollup -c --bundleConfigAsCjs --build-all && npm run build-type",
  "build-lib": "rimraf lib && rollup -c --build-lib",
  "build-module": "rimraf build && rollup -c --build-module && npm run build-type",
  watch: "rimraf build && npm run build-type && rollup -c -w --build-module",
  "build-type": "tsc --emitDeclarationOnly -d && api-extractor run --local && rimraf ./build/tempTypes",
  lint: "tslint src/**/*.ts -t verbose",
  prepublish: "rimraf build && NODE_ENV=production npm run build-module",
  pack: "NODE_ENV=production npm run build"
};
var repository = {
  type: "git",
  url: "https://github.com/pili-engineering/QNRTC-Web.git"
};
var homepage = "https://github.com/pili-engineering/QNRTC-Web#readme";
var author = "yaox023 <yaoyaox023@gmail.com>";
var license = "MIT";
var dependencies = {
  "blueimp-md5": "^2.10.0",
  "detect-browser": "^3.0.1",
  eventemitter3: "^5.0.0",
  fingerprintjs2: "^2.0.6",
  localforage: "^1.7.2",
  "lodash.groupby": "^4.6.0",
  "lodash.remove": "^4.7.0",
  "lodash.uniqby": "^4.7.0",
  "mobile-detect": "^1.4.5",
  pako: "^2.0.4",
  "sdp-transform": "^2.4.1",
  semver: "^5.6.0",
  "webrtc-adapter": "^8.0.0"
};
var devDependencies = {
  "@babel/core": "^7.3.3",
  "@babel/plugin-proposal-class-properties": "^7.18.6",
  "@babel/plugin-proposal-nullish-coalescing-operator": "^7.18.6",
  "@babel/plugin-transform-runtime": "^7.23.2",
  "@babel/preset-env": "^7.3.1",
  "@babel/preset-typescript": "^7.22.5",
  "@babel/runtime": "^7.3.1",
  "@microsoft/api-extractor": "^7.38.0",
  "@rollup/plugin-babel": "^6.0.3",
  "@rollup/plugin-commonjs": "^24.1.0",
  "@rollup/plugin-json": "^6.0.0",
  "@rollup/plugin-node-resolve": "^15.0.2",
  "@rollup/plugin-replace": "^5.0.2",
  "@rollup/plugin-terser": "^0.4.1",
  "@rollup/plugin-typescript": "^11.1.0",
  "@types/blueimp-md5": "^2.7.0",
  "@types/detect-browser": "^2.0.1",
  "@types/fingerprintjs2": "^1.5.2",
  "@types/lodash.groupby": "^4.6.6",
  "@types/lodash.remove": "^4.7.4",
  "@types/lodash.uniqby": "^4.7.4",
  "@types/node": "^18.15.13",
  "@types/pako": "^1.0.3",
  "@types/sdp-transform": "^2.4.6",
  "@types/semver": "^5.5.0",
  "fs-walk": "^0.0.2",
  prettier: "^2.8.7",
  rimraf: "^3.0.2",
  rollup: "^3.20.7",
  tslib: "^2.6.2",
  tslint: "^5.11.0",
  "tslint-config-prettier": "^1.18.0",
  typescript: "^5.0.4"
};
var eslintConfig = {
  env: {
    browser: true,
    es2021: true
  },
  "extends": ["eslint:recommended", "plugin:@typescript-eslint/recommended"],
  ignorePatterns: ["src/"],
  overrides: [{
    env: {
      node: true
    },
    files: [".eslintrc.{js,cjs}"],
    parserOptions: {
      sourceType: "script"
    }
  }],
  parser: "@typescript-eslint/parser",
  parserOptions: {
    ecmaVersion: "latest",
    sourceType: "module"
  },
  plugins: ["@typescript-eslint"],
  rules: {}
};
var pkg = {
  name: name,
  type: type,
  version: version$1,
  description: description,
  main: main,
  types: types,
  files: files,
  engines: engines,
  scripts: scripts,
  repository: repository,
  homepage: homepage,
  author: author,
  license: license,
  dependencies: dependencies,
  devDependencies: devDependencies,
  eslintConfig: eslintConfig
};

/**
 * SDK版本号
 */
var version = pkg.version;
function detectBrowser() {
  var originBrowser = detect();
  if (!navigator || !navigator.appVersion || !originBrowser) {
    return originBrowser;
  }
  var IChrome = /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/;
  var chromeInfo = IChrome.exec(window.navigator.appVersion);
  if (!chromeInfo || !chromeInfo[1]) {
    return originBrowser;
  }
  return Object.assign(Object.assign({}, originBrowser), {
    chromeVersion: chromeInfo[1]
  });
}
var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
var isChrome = !!window.chrome;
var isIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
var browser = detectBrowser() || {};
var isMobile = !!new MobileDetect(navigator.userAgent).mobile();
var isElectron = navigator.userAgent.toLowerCase().indexOf("electron") > -1;
function baseSupportCheck() {
  try {
    if (!window) {
      return false;
    }
    if (!("RTCPeerConnection" in window)) {
      return false;
    }
    if (!("WebSocket" in window)) {
      return false;
    }
    if (!navigator) {
      return false;
    }
    if (!navigator.mediaDevices) {
      return false;
    }
    if (!navigator.mediaDevices.getUserMedia) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}
function supportGetSettings() {
  return "getSettings" in MediaStreamTrack.prototype;
}
function supportGetDisplayMedia() {
  var hasGetDisplayMediaAPI = navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;
  var supportDisplaysurface = navigator && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().displaySurface;
  // 在 Firefox 支持标准的选择采集源之前，继续使用老的 API，因为反正都不需要插件
  if (isFirefox) {
    return !!hasGetDisplayMediaAPI && !!supportDisplaysurface;
  }
  return !!hasGetDisplayMediaAPI;
}
function supportMediaStreamDest() {
  // unsupport fallback
  var _AudioContext = window.AudioContext || window.webkitAudioContext || window.Object;
  return "createMediaStreamDestination" in _AudioContext.prototype;
}
function browserCheck() {
  if (!browser) {
    return {
      support: baseSupportCheck(),
      supportRestartICE: true,
      getDisplayMedia: supportGetDisplayMedia(),
      disconnectAudioNode: true
    };
  }
  switch (browser.name) {
    case "chrome":
      return {
        support: baseSupportCheck(),
        mediaStreamDest: semver.gte(browser.version, "55.0.0"),
        replaceTrack: semver.gte(browser.version, "65.0.0"),
        screenSharing: semver.gte(browser.version, "55.0.0"),
        connectionState: semver.gte(browser.version, "72.0.0"),
        stats: semver.gte(browser.version, "67.0.0"),
        ondevicechange: semver.gte(browser.version, "57.0.0"),
        minMaxWithIdeal: semver.gte(browser.version, "56.0.0"),
        supportTransceivers: semver.gte(browser.version, "69.0.0"),
        // https://www.chromestatus.com/feature/5723303167655936
        unifiedPlan: semver.gte(browser.version, "72.0.0"),
        supportRestartICE: true,
        getReceivers: semver.gte(browser.version, "59.0.0"),
        needH264FmtpLine: semver.lte(browser.version, "51.0.0"),
        audioContextOptions: true,
        getDisplayMedia: supportGetDisplayMedia(),
        disconnectAudioNode: true,
        setPlaybackDevice: true
      };
    case "ios":
    case "safari":
      return {
        support: baseSupportCheck(),
        replaceTrack: semver.gte(browser.version, "11.0.0"),
        stats: semver.gte(browser.version, "11.0.0"),
        ondevicechange: false,
        connectionState: true,
        mediaStreamDest: semver.gte(browser.version, "12.0.0"),
        // https://developer.mozilla.org/en-US/docs/Web/API/Screen_Capture_API
        screenSharing: semver.gte(browser.version, "13.0.0"),
        unifiedPlan: semver.gte(browser.version, "12.1.0"),
        supportTransceivers: true,
        minMaxWithIdeal: false,
        supportRestartICE: true,
        getReceivers: true,
        audioContextOptions: true,
        getDisplayMedia: supportGetDisplayMedia(),
        disconnectAudioNode: false
      };
    case "firefox":
      return {
        support: baseSupportCheck(),
        replaceTrack: true,
        stats: semver.gte(browser.version, "66.0.0"),
        ondevicechange: semver.gte(browser.version, "52.0.0"),
        connectionState: true,
        mediaStreamDest: true,
        screenSharing: true,
        minMaxWithIdeal: true,
        unifiedPlan: true,
        // https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/59
        supportTransceivers: semver.gte(browser.version, "59.0.0"),
        supportRestartICE: false,
        getReceivers: true,
        // Firefox 55 以后不会抛出 audioContext 构造函数错误，但是依旧还是 ignore
        audioContextOptions: semver.gte(browser.version, "55.0.0"),
        getDisplayMedia: supportGetDisplayMedia(),
        disconnectAudioNode: true
      };
    case "crios":
    case "ios-webview":
      return {
        support: baseSupportCheck(),
        getDisplayMedia: supportGetDisplayMedia(),
        mediaStreamDest: supportMediaStreamDest(),
        unifiedPlan: true,
        supportTransceivers: true,
        supportRestartICE: true,
        disconnectAudioNode: true
      };
    default:
      return {
        support: baseSupportCheck(),
        mediaStreamDest: supportMediaStreamDest(),
        supportRestartICE: true,
        getDisplayMedia: supportGetDisplayMedia(),
        disconnectAudioNode: true
      };
  }
}
var browserReport = browserCheck();
var TaskQueue = /*#__PURE__*/function (_EventEmitter2) {
  _inherits(TaskQueue, _EventEmitter2);
  function TaskQueue(name) {
    var _this3;
    _classCallCheck(this, TaskQueue);
    var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(TaskQueue).call(this));
    // Closed flag.
    _this3._closed = false;
    // Busy running a command.
    _this3._busy = false;
    // Queue for pending commands. Each command is an Object with method,
    // resolve, reject, and other members (depending the case).
    _this3._queue = [];
    _this3.name = name || "TaskQueue";
    _this3.isDebug = debug;
    return _this3;
  }
  _createClass(TaskQueue, [{
    key: "close",
    value: function close() {
      this._closed = true;
    }
  }, {
    key: "push",
    value: function push(method, data) {
      var _this4 = this;
      if (this.isDebug) {
        log.debug("".concat(this.name, " push()"), method, data);
      }
      return new Promise(function (resolve, reject) {
        var queue = _this4._queue;
        // Append command to the queue.
        queue.push({
          method: method,
          data: data,
          resolve: resolve,
          reject: reject
        });
        _this4._handlePendingCommands();
      });
    }
  }, {
    key: "_handlePendingCommands",
    value: function _handlePendingCommands() {
      var _this5 = this;
      if (this._busy) {
        return;
      }
      var queue = this._queue;
      // Take the first command.
      var command = queue[0];
      if (!command) {
        return;
      }
      this._busy = true;
      // Execute it.
      this._handleCommand(command).then(function () {
        _this5._busy = false;
        // Remove the first command (the completed one) from the queue.
        queue.shift();
        // And continue.
        _this5._handlePendingCommands();
      });
    }
  }, {
    key: "_handleCommand",
    value: function _handleCommand(command) {
      var _this6 = this;
      if (this.isDebug) {
        log.debug("".concat(this.name, " _handleCommand() "), command.method, command.data);
      }
      if (this._closed) {
        command.reject(new InvalidStateError("closed"));
        return Promise.resolve();
      }
      var promiseHolder = {
        promise: null
      };
      this.emit("exec", command, promiseHolder);
      return Promise.resolve().then(function () {
        return promiseHolder.promise;
      }).then(function (result) {
        if (_this6.isDebug) {
          log.debug("".concat(_this6.name, " _handleCommand() | command succeeded"), command.method);
        }
        if (_this6._closed) {
          command.reject(new InvalidStateError("closed"));
          return;
        }
        // Resolve the command with the given result (if any).
        command.resolve(result);
      }).catch(function (error) {
        if (_this6.isDebug) {
          log.warning("".concat(_this6.name, " _handleCommand() | command failed [method:%s]: %o"), command.method, error);
        }
        // Reject the command with the error.
        command.reject(error);
      });
    }
  }]);
  return TaskQueue;
}(EventEmitter);
/**
 * @public
 * 房间连接状态
 */
var QNConnectionState;
(function (QNConnectionState) {
  /**
   * 初始状态
   */
  QNConnectionState["DISCONNECTED"] = "DISCONNECTED";
  /**
   * 正在连接
   */
  QNConnectionState["CONNECTING"] = "CONNECTING";
  /**
   * 连接成功
   */
  QNConnectionState["CONNECTED"] = "CONNECTED";
  /**
   * 正在重连
   */
  QNConnectionState["RECONNECTING"] = "RECONNECTING";
  /**
   * 重连成功
   */
  QNConnectionState["RECONNECTED"] = "RECONNECTED";
})(QNConnectionState || (QNConnectionState = {}));
/**
 * @public
 * 设备状态信息
 */
var QNDeviceState;
(function (QNDeviceState) {
  /**
   * 设备插入
   */
  QNDeviceState["ACTIVE"] = "ACTIVE";
  /**
   * 设备拔出
   */
  QNDeviceState["INACTIVE"] = "INACTIVE";
})(QNDeviceState || (QNDeviceState = {}));
/**
 * @public
 * 视频采集编码预设值数组
 */
var SUPPORT_VIDEO_ENCODER_CONFIG_LIST = {
  "360p": {
    width: 640,
    height: 360,
    frameRate: 15,
    bitrate: 400
  },
  "640x360_15": {
    width: 640,
    height: 360,
    frameRate: 15,
    bitrate: 400
  },
  "640x360_30": {
    width: 640,
    height: 360,
    frameRate: 30,
    bitrate: 600
  },
  "480p": {
    width: 640,
    height: 480,
    frameRate: 15,
    bitrate: 500
  },
  "640x480_15": {
    width: 640,
    height: 480,
    frameRate: 15,
    bitrate: 500
  },
  "640x480_30": {
    width: 640,
    height: 480,
    frameRate: 30,
    bitrate: 1000
  },
  "720p": {
    width: 1280,
    height: 720,
    frameRate: 15,
    bitrate: 1130
  },
  "1280x720_15": {
    width: 1280,
    height: 720,
    frameRate: 15,
    bitrate: 1130
  },
  "1280x720_30": {
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrate: 2000
  },
  "1080p": {
    width: 1920,
    height: 1080,
    frameRate: 15,
    bitrate: 2080
  },
  "1920x1080_15": {
    width: 1920,
    height: 1080,
    frameRate: 15,
    bitrate: 2080
  },
  "1920x1080_30": {
    width: 1920,
    height: 1080,
    frameRate: 30,
    bitrate: 4000
  },
  "1440p": {
    width: 2560,
    height: 1440,
    frameRate: 30,
    bitrate: 4850
  },
  "2560x1440_30": {
    width: 2560,
    height: 1440,
    frameRate: 30,
    bitrate: 4850
  },
  "4k": {
    width: 3840,
    height: 2160,
    frameRate: 30,
    bitrate: 8910
  },
  "3840x2160_30": {
    width: 3840,
    height: 2160,
    frameRate: 30,
    bitrate: 8910
  }
};
/**
 * @internal
 */
var defaultVideoEncoderConfiguration = SUPPORT_VIDEO_ENCODER_CONFIG_LIST["480p"];
/**
 * @public
 * 音频采集编码预设值数组
 */
var AUDIO_ENCODER_CONFIG_SETTINGS = {
  LOW: {
    sampleRate: 16000,
    stereo: false,
    bitrate: 24,
    sampleSize: 16
  },
  STANDARD: {
    sampleRate: 48000,
    stereo: false,
    bitrate: 64,
    sampleSize: 16
  },
  STANDARD_STEREO: {
    sampleRate: 48000,
    stereo: true,
    bitrate: 80,
    sampleSize: 16
  },
  HIGH: {
    sampleRate: 48000,
    stereo: false,
    bitrate: 96,
    sampleSize: 16
  },
  HIGH_STEREO: {
    sampleRate: 48000,
    stereo: true,
    bitrate: 128,
    sampleSize: 16
  }
};
/**
 * @internal
 */
var defaultAudioEncoderConfiguration = AUDIO_ENCODER_CONFIG_SETTINGS["STANDARD"];
/**
 * @public
 * 屏幕分享采集编码预设值数组
 */
var SUPPORT_SCREEN_ENCODER_CONFIG_LIST = {
  "480p": {
    width: 640,
    height: 480,
    frameRate: 15,
    bitrate: 500
  },
  "640x480_5": {
    width: 640,
    height: 480,
    frameRate: 5,
    bitrate: 200
  },
  "640x480_15": {
    width: 640,
    height: 480,
    frameRate: 15,
    bitrate: 500
  },
  "640x480_30": {
    width: 640,
    height: 480,
    frameRate: 30,
    bitrate: 1000
  },
  "720p": {
    width: 1280,
    height: 720,
    frameRate: 15,
    bitrate: 1130
  },
  "1280x720_5": {
    width: 1280,
    height: 720,
    frameRate: 5,
    bitrate: 400
  },
  "1280x720_15": {
    width: 1280,
    height: 720,
    frameRate: 15,
    bitrate: 1130
  },
  "1280x720_30": {
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrate: 2000
  },
  "1080p": {
    width: 1920,
    height: 1080,
    frameRate: 15,
    bitrate: 2080
  },
  "1920x1080_5": {
    width: 1920,
    height: 1080,
    frameRate: 5,
    bitrate: 700
  },
  "1920x1080_15": {
    width: 1920,
    height: 1080,
    frameRate: 15,
    bitrate: 2080
  },
  "1920x1080_30": {
    width: 1920,
    height: 1080,
    frameRate: 30,
    bitrate: 4000
  }
};
/**
 * @internal
 */
var defaultScreenEncoderConfiguration = SUPPORT_SCREEN_ENCODER_CONFIG_LIST["720p"];
/**
 * @public
 * Chrome 插件采集源
 */
var QNChromeExtensionSourceType;
(function (QNChromeExtensionSourceType) {
  /**
   * 窗口采集
   */
  QNChromeExtensionSourceType["WINDOW"] = "window";
  /**
   * 屏幕采集
   */
  QNChromeExtensionSourceType["SCREEN"] = "screen";
  /**
   * 全部数据源
   */
  QNChromeExtensionSourceType["ALL"] = "all";
})(QNChromeExtensionSourceType || (QNChromeExtensionSourceType = {}));
/**
 * @public
 * 音频数据处理状态
 */
var QNAudioSourceState;
(function (QNAudioSourceState) {
  /**
   * 初始化
   */
  QNAudioSourceState["IDLE"] = "IDLE";
  /**
   * 播放中
   */
  QNAudioSourceState["PlAYING"] = "PlAYING";
  /**
   * 播放中（新版）
   */
  QNAudioSourceState["MIXING"] = "MIXING";
  /**
   * 暂停
   */
  QNAudioSourceState["PAUSED"] = "PAUSED";
  /**
   * 停止
   */
  QNAudioSourceState["STOPPED"] = "STOPPED";
  /**
   * 结束
   */
  QNAudioSourceState["COMPLETED"] = "COMPLETED";
})(QNAudioSourceState || (QNAudioSourceState = {}));
/**
 * @public
 * 拉伸模式
 */
var QNRenderMode;
(function (QNRenderMode) {
  /**
   * 视频被拉伸以填充视图的大小，而不需要保持长宽比
   */
  QNRenderMode["FILL"] = "scaleToFit";
  /**
   * 默认值, 视频通过保持长宽比来填充视图的大小。视频的某些部分可能被剪切
   */
  QNRenderMode["ASPECT_FILL"] = "aspectFill";
  /**
   * 通过保持宽高比(可能显示黑色边框)，视频被缩放以适应视图的大小
   */
  QNRenderMode["ASPECT_FIT"] = "aspectFit";
})(QNRenderMode || (QNRenderMode = {}));
/**
 * @public
 * CDN 转推状态
 */
var QNLiveStreamingState;
(function (QNLiveStreamingState) {
  /**
   * 已开始
   */
  QNLiveStreamingState["STARTED"] = "STARTED";
  /**
   * 已停止
   */
  QNLiveStreamingState["STOPPED"] = "STOPPED";
})(QNLiveStreamingState || (QNLiveStreamingState = {}));
/**
 * @public
 * 网络状态
 */
var QNNetworkQuality;
(function (QNNetworkQuality) {
  /**
   * 网络质量未知
   */
  QNNetworkQuality["UNKNOWN"] = "UNKNOWN";
  /**
   * 质量极好
   */
  QNNetworkQuality["EXCELLENT"] = "EXCELLENT";
  /**
   * 用户主观感觉和极好差不多，但码率可能略低于极好
   */
  QNNetworkQuality["GOOD"] = "GOOD";
  /**
   * 网络一般
   */
  QNNetworkQuality["FAIR"] = "FAIR";
  /**
   * 网络质量差，影响正常通信
   */
  QNNetworkQuality["POOR"] = "POOR";
})(QNNetworkQuality || (QNNetworkQuality = {}));
/**
 * @public
 * 大小流类型
 */
var QNTrackProfile;
(function (QNTrackProfile) {
  /**
   * 低分辨率
   */
  QNTrackProfile["LOW"] = "LOW";
  /**
   * 中分辨率
   */
  QNTrackProfile["MEDIUM"] = "MEDIUM";
  /**
   * 高分辨率
   */
  QNTrackProfile["HIGH"] = "HIGH";
})(QNTrackProfile || (QNTrackProfile = {}));
/**
 * @public
 * 连接断开原因
 */
var QNConnectionDisconnectedReason;
(function (QNConnectionDisconnectedReason) {
  /**
   * 主动退出
   */
  QNConnectionDisconnectedReason["LEAVE"] = "LEAVE";
  /**
   * 被踢出房间
   */
  QNConnectionDisconnectedReason["KICKED_OUT"] = "KICKED_OUT";
  /**
   * 发生错误，异常断开
   */
  QNConnectionDisconnectedReason["ERROR"] = "ERROR";
})(QNConnectionDisconnectedReason || (QNConnectionDisconnectedReason = {}));
/**
 * @public
 * 日志等级
 */
var QNLogLevel;
(function (QNLogLevel) {
  /**
   * VERBOSE 级别日志打印
   */
  QNLogLevel["VERBOSE"] = "VERBOSE";
  /**
   * INFO 级别日志打印
   */
  QNLogLevel["INFO"] = "INFO";
  /**
   * WARNING 级别日志打印
   */
  QNLogLevel["WARNING"] = "WARNING";
  /**
   * ERROR 级别日志打印
   */
  QNLogLevel["ERROR"] = "ERROR";
  /**
   * 关闭日志打印
   */
  QNLogLevel["NONE"] = "NONE";
})(QNLogLevel || (QNLogLevel = {}));
/**
 * @public
 * 传输策略
 */
var QNTransportPolicy;
(function (QNTransportPolicy) {
  /**
   * 强制使用 UDP
   */
  QNTransportPolicy["FORCE_UDP"] = "FORCE_UDP";
  /**
   * 强制使用 TCP
   */
  QNTransportPolicy["FORCE_TCP"] = "FORCE_TCP";
  /**
   * 优先使用 UDP
   */
  QNTransportPolicy["PREFER_UDP"] = "PREFER_UDP";
})(QNTransportPolicy || (QNTransportPolicy = {}));
/**
 * @public
 * 视频优化模式
 */
var QNVideoOptimizationMode;
(function (QNVideoOptimizationMode) {
  /**
   * 流畅优先
   */
  QNVideoOptimizationMode["MOTION"] = "motion";
  /**
   * 清晰度优先
   */
  QNVideoOptimizationMode["DETAIL"] = "detail";
  /**
   * 由 SDK 自动判断
   */
  QNVideoOptimizationMode["DEFAULT"] = "";
})(QNVideoOptimizationMode || (QNVideoOptimizationMode = {}));
/**
 * The type of the source for screen sharing.
 * @public
 */
var QNElectronScreenSourceType;
(function (QNElectronScreenSourceType) {
  /**
   * 分享整个屏幕
   */
  QNElectronScreenSourceType["SCREEN"] = "screen";
  /**
   * 分享应用窗口
   */
  QNElectronScreenSourceType["WINDOW"] = "window";
  /**
   * 所有数据源
   */
  QNElectronScreenSourceType["ALL"] = "all";
})(QNElectronScreenSourceType || (QNElectronScreenSourceType = {}));
/**
 * 场景
 * @public
 */
var QNClientMode;
(function (QNClientMode) {
  /**
   * 通信场景
   */
  QNClientMode["RTC"] = "RTC";
  /**
   * 互动直播场景
   */
  QNClientMode["LIVE"] = "LIVE";
})(QNClientMode || (QNClientMode = {}));
/**
 * 角色
 * @public
 */
var QNClientRole;
(function (QNClientRole) {
  /**
   * 主播
   */
  QNClientRole["BROADCASTER"] = "BROADCASTER";
  /**
   * 观众
   */
  QNClientRole["AUDIENCE"] = "AUDIENCE";
})(QNClientRole || (QNClientRole = {}));
/**
 * 跨房媒体转发状态
 * @public
 */
var QNMediaRelayState;
(function (QNMediaRelayState) {
  /**
   * 成功
   */
  QNMediaRelayState[QNMediaRelayState["SUCCESS"] = 0] = "SUCCESS";
  /**
   * 主动退出
   */
  QNMediaRelayState[QNMediaRelayState["STOPPED"] = 1] = "STOPPED";
  /**
   * 无效 token
   */
  QNMediaRelayState[QNMediaRelayState["INVALID_TOKEN"] = 2] = "INVALID_TOKEN";
  /**
   * 目标房间不存在
   */
  QNMediaRelayState[QNMediaRelayState["NO_ROOM"] = 3] = "NO_ROOM";
  /**
   * 目标房间已关闭
   */
  QNMediaRelayState[QNMediaRelayState["ROOM_CLOSED"] = 4] = "ROOM_CLOSED";
  /**
   * 目标房间存在相同用户名的用户
   */
  QNMediaRelayState[QNMediaRelayState["PLAYER_EXISTED"] = 5] = "PLAYER_EXISTED";
})(QNMediaRelayState || (QNMediaRelayState = {}));
/**
 * Qos打点事件等级
 * @public
 */
var QNEventGrade;
(function (QNEventGrade) {
  /**
   * NORMAL 事件不会影响通话体验，如成功加入频道等。
   */
  QNEventGrade["NORMAL"] = "NORMAL";
  /**
   * GENERAL 事件对通话体验可能造成一定影响。如用户网络状态未知、用户停止发布/订阅音视频流等；
   */
  QNEventGrade["GENERAL"] = "GENERAL";
  /**
   *  SERVERE 事件会直接影响通话体验，如用户加入频道失败、网络连接失败、停止摄像头采集等；
   */
  QNEventGrade["SERVERE"] = "SERVERE";
})(QNEventGrade || (QNEventGrade = {}));
/**
 * Qos打点事件类型
 * @public
 */
var QNEventCategory;
(function (QNEventCategory) {
  QNEventCategory["CORE"] = "Core";
  QNEventCategory["API"] = "API";
  QNEventCategory["AUDIO"] = "Audio";
  QNEventCategory["VIDEO"] = "Video";
  QNEventCategory["SIGNAL"] = "Signal";
})(QNEventCategory || (QNEventCategory = {}));
var QNRTC_EVENTS_STORATE_KEY = "qnrtcqosevents";
var QosModel = /*#__PURE__*/function () {
  function QosModel() {
    var _this7 = this;
    _classCallCheck(this, QosModel);
    this.events = [];
    this.lastSubmitTime = Date.now();
    this.submitQueue = new TaskQueue("qossubmit", false);
    getDeviceId().then(function (deviceId) {
      _this7.deviceId = deviceId;
      _this7.base.device_id = _this7.deviceId;
    }).catch(function () {
      _this7.deviceId = "unknow";
      _this7.base.device_id = _this7.deviceId;
    });
    this.base = {
      qos_version: "2.0",
      device_id: "",
      bundle_id: "",
      url: window.location.href,
      app_version: "",
      sdk_version: version,
      device_model: "".concat(browser.name).concat(browser.version),
      os_platform: "Web",
      os_version: "",
      host_environment: browser.os
    };
    this.initSubmitQueue();
    this.submitQueue.push("resume").catch(noop);
  }
  _createClass(QosModel, [{
    key: "setSessionId",
    value: function setSessionId(sessionId) {
      for (var i = this.events.length - 1; i >= 0; i -= 1) {
        var event = this.events[i];
        if (event.session_id) break;
        event.session_id = sessionId;
      }
      this.sessionId = sessionId;
    }
  }, {
    key: "setUserBase",
    value: function setUserBase(userName, roomName, appId) {
      this.userBase = {
        user_id: userName,
        room_name: roomName,
        app_id: appId
      };
      for (var i = this.events.length - 1; i >= 0; i -= 1) {
        var event = this.events[i];
        if (event.user_base) break;
        event.user_base = this.userBase;
      }
    }
  }, {
    key: "addEvent",
    value: function addEvent(eventType, data, isForce) {
      var event = Object.assign({
        timestamp: Date.now(),
        event_id: QosEventType[eventType],
        event_name: eventType
      }, data);
      this.submitQueue.push("add", event).catch(noop);
      this.submit(isForce);
    }
  }, {
    key: "submit",
    value: function submit() {
      var isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.submitQueue.push("submit", isForce).catch(noop);
    }
  }, {
    key: "initSubmitQueue",
    value: function initSubmitQueue() {
      var _this8 = this;
      this.submitQueue.on("exec", function (command, ph) {
        switch (command.method) {
          case "submit":
            {
              ph.promise = _this8._submit(command.data);
              return;
            }
          case "add":
            {
              ph.promise = _this8._addEvent(command.data);
              return;
            }
          case "resume":
            {
              ph.promise = _this8._recoverStoredEvents();
              return;
            }
        }
      });
    }
  }, {
    key: "_recoverStoredEvents",
    value: function _recoverStoredEvents() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localforage.getItem(QNRTC_EVENTS_STORATE_KEY);
            case 2:
              res = _context.sent;
              _context.next = 5;
              return localforage.removeItem(QNRTC_EVENTS_STORATE_KEY);
            case 5:
              if (res) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              this.events = JSON.parse(window.atob(decodeURIComponent(res)));
              // 没有 sessionid 或者 user_base 的数据将被丢弃
              this.events = this.events.filter(function (e) {
                return !!e.session_id && !!e.user_base;
              }).sort(function (a, b) {
                return a.event.timestamp - b.event.timestamp;
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_addEvent",
    value: function _addEvent(event) {
      this.events.push({
        user_base: this.userBase,
        event: event,
        session_id: this.sessionId
      });
      this.submit();
      return Promise.resolve();
    }
  }, {
    key: "saveEvents",
    value: function saveEvents() {
      var events = encodeURIComponent(window.btoa(JSON.stringify(this.events)));
      localforage.setItem(QNRTC_EVENTS_STORATE_KEY, events).catch(noop);
    }
  }, {
    key: "submitCheck",
    value: function submitCheck() {
      if (!this.sessionId || !this.deviceId || !this.userBase) return false;
      if (Date.now() - this.lastSubmitTime > 60000 * 5) return true;
      if (this.events.length >= 30) return true;
      return false;
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, submitData, _iterator, _step, data, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              result = isForce ? true : this.submitCheck();
              if (result) {
                _context2.next = 4;
                break;
              }
              this.saveEvents();
              return _context2.abrupt("return");
            case 4:
              _context2.prev = 4;
              submitData = this.encodeQosSubmitData();
              _iterator = _createForOfIteratorHelper(submitData);
              _context2.prev = 7;
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context2.next = 18;
                break;
              }
              data = _step.value;
              _context2.next = 13;
              return fetch("https://pili-rtc-qos.qiniuapi.com/v1/rtcevent", {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-gzip"
                },
                body: data.buffer
              });
            case 13:
              res = _context2.sent;
              if (res.ok) {
                _context2.next = 16;
                break;
              }
              throw ERROR_FATAL("rtcevent error");
            case 16:
              _context2.next = 9;
              break;
            case 18:
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](7);
              _iterator.e(_context2.t0);
            case 23:
              _context2.prev = 23;
              _iterator.f();
              return _context2.finish(23);
            case 26:
              this.lastSubmitTime = Date.now();
              this.events = [];
              _context2.next = 30;
              return localforage.removeItem(QNRTC_EVENTS_STORATE_KEY);
            case 30:
              _context2.next = 35;
              break;
            case 32:
              _context2.prev = 32;
              _context2.t1 = _context2["catch"](4);
              log.log(_context2.t1);
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 32], [7, 20, 23, 26]]);
      }));
    }
  }, {
    key: "encodeQosSubmitData",
    value: function encodeQosSubmitData() {
      var submitDataGroup = groupBy(this.events, function (e) {
        return e.session_id || "" + JSON.stringify(e.user_base);
      });
      var data = [];
      for (var key in submitDataGroup) {
        var events = submitDataGroup[key];
        if (events.length === 0) continue;
        var submitData = {
          session_id: events[0].session_id,
          user_base: events[0].user_base,
          base: this.base,
          items: events.map(function (e) {
            return e.event;
          })
        };
        log.log("encode", submitData);
        var byteArray = new Uint8Array(pako.gzip(toUTF8Array(JSON.stringify(submitData))));
        data.push(byteArray);
      }
      return data;
    }
  }]);
  return QosModel;
}();
function getDeviceId() {
  return new Promise(function (resolve, reject) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        Fingerprint2.get(function (components) {
          var deviceId = md5(JSON.stringify(components));
          resolve(deviceId);
        });
      });
    } else {
      setTimeout(function () {
        Fingerprint2.get(function (components) {
          var deviceId = md5(JSON.stringify(components));
          resolve(deviceId);
        });
      }, 500);
    }
  });
}
function toUTF8Array(str) {
  var utf8 = [];
  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);
    if (charcode < 0x80) utf8.push(charcode);else if (charcode < 0x800) {
      utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
    }
    // surrogate pair
    else {
      i++;
      // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
    }
  }
  return new Uint8Array(utf8);
}
var qos = new QosModel();
/**
 * setup permissions qos event
 */
{
  var sendQosPermission = function sendQosPermission(state, permissionNameCode) {
    var permissionStateCode;
    switch (state) {
      case "prompt":
        permissionStateCode = PermissionStateCode["prompt"];
        break;
      case "granted":
        permissionStateCode = PermissionStateCode["granted"];
        break;
      case "denied":
        permissionStateCode = PermissionStateCode["denied"];
        break;
      default:
        return;
    }
    var eventGrade = QNEventGrade.NORMAL;
    // 权限被拒绝或者受限，则等级为 SERVERE，否则为 NORMAL
    if (permissionStateCode === PermissionStateCode["prompt"] || PermissionStateCode["denied"]) {
      eventGrade = QNEventGrade.SERVERE;
    }
    qos.addEvent("AuthorizationStatus", {
      type: permissionNameCode,
      status: permissionStateCode,
      event_grade: eventGrade,
      event_category: QNEventCategory.CORE
    });
  };
  var queryPermission = function queryPermission(qosPermissionName) {
    if (n && n.permissions) {
      n.permissions.query({
        name: qosPermissionName
      }).then(function (permissionStatus) {
        sendQosPermission(permissionStatus.state, PermissionNameCode[qosPermissionName]);
        permissionStatus.onchange = function () {
          sendQosPermission(permissionStatus.state, PermissionNameCode[qosPermissionName]);
        };
      }).catch(function (error) {
        log.debug("error when queryPermission", error);
      });
    }
  };
  var n = navigator;
  queryPermission("camera");
  queryPermission("microphone");
}
/**
 * setup page visibility qos event
 */
{
  if (!!document.visibilityState) {
    document.addEventListener("visibilitychange", function () {
      qos.addEvent("ApplicationState", {
        state: document.visibilityState === "visible" ? 0 : 2,
        // -------Qos打点v2优化--------
        event_grade: QNEventGrade.GENERAL,
        event_category: QNEventCategory.CORE
      });
    });
  }
}
var qnCheckNetworkChangeQos = function () {
  var networkGrade = NetworkGrade.INVALID;
  var networkName = "unknow";
  var getNetworkTypeByNetworkName = function getNetworkTypeByNetworkName(name) {
    var networkType;
    switch (name) {
      case "cellular":
        networkType = 0;
        break;
      case "wifi":
        networkType = 1;
        break;
      case "ethernet":
        networkType = 2;
        break;
      default:
        networkType = -1;
    }
    return networkType;
  };
  var addQos = function addQos() {
    qos.addEvent("NetworkChange", {
      network_type: getNetworkTypeByNetworkName(networkName),
      network_name: networkName,
      network_grade: networkGrade,
      event_grade: QNEventGrade.GENERAL,
      event_category: QNEventCategory.CORE
    });
  };
  var n = navigator;
  var connection = n.connection || n.mozConnection || n.webkitConnection;
  if (connection && connection.type) {
    networkName = connection.type;
    connection.onchange = function () {
      if (networkName !== connection.type) {
        networkName = connection.type;
        addQos();
      }
    };
  }
  addQos();
  return function (g) {
    if (g !== networkGrade) {
      networkGrade = g;
      addQos();
    }
  };
}();
var QNRTCError = /*#__PURE__*/function (_Error) {
  _inherits(QNRTCError, _Error);
  function QNRTCError(code, message) {
    var _this9;
    _classCallCheck(this, QNRTCError);
    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCError).call(this, message));
    _this9.code = code;
    _this9.error = message;
    qos.addEvent("SDKError", {
      error_code: code,
      error_msg: message
    });
    return _this9;
  }
  return QNRTCError;
}(_wrapNativeSuper(Error)); // 各端错误码统一
// 客户端自定义的，按照这个文档：https://cf.qiniu.io/pages/viewpage.action?pageId=75957748
// 服务端返回的，直接使用服务端返回的 error code
// 客户端自定义 code
var ERROR_INVALID_PARAMETER = function ERROR_INVALID_PARAMETER(msg) {
  return new QNRTCError(10053, "invalid parameters: ".concat(msg));
};
var ERROR_FATAL = function ERROR_FATAL(msg) {
  return new QNRTCError(21005, "piliRTC: unexpected error ".concat(msg));
};
var ERROR_AUTH_FAILED = function ERROR_AUTH_FAILED(msg) {
  return new QNRTCError(21001, "enterRoom error, can not get accessToken. Error: ".concat(msg, "\n please check enterRoom arguments"));
};
var ERROR_RECONNECT_FAILED$1 = function ERROR_RECONNECT_FAILED$1(msg) {
  return new QNRTCError(21003, "reconnect failed\uFF01".concat(msg));
};
var ERROR_NOT_SUPPORT = function ERROR_NOT_SUPPORT(msg) {
  return new QNRTCError(21006, "not support! ".concat(msg));
};
var ERROR_PLAY_NOT_ALLOWED = function ERROR_PLAY_NOT_ALLOWED(msg) {
  return new QNRTCError(21007, "track play is not allowed: ".concat(msg));
};
var ERROR_PLUGIN_NOT_AVAILABLE = function ERROR_PLUGIN_NOT_AVAILABLE(msg) {
  return new QNRTCError(23003, "plugin not avaliable! ".concat(msg));
};
var ERROR_DEVICE_NOT_ALLOWED = function ERROR_DEVICE_NOT_ALLOWED(msg) {
  return new QNRTCError(23004, "NotAllowedError: no permission to access media device. ".concat(msg));
};
var ERROR_AUDIO_DECODE_ERROR = function ERROR_AUDIO_DECODE_ERROR(e) {
  return new QNRTCError(22011, "can not decode audio data, ".concat(e.toString()));
};
var CREATE_SCREEN_AUDIO_ERROR = function CREATE_SCREEN_AUDIO_ERROR() {
  return new QNRTCError(23005, "no audio track when createScreenVideoTrack withAudio enable");
};
var ERROR_ELECTRON_REQUIRE_ERROR = function ERROR_ELECTRON_REQUIRE_ERROR(msg) {
  return new QNRTCError(23008, "require('electron') error, please checkout if electron environment is ok: ".concat(msg));
};
var ERROR_RELAY_TOKEN = function ERROR_RELAY_TOKEN(msg) {
  return new QNRTCError(24000, "relay error, can not get relayToken. Error: ".concat(msg));
};
var ERROR_INVALID_CLIENT_MODE = function ERROR_INVALID_CLIENT_MODE(msg) {
  return new QNRTCError(24001, "invalid client mode, ".concat(msg));
};
var ERROR_INVALID_CLIENT_ROLE = function ERROR_INVALID_CLIENT_ROLE(msg) {
  return new QNRTCError(24002, "invalid client role, ".concat(msg));
};
var WS_ABORT = function WS_ABORT() {
  return ERROR_FATAL("websocket abort");
};
var NO_MERGE_JOB = function NO_MERGE_JOB(id) {
  return ERROR_INVALID_PARAMETER("can not set merge layout stream, no merge job id ".concat(id));
};
var SCREEN_PERMISSION_DENIED = function SCREEN_PERMISSION_DENIED() {
  return ERROR_DEVICE_NOT_ALLOWED("can not sharing screen/window on chrome");
};
var SUB_PUB_ABORT = function SUB_PUB_ABORT() {
  return ERROR_FATAL("subscribe/publish operation is aborted");
};
var PRESET_NOT_FOUND = function PRESET_NOT_FOUND() {
  return ERROR_INVALID_PARAMETER("cannot found preset");
};
var ERROR_AUDIO_MIXING_IO_EXCEPTION = function ERROR_AUDIO_MIXING_IO_EXCEPTION() {
  return new QNRTCError(22003, "mix source error");
};
var ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND = function ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND() {
  return new QNRTCError(22002, "mixed source does not find a valid track");
};
var ERROR_EFFECT_ID_IS_EXIST = function ERROR_EFFECT_ID_IS_EXIST() {
  return new QNRTCError(22001, "effectID already exists, cannot create QNAudioEffect");
};
var ERROR_EFFECT_ID_IS_NOT_EXIST = function ERROR_EFFECT_ID_IS_NOT_EXIST() {
  return new QNRTCError(22004, "effectID is not exists, pleast createAudioEffect first");
};
var ERROR_RECORDER_WRITE = function ERROR_RECORDER_WRITE() {
  return new QNRTCError(22005, "failed to write recording file");
};
var ERROR_RECORDER_SOURCE_EXCEPTION = function ERROR_RECORDER_SOURCE_EXCEPTION() {
  return new QNRTCError(22006, "audio and video resources do not exist");
};
var ERROR_RECORDER_EXCEEDING_TIME = function ERROR_RECORDER_EXCEEDING_TIME() {
  return new QNRTCError(22007, "recording time exceeded limit");
};
var ERROR_RECORDER_PARAMS_EXCEPTION = function ERROR_RECORDER_PARAMS_EXCEPTION() {
  return new QNRTCError(22008, "");
};
var ERROR_RECORDER_STATE_EXCEPTION = function ERROR_RECORDER_STATE_EXCEPTION() {
  return new QNRTCError(22009, "the operation is not supported in the current state");
};
// 服务端返回 code
var PUBLISH_ERROR = function PUBLISH_ERROR(code, msg) {
  return new QNRTCError(code, "publish error, signaling code: ".concat(code, ", msg: ").concat(msg));
};
var CREATE_MERGE_JOB_ERROR = function CREATE_MERGE_JOB_ERROR(code, msg) {
  return new QNRTCError(code, "create merge job error, signaling code: ".concat(code, ", msg: ").concat(msg));
};
var CREATE_FORWARD_JOB_ERROR = function CREATE_FORWARD_JOB_ERROR(code, msg) {
  return new QNRTCError(code, "create forward job error, signaling code: ".concat(code, ", msg: ").concat(msg));
};
var UNSUPPORT_FMT = function UNSUPPORT_FMT(code, msg) {
  return new QNRTCError(code, "media format not support, ".concat(msg));
};
var JOIN_ROOM_ERROR$1 = function JOIN_ROOM_ERROR$1(code, msg) {
  return new QNRTCError(code, "joinRoom error, code: ".concat(code, ", ").concat(msg));
};
var SUB_ERROR = function SUB_ERROR(code, msg) {
  return new QNRTCError(code, "subscribe error, signaling code: ".concat(code, ", msg: ").concat(msg));
};
var UNPUBLISH_ERROR = function UNPUBLISH_ERROR(code, msg) {
  return new QNRTCError(code, "unpublish error, code: ${code}, msg: ${msg}");
};
var UNSUB_ERROR = function UNSUB_ERROR(code, msg) {
  return new QNRTCError(code, "unsubscribe error, code: ${code}, msg: ${msg}");
};
var CONTROL_ERROR = function CONTROL_ERROR(code, msg) {
  return new QNRTCError(code, "send control error, code: ".concat(code, ", msg: ").concat(msg));
};
var SERVER_ERROR = function SERVER_ERROR(code, msg) {
  return new QNRTCError(code, msg);
};
var SERVER_UNAVAILABLE = function SERVER_UNAVAILABLE() {
  return new QNRTCError(10052, "server unavailable");
};
/**
 * Error produced when calling a method in an invalid state.
 */
var InvalidStateError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidStateError, _Error2);
  function InvalidStateError(message) {
    var _this10;
    _classCallCheck(this, InvalidStateError);
    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidStateError).call(this, message));
    _this10.name = "InvalidStateError";
    if (Error.hasOwnProperty("captureStackTrace")) {
      // Just in V8.
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this10)), InvalidStateError);
    } else {
      _this10.stack = new Error(message).stack;
    }
    return _this10;
  }
  return InvalidStateError;
}(_wrapNativeSuper(Error));
var error = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CONTROL_ERROR: CONTROL_ERROR,
  CREATE_FORWARD_JOB_ERROR: CREATE_FORWARD_JOB_ERROR,
  CREATE_MERGE_JOB_ERROR: CREATE_MERGE_JOB_ERROR,
  CREATE_SCREEN_AUDIO_ERROR: CREATE_SCREEN_AUDIO_ERROR,
  ERROR_AUDIO_DECODE_ERROR: ERROR_AUDIO_DECODE_ERROR,
  ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND: ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND,
  ERROR_AUDIO_MIXING_IO_EXCEPTION: ERROR_AUDIO_MIXING_IO_EXCEPTION,
  ERROR_AUTH_FAILED: ERROR_AUTH_FAILED,
  ERROR_DEVICE_NOT_ALLOWED: ERROR_DEVICE_NOT_ALLOWED,
  ERROR_EFFECT_ID_IS_EXIST: ERROR_EFFECT_ID_IS_EXIST,
  ERROR_EFFECT_ID_IS_NOT_EXIST: ERROR_EFFECT_ID_IS_NOT_EXIST,
  ERROR_ELECTRON_REQUIRE_ERROR: ERROR_ELECTRON_REQUIRE_ERROR,
  ERROR_FATAL: ERROR_FATAL,
  ERROR_INVALID_CLIENT_MODE: ERROR_INVALID_CLIENT_MODE,
  ERROR_INVALID_CLIENT_ROLE: ERROR_INVALID_CLIENT_ROLE,
  ERROR_INVALID_PARAMETER: ERROR_INVALID_PARAMETER,
  ERROR_NOT_SUPPORT: ERROR_NOT_SUPPORT,
  ERROR_PLAY_NOT_ALLOWED: ERROR_PLAY_NOT_ALLOWED,
  ERROR_PLUGIN_NOT_AVAILABLE: ERROR_PLUGIN_NOT_AVAILABLE,
  ERROR_RECONNECT_FAILED: ERROR_RECONNECT_FAILED$1,
  ERROR_RECORDER_EXCEEDING_TIME: ERROR_RECORDER_EXCEEDING_TIME,
  ERROR_RECORDER_PARAMS_EXCEPTION: ERROR_RECORDER_PARAMS_EXCEPTION,
  ERROR_RECORDER_SOURCE_EXCEPTION: ERROR_RECORDER_SOURCE_EXCEPTION,
  ERROR_RECORDER_STATE_EXCEPTION: ERROR_RECORDER_STATE_EXCEPTION,
  ERROR_RECORDER_WRITE: ERROR_RECORDER_WRITE,
  ERROR_RELAY_TOKEN: ERROR_RELAY_TOKEN,
  InvalidStateError: InvalidStateError,
  JOIN_ROOM_ERROR: JOIN_ROOM_ERROR$1,
  NO_MERGE_JOB: NO_MERGE_JOB,
  PRESET_NOT_FOUND: PRESET_NOT_FOUND,
  PUBLISH_ERROR: PUBLISH_ERROR,
  QNRTCError: QNRTCError,
  SCREEN_PERMISSION_DENIED: SCREEN_PERMISSION_DENIED,
  SERVER_ERROR: SERVER_ERROR,
  SERVER_UNAVAILABLE: SERVER_UNAVAILABLE,
  SUB_ERROR: SUB_ERROR,
  SUB_PUB_ABORT: SUB_PUB_ABORT,
  UNPUBLISH_ERROR: UNPUBLISH_ERROR,
  UNSUB_ERROR: UNSUB_ERROR,
  UNSUPPORT_FMT: UNSUPPORT_FMT,
  WS_ABORT: WS_ABORT
});
function getPayloadFromJwt(jwttoken) {
  var payloadString = jwttoken.split(".")[1];
  if (!payloadString) {
    throw new Error("parse jwt error, can not find payload string.");
  }
  var decoedString = atob(payloadString);
  return JSON.parse(decoedString);
}
function getRoomAccessFromToken(roomToken) {
  try {
    var roomAccessString = roomToken.split(":")[2];
    var decoedString = atob(roomAccessString);
    return JSON.parse(decoedString);
  } catch (e) {
    throw ERROR_FATAL("can not parse roomToken, ".concat(e));
  }
}
function removeElementFromArray(array, key, value) {
  var newArray = [];
  var removeElement = null;
  for (var i = 0; i < array.length; i += 1) {
    var element = array[i];
    if (element[key] === value) {
      removeElement = array[i];
      continue;
    }
    newArray.push(array[i]);
  }
  return {
    removeElement: removeElement,
    newArray: newArray
  };
}
function getElementFromArray(array, key, value) {
  if (!value) {
    return null;
  }
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];
    if (item[key] === value) {
      return item;
    }
  }
  return null;
}
function noop() {}
function removeUndefinedKey(obj) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (depth >= 4) {
    return obj;
  }
  for (var key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    }
    if (obj[key] instanceof File) continue;
    if (obj[key] instanceof ArrayBuffer) continue;
    if (typeof obj[key] === "object") {
      obj[key] = removeUndefinedKey(obj[key], depth + 1);
    }
  }
  return obj;
}
function nextTick(func) {
  var p = Promise.resolve();
  p.then(func);
}
function getMissingUserEvent(currentUserId, lastTracksInfo, currentTracksInfo, lastUsers, currentUsers) {
  var missingEvent = {
    join: [],
    leave: [],
    add: [],
    remove: [],
    mute: []
  };
  var lastTracksIds = lastTracksInfo.map(function (info) {
    return info.trackid;
  });
  var currentTracksIds = currentTracksInfo.map(function (info) {
    return info.trackid;
  });
  lastTracksIds.forEach(function (trackID, i) {
    if (lastTracksInfo[i].playerid === currentUserId) {
      return;
    }
    if (currentTracksIds.indexOf(trackID) === -1) {
      missingEvent.remove.push(lastTracksInfo[i]);
    } else {
      var currentTracksInfoItem = currentTracksInfo.find(function (t) {
        return t.trackid === trackID;
      });
      var lastTrackInfoItem = lastTracksInfo[i];
      // 如果重连后 trackid 相同但是 versionid 不同，抛出 track-remove 和 track-add
      if (currentTracksInfoItem.versionid !== lastTrackInfoItem.versionid) {
        missingEvent.remove.push(lastTrackInfoItem);
        missingEvent.add.push(currentTracksInfoItem);
      }
    }
  });
  currentTracksIds.forEach(function (trackID, i) {
    if (currentTracksInfo[i].playerid === currentUserId) {
      return;
    }
    var index = lastTracksIds.indexOf(trackID);
    if (index === -1) {
      missingEvent.add.push(currentTracksInfo[i]);
      missingEvent.mute.push({
        trackid: trackID,
        muted: currentTracksInfo[i].muted
      });
    } else {
      if (currentTracksInfo[i].muted !== lastTracksInfo[index].muted) {
        missingEvent.mute.push({
          trackid: trackID,
          muted: currentTracksInfo[i].muted
        });
      }
    }
  });
  lastUsers.forEach(function (userID) {
    if (userID === currentUserId) {
      return;
    }
    if (currentUsers.indexOf(userID) === -1) {
      missingEvent.leave.push({
        playerid: userID
      });
    }
  });
  currentUsers.forEach(function (userID) {
    if (userID === currentUserId) {
      return;
    }
    if (lastUsers.indexOf(userID) === -1) {
      missingEvent.join.push({
        playerid: userID
      });
    }
  });
  return missingEvent;
}
function dec2hex(dec) {
  return ("0" + dec.toString(16)).substr(-2);
}
function randomStringGen() {
  var strLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var arr = new Uint8Array((strLength || 40) / 2);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, dec2hex).join("");
}
function timeout(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}
var runOnceFlag = {};
/**
 * 对于相同 key 的调用，只会执行一次
 */
function runOnce(func, key) {
  if (!runOnceFlag[key]) {
    runOnceFlag[key] = true;
    return func();
  }
}
function showPlayWarn(e) {
  log.warning("play failed!", e);
  log.warning("play failed due to browser security policy, see: http://s.qnsdk.com/s/Txsdz");
}
/**
 * 计算字符串字节数
 * @param {string} strs 字符串
 * @returns {number} 字符串字节数
 */
function calcCharacterLength(strs) {
  return new Blob([strs]).size;
}
var customServerHosts = [];
function getHosts() {
  return _regeneratorRuntime().wrap(function getHosts$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        if (!customServerHosts.length) {
          _context3.next = 3;
          break;
        }
        log.debug("using custom mcu server hosts:", customServerHosts);
        return _context3.delegateYield(customServerHosts, "t0", 3);
      case 3:
        _context3.next = 5;
        return "https://rtc.qiniuapi.com";
      case 5:
        _context3.next = 7;
        return "https://rtc.qiniu.com";
      case 7:
      case "end":
        return _context3.stop();
    }
  }, _marked);
}
var lastHost;
/**
 *
 * @param path path of the resource, without preceding host and schema.
 * @param timeout timeout to cancel, in miliseconds.
 * @returns response
 */
function requestMcu(path) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _iterator2, _step2, host, result, request;
    return _regeneratorRuntime().wrap(function _callee4$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          request = function _request(selected) {
            return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var url, abortController, timeoutId, response, status, statusText;
              return _regeneratorRuntime().wrap(function _callee3$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    url = "".concat(selected).concat(path);
                    log.debug("requesting on", url);
                    _context4.prev = 2;
                    abortController = new AbortController();
                    _context4.next = 6;
                    return Promise.race([new Promise(function (_, reject) {
                      timeoutId = window.setTimeout(function () {
                        abortController.abort("Time limit exceeded");
                        reject({
                          networkCode: -1,
                          message: "请求超时"
                        });
                      }, timeout);
                    }), fetch(url, {
                      signal: abortController.signal
                    })]);
                  case 6:
                    response = _context4.sent;
                    clearTimeout(timeoutId);
                    status = response.status, statusText = response.statusText;
                    if (!(status >= 500)) {
                      _context4.next = 13;
                      break;
                    }
                    return _context4.abrupt("return", undefined);
                  case 13:
                    if (!(status >= 400)) {
                      _context4.next = 15;
                      break;
                    }
                    throw {
                      retry: false,
                      message: "".concat(status, " ").concat(statusText)
                    };
                  case 15:
                    return _context4.abrupt("return", response.json());
                  case 18:
                    _context4.prev = 18;
                    _context4.t0 = _context4["catch"](2);
                    if (!(_context4.t0 instanceof TypeError)) {
                      _context4.next = 25;
                      break;
                    }
                    log.error("bad request with host:", selected, _context4.t0.message);
                    // try another domain
                    return _context4.abrupt("return", undefined);
                  case 25:
                    console.error(selected, _context4.t0);
                    return _context4.abrupt("return", _context4.t0);
                  case 27:
                  case "end":
                    return _context4.stop();
                }
              }, _callee3, null, [[2, 18]]);
            }));
          };
          if (lastHost) {
            _context5.next = 25;
            break;
          }
          _iterator2 = _createForOfIteratorHelper(getHosts());
          _context5.prev = 3;
          _iterator2.s();
        case 5:
          if ((_step2 = _iterator2.n()).done) {
            _context5.next = 15;
            break;
          }
          host = _step2.value;
          _context5.next = 9;
          return request(host);
        case 9:
          result = _context5.sent;
          if (!result) {
            _context5.next = 13;
            break;
          }
          lastHost = host;
          return _context5.abrupt("return", result);
        case 13:
          _context5.next = 5;
          break;
        case 15:
          _context5.next = 20;
          break;
        case 17:
          _context5.prev = 17;
          _context5.t0 = _context5["catch"](3);
          _iterator2.e(_context5.t0);
        case 20:
          _context5.prev = 20;
          _iterator2.f();
          return _context5.finish(20);
        case 23:
          _context5.next = 26;
          break;
        case 25:
          return _context5.abrupt("return", request(lastHost));
        case 26:
        case "end":
          return _context5.stop();
      }
    }, _callee4, null, [[3, 17, 20, 23]]);
  }));
}
function resolveIceHost(host) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var ipv6Match, ipv4Match, res, data;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          ipv6Match = host.match(/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/);
          ipv4Match = host.match(/^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/);
          if (!(!!ipv4Match || !!ipv6Match)) {
            _context6.next = 4;
            break;
          }
          return _context6.abrupt("return", host);
        case 4:
          _context6.prev = 4;
          _context6.next = 7;
          return fetch("https://".concat(host, "/ip"));
        case 7:
          res = _context6.sent;
          _context6.next = 10;
          return res.json();
        case 10:
          data = _context6.sent;
          return _context6.abrupt("return", data.ip);
        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](4);
          log.warning("resolve ice failed, retry", _context6.t0);
          _context6.next = 19;
          return timeout(1000);
        case 19:
          _context6.next = 21;
          return resolveIceHost(host);
        case 21:
          return _context6.abrupt("return", _context6.sent);
        case 22:
        case "end":
          return _context6.stop();
      }
    }, _callee5, null, [[4, 14]]);
  }));
}
var ExceptionStatus;
(function (ExceptionStatus) {
  ExceptionStatus[ExceptionStatus["AudioLevelUnusual"] = 0] = "AudioLevelUnusual";
})(ExceptionStatus || (ExceptionStatus = {}));
var WebSDKException = /*#__PURE__*/function () {
  _createClass(WebSDKException, null, [{
    key: "create",
    value: function create(qosInfo) {
      if (!this.instance) {
        this.instance = new WebSDKException();
      }
      var validStandard = this.instance.getValidStandard(qosInfo.code);
      this.instance.qosAddEvent(Object.assign(Object.assign({
        valid_standard: validStandard
      }, qosInfo), {
        event_grade: QNEventGrade.SERVERE
      }));
      return this.instance;
    }
  }]);
  function WebSDKException() {
    _classCallCheck(this, WebSDKException);
  }
  _createClass(WebSDKException, [{
    key: "qosAddEvent",
    value: function qosAddEvent(qosInfo) {
      qos.addEvent("WebSDKException", qosInfo);
    }
  }, {
    key: "getValidStandard",
    value: function getValidStandard(code) {
      switch (code) {
        case ExceptionStatus.AudioLevelUnusual:
          return '0-1';
      }
    }
  }]);
  return WebSDKException;
}(); // borrowed from webrtc rtc_base/numerics/exp_filter.cc
var ExpFilter = /*#__PURE__*/function () {
  function ExpFilter(filterType) {
    _classCallCheck(this, ExpFilter);
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExpFilter.AlphaForPacketLossFractionSmoother;
    this.mLastFilteredTimestamp = Date.now();
    this.mMax = ExpFilter.kValueUndefined;
    this.smooth_interval = filterType === "audio" ? ExpFilter.SMOOTH_AUDIO_INTERVAL : ExpFilter.SMOOTH_VIDEO_INTERVAL;
    this.Reset(alpha);
  }
  // Resets the filter to its initial state, and resets filter factor base to
  // the given value |alpha|.
  _createClass(ExpFilter, [{
    key: "Reset",
    value: function Reset(alpha) {
      this.mAlpha = alpha;
      this.mFiltered = ExpFilter.kValueUndefined;
    } // Applies the filter with a given exponent on the provided sample:
    // y(k) = min(alpha_^ exp * y(k-1) + (1 - alpha_^ exp) * sample, max_).
  }, {
    key: "Apply",
    value: function Apply(sample) {
      var exp = Date.now() - this.mLastFilteredTimestamp;
      // only when sample === 0 then it may be false report
      if (exp < this.smooth_interval && sample === 0) {
        this.applied = false;
        return;
      }
      var value;
      if (this.mFiltered === ExpFilter.kValueUndefined) {
        // Initialize filtered value.
        value = sample;
      } else if (exp === 1.0) {
        value = this.mAlpha * this.mFiltered + (1 - this.mAlpha) * sample;
      } else {
        var alpha = Math.pow(this.mAlpha, exp);
        value = alpha * this.mFiltered + (1 - alpha) * sample;
      }
      // Math.pow above may get NaN
      if (!isNaN(value)) {
        this.mFiltered = value;
      }
      if (this.mMax !== ExpFilter.kValueUndefined && this.mFiltered > this.mMax) {
        this.mFiltered = this.mMax;
      }
      this.mLastFilteredTimestamp = Date.now();
      this.applied = true;
    } // Returns current filtered value.
  }, {
    key: "Filtered",
    value: function Filtered() {
      return this.mFiltered;
    }
  }, {
    key: "LastFilteredTime",
    value: function LastFilteredTime() {
      return this.mLastFilteredTimestamp;
    } // Changes the filter factor base to the given value |alpha|.
  }, {
    key: "UpdateBase",
    value: function UpdateBase(alpha) {
      this.mAlpha = alpha;
    }
  }]);
  return ExpFilter;
}();
ExpFilter.kValueUndefined = -1;
ExpFilter.AlphaForPacketLossFractionSmoother = 0.9999;
/**
 * the smooth should be done when rtcp packet arrive/send, but we can't get the rtcp
 * packet arrive/send time. according to webrtc and media server, the default rtcp
 * interval is:
 *
 * kDefaultVideoReportInterval = 1000;
 * kDefaultAudioReportInterval = 5000;
 * so we define the value accordingly
 */
ExpFilter.SMOOTH_VIDEO_INTERVAL = 1000;
ExpFilter.SMOOTH_AUDIO_INTERVAL = 5000;
/**
 * Each one ssrc which has an unique id has its own ExpFilter
 */
function manageExpFilter() {
  var filters = {};
  return function (id, filterType) {
    if (id in filters) {
      return filters[id];
    } else {
      filters[id] = new ExpFilter(filterType);
      return filters[id];
    }
  };
}
/**
 * TrackStatsReport and MediaStatisticStatsWithCalculationReport use different timer
 * So two filters for each here.
 */
var getReportExpFilter = manageExpFilter();
var getStatisticExpFilter = manageExpFilter();
var defaultTrackStatsReport = function defaultTrackStatsReport() {
  return {
    id: "",
    kind: "audio",
    packetLossRate: 0,
    bitrate: 0,
    bytes: 0,
    packets: 0,
    packetLoss: 0,
    frameRate: 0,
    rtt: 0,
    timestamp: Date.now(),
    networkGrade: NetworkGrade.INVALID
  };
};
function getNetworkGrade(maxLostRate, maxRtt) {
  var networkGrade;
  if (maxLostRate > 15 || maxRtt > 400) {
    networkGrade = NetworkGrade.POOR;
  } else if (maxLostRate > 8 || maxRtt > 200) {
    networkGrade = NetworkGrade.FAIR;
  } else if (maxLostRate > 1 || maxRtt > 100) {
    networkGrade = NetworkGrade.GOOD;
  } else {
    networkGrade = NetworkGrade.EXCELLENT;
  }
  // connection is not in this version's typescript
  var n = navigator;
  if (n.connection && n.connection.effectiveType && ['slow-2g', '2g', '3g'].includes(n.connection.effectiveType)) {
    networkGrade = NetworkGrade.POOR;
  }
  return networkGrade;
}
function getStats(pc, track, pctype) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var report, statsReportList, _iterator3, _step3, item, statsReport, remoteItem;
    return _regeneratorRuntime().wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return pc.getStats(track);
        case 3:
          report = _context7.sent;
          _context7.next = 10;
          break;
        case 6:
          _context7.prev = 6;
          _context7.t0 = _context7["catch"](0);
          log.debug("get stats error, fallback to default", _context7.t0);
          return _context7.abrupt("return", []);
        case 10:
          if (report) {
            _context7.next = 13;
            break;
          }
          log.debug("get null stats, fallback to default");
          return _context7.abrupt("return", []);
        case 13:
          statsReportList = [];
          _iterator3 = _createForOfIteratorHelper(report.values());
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              item = _step3.value;
              /**
               * isRemote is for compatible with old browsers.
               * see: https://blog.mozilla.org/webrtc/getstats-isremote-66/
               */
              if (pctype === "send" && item.type === "outbound-rtp" && !item.isRemote || pctype === "recv" && item.type === "inbound-rtp" && !item.isRemote) {
                statsReport = defaultTrackStatsReport();
                remoteItem = report.get(item.remoteId);
                statsReport.packetLoss = getPacketsLost(item, remoteItem) || 0;
                statsReport.bytes = pctype === "send" ? item.bytesSent : item.bytesReceived;
                statsReport.packets = pctype === "send" ? item.packetsSent : item.packetsReceived;
                statsReport.rtt = getRtt(item) || getRtt(remoteItem) || 0;
                statsReport.id = item.id;
                statsReport.kind = item.kind;
                if (item.frameWidth) {
                  statsReport.width = item.frameWidth;
                }
                if (item.frameHeight) {
                  statsReport.height = item.frameHeight;
                }
                if (item.framesPerSecond) {
                  statsReport.frameRate = item.framesPerSecond;
                }
                // for Firefox/81
                if (item.framerateMean) {
                  statsReport.frameRate = Math.ceil(item.framerateMean);
                }
                statsReportList.push(statsReport);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return _context7.abrupt("return", statsReportList);
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[0, 6]]);
  }));
}
var defaultAudioExtraStats = {
  track_audio_volume: 0,
  jitter_buffer_delay: 0,
  bytes_sent: 0,
  bytes_received: 0
};
var defaultVideoExtraStats = {
  nack_count: 0,
  fir_count: 0,
  pli_count: 0,
  width: 0,
  height: 0,
  jitter_buffer_delay: 0,
  bytes_sent: 0,
  frame_encoded: 0,
  bytes_received: 0,
  frame_decoded: 0
};
var defaultCalculationStats = {
  frames_received: 0,
  frames_sent: 0,
  packets_lost: 0,
  packets_received: 0,
  packets_sent: 0,
  timestamp: 0,
  bytes_sent: 0,
  bytes_received: 0
};
var MediaType;
(function (MediaType) {
  MediaType["Video"] = "video";
  MediaType["Audio"] = "audio";
})(MediaType || (MediaType = {}));
var StatsReportType;
(function (StatsReportType) {
  StatsReportType["MediaSource"] = "media-source";
  StatsReportType["Track"] = "track";
  StatsReportType["OutBoundRtp"] = "outbound-rtp";
  StatsReportType["InBoundRtp"] = "inbound-rtp";
  StatsReportType["RemoteInBound"] = "remote-inbound-rtp";
})(StatsReportType || (StatsReportType = {}));
var BoundType;
(function (BoundType) {
  BoundType["In"] = "in";
  BoundType["Out"] = "out";
})(BoundType || (BoundType = {}));
function getDefaultMediaStatisticWithCalculationReport(id, trackID, mediaType) {
  var report = {
    id: id,
    track_id: trackID,
    kind: "audio",
    kbps: 0,
    framerate: 0,
    packet_lost_rate: 0,
    rtt: 0,
    extra_stats: null,
    calculation_stats: Object.assign({}, defaultCalculationStats)
  };
  if (mediaType === MediaType.Audio) {
    report.extra_stats = Object.assign({}, defaultAudioExtraStats);
  } else {
    report.extra_stats = Object.assign({}, defaultVideoExtraStats);
  }
  return report;
}
function getQualityStats(pc, core) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var report, items, stats;
    return _regeneratorRuntime().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return pc.getStats();
        case 3:
          report = _context8.sent;
          _context8.next = 10;
          break;
        case 6:
          _context8.prev = 6;
          _context8.t0 = _context8["catch"](0);
          runOnce(function () {
            log.debug("get media statistic stats error, fallback to default", _context8.t0);
          }, "getStats error");
          return _context8.abrupt("return", []);
        case 10:
          if (report) {
            _context8.next = 13;
            break;
          }
          runOnce(function () {
            log.debug("get null media statistic stats, fallback to default");
          }, "getStats error");
          return _context8.abrupt("return", []);
        case 13:
          items = _toConsumableArray(report.values());
          stats = core.subscribedTracks.map(function (track) {
            var mediaTrack = track.mediaTrack;
            var trackItem = items.find(function (item) {
              return item.type === StatsReportType.Track && item.trackIdentifier === mediaTrack.id;
            });
            if (!trackItem) return undefined;
            var inboundItem = items.find(function (item) {
              return item.type === StatsReportType.InBoundRtp && item.trackId === trackItem.id;
            });
            if (!inboundItem) return undefined;
            return {
              time: Date.now(),
              trackID: track.info.trackID,
              kind: inboundItem.kind === "video" ? "video" : "audio",
              framesDecoded: inboundItem.framesDecoded || -1,
              totalSamplesReceived: inboundItem.totalSamplesReceived || -1
            };
          }).filter(isDefined);
          return _context8.abrupt("return", stats);
        case 16:
        case "end":
          return _context8.stop();
      }
    }, _callee7, null, [[0, 6]]);
  }));
}
function getMediaStatisticStats(pc, core) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var report, reportList, statisticReports;
    return _regeneratorRuntime().wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return pc.getStats();
        case 3:
          report = _context9.sent;
          _context9.next = 10;
          break;
        case 6:
          _context9.prev = 6;
          _context9.t0 = _context9["catch"](0);
          log.debug("get media statistic stats error, fallback to default", _context9.t0);
          return _context9.abrupt("return", []);
        case 10:
          if (report) {
            _context9.next = 13;
            break;
          }
          log.debug("get null media statistic stats, fallback to default");
          return _context9.abrupt("return", []);
        case 13:
          reportList = _toConsumableArray(report.values());
          statisticReports = reportList.filter(function (reportItem) {
            return (reportItem.type === StatsReportType.InBoundRtp || reportItem.type === StatsReportType.OutBoundRtp) && (reportList.find(function (item) {
              return item.id === reportItem.trackId && item.type === 'track';
            }) || reportList.find(function (item) {
              return item.id === reportItem.mediaSourceId && item.type === 'media-source';
            }));
          }).map(function (item) {
            return createStatisticReport(item, reportList, core);
          });
          return _context9.abrupt("return", statisticReports);
        case 16:
        case "end":
          return _context9.stop();
      }
    }, _callee8, null, [[0, 6]]);
  }));
}
function parseVideoInOutBound(item, report) {
  report.kind = item.kind;
  report.extra_stats.nack_count = item.nackCount;
  report.extra_stats.fir_count = item.firCount;
  report.extra_stats.pli_count = item.pliCount;
  report.extra_stats.bytes_sent = item.bytesSent || 0;
  report.extra_stats.frame_encoded = item.framesEncoded || 0;
  report.extra_stats.bytes_received = item.bytesReceived || 0;
  report.extra_stats.frame_decoded = item.framesDecoded || 0;
  report.calculation_stats.bytes_received = item.bytesReceived || 0;
  report.calculation_stats.bytes_sent = item.bytesSent || 0;
  report.calculation_stats.packets_received = item.packetsReceived || 0;
  report.calculation_stats.packets_sent = item.packetsSent || 0;
  report.calculation_stats.timestamp = item.timestamp || 0;
  return report;
}
function parseVideoMediaSource(item, report) {
  report.framerate = item.framesPerSecond;
  return report;
}
function parseVideoTrack(item, report, core) {
  var pcTracks = [].concat(_toConsumableArray(core.publishedTracks), _toConsumableArray(core.subscribedTracks));
  var currentTrack = pcTracks.find(function (track) {
    return track.mediaTrack.id === item.trackIdentifier;
  });
  report.track_id = currentTrack ? currentTrack.info ? currentTrack.info.trackID || "" : "" : "";
  report.extra_stats.width = item.frameWidth;
  report.extra_stats.height = item.frameHeight;
  report.extra_stats.jitter_buffer_delay = item.jitterBufferDelay || 0;
  report.calculation_stats.frames_sent = item.framesSent || 0;
  report.calculation_stats.frames_received = item.framesReceived || 0;
  return report;
}
function checkAudioLevel(audioLevel, type) {
  var result = audioLevel || 0;
  var unusualBorwserVersion = {
    chrome: ['86.0.4240', '87.0.4280']
  };
  if (unusualBorwserVersion[browser.name] && unusualBorwserVersion[browser.name].includes(browser.version) && type === StatsReportType.InBoundRtp) {
    // 某些浏览器的bug，当类型是inbound时，获取的audioLevel大于一 https://bugs.chromium.org/p/chromium/issues/detail?id=1142626&q=audioLevel&can=1
    result = Math.min(audioLevel / 32767, 1);
    WebSDKException.create({
      code: ExceptionStatus.AudioLevelUnusual,
      actual_value: audioLevel,
      extra_info: {
        stats_report_type: type
      }
    });
  } else if (result > 1 || result < 0) {
    WebSDKException.create({
      code: ExceptionStatus.AudioLevelUnusual,
      actual_value: audioLevel,
      extra_info: {
        stats_report_type: type
      }
    });
  }
  return result;
}
function parseAudioInOutBound(item, report) {
  report.kind = item.kind;
  report.extra_stats.bytes_sent = item.bytesSent || 0;
  report.extra_stats.bytes_received = item.bytesReceived || 0;
  report.extra_stats.track_audio_volume = checkAudioLevel(item.audioLevel, item.type);
  report.calculation_stats.bytes_received = item.bytesReceived || 0;
  report.calculation_stats.bytes_sent = item.bytesSent || 0;
  report.calculation_stats.packets_received = item.packetsReceived || 0;
  report.calculation_stats.packets_sent = item.packetsSent || 0;
  report.calculation_stats.timestamp = item.timestamp || 0;
  return report;
}
function parseAudioMediaSource(item, report) {
  report.extra_stats.track_audio_volume = checkAudioLevel(item.audioLevel, item.type);
  return report;
}
function parseAudioTrack(item, report, core) {
  var pcTracks = [].concat(_toConsumableArray(core.publishedTracks), _toConsumableArray(core.subscribedTracks));
  var currentTrack = pcTracks.find(function (track) {
    return track.mediaTrack.id === item.trackIdentifier;
  });
  report.track_id = currentTrack ? currentTrack.info ? currentTrack.info.trackID || "" : "" : "";
  report.extra_stats.jitter_buffer_delay = item.jitterBufferDelay || 0;
  report.calculation_stats.frames_sent = item.framesSent || 0;
  report.calculation_stats.frames_received = item.framesReceived || 0;
  return report;
}
/** get rtt(round trip time) from one type data of RTCStatsReport
 *
 * Rtt was in outbound-rtp or inbound-rtp in older versions of chrome and Firefox and now in remote-inbound-rtp.
 * see https://github.com/w3c/webrtc-stats/pull/167 and https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/55#WebRTC
 *
 * Older versions of Chrome and Firefox implement prefix version of rtt,
 * which is googRtt in Chrome and mozRtt in Firefox, and using milliseconds as unit.
 * Now its roundTripTime and it uses seconds.
 * see https://github.com/w3c/webrtc-stats/pull/44/commits and https://groups.google.com/g/discuss-webrtc/c/xp4dMYElqBQ
 *
 * @param item one type data of RTCStatsReport
 * @returns value of rtt in miliseconds and undefined for not found
 */
function getRtt(item) {
  if (!item) return;
  if (item.roundTripTime) {
    return item.roundTripTime * 1000;
  }
  if (item.googRtt) {
    return item.googRtt;
  }
  if (item.mozRtt) {
    return item.mozRtt;
  }
}
/** get packetsLost from one type data of RTCStatsReport
 *
 * if item.type === "outbound-rtp", then packetsLost is in remote-inbound-rtp.packetsLost
 * if item.type === "inbound-rtp", then packetsLost is in inbound-rtp.packetsLost
 *
 * item/remoteItem: one type data of RTCStatsReport
 * @param item "inbound-rtp" | "outbound-rtp"
 * @param remoteItem "remote-inbound-rtp" | undefined
 * @returns packetsLost
 */
function getPacketsLost(item, remoteItem) {
  if (item.type === "inbound-rtp") {
    return item.packetsLost;
  }
  if (item.type === "outbound-rtp" && remoteItem) {
    return remoteItem.packetsLost;
  }
}
/**
 * Note that:
 * - packetsLost means total number of RTP packets lost for this SSRC and can be negative if more packets are received than sent.
 * - packetsTrans stands for packetsSent in outbound-rtp or packetsReceived in inbound-rtp.
 *   - packetsSent means total number of RTP packets sent for this SSRC.
 *   - packetsReceived means total number of RTP packets received for this SSRC.
 *
 * So we calculate packets lost rate by following math:
 *    packetsLostRate = difference of packetsLost between two gatherings / difference of packetsTrans between two gatherings
 */
function calculatePacketsLostRate(lastPacketsLost, currentPacketsLost, lastPacketsTrans, currentPacketsTrans) {
  var diffPacketsLost = currentPacketsLost - lastPacketsLost;
  var diffPacketsTrans = currentPacketsTrans - lastPacketsTrans;
  if (diffPacketsLost <= 0 || diffPacketsTrans <= 0) return 0;
  var packetsLostRate = diffPacketsLost / diffPacketsTrans;
  return packetsLostRate > 1 ? 1 : packetsLostRate;
}
function createStatisticReport(item, reports, core) {
  var reportMap = _defineProperty(_defineProperty(_defineProperty({}, StatsReportType.MediaSource, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.MediaSource;
  }).find(function (reportItem) {
    return reportItem.id === item.mediaSourceId;
  })), StatsReportType.Track, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.Track;
  }).find(function (reportItem) {
    return reportItem.id === item.trackId;
  })), StatsReportType.RemoteInBound, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.RemoteInBound;
  }).find(function (reportItem) {
    return reportItem.id === item.remoteId;
  }));
  var report = getDefaultMediaStatisticWithCalculationReport(item.id, item.trackID, item.mediaType);
  report.rtt = getRtt(reportMap[StatsReportType.RemoteInBound]) || getRtt(item) || 0;
  report.calculation_stats.packets_lost = getPacketsLost(item, reportMap[StatsReportType.RemoteInBound]) || 0;
  if (item.mediaType === MediaType.Video) {
    report = parseVideoInOutBound(item, report);
    if (reportMap[StatsReportType.MediaSource]) {
      report = parseVideoMediaSource(reportMap[StatsReportType.MediaSource], report);
    }
    if (reportMap[StatsReportType.Track]) {
      report = parseVideoTrack(reportMap[StatsReportType.Track], report, core);
    }
  } else {
    report = parseAudioInOutBound(item, report);
    if (reportMap[StatsReportType.MediaSource]) {
      report = parseAudioMediaSource(reportMap[StatsReportType.MediaSource], report);
    }
    if (reportMap[StatsReportType.Track]) {
      report = parseAudioTrack(reportMap[StatsReportType.Track], report, core);
    }
  }
  return report;
}
function calculationMediaStatisticReport(calculation, lastCalculation, expFilter) {
  if (!calculation || !lastCalculation) {
    return {
      framerate: 0,
      kbps: 0,
      packet_lost_rate: 0
    };
  }
  var gapTime = (calculation.timestamp - lastCalculation.timestamp) / 1000;
  var framerate = gapTime === 0 ? 0 : (calculation.frames_sent - lastCalculation.frames_sent + (calculation.frames_received - lastCalculation.frames_received)) / gapTime;
  var kbps = gapTime === 0 ? 0 : (calculation.bytes_sent - lastCalculation.bytes_sent + (calculation.bytes_received - lastCalculation.bytes_received)) / (gapTime * 1024 / 8);
  /**
   * Note that we do not distinguish send and receive here.
   * if it's inbound, then send should be 0, the reverse is the same.
   */
  var packetLostRate = calculatePacketsLostRate(lastCalculation.packets_lost, calculation.packets_lost, lastCalculation.packets_received + lastCalculation.packets_sent, calculation.packets_received + calculation.packets_sent);
  expFilter.Apply(packetLostRate);
  // scale value from 0-1 to 0-100
  var packet_lost_rate = expFilter.Filtered() < 0 ? 0 : expFilter.Filtered() * 100;
  return {
    framerate: Math.ceil(framerate),
    kbps: Math.ceil(kbps),
    packet_lost_rate: Math.ceil(packet_lost_rate)
  };
}
function createPC() {
  var rtcOptions = {
    bundlePolicy: "max-bundle",
    rtcpMuxPolicy: "require",
    iceServers: []
  };
  if (browserReport.unifiedPlan) {
    rtcOptions.sdpSemantics = "unified-plan";
  } else {
    rtcOptions.sdpSemantics = "plan-b";
  }
  var pc = new RTCPeerConnection(rtcOptions);
  if (browserReport.unifiedPlan && browserReport.supportTransceivers) {
    // stub transceiver is needed;
    pc.addTransceiver("audio", {
      direction: "inactive"
    });
    pc.addTransceiver("video", {
      direction: "inactive"
    });
  }
  return pc;
}
function addTransceiver(track, pc, lowStreamConfig) {
  var bitrate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 600;
  var stream = arguments.length > 4 ? arguments[4] : undefined;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var sendEncodings;
    return _regeneratorRuntime().wrap(function _callee9$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (lowStreamConfig) {
            _context10.next = 6;
            break;
          }
          _context10.next = 3;
          return pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [stream]
          });
        case 3:
          return _context10.abrupt("return", _context10.sent);
        case 6:
          sendEncodings = [{
            rid: "hi",
            active: true,
            maxBitrate: bitrate * 1000
          }, {
            rid: "lo",
            active: true,
            maxBitrate: lowStreamConfig.bitrate * 1000,
            scaleResolutionDownBy: lowStreamConfig.scaleResolutionDownBy
          }];
          _context10.next = 9;
          return pc.addTransceiver(track, {
            direction: "sendonly",
            sendEncodings: sendEncodings,
            streams: [stream]
          });
        case 9:
          return _context10.abrupt("return", _context10.sent);
        case 10:
        case "end":
          return _context10.stop();
      }
    }, _callee9);
  }));
}
function getPCStats(pc, track, pctype, lastReportList) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var stats;
    return _regeneratorRuntime().wrap(function _callee10$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          if (!browserReport.stats) {
            _context11.next = 7;
            break;
          }
          _context11.next = 3;
          return getStats(pc, track, pctype);
        case 3:
          stats = _context11.sent;
          return _context11.abrupt("return", getRateStats(stats, lastReportList));
        case 7:
          runOnce(function () {
            log.warning("your browser does not support getStats");
          }, "not-support-stats-warning");
          return _context11.abrupt("return", []);
        case 9:
        case "end":
          return _context11.stop();
      }
    }, _callee10);
  }));
}
function getRateStats(reportList, lastReportList) {
  if (!lastReportList || lastReportList.length === 0) {
    return reportList;
  }
  if (lastReportList.length !== reportList.length) {
    return reportList;
  }
  var groupedReportLists = Object.values(groupBy([].concat(_toConsumableArray(reportList), _toConsumableArray(lastReportList)), "id"));
  /** if there is no two report using the same id */
  if (!groupedReportLists.every(function (list) {
    return list.length === 2;
  })) {
    return reportList;
  }
  var newReportList = groupedReportLists.map(function (_ref) {
    var _ref7 = _slicedToArray(_ref, 2),
      report = _ref7[0],
      lastReport = _ref7[1];
    var time = (report.timestamp - lastReport.timestamp) / 1000;
    if (time <= 0) {
      return report;
    }
    var newReport = Object.assign({}, report);
    var packetLossRate = calculatePacketsLostRate(lastReport.packetLoss, report.packetLoss, lastReport.packets, report.packets);
    newReport.networkGrade = getNetworkGrade(packetLossRate, newReport.rtt);
    var filter = getReportExpFilter(report.id, report.kind);
    filter.Apply(packetLossRate);
    newReport.packetLossRate = filter.Filtered() < 0 ? 0 : filter.Filtered();
    newReport.bitrate = 8 * (report.bytes - lastReport.bytes) / time;
    if (newReport.bitrate < 0) {
      return lastReport;
    }
    return newReport;
  });
  return newReportList;
}
window.addEventListener("message", function (e) {
  if (e.origin !== window.location.origin) {
    return;
  }
  onMessageCallback(e.data);
});
// and the function that handles received messages
function onMessageCallback(data) {
  // "cancel" button is clicked
  if (data === "PermissionDeniedError") {
    chromeMediaSource = "PermissionDeniedError";
    if (screenCallback) {
      return screenCallback("PermissionDeniedError");
    } else {
      throw SCREEN_PERMISSION_DENIED();
    }
  }
  // extension notified his presence
  if (data === "qnrtc:rtcmulticonnection-extension-loaded") {
    chromeMediaSource = "desktop";
  }
  // old plugin version
  if (data === "rtcmulticonnection-extension-loaded") {
    log.warning("your chrome screen sharing plugin is not the latest version, or you have other screen sharing plugins.");
    isLatestVersion = false;
  }
  // extension shared temp sourceId
  if (data.sourceId && screenCallback) {
    screenCallback(sourceId = data.sourceId, data.canRequestAudioTrack === true);
  }
}
// global variables
var chromeMediaSource = "screen";
var isLatestVersion = true;
var sourceId;
var screenCallback;
function _isChromeExtensionAvailable() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var promise;
    return _regeneratorRuntime().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          promise = function promise() {
            return new Promise(function (resolve, reject) {
              if (chromeMediaSource === "desktop") {
                resolve(true);
                return;
              }
              // ask extension if it is available
              window.postMessage("qnrtc:are-you-there", "*");
              setTimeout(function () {
                if (chromeMediaSource === "screen") {
                  resolve(false);
                } else {
                  resolve(true);
                }
              }, 2000);
            });
          };
          _context12.next = 3;
          return promise();
        case 3:
          return _context12.abrupt("return", _context12.sent);
        case 4:
        case "end":
          return _context12.stop();
      }
    }, _callee11);
  }));
}
// this function can be used to get "source-id" from the extension
function getSourceId(callback) {
  var screenOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var windowOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  screenCallback = callback;
  if (screenOnly) {
    window.postMessage("qnrtc:get-sourceId-screen", "*");
    return;
  }
  if (windowOnly) {
    window.postMessage("qnrtc:get-sourceId-window", "*");
    return;
  }
  window.postMessage("qnrtc:get-sourceId", "*");
}
// this function can be used to get "source-id" from the extension
function getSourceIdWithAudio(callback) {
  if (sourceId) {
    return callback(sourceId);
  }
  screenCallback = callback;
  window.postMessage("qnrtc:audio-plus-tab", "*");
}
// this function explains how to use above methods/objects
function getScreenConstraints(captureSourceIdWithAudio, screen) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var source, contraintPromise;
    return _regeneratorRuntime().wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          source = screen.source;
          contraintPromise = function contraintPromise() {
            return new Promise(function (resolve, reject) {
              var firefoxScreenConstraints = {
                mozMediaSource: source || "window",
                mediaSource: source || "window",
                height: screen.height,
                width: screen.width
              };
              if (isFirefox) {
                resolve(firefoxScreenConstraints);
                return;
              }
              // this statement defines getUserMedia constraints
              // that will be used to capture content of screen
              var screen_constraints = {
                mandatory: {
                  chromeMediaSource: chromeMediaSource,
                  maxWidth: getNumberRangeMax(screen.width),
                  maxHeight: getNumberRangeMax(screen.height)
                },
                optional: []
              };
              // this statement verifies chrome extension availability
              // if installed and available then it will invoke extension API
              // otherwise it will fallback to command-line based screen capturing API
              if (chromeMediaSource === "desktop") {
                if (captureSourceIdWithAudio) {
                  getSourceIdWithAudio(function (sourceId, canRequestAudioTrack) {
                    screen_constraints.mandatory.chromeMediaSourceId = sourceId;
                    if (canRequestAudioTrack) {
                      screen_constraints.canRequestAudioTrack = true;
                    }
                    if (sourceId === "PermissionDeniedError") {
                      reject(SCREEN_PERMISSION_DENIED());
                      return;
                    }
                    resolve(screen_constraints);
                    return;
                  });
                } else {
                  getSourceId(function (sourceId) {
                    screen_constraints.mandatory.chromeMediaSourceId = sourceId;
                    if (sourceId === "PermissionDeniedError") {
                      reject(SCREEN_PERMISSION_DENIED());
                      return;
                    }
                    resolve(screen_constraints);
                    return;
                  }, source === "screen", source === "window");
                }
                return;
              }
              resolve(screen_constraints);
            });
          };
          _context13.next = 4;
          return contraintPromise();
        case 4:
          return _context13.abrupt("return", _context13.sent);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee12);
  }));
}
function createScreenSelectionUI(sources) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    return _regeneratorRuntime().wrap(function _callee13$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", new Promise(function (resolve, reject) {
            var container = document.createElement("div");
            container.setAttribute('style', "position: fixed; z-index: 99999999; top: 50%; left: 50%; width: 620px; height: 525px; background: #ECECEC; border-radius: 4px; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%);");
            var title = document.createElement("div");
            title.setAttribute('style', "text-align: center; height: 25px; line-height: 25px; border-radius: 4px 4px 0 0; background: #D4D2D4; border-bottom:  solid 1px #B9B8B9;");
            title.innerText = "share screen";
            var contentContainer = document.createElement("div");
            contentContainer.setAttribute('style', "width: 100%; height: 500px; padding: 15px 25px ; box-sizing: border-box;");
            container.appendChild(title);
            container.appendChild(contentContainer);
            var desc = document.createElement("div");
            desc.setAttribute('style', "height: 12%;");
            desc.innerText = "QiNiu Web Screensharing wants to share the contents. Choose what you'd like to share.";
            var sourcesContainer = document.createElement("div");
            sourcesContainer.setAttribute('style', "width: 100%; height: 80%; background: #FFF; border:  solid 1px #CBCBCB; display: flex; flex-wrap: wrap; justify-content: space-around; overflow-y: scroll; padding: 0 15px; box-sizing: border-box;");
            var cancelBtn = document.createElement("button");
            cancelBtn.setAttribute('style', "width: 85px;");
            cancelBtn.innerText = "cancel";
            cancelBtn.onclick = function () {
              document.body.removeChild(container);
              reject(ERROR_DEVICE_NOT_ALLOWED("user cancel selection"));
            };
            var cancelBtnContainer = document.createElement("div");
            cancelBtnContainer.setAttribute('style', "text-align: right; padding: 16px 0;");
            cancelBtnContainer.appendChild(cancelBtn);
            contentContainer.appendChild(desc);
            contentContainer.appendChild(sourcesContainer);
            contentContainer.appendChild(cancelBtnContainer);
            var _iterator4 = _createForOfIteratorHelper(sources),
              _step4;
            try {
              var _loop = function _loop() {
                var source = _step4.value;
                var sourceContainer = document.createElement("div");
                sourceContainer.setAttribute('style', "width: 30%; height: 160px; padding: 20px 0; text-align: center;box-sizing: content-box;");
                sourceContainer.onclick = function () {
                  document.body.removeChild(container);
                  resolve(source.ID);
                };
                var iconContainer = document.createElement("div");
                iconContainer.setAttribute('style', "height: 120px; display: table-cell; vertical-align: middle;");
                var icon = document.createElement("img");
                icon.setAttribute('style', "width: 100%; background: #333333; box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);");
                icon.src = source.url;
                iconContainer.appendChild(icon);
                var sourceDesc = document.createElement("div");
                sourceDesc.setAttribute('style', "height: 40px; line-height: 40px; display: inline-block; width: 70%; word-break: keep-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;");
                sourceDesc.innerText = source.name;
                sourceContainer.appendChild(iconContainer);
                sourceContainer.appendChild(sourceDesc);
                sourcesContainer.appendChild(sourceContainer);
              };
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            document.body.appendChild(container);
          }));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee13);
  }));
}
var User = /*#__PURE__*/function () {
  function User(userID, userData) {
    _classCallCheck(this, User);
    /**
     * 指这个用户在本地的 Track 对象，一般用来播放
     */
    this.tracks = [];
    /**
     * 指这个用户在这个房间内已经发布的流信息，一般用来发起订阅
     */
    this.publishedTrackInfo = [];
    this.userID = userID;
    this.userData = userData;
  }
  /**
   * 只要有 track 就认为其已经发布
   */
  _createClass(User, [{
    key: "addTracks",
    /* @internal */value: function addTracks(tracks) {
      var _this11 = this;
      this.tracks = this.tracks.concat(tracks);
      this.tracks = uniqBy(this.tracks, "mediaTrack");
      var _iterator5 = _createForOfIteratorHelper(this.tracks),
        _step5;
      try {
        var _loop2 = function _loop2() {
          var track = _step5.value;
          track.once("release", function () {
            remove(_this11.tracks, function (t) {
              return t === track;
            });
          });
        };
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    } /* @internal */
  }, {
    key: "removeTracksByTrackId",
    value: function removeTracksByTrackId(trackIDs) {
      remove(this.tracks, function (track) {
        if (!track.info.trackID) return false;
        return trackIDs.indexOf(track.info.trackID) !== -1;
      });
    } /* @internal */
  }, {
    key: "addPublishedTrackInfo",
    value: function addPublishedTrackInfo(info) {
      this.publishedTrackInfo = this.publishedTrackInfo.concat(info);
      this.publishedTrackInfo = uniqBy(this.publishedTrackInfo, "trackID");
    } /* @internal */
  }, {
    key: "removePublishedTrackInfo",
    value: function removePublishedTrackInfo(trackIDs) {
      remove(this.publishedTrackInfo, function (info) {
        return trackIDs.indexOf(info.trackID) !== -1;
      });
    }
  }, {
    key: "published",
    get: function get() {
      return this.publishedTrackInfo.length > 0;
    }
  }]);
  return User;
}();
function createAudioElement(track) {
  var audio = document.createElement("audio");
  var stream = new MediaStream([track]);
  audio.style.visibility = "hidden";
  audio.className = "qnrtc-audio-player qnrtc-stream-player";
  audio.dataset.localid = track.id;
  audio.srcObject = stream;
  audio.autoplay = true;
  return {
    element: audio,
    stream: stream
  };
}
function createVideoElement(track) {
  var video = document.createElement("video");
  var stream = new MediaStream([track]);
  video.style.width = "100%";
  video.style.height = "100%";
  video.style.objectFit = "contain";
  video.muted = true;
  video.className = "qnrtc-video-player qnrtc-stream-player";
  video.dataset.localid = track.id;
  video.setAttribute("playsinline", true);
  video.autoplay = true;
  video.srcObject = stream;
  if (isIOS) {
    video.setAttribute("controls", true);
    nextTick(function () {
      if (video && video.srcObject) {
        video.removeAttribute("controls");
      }
    });
  }
  return {
    element: video,
    stream: stream
  };
}
function webAudioUnlock(context) {
  return new Promise(function (resolve, reject) {
    if (context.state === "suspended") {
      log.log("audio context state is suspended");
      var unlock = function unlock() {
        context.resume().then(function () {
          document.body.removeEventListener("touchstart", unlock);
          document.body.removeEventListener("touchend", unlock);
          document.body.removeEventListener("mousedown", unlock);
          document.body.removeEventListener("mouseup", unlock);
          resolve(true);
        }).catch(reject);
      };
      document.body.addEventListener("touchstart", unlock, true);
      document.body.addEventListener("touchend", unlock, true);
      document.body.addEventListener("mousedown", unlock, true);
      document.body.addEventListener("mouseup", unlock, true);
      unlock();
    } else {
      resolve(false);
    }
  });
}
function getFrameFromVideo(video) {
  var canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return "data:,";
  }
  ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  return canvas.toDataURL();
}
var EnhancedEventEmitter = /*#__PURE__*/function (_EventEmitter3) {
  _inherits(EnhancedEventEmitter, _EventEmitter3);
  function EnhancedEventEmitter() {
    _classCallCheck(this, EnhancedEventEmitter);
    return _possibleConstructorReturn(this, _getPrototypeOf(EnhancedEventEmitter).apply(this, arguments));
  }
  _createClass(EnhancedEventEmitter, [{
    key: "safeEmit",
    value: function safeEmit(event) {
      try {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        this.emit.apply(this, [event].concat(args));
      } catch (error) {
        log.warning("safeEmit() | event listener threw an error [event:%s]:%o", event, error);
      }
    }
  }, {
    key: "safeEmitAsPromise",
    value: function safeEmitAsPromise(event) {
      var _this12 = this;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      return new Promise(function (resolve, reject) {
        var callback = resolve;
        var errback = function errback(error) {
          log.warning("safeEmitAsPromise() | errback called [event:%s]:%o", event, error);
          reject(error);
        };
        _this12.safeEmit.apply(_this12, [event].concat(args, [callback, errback]));
      });
    }
  }]);
  return EnhancedEventEmitter;
}(EventEmitter);
function playTrack(mediaElement) {
  var _this13 = this;
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  var playFunc = function playFunc() {
    return __awaiter(_this13, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      return _regeneratorRuntime().wrap(function _callee14$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (QNRTC$1.deviceManager && QNRTC$1.deviceManager.currentPlaybackDeviceID) {
              //@ts-ignore
              mediaElement.setSinkId && mediaElement.setSinkId(QNRTC$1.deviceManager.currentPlaybackDeviceID);
            }
            if (!mediaElement.paused) {
              _context15.next = 3;
              break;
            }
            return _context15.abrupt("return", mediaElement.play());
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee14);
    }));
  };
  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      playFunc().then(resolve).catch(reject);
    }, timeout);
    mediaElement.onloadedmetadata = function () {
      clearTimeout(timeoutID);
      playFunc().then(resolve).catch(reject);
    };
    if ('WeixinJSBridge' in window) {
      window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
        playFunc().then(resolve).catch(noop);
      }, false);
    } else {
      document.addEventListener('WeixinJSBridgeReady', function () {
        playFunc().then(resolve).catch(noop);
      }, false);
    }
  });
}
var Track = /*#__PURE__*/function (_EnhancedEventEmitter) {
  _inherits(Track, _EnhancedEventEmitter);
  _createClass(Track, [{
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(deviceId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!browserReport.setPlaybackDevice) {
                ERROR_NOT_SUPPORT("setPlaybackDevice api not support");
              }
              this.playbackDevice = deviceId;
              if (!this.mediaElement) {
                _context16.next = 4;
                break;
              }
              return _context16.abrupt("return", this.mediaElement.setSinkId(deviceId));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee15, this);
      }));
    }
  }]);
  function Track(track, userID, direction, profiles) {
    var _this14;
    _classCallCheck(this, Track);
    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(Track).call(this));
    _this14.master = false;
    _this14.stats = [];
    // 当前 track 是否被替换成了 image track
    _this14.isReplacedByImageTrack = false;
    /**
     * @internal
     */
    _this14.direction = "local";
    _this14.sourceType = TrackSourceType.NORMAL;
    /* @internal */
    _this14.onended = function (event) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this14)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!(this.direction === "local")) {
                _context17.next = 10;
                break;
              }
              log.warning("track ended", this.mediaTrack, this.info.trackID);
              if (!(this.info.trackID && this._selfEndedCallback)) {
                _context17.next = 5;
                break;
              }
              _context17.next = 5;
              return this._selfEndedCallback([this.info.trackID]);
            case 5:
              this.emit("ended", event);
              qos.addEvent("TrackEnded", {
                track_id: this.info.trackID,
                kind: this.info.kind,
                label: this.mediaTrack.label,
                event_grade: QNEventGrade.SERVERE
              });
              this.release();
              _context17.next = 11;
              break;
            case 10:
              this.emit("@ended", event);
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee16, this);
      }));
    };
    _this14.mediaTrack = track;
    _this14.mediaTrack.addEventListener("ended", _this14.onended);
    _this14.userID = userID;
    if (direction) {
      _this14.direction = direction;
    }
    _this14.info = {
      kind: track.kind,
      muted: !track.enabled,
      userID: _this14.userID,
      versionid: 0,
      profiles: profiles || []
    };
    _this14.handleMediaPause = _this14.handleMediaPause.bind(_assertThisInitialized(_assertThisInitialized(_this14)));
    return _this14;
  }
  _createClass(Track, [{
    key: "play",
    value: function play(container, muted) {
      var _this15 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        mirror: false
      };
      return new Promise(function (resolve, reject) {
        _this15.removeMediaElement();
        var createEleFunc = _this15.info.kind === "video" ? createVideoElement : createAudioElement;
        var _createEleFunc = createEleFunc(_this15.mediaTrack),
          element = _createEleFunc.element,
          stream = _createEleFunc.stream;
        _this15.mediaElement = element;
        if (_this15.info.kind === "audio") {
          // 
          // if(this.direction === "remote") {
          //   this.remoteAudioHelper = new RemoteAudioHelper(stream, element);
          // }
          if (muted !== undefined) {
            _this15.mediaElement.muted = muted;
          }
        }
        if (config.mirror) {
          _this15.mediaElement.style.transform = 'rotateY(180deg)';
        } else {
          _this15.mediaElement.style.transform = '';
        }
        _this15.mediaElement.setAttribute("controls", true);
        container.appendChild(_this15.mediaElement);
        _this15.mediaElement.onplaying = function () {
          if (_this15.mediaElement) {
            _this15.mediaElement.onplaying = null;
          }
          resolve();
        };
        Promise.resolve().then(function () {
          _this15.mediaElement.removeAttribute("controls");
          if (_this15.playbackDevice) {
            return _this15.setPlaybackDevice(_this15.playbackDevice);
          }
        }).then(function () {
          playTrack(_this15.mediaElement).then(resolve).catch(function (playError) {
            var message = playError instanceof Error ? playError.name + ", " + playError.message : "play failed" + String(playError);
            if (playError.name === "NotAllowedError") {
              reject(ERROR_PLAY_NOT_ALLOWED(message));
              qos.addEvent("AutoplayFail", {
                track_id: _this15.info.trackID,
                local_id: _this15.mediaTrack.id,
                label: _this15.mediaTrack.label,
                kind: _this15.info.kind,
                reason: message,
                event_grade: QNEventGrade.SERVERE
              });
            } else {
              reject(ERROR_FATAL(message));
            }
          });
        });
      });
    }
  }, {
    key: "handleMediaPause",
    value: function handleMediaPause() {
      var _this16 = this;
      // auto play try after 900ms
      setTimeout(function () {
        return _this16.mediaElement.play().catch(showPlayWarn);
      }, 900);
    }
    /**
     * @internal
     * @description 根据当前 isReplacedByImageTrack 状态确定正在播放的 track
     */
  }, {
    key: "switchPlayingTrack",
    value: function switchPlayingTrack() {
      if (!this.mediaElement) return;
      if (this.isReplacedByImageTrack && this.imageStreamTrack) {
        this.mediaElement.srcObject = new MediaStream([this.imageStreamTrack.mediaTrack]);
      } else if (!this.isReplacedByImageTrack && this.mediaTrack) {
        this.mediaElement.srcObject = new MediaStream([this.mediaTrack]);
      } else {
        return;
      }
      if (!this.mediaElement.paused) {
        this.mediaElement.play().catch(showPlayWarn);
      }
    }
    /**
     * @internal
     */
  }, {
    key: "resume",
    value: function resume(track) {
      this.mediaTrack.removeEventListener("ended", this.onended);
      this.mediaTrack.stop();
      this.mediaTrack = track;
      this.mediaTrack.addEventListener("ended", this.onended);
      if (this.mediaElement) {
        var stream = new MediaStream([track]);
        this.mediaElement.dataset.localid = track.id;
        this.mediaElement.srcObject = stream;
      }
      this.removeAllListeners("@get-stats");
      this.resetStats();
    }
  }, {
    key: "getStats",
    value: function getStats() {
      if (!this.statsInterval) {
        this.startGetStatsInterval();
      }
      return this.stats;
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      if (!this.mediaElement || !(this.mediaElement instanceof HTMLVideoElement)) {
        return "data:,";
      }
      return getFrameFromVideo(this.mediaElement);
    }
    /**
     * 设置 Track 为 Master SDK只允许发布一路 Audio Track 和一路 Video Track
     * @param master 是否为master
     */
  }, {
    key: "setMaster",
    value: function setMaster(master) {
      this.master = master;
    }
    /**
     * @internal
     */
  }, {
    key: "setMute",
    value: function setMute(muted) {
      this.info.muted = muted;
      this.mediaTrack.enabled = !muted;
      this.emit("mute", muted);
    }
    /**
     * @internal
     */
  }, {
    key: "setKbps",
    value: function setKbps(v) {
      this.info.kbps = v;
    }
    /**
     * @internal
     */
  }, {
    key: "setInfo",
    value: function setInfo(info) {
      this.info = Object.assign(Object.assign({}, this.info), info);
    }
    /**
     * @internal
     */
  }, {
    key: "removeMediaElement",
    value: function removeMediaElement() {
      if (this.mediaElement) {
        this.mediaElement.removeEventListener("pause", this.handleMediaPause);
        this.mediaElement.remove();
        this.mediaElement = undefined;
      }
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release");
      this.removeAllListeners();
      if (this.statsInterval) {
        window.clearInterval(this.statsInterval);
      }
      // unified-plan 下订阅的 Track 会被复用，不能释放
      if (this.direction === "local" || !browserReport.unifiedPlan) {
        this.mediaTrack.stop();
      }
      this.removeMediaElement();
      if (this.imageStreamTrack) {
        this.imageStreamTrack.release();
        this.imageStreamTrack = undefined;
      }
      // 释放远端音频处理
      if (this.remoteAudioHelper) {
        this.remoteAudioHelper.release();
        this.remoteAudioHelper = undefined;
      }
    }
    /**
     * @internal
     * 重置 trackID 和 userID，在 unpublish 的时候会自动调用
     */
  }, {
    key: "reset",
    value: function reset() {
      this.info.trackID = undefined;
      this.info.userID = undefined;
      this.info.versionid = 0;
      this.userID = undefined;
      this.resetStats();
    }
    /**
     * @internal
     * 重置 stats，每当 pc 重新构建的时候调用
     */
  }, {
    key: "resetStats",
    value: function resetStats() {
      this.stats = [];
      this.lastStats = [];
    }
    /**
     * @internal
     */
  }, {
    key: "startGetStatsInterval",
    value: function startGetStatsInterval() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this17 = this;
        var getStatsFunc;
        return _regeneratorRuntime().wrap(function _callee18$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              getStatsFunc = function getStatsFunc() {
                return __awaiter(_this17, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
                  var handlers;
                  return _regeneratorRuntime().wrap(function _callee17$(_context18) {
                    while (1) switch (_context18.prev = _context18.next) {
                      case 0:
                        handlers = this.listeners("@get-stats");
                        if (!(!handlers || handlers.length === 0)) {
                          _context18.next = 3;
                          break;
                        }
                        return _context18.abrupt("return", []);
                      case 3:
                        _context18.next = 5;
                        return this.safeEmitAsPromise("@get-stats", this.lastStats);
                      case 5:
                        this.stats = _context18.sent;
                        this.lastStats = _toConsumableArray(this.stats);
                      case 7:
                      case "end":
                        return _context18.stop();
                    }
                  }, _callee17, this);
                }));
              };
              this.statsInterval = window.setInterval(getStatsFunc, 1000);
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "setVolume",
    /**
     * @abstract
     */
    value: function setVolume(value) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      log.warning("not implement");
      return new Uint8Array();
    }
    /**
     * @abstract
     */
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      log.warning("not implement");
      return new Uint8Array();
    }
    /**
     * @abstract
     */
  }, {
    key: "getVolume",
    value: function getVolume() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(val) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      log.warning("not implement");
      return 0;
    }
  }, {
    key: "selfEndedCallback",
    set: function set(cb) {
      this._selfEndedCallback = cb;
    }
  }]);
  return Track;
}(EnhancedEventEmitter);
function transferSignalingCustomMessageToCustomMessage(msg) {
  return {
    timestamp: msg.msgts,
    data: msg.text,
    userID: msg.playerid,
    type: msg.type,
    msgid: msg.msgid
  };
}
function transferSignalingTrackToTrackBaseInfo(track) {
  return {
    trackID: track.trackid,
    tag: track.tag,
    mid: track.mid || undefined,
    kind: track.kind,
    userID: track.playerid,
    muted: track.muted,
    versionid: track.versionid,
    profiles: track.profiles || []
  };
}
function transferTrackBaseInfoToSignalingTrack(track, isMaster) {
  return {
    trackid: track.trackID,
    mid: track.mid || undefined,
    kind: track.kind,
    master: isMaster,
    muted: !!track.muted,
    playerid: track.userID,
    tag: track.tag || "",
    versionid: track.versionid
  };
}
function transferTrackToPublishTrack(track) {
  if (!track.info.mid && browserReport.unifiedPlan) {
    throw ERROR_FATAL("can not find track mid!");
  }
  return {
    localid: track.mediaTrack.id,
    localmid: track.info.mid || undefined,
    master: track.master,
    kind: track.info.kind,
    kbps: track.info.kbps,
    tag: track.info.tag
  };
}
function transferSignalingUserToUser(sigUser) {
  return new User(sigUser.playerid, sigUser.playerdata);
}
function createCustomTrack(mediaTrack, tag, kbps) {
  var track;
  if (mediaTrack.kind === "audio") {
    track = new AudioTrack(mediaTrack);
    track.initAudioManager(true);
  } else {
    track = new Track(mediaTrack);
  }
  if (kbps) {
    track.setKbps(kbps);
  }
  track.setInfo({
    tag: tag
  });
  return track;
}
function transferRecordOptionToMediaConstraints(options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var screenOptions, plugin, audio, video, constraints;
    return _regeneratorRuntime().wrap(function _callee19$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          if (options) {
            _context20.next = 2;
            break;
          }
          return _context20.abrupt("return", {
            audio: true,
            video: true
          });
        case 2:
          if (!REC_SCREEN_ENABLE(options)) {
            _context20.next = 14;
            break;
          }
          if (!REC_VIDEO_ENABLE(options)) {
            _context20.next = 5;
            break;
          }
          throw ERROR_FATAL("can not get mediaStream with video and screen are all enabled");
        case 5:
          if (browserReport.screenSharing) {
            _context20.next = 7;
            break;
          }
          throw ERROR_NOT_SUPPORT("your browser can not share screen");
        case 7:
          screenOptions = options.screen; // 只有在 chrome 下，用户强制指定用插件或者用户不支持 plugin free 采集才会检查插件
          if (!(isChrome && (screenOptions.forceChromePlugin || !browserReport.getDisplayMedia))) {
            _context20.next = 14;
            break;
          }
          _context20.next = 11;
          return _isChromeExtensionAvailable();
        case 11:
          plugin = _context20.sent;
          if (plugin) {
            _context20.next = 14;
            break;
          }
          throw ERROR_PLUGIN_NOT_AVAILABLE("");
        case 14:
          audio = !options.audio || !options.audio.enabled || !!options.audio.source ? false : {
            deviceId: options.audio.deviceId,
            sampleRate: options.audio.sampleRate,
            sampleSize: options.audio.sampleSize,
            channelCount: options.audio.channelCount,
            autoGainControl: options.audio.autoGainControl,
            echoCancellation: options.audio.echoCancellation,
            noiseSuppression: options.audio.noiseSuppression
          };
          video = !options.video || !options.video.enabled ? false : {
            frameRate: options.video.frameRate,
            height: options.video.height,
            width: options.video.width,
            deviceId: options.video.deviceId,
            facingMode: options.video.facingMode
          };
          if (!(REC_SCREEN_ENABLE(options) && options.screen)) {
            _context20.next = 23;
            break;
          }
          if (!(browserReport.getDisplayMedia && !options.screen.forceChromePlugin)) {
            _context20.next = 19;
            break;
          }
          return _context20.abrupt("return", createConstraints({
            audio: audio,
            video: {
              displaySurface: getDisplaySurfaceFromSourceOption(options.screen.source),
              width: options.screen.width,
              height: options.screen.height,
              frameRate: options.screen.frameRate
            }
          }));
        case 19:
          _context20.next = 21;
          return getScreenConstraints(false, options.screen);
        case 21:
          constraints = _context20.sent;
          return _context20.abrupt("return", createConstraints({
            audio: audio,
            video: constraints
          }));
        case 23:
          return _context20.abrupt("return", createConstraints({
            audio: audio,
            video: video
          }));
        case 24:
        case "end":
          return _context20.stop();
      }
    }, _callee19);
  }));
}
function getDisplaySurfaceFromSourceOption(opt) {
  switch (opt) {
    case "window":
      return "application";
    case "screen":
      return ["window", "monitor"];
    default:
      return undefined;
  }
}
var createConstraints = function createConstraints(constraints) {
  return deleteConstraintsEmptyObject(processConstraints(removeUndefinedKey(constraints)));
};
function processConstraints(constraints) {
  if (browserReport.minMaxWithIdeal) {
    return constraints;
  }
  var keys = ["video", "screen"];
  keys.forEach(function (key) {
    if (typeof constraints[key] === "object" && typeof constraints[key].width === "object" && constraints[key].width.ideal) {
      delete constraints[key].width.ideal;
    }
    if (typeof constraints[key] === "object" && typeof constraints[key].height === "object" && constraints[key].height.ideal) {
      delete constraints[key].height.ideal;
    }
  });
  return constraints;
}
// fix old chrome
function deleteConstraintsEmptyObject(constraints) {
  if (Object.keys(constraints.audio).length === 0 && typeof constraints.audio !== "boolean") {
    constraints.audio = true;
  }
  if (Object.keys(constraints.video).length === 0 && typeof constraints.video !== "boolean") {
    constraints.video = true;
  }
  return constraints;
}
function getNumberRangeMax(range) {
  if (!range) {
    return undefined;
  }
  if (typeof range === "number") {
    return range;
  }
  if (range.exact) {
    return range.exact;
  }
  if (range.max) {
    return range.max;
  }
  if (range.ideal) {
    return range.ideal;
  }
  if (range.min) {
    return range.min;
  }
  return undefined;
}
var NEW_LINE = "\n";
var REMOTE_SERVER_NAME = "qiniu-rtc-client";
function iceCandidates2Candidates(iceCandidates) {
  return iceCandidates.map(function (iceCandidate) {
    var candidate = {
      component: 1,
      foundation: iceCandidate.foundation,
      ip: iceCandidate.ip,
      port: iceCandidate.port,
      priority: iceCandidate.priority,
      transport: iceCandidate.protocol,
      type: iceCandidate.type
    };
    if (iceCandidate.tcpType) {
      candidate.tcptype = iceCandidate.tcpType;
    }
    return candidate;
  });
}
var RemoteSdp = /*#__PURE__*/function () {
  _createClass(RemoteSdp, [{
    key: "transportRemoteParameters",
    get: function get() {
      return this._transportRemoteParameters;
    }
  }]);
  function RemoteSdp(direction, rtpcap) {
    _classCallCheck(this, RemoteSdp);
    this.lastSubMids = [];
    this.sessionVersion = 0;
    this.direction = direction;
    this.extendedRtpCapabilities = rtpcap;
  }
  _createClass(RemoteSdp, [{
    key: "setTransportRemoteParameters",
    value: function setTransportRemoteParameters(remoteParameters) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _iterator6, _step6, candidate;
        return _regeneratorRuntime().wrap(function _callee20$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(remoteParameters.iceCandidates);
              _context21.prev = 1;
              _iterator6.s();
            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context21.next = 10;
                break;
              }
              candidate = _step6.value;
              _context21.next = 7;
              return resolveIceHost(candidate.ip);
            case 7:
              candidate.ip = _context21.sent;
            case 8:
              _context21.next = 3;
              break;
            case 10:
              _context21.next = 15;
              break;
            case 12:
              _context21.prev = 12;
              _context21.t0 = _context21["catch"](1);
              _iterator6.e(_context21.t0);
            case 15:
              _context21.prev = 15;
              _iterator6.f();
              return _context21.finish(15);
            case 18:
              this._transportRemoteParameters = remoteParameters;
            case 19:
            case "end":
              return _context21.stop();
          }
        }, _callee20, this, [[1, 12, 15, 18]]);
      }));
    }
  }, {
    key: "createRemoteAnswer",
    value: function createRemoteAnswer(offer, midRidEncoding, removeMids) {
      log.log("create remote answer", midRidEncoding, removeMids);
      if (!this.transportRemoteParameters) throw ERROR_FATAL("no transportRemoteParameters!");
      if (browserReport.unifiedPlan) {
        return createUnifiedPlanAnswerSdp(this.extendedRtpCapabilities, this.transportRemoteParameters, offer, midRidEncoding, removeMids);
      } else {
        return createPlanBAnswerSdp(this.extendedRtpCapabilities, this.transportRemoteParameters, offer);
      }
    }
  }, {
    key: "createRemoteOffer",
    value: function createRemoteOffer(consumerInfos) {
      if (!this.transportRemoteParameters) throw ERROR_FATAL("no transportRemoteParameters!");
      if (browserReport.unifiedPlan) {
        var sortedConsumerInfos = sortConsumerInfos(consumerInfos, this.lastSubMids);
        this.lastSubMids = sortedConsumerInfos.map(function (c) {
          return c.mid;
        });
        this.sessionVersion += 1;
        return createUnifiedPlanOfferSdp(sortedConsumerInfos, this.extendedRtpCapabilities, this.transportRemoteParameters, this.sessionVersion);
      } else {
        var kind = new Set();
        consumerInfos.forEach(function (c) {
          return kind.add(c.kind);
        });
        //  如果没有传入 consumerInfos 代表是创建 sub pc
        if (consumerInfos.length === 0) {
          kind.add("audio");
          kind.add("video");
        }
        return createPlanBOfferSdp(Array.from(kind), consumerInfos, this.extendedRtpCapabilities, this.transportRemoteParameters);
      }
    }
  }, {
    key: "updateICEData",
    value: function updateICEData(iceParameters, iceCandidates) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _iterator7, _step7, candidate;
        return _regeneratorRuntime().wrap(function _callee21$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (this.transportRemoteParameters) {
                _context22.next = 2;
                break;
              }
              return _context22.abrupt("return");
            case 2:
              _iterator7 = _createForOfIteratorHelper(iceCandidates);
              _context22.prev = 3;
              _iterator7.s();
            case 5:
              if ((_step7 = _iterator7.n()).done) {
                _context22.next = 12;
                break;
              }
              candidate = _step7.value;
              _context22.next = 9;
              return resolveIceHost(candidate.ip);
            case 9:
              candidate.ip = _context22.sent;
            case 10:
              _context22.next = 5;
              break;
            case 12:
              _context22.next = 17;
              break;
            case 14:
              _context22.prev = 14;
              _context22.t0 = _context22["catch"](3);
              _iterator7.e(_context22.t0);
            case 17:
              _context22.prev = 17;
              _iterator7.f();
              return _context22.finish(17);
            case 20:
              this.transportRemoteParameters.iceCandidates = iceCandidates;
              this.transportRemoteParameters.iceParameters = iceParameters;
            case 22:
            case "end":
              return _context22.stop();
          }
        }, _callee21, this, [[3, 14, 17, 20]]);
      }));
    }
  }]);
  return RemoteSdp;
}();
function checkH264(pc) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var offerOptions, offer;
    return _regeneratorRuntime().wrap(function _callee22$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          offerOptions = {
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
          };
          _context23.next = 3;
          return pc.createOffer(offerOptions);
        case 3:
          offer = _context23.sent;
          if (offer.sdp) {
            _context23.next = 8;
            break;
          }
          return _context23.abrupt("return", {
            isH264: false,
            sdp: ""
          });
        case 8:
          return _context23.abrupt("return", {
            isH264: offer.sdp.toLowerCase().indexOf('h264') === -1 ? false : true,
            sdp: offer.sdp
          });
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee22);
  }));
}
function getClientCapabilitiesSdp() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var pc, _yield$checkH, isH264, sdp, n, _yield$checkH2, capsdp;
    return _regeneratorRuntime().wrap(function _callee23$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          pc = createPC();
          _context24.next = 3;
          return checkH264(pc);
        case 3:
          _yield$checkH = _context24.sent;
          isH264 = _yield$checkH.isH264;
          sdp = _yield$checkH.sdp;
          n = 5;
        case 7:
          if (!(!isH264 && n > 0)) {
            _context24.next = 18;
            break;
          }
          pc.close();
          pc = createPC();
          _context24.next = 12;
          return checkH264(pc);
        case 12:
          _yield$checkH2 = _context24.sent;
          isH264 = _yield$checkH2.isH264;
          sdp = _yield$checkH2.sdp;
          n--;
          _context24.next = 7;
          break;
        case 18:
          if (browserReport.needH264FmtpLine) {
            sdp += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat(NEW_LINE);
          }
          // 注释移除 red 编码器的逻辑，服务端已提供支持
          // sdp = removeAudioREDLine(sdp);
          sdp = removeVideOrientation(sdp);
          capsdp = {
            capsdp: sdp,
            agent: navigator.userAgent
          };
          pc.close();
          return _context24.abrupt("return", capsdp);
        case 23:
        case "end":
          return _context24.stop();
      }
    }, _callee23);
  }));
}
function createPlanBAnswerSdp(rtpcaps, data, offer) {
  var sdpObj = sdpTransform.parse(offer);
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344376",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var newMedia = [];
  var _iterator8 = _createForOfIteratorHelper(sdpObj.media),
    _step8;
  try {
    var _loop3 = function _loop3() {
      var _mSection = _step8.value;
      var kind = _mSection.type;
      var codec = rtpcaps.codecs.find(function (c) {
        return c.kind === kind;
      });
      var headerExtensions = (rtpcaps.headerExtensions || []).filter(function (h) {
        return h.kind === kind;
      });
      if (!codec) throw ERROR_FATAL("can not find codec" + kind);
      var mSection = {
        type: kind,
        mid: kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: "recvonly",
        rtp: [{
          payload: codec.sendPayloadType,
          codec: codec.name,
          rate: codec.clockRate,
          encoding: codec.channels > 1 ? codec.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codec.sendPayloadType,
          config: Object.keys(codec.parameters).map(function (k) {
            return "".concat(k, "=").concat(codec.parameters[k], ";");
          }).join("")
        }],
        payloads: codec.sendPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.sendId
          };
        })
      };
      if (codec.rtcpFeedback && codec.rtcpFeedback.length > 0) {
        codec.rtcpFeedback.forEach(function (rf) {
          mSection.rtcpFb.push({
            payload: codec.sendPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }
      if (codec.sendRtxPayloadType) {
        mSection.rtp.push({
          payload: codec.sendRtxPayloadType,
          codec: "rtx",
          rate: codec.clockRate,
          encoding: codec.channels > 1 ? codec.channels : undefined
        });
        mSection.fmtp.push({
          payload: codec.sendRtxPayloadType,
          config: "apt=".concat(codec.sendPayloadType, ";")
        });
        mSection.payloads = "".concat(codec.sendPayloadType, " ").concat(codec.sendRtxPayloadType);
      }
      newMedia.push(mSection);
    };
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  sdpObj.media = newMedia;
  return sdpTransform.write(sdpObj);
}
/**
 * unified-plan 对 mid 顺序敏感，必须保证每次重协商顺序一致
 */
function sortConsumerInfos(infos, lastSubMids) {
  var newInfos = [];
  var _iterator9 = _createForOfIteratorHelper(lastSubMids),
    _step9;
  try {
    var _loop4 = function _loop4() {
      var mid = _step9.value;
      var info = remove(infos, function (i) {
        return i.mid === mid;
      })[0];
      if (!info) return 1; // continue
      newInfos.push(info);
    };
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      if (_loop4()) continue;
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  newInfos = newInfos.concat(infos);
  lastSubMids = newInfos.map(function (i) {
    return i.mid;
  });
  return newInfos;
}
function createUnifiedPlanOfferSdp(consumerInfos, rtpcaps, data, sessionVersion) {
  log.debug("createUnifiedPlanOfferSdp: consumerInfos", consumerInfos);
  var sdpObj = {};
  var mids = consumerInfos.map(function (i) {
    return i.mid;
  });
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344377",
    sessionVersion: sessionVersion,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  if (mids.length > 0) {
    sdpObj.groups = [{
      type: "BUNDLE",
      mids: mids.join(" ")
    }];
  }
  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iterator10 = _createForOfIteratorHelper(consumerInfos),
    _step10;
  try {
    var _loop5 = function _loop5() {
      var info = _step10.value;
      var codecs = info.kind === "audio" ? rtpcaps.codecs[0] : rtpcaps.codecs[1];
      var headerExtensions = rtpcaps.headerExtensions.filter(function (h) {
        return h.kind === info.kind;
      });
      var mediaObj = {
        type: info.kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: info.mid,
        msid: "".concat(info.streamId, " ").concat(info.trackID),
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: info.closed ? "inactive" : "sendonly",
        rtp: [{
          payload: codecs.recvPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.recvPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.recvPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: !info.closed ? headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.recvId
          };
        }) : [],
        ssrcs: !info.closed && info.ssrc ? [{
          id: info.ssrc,
          attribute: "cname",
          value: info.cname
        }
        /*
        {
          id: info.ssrc,
          attribute: "msid",
          value: `${info.streamId} ${info.trackID}`,
        }, {
          id: info.ssrc,
          attribute: "mslabel",
          value: info.streamId,
        }, {
          id: info.ssrc,
          attribute: "label",
          value: info.trackID,
        },
        */] : [],
        ssrcGroups: []
      };
      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          mediaObj.rtcpFb.push({
            payload: codecs.recvPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }
      if (codecs.recvRtxPayloadType) {
        mediaObj.rtp.push({
          payload: codecs.recvRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        mediaObj.fmtp.push({
          payload: codecs.recvRtxPayloadType,
          config: "apt=".concat(codecs.recvPayloadType, ";")
        });
        mediaObj.payloads = "".concat(codecs.recvPayloadType, " ").concat(codecs.recvRtxPayloadType);
      }
      addRelatedCodecs(info.kind, mediaObj, rtpcaps, codecs, true);
      if (info.rtxSsrc && !info.closed) {
        mediaObj.ssrcs = mediaObj.ssrcs.concat([{
          id: info.rtxSsrc,
          attribute: "cname",
          value: info.cname
        }
        /*
        {
          id: info.rtxSsrc,
          attribute: "msid",
          value: `${info.streamId} ${info.trackID}`,
        }, {
          id: info.rtxSsrc,
          attribute: "mslabel",
          value: info.streamId,
        }, {
          id: info.rtxSsrc,
          attribute: "label",
          value: info.trackID,
        },
        */]);
        mediaObj.ssrcGroups.push({
          semantics: "FID",
          ssrcs: "".concat(info.ssrc, " ").concat(info.rtxSsrc)
        });
      }
      sdpObj.media.push(mediaObj);
    };
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      _loop5();
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return sdpTransform.write(sdpObj);
}
/**
 * 配置额外的 sdp 协商信息，增加关联编码器 例如 red
 *
 * @param kind 媒体类型 audio video
 * @param mediaObj 协商信息对象
 * @param rtpcaps 服务端返回 rtp 配置
 * @param codecs 当前媒体的 codec 配置
 * @param isRecv 是否是接收方
 */
function addRelatedCodecs(kind, mediaObj, rtpcaps, codecs) {
  var isRecv = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var relatedCodecs = rtpcaps.codecs.filter(function (co) {
    return co.kind === kind && co.name !== codecs.name;
  });
  if (relatedCodecs.length > 0) {
    var codecPayloadType = isRecv ? codecs.recvPayloadType : codecs.sendPayloadType;
    var relatedPayloads = [];
    relatedCodecs.forEach(function (oc) {
      var relatedCodecPayloadType = isRecv ? oc.recvPayloadType : oc.sendPayloadType;
      relatedPayloads.push(relatedCodecPayloadType);
      mediaObj.rtp.push({
        payload: relatedCodecPayloadType,
        codec: oc.name,
        rate: oc.clockRate,
        encoding: oc.channels > 1 ? oc.channels : undefined
      });
      mediaObj.fmtp.push({
        payload: relatedCodecPayloadType,
        config: "".concat(codecPayloadType, "/").concat(codecPayloadType)
      });
    });
    mediaObj.payloads = "".concat(mediaObj.payloads, " ").concat(relatedPayloads.join(' '));
  }
}
function createUnifiedPlanAnswerSdp(rtpcaps, data, offer, midRidEncoding, removeMids) {
  var localSdpObj = sdpTransform.parse(offer);
  var sdpObj = {};
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344376",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iterator11 = _createForOfIteratorHelper(localSdpObj.media),
    _step11;
  try {
    var _loop6 = function _loop6() {
      var localMediaObj = _step11.value;
      var closed = localMediaObj.direction === "inactive";
      var kind = localMediaObj.type;
      var codecs = kind === "audio" ? rtpcaps.codecs[0] : rtpcaps.codecs[1];
      var headerExtensions = rtpcaps.headerExtensions.filter(function (h) {
        return h.kind === kind;
      });
      if (isSafari151) {
        // @ts-ignore
        headerExtensions.push({
          uri: "urn:3gpp:video-orientation",
          sendId: 13
        });
      }
      var remoteMediaObj = {
        type: localMediaObj.type,
        port: removeMids && removeMids.has(String(localMediaObj.mid)) ? 0 : 7,
        // set removed tracks port 0
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: localMediaObj.mid,
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: localMediaObj.direction === "sendonly" || localMediaObj.direction === "sendrecv" ? "recvonly" : "inactive",
        rtp: [{
          payload: codecs.sendPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.sendPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.sendPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.sendId
          };
        })
      };
      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          remoteMediaObj.rtcpFb.push({
            payload: codecs.sendPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }
      if (codecs.sendRtxPayloadType) {
        remoteMediaObj.rtp.push({
          payload: codecs.sendRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        remoteMediaObj.fmtp.push({
          payload: codecs.sendRtxPayloadType,
          config: "apt=".concat(codecs.sendPayloadType, ";")
        });
        remoteMediaObj.payloads = "".concat(codecs.sendPayloadType, " ").concat(codecs.sendRtxPayloadType);
      }
      // 增加关联编码器 比如 red
      addRelatedCodecs(kind, remoteMediaObj, rtpcaps, codecs);
      var profileEncodings = midRidEncoding[remoteMediaObj.mid];
      //fix:Firefox下 如果media是direction === 'inactive', rids和simulcast设置会出现解析错误
      if (remoteMediaObj.type === 'video' && profileEncodings && !closed) {
        remoteMediaObj.rids = [{
          id: "hi",
          direction: "recv"
        }, {
          id: "lo",
          direction: "recv"
        }];
        remoteMediaObj.simulcast = {
          dir1: "recv",
          list1: "hi;lo"
        };
      }
      sdpObj.media.push(remoteMediaObj);
    };
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      _loop6();
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
  var bundleMids = (localSdpObj.media || []).filter(function (m) {
    return m.hasOwnProperty("mid") && m.port !== 0;
  }).map(function (m) {
    return String(m.mid);
  });
  if (bundleMids.length > 0) {
    sdpObj.groups = [{
      type: "BUNDLE",
      mids: bundleMids.join(" ")
    }];
  }
  return sdpTransform.write(sdpObj);
}
function createPlanBOfferSdp(kinds, consumerInfos, rtpcaps, data) {
  log.debug("createPlanBOfferSdp: consumerInfos", consumerInfos, 'kinds', kinds);
  // 保证 audio 在 video 前
  kinds = ["audio", "video"];
  var sdpObj = {};
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344377",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.groups = [{
    type: "BUNDLE",
    mids: kinds.join(" ")
  }];
  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iterator12 = _createForOfIteratorHelper(kinds),
    _step12;
  try {
    var _loop7 = function _loop7() {
      var kind = _step12.value;
      var kindConsumerInfos = consumerInfos.filter(function (i) {
        return i.kind === kind;
      });
      var codecs = rtpcaps.codecs.find(function (c) {
        return c.kind === kind;
      });
      var headerExtensions = (rtpcaps.headerExtensions || []).filter(function (e) {
        return e.kind === kind;
      });
      if (!codecs) throw ERROR_FATAL("no codec" + kind);
      var mediaObj = {
        type: kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: kind,
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: "sendonly",
        rtp: [{
          payload: codecs.recvPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.recvPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.recvPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ssrcs: [],
        ssrcGroups: [],
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.recvId
          };
        })
      };
      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          mediaObj.rtcpFb.push({
            payload: codecs.recvPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }
      if (codecs.recvRtxPayloadType) {
        mediaObj.rtp.push({
          payload: codecs.recvRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        mediaObj.fmtp.push({
          payload: codecs.recvRtxPayloadType,
          config: "apt=".concat(codecs.recvPayloadType, ";")
        });
        mediaObj.payloads = "".concat(codecs.recvPayloadType, " ").concat(codecs.recvRtxPayloadType);
      }
      var _iterator13 = _createForOfIteratorHelper(kindConsumerInfos),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var info = _step13.value;
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "msid",
            value: "".concat(info.streamId, " ").concat(info.trackID)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "mslabel",
            value: "".concat(info.streamId)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "label",
            value: "".concat(info.trackID)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "cname",
            value: "".concat(info.cname)
          });
          if (info.rtxSsrc) {
            mediaObj.ssrcGroups.push({
              semantics: "FID",
              ssrcs: "".concat(info.ssrc, " ").concat(info.rtxSsrc)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "msid",
              value: "".concat(info.streamId, " ").concat(info.trackID)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "mslabel",
              value: "".concat(info.streamId)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "label",
              value: "".concat(info.trackID)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "cname",
              value: "".concat(info.cname)
            });
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      sdpObj.media.push(mediaObj);
    };
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      _loop7();
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
  return sdpTransform.write(sdpObj);
}
// 解决手机端合流旋转方向异常问题，删除 urn:3gpp:video-orientation 属性
function removeVideOrientation(sdp) {
  var sdpObj = sdpTransform.parse(sdp);
  if (!('media' in sdpObj)) return sdpTransform.write(sdpObj);
  if (!Array.isArray(sdpObj.media)) return sdpTransform.write(sdpObj);
  var _iterator14 = _createForOfIteratorHelper(sdpObj.media),
    _step14;
  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var media = _step14.value;
      if (!('ext' in media) || !Array.isArray(media.ext)) continue;
      if (media.type !== "video") continue;
      media.ext = media.ext.filter(function (ext) {
        return ext.uri !== "urn:3gpp:video-orientation";
      });
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }
  return sdpTransform.write(sdpObj);
}
function transformOfferSdp(sdp, layers) {
  var sdpObj = sdpTransform.parse(sdp);
  if (layers) {
    if (browser.name === 'chrome') {
      sdpObj.media = sdpObj.media.map(function (media) {
        if (!media.ssrcGroups || media.ssrcGroups.length === 0 || !media.ssrcs || media.ssrcs.length === 0) {
          return media;
        }
        var fidGroup = media.ssrcGroups.find(function (group) {
          return group.semantics === 'FID';
        });
        if (!fidGroup) {
          return media;
        }
        var _fidGroup$ssrcs$split = fidGroup.ssrcs.split(' ').map(function (ssrc) {
            return parseInt(ssrc, 10);
          }),
          _fidGroup$ssrcs$split2 = _slicedToArray(_fidGroup$ssrcs$split, 2),
          videoSSRC1 = _fidGroup$ssrcs$split2[0],
          rtxSSRC1 = _fidGroup$ssrcs$split2[1];
        var cname, msid;
        media.ssrcs.forEach(function (ssrc) {
          if (ssrc.attribute === 'cname') {
            cname = ssrc.value;
          }
          if (ssrc.attribute === 'msid') {
            msid = ssrc.value;
          }
        });
        var simSsrcs = [];
        simSsrcs.push(videoSSRC1);
        if (layers >= 2) {
          var videoSSRC2 = videoSSRC1 + 1;
          var rtxSSRC2 = rtxSSRC1 + 1;
          media.ssrcs.push({
            id: videoSSRC2,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: videoSSRC2,
            attribute: 'msid',
            value: msid
          });
          media.ssrcs.push({
            id: rtxSSRC2,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: rtxSSRC2,
            attribute: 'msid',
            value: msid
          });
          media.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(videoSSRC2, " ").concat(rtxSSRC2)
          });
          simSsrcs.push(videoSSRC2);
        }
        if (layers >= 3) {
          var videoSSRC3 = videoSSRC1 + 2;
          var rtxSSRC3 = rtxSSRC1 + 2;
          media.ssrcs.push({
            id: videoSSRC3,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: videoSSRC3,
            attribute: 'msid',
            value: msid
          });
          media.ssrcs.push({
            id: rtxSSRC3,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: rtxSSRC3,
            attribute: 'msid',
            value: msid
          });
          media.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(videoSSRC3, " ").concat(rtxSSRC3)
          });
          simSsrcs.push(videoSSRC3);
        }
        media.ssrcGroups.push({
          semantics: "SIM",
          ssrcs: simSsrcs.join(' ')
        });
        return media;
      });
    }
  }
  var newSdp = sdpTransform.write(sdpObj);
  var sdpLines = newSdp.split('\r\n');
  var ssrcGroupsIdx = sdpLines.findIndex(function (line) {
    return line.indexOf('a=ssrc-group:FID') === 0;
  });
  while (ssrcGroupsIdx !== -1 && sdpLines[ssrcGroupsIdx].indexOf('a=ssrc-group:FID') === 0) {
    var rtxSSRC = sdpLines[ssrcGroupsIdx].split(' ')[2];
    for (var i = ssrcGroupsIdx - 1; i >= 0; i--) {
      if (sdpLines[i].indexOf(rtxSSRC) > 0) {
        sdpLines.splice(i + 1, 0, sdpLines[ssrcGroupsIdx]);
        sdpLines.splice(ssrcGroupsIdx + 1, 1);
        break;
      }
    }
    ssrcGroupsIdx++;
  }
  return sdpLines.join('\r\n');
}
function getAccessToken(roomAccess, roomToken, requestTimeout) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var fireTimes, isReconnect, appId, roomName, userId, path, qosItem, res, e;
    return _regeneratorRuntime().wrap(function _callee24$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          fireTimes = 0;
          isReconnect = false;
          appId = roomAccess.appId, roomName = roomAccess.roomName, userId = roomAccess.userId;
          path = "/v3/apps/".concat(appId, "/rooms/").concat(roomName, "/auth?user=").concat(userId, "&token=").concat(roomToken);
        case 4:
          if (!true) {
            _context25.next = 28;
            break;
          }
          qosItem = {
            auth_start_time: Date.now(),
            auth_dns_time: 0,
            auth_server_ip: "",
            room_token: roomToken,
            // 鉴权请求地址
            auth_url: path
          };
          _context25.prev = 6;
          _context25.next = 9;
          return requestMcu(path, requestTimeout);
        case 9:
          res = _context25.sent;
          fireTimes++;
          qos.addEvent("MCSAuth", Object.assign(Object.assign({}, qosItem), {
            auth_take_time: Date.now() - qosItem.auth_start_time,
            auth_error_code: 0,
            auth_error_message: "",
            access_token: res.accessToken,
            //-------Qos打点v2优化--------
            event_grade: QNEventGrade.NORMAL,
            event_category: QNEventCategory.CORE,
            auth_network_code: 0,
            fire_times: fireTimes,
            auth_reason: isReconnect ? "reconnect" : "connect"
          }));
          return _context25.abrupt("return", res);
        case 15:
          _context25.prev = 15;
          _context25.t0 = _context25["catch"](6);
          e = _context25.t0; // 设置重连标记
          isReconnect = true;
          // 重连次数+1
          fireTimes++;
          qos.addEvent("MCSAuth", Object.assign(Object.assign({}, qosItem), {
            auth_take_time: Date.now() - qosItem.auth_start_time,
            auth_error_code: e.retry === undefined ? -1 : Number(e.message),
            auth_error_message: e.retry === undefined ? e.toString() : e.message,
            access_token: "",
            //-------Qos打点v2优化--------
            event_grade: QNEventGrade.SERVERE,
            event_category: QNEventCategory.CORE,
            // retry === undefined表示 请求未正常走到request then回调，表示未调通接口
            // 调用接口超时 reject返回networkCode = -1, 异常调用接口e.networkCode为2
            // catch回调reject执行参数中networkCode undefined表示网络未到达(-2)
            // 正常调用场景 networkCode为0
            auth_network_code: e.retry === undefined ? e.networkCode || -2 : 0,
            fire_times: fireTimes,
            auth_reason: isReconnect ? "reconnect" : "connect"
          }));
          if (!(e.retry === false)) {
            _context25.next = 23;
            break;
          }
          throw ERROR_AUTH_FAILED(e.message);
        case 23:
          _context25.next = 25;
          return timeout(1000);
        case 25:
          log.warning("can not get accessToken, retry.", ERROR_AUTH_FAILED(e));
        case 26:
          _context25.next = 4;
          break;
        case 28:
        case "end":
          return _context25.stop();
      }
    }, _callee24, null, [[6, 15]]);
  }));
}
function getRelayToken(roomAccess, roomToken, requestTimeout) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var appId, roomName, userId, path, qosItem, res, e;
    return _regeneratorRuntime().wrap(function _callee25$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          appId = roomAccess.appId, roomName = roomAccess.roomName, userId = roomAccess.userId;
          path = "/v3/apps/".concat(appId, "/rooms/").concat(roomName, "/relay/token?user=").concat(userId, "&token=").concat(roomToken);
        case 2:
          if (!true) {
            _context26.next = 25;
            break;
          }
          qosItem = {
            auth_start_time: Date.now(),
            auth_dns_time: 0,
            auth_server_ip: "",
            room_token: roomToken
          };
          _context26.prev = 4;
          _context26.next = 7;
          return requestMcu(path, requestTimeout);
        case 7:
          res = _context26.sent;
          if (!(res === undefined)) {
            _context26.next = 10;
            break;
          }
          throw SERVER_UNAVAILABLE();
        case 10:
          qos.addEvent("MCURelayAuth", Object.assign(Object.assign({}, qosItem), {
            auth_take_time: Date.now() - qosItem.auth_start_time,
            auth_error_code: 0,
            auth_error_message: "",
            access_token: res.relayToken || "no relay token",
            // 默认值0, 请求超时-1，网络不可达-2
            auth_network_code: 0
          }));
          return _context26.abrupt("return", res);
        case 14:
          _context26.prev = 14;
          _context26.t0 = _context26["catch"](4);
          e = _context26.t0;
          qos.addEvent("MCURelayAuth", Object.assign(Object.assign({}, qosItem), {
            auth_take_time: Date.now() - qosItem.auth_start_time,
            auth_error_code: e.retry === undefined ? -1 : Number(e.message),
            auth_error_message: e.retry === undefined ? e.toString() : e.message,
            access_token: "",
            auth_network_code: e.networkCode || 0
          }));
          if (e.retry) {
            _context26.next = 20;
            break;
          }
          throw ERROR_RELAY_TOKEN(e.message);
        case 20:
          _context26.next = 22;
          return timeout(1000);
        case 22:
          log.warning("can not get relayToken, retry.", ERROR_RELAY_TOKEN(e));
        case 23:
          _context26.next = 2;
          break;
        case 25:
        case "end":
          return _context26.stop();
      }
    }, _callee25, null, [[4, 14]]);
  }));
}
var SignalingState;
(function (SignalingState) {
  SignalingState[SignalingState["CONNECTING"] = 0] = "CONNECTING";
  SignalingState[SignalingState["OPEN"] = 1] = "OPEN";
  SignalingState[SignalingState["CLOSING"] = 2] = "CLOSING";
  SignalingState[SignalingState["CLOSED"] = 3] = "CLOSED";
})(SignalingState || (SignalingState = {}));
var JOIN_ROOM_ERROR = error.JOIN_ROOM_ERROR,
  ERROR_RECONNECT_FAILED = error.ERROR_RECONNECT_FAILED;
var SignalingWS = /*#__PURE__*/function (_EnhancedEventEmitter2) {
  _inherits(SignalingWS, _EnhancedEventEmitter2);
  _createClass(SignalingWS, [{
    key: "setUrl",
    value: function setUrl(url) {
      this.url = url + "?rpcid=".concat(this.rpcid);
    }
  }, {
    key: "_state",
    set: function set(state) {
      this.emit("@ws-state-change", this.__state, state);
      this.__state = state;
    }
  }, {
    key: "state",
    get: function get() {
      return this.__state;
    }
  }, {
    key: "reconnectTimes",
    set: function set(n) {
      this._reconnectTimes = n;
      this.currentLeftReconnectTimes = n;
    },
    get: function get() {
      return this._reconnectTimes;
    }
  }, {
    key: "requestTimeout",
    set: function set(v) {
      this.wsConnectTimeout = v;
    }
  }]);
  function SignalingWS(token, capsdp, reconnectTimes, timeout, playerdata) {
    var _this18;
    _classCallCheck(this, SignalingWS);
    var _this;
    var privileges = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ["subscribe", "publish"];
    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(SignalingWS).call(this));
    _this = _assertThisInitialized(_assertThisInitialized(_this18));
    _this18.privileges = [];
    /**
     * websocket 连接地址后加上 query
     * wss://bc1178-roomd.cloudvdn.com/v2/signaling => wss://bc1178-roomd.cloudvdn.com/v2/signaling?rpcid=XXXXXXXX
     */
    _this18.rpcid = randomStringGen(16);
    /**
     * 初始化 ws 开始时间
     */
    _this18.startInitTime = -1;
    /**
     * 如果为 0 说明鉴权完成，或者还没有开始鉴权
     */
    _this18.startAuthTime = 0;
    _this18.initWs = function () {
      var isUserAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ws = arguments.length > 1 ? arguments[1] : undefined;
      var url = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise(function (resolve, reject) {
        if (_this.ws && _this.ws.readyState === WebSocket.OPEN) {
          _this.ws.close();
          _this.ws.onclose = null;
        }
        if (isUserAction) {
          _this.ws = ws;
          _this.setUrl(url);
        } else {
          _this.startInitTime = Date.now();
          try {
            _this.wsConnectTimeoutID = setTimeout(function () {
              if (_this.ws) {
                _this.ws.onopen = null;
                _this.ws.onclose = null;
                _this.ws.onerror = null;
                _this.ws.close();
              }
              var errorMsg = _this.wsConnectTimeout / 1000 + "s timeout";
              qos.addEvent("WebsocketConnect", {
                happy_dns_resolve_time: 0,
                happy_dns_take_effect: false,
                socket_node_info: _this.url,
                socket_connect_time: Date.now() - _this.startInitTime,
                socket_connect_success: false,
                socket_connect_error_message: errorMsg,
                event_grade: QNEventGrade.SERVERE,
                event_category: QNEventCategory.CORE,
                dns_resolve_time: 0,
                dns_take_effect: false,
                dns_resolved_ip: "",
                socket_connect_reason: isUserAction ? "connect" : "reconnect"
              });
              _this.startInitTime = -1;
              _this.reconnect(_this.wsConnectTimeout).catch(function (e) {
                log.warning("signaling: reconnect timeout error", e);
              });
            }, _this.wsConnectTimeout);
            _this.ws = new WebSocket(_this.url);
            _this._state = SignalingState.CONNECTING;
          } catch (e) {
            throw ERROR_FATAL("init signaling websocket faild!\nError: ".concat(e));
          }
        }
        _this.ws.onerror = _this.onWsError;
        _this.ws.onclose = _this.onWsClose.bind(_this, resolve, reject);
        var onWsOpen = function onWsOpen() {
          if (_this.wsConnectTimeoutID) {
            clearTimeout(_this.wsConnectTimeoutID);
          }
          _this.emit("ws:onopen");
          log.log("signaling: websocket open", _this.url);
          if (!isUserAction) {
            qos.addEvent("WebsocketConnect", {
              happy_dns_resolve_time: 0,
              happy_dns_take_effect: false,
              socket_node_info: _this.url,
              socket_connect_time: Date.now() - _this.startInitTime,
              socket_connect_success: true,
              event_grade: QNEventGrade.NORMAL,
              event_category: QNEventCategory.CORE,
              dns_resolve_time: 0,
              dns_take_effect: false,
              dns_resolved_ip: "",
              socket_connect_reason: isUserAction ? "connect" : "reconnect"
            });
            _this.startInitTime = -1;
          }
          _this.ws.onmessage = _this.onWsMsg;
          var authData = {
            token: _this.accessToken,
            reconntoken: _this.reconnectToken,
            agent: "".concat(browser.name).concat(browser.version),
            sdkversion: version,
            capsdp: _this.capsdp,
            msgsn: _this.customMsgNumber,
            supportdomain: true,
            privileges: _this.privileges
          };
          if (_this.playerdata) {
            authData.playerdata = _this.playerdata;
          }
          _this.startAuthTime = Date.now();
          _this.request("auth", authData).then(function (msgData) {
            if (msgData.code !== 0) {
              qos.addEvent("SignalAuth", {
                auth_start_time: _this.startAuthTime,
                auth_dns_time: 0,
                auth_server_ip: _this.url,
                auth_error_code: msgData.code,
                auth_error_message: msgData.error,
                auth_take_time: Date.now() - _this.startAuthTime,
                access_token: _this.accessToken,
                //-------Qos打点v2优化--------
                event_grade: QNEventGrade.SERVERE,
                event_category: QNEventCategory.CORE,
                auth_server_info: url,
                // isUserAction true 表示用户主动连接，false表示重连
                auth_reason: isUserAction ? "connect" : "reconnect"
              });
              _this.startAuthTime = 0;
            }
            switch (msgData.code) {
              case 0:
                {
                  _this.ws.onclose = _this.onWsClose.bind(_this, null, null);
                  _this.reconnectToken = msgData.reconntoken;
                  log.log("signaling: websocket authed");
                  _this._state = SignalingState.OPEN;
                  qos.addEvent("SignalAuth", {
                    auth_start_time: _this.startAuthTime,
                    auth_dns_time: 0,
                    auth_server_ip: _this.url,
                    auth_error_code: 0,
                    auth_error_message: "",
                    auth_take_time: Date.now() - _this.startAuthTime,
                    access_token: _this.accessToken,
                    //-------Qos打点v2优化--------
                    event_grade: QNEventGrade.NORMAL,
                    event_category: QNEventCategory.CORE,
                    auth_server_info: url,
                    // isUserAction true 表示用户主动连接，false表示重连
                    auth_reason: isUserAction ? "connect" : "reconnect"
                  });
                  _this.emit("@signalingauth", msgData);
                  _this.startAuthTime = 0;
                  resolve(msgData);
                  break;
                }
              case 10001:
              // 用户 token 错误
              case 10002:
              // 用户 token 过期
              case 10011:
              // 房间人数已满
              case 10022:
              // 房间已关闭
              case 10012:
              // 已经在其他设备登陆
              case 10004:
                {
                  // 重连失败，重连超时
                  _this.emit("@error", msgData);
                  reject(ERROR_RECONNECT_FAILED(msgData.error));
                  break;
                }
              case 10005:
                {
                  // 重连失败，房间已被销毁
                  _this.emit("@error", msgData);
                  reject(ERROR_RECONNECT_FAILED(msgData.error));
                }
              case 10052:
                {
                  log.debug("10052 auth, retry", isUserAction);
                  // 媒体服务器宕机或者重启
                  _this.reconnectToken = undefined;
                  if (isUserAction) {
                    reject(JOIN_ROOM_ERROR(msgData.code, msgData.error));
                    break;
                  } else {
                    _this.emit("@error", msgData);
                    return;
                  }
                }
              case 10054:
                {
                  // 客户端与服务端编码能力不匹配
                  reject(UNSUPPORT_FMT(10054, msgData.error));
                  break;
                }
              default:
                reject(ERROR_FATAL(msgData.error));
                break;
            }
            if (msgData.code !== 0) {
              _this.reconnectToken = undefined;
              _this._state = SignalingState.CLOSED;
              _this.release();
            }
          });
        };
        _this.ws.onopen = function () {
          onWsOpen();
        };
        if (isUserAction) {
          onWsOpen();
        }
      });
    };
    _this18.onWsMsg = function (e) {
      // data 格式为 'xxx={ "a": 1, "b": 2 }'
      var data = e.data;
      _this18.emit("ws:onmessage", data);
      var index = data.indexOf("=");
      if (index > 0) {
        var msgType = data.substring(0, index);
        var payload = JSON.parse(data.substring(index + 1));
        var rpcid = payload.rpcid,
          pcid = payload.pcid,
          code = payload.code,
          _error = payload.error,
          rest = __rest(payload, ["rpcid", "pcid", "code", "error"]);
        var eventData = {
          cmd_type: msgType,
          rpcid: rpcid,
          pcid: pcid,
          code: code,
          error: _error,
          raw: JSON.stringify(rest)
        };
        if (msgType !== "ping" && msgType !== "send-message-res" && msgType !== "send-qos-message-res") {
          if (/res$/.test(msgType)) {
            qos.addEvent("SignalFired", Object.assign({
              kind: "receive"
            }, eventData));
          } else {
            qos.addEvent("SignalFired", Object.assign({
              kind: "notify"
            }, eventData));
          }
        }
        _this18.receiveWsMsg(msgType, payload);
      } else {
        throw ERROR_FATAL("signaling model can not parse message: ".concat(data));
      }
    };
    _this18.onWsError = function (e) {
      if (_this18.wsConnectTimeoutID) {
        clearTimeout(_this18.wsConnectTimeoutID);
      }
      log.warning("signaling: websocket error", e);
      _this18.emit("@ws:error", e);
      // 只有当新建 ws 连接后，没有 open 成功的情况下，才打这个错误的点，仅仅用于表示建连时出错
      // 过程中出错的情况在 onClose 事件中打点
      if (_this18.startInitTime !== -1) {
        qos.addEvent("WebsocketConnect", {
          happy_dns_resolve_time: 0,
          happy_dns_take_effect: false,
          socket_node_info: _this18.url,
          socket_connect_time: Date.now() - _this18.startInitTime,
          socket_connect_success: false,
          event_grade: QNEventGrade.SERVERE,
          event_category: QNEventCategory.CORE,
          dns_resolve_time: 0,
          dns_take_effect: false,
          dns_resolved_ip: "",
          // 没有open场景下，无法判定重连还是加入房间
          socket_connect_reason: ""
        });
        _this18.startInitTime = -1;
      }
    };
    _this18.sendWsMsg = function (msgType, msgData) {
      var rpcid = msgData.rpcid,
        rest = __rest(msgData, ["rpcid"]);
      if (msgType !== "pong" && msgType !== "send-qos-message" && msgType !== "send-message") {
        qos.addEvent("SignalFired", {
          kind: "send",
          cmd_type: msgType,
          rpcid: rpcid,
          raw: JSON.stringify(rest)
        });
      }
      if (_this18.ws.readyState !== WebSocket.OPEN) {
        throw WS_ABORT();
      }
      var jsonString = JSON.stringify(msgData);
      try {
        _this18.ws.send("".concat(msgType, "=").concat(jsonString));
        _this18.emit("send", msgType, msgData);
      } catch (e) {
        log.warning("signaling: websocket send error", e);
        _this18.reconnect().catch(function (e) {
          log.warning("signaling: reconnect error", e);
        });
        throw WS_ABORT();
      }
    };
    _this18.handlePing = function () {
      _this18.sendWsMsg("pong", {});
      if (_this18.reconnectTimeoutID) {
        clearTimeout(_this18.reconnectTimeoutID);
      }
      _this18.reconnectTimeoutID = setTimeout(function () {
        log.debug("signaling: websocket heartbeat timeout");
        _this18.reconnect().catch(function (e) {
          log.warning("signaling: reconnect error", e);
        });
      }, 9000);
    };
    _this18.receiveWsMsg = function (msgType, msgData) {
      _this18.emit("receive", msgType, msgData);
      switch (msgType) {
        case "ping":
          _this18.handlePing();
          break;
        case "auth-res":
          _this18.emit("@auth-res", msgData);
        case "pubpc-res":
        case "subpc-res":
        case "pub-tracks":
        case "webrtc-candidate":
        case "on-player-in":
        case "on-player-out":
        case "disconnect":
        case "mute-tracks":
        case "on-add-tracks":
        case "on-remove-tracks":
        case "on-player-reconnect":
        case "on-player-reconnect-in":
        case "on-command":
          _this18.emit(msgType, msgData);
          break;
        case "sub-res":
        case "unsub-res":
          _this18.emit(msgType, msgData);
          _this18.emit("".concat(msgType, "-").concat(msgData.streamid), msgData);
          break;
        case "control-res":
          _this18.emit(msgType, msgData);
          _this18.emit("".concat(msgType, "-").concat(msgData.command, "-").concat(msgData.playerid), msgData);
          break;
        case "on-pubpc-connected":
        case "on-pubpc-disconnected":
          _this18.emit("on-pubpc-state", {
            pcid: msgData.pcid,
            connected: msgType === "on-pubpc-connected"
          });
          _this18.emit("".concat(msgType, "-").concat(msgData.pcid), msgData);
          break;
        case "on-subpc-disconnected":
        case "on-subpc-connected":
          _this18.emit("on-subpc-state", {
            pcid: msgData.pcid,
            connected: msgType === "on-subpc-connected"
          });
          _this18.emit(msgType, msgData);
          break;
        case "pub-tracks-res":
          _this18.emit(msgType, msgData);
          break;
        case "on-messages":
        case "on-qos-messages":
          // 按照 msgsn 从小到大排序
          msgData.messages = msgData.messages.sort(function (a, b) {
            return a.msgsn - b.msgsn;
          });
          _this18.customMsgNumber = msgData.messages[msgData.messages.length - 1].msgsn;
          _this18.emit(msgType, msgData);
          break;
        case "unpub-tracks-res":
        case "sub-tracks-res":
        case "unsub-tracks-res":
        case "on-pubpc-restart-notify":
        case "on-subpc-restart-notify":
        case "set-sub-profile-res":
        case "on-sub-profile-changed":
        case "pubpc-restart-res":
        case "subpc-restart-res":
        case "create-merge-job-res":
        case "create-forward-job-res":
        case "stop-forward-res":
        case "on-job-connected":
        case "on-job-disconnected":
        case "on-merge-job-connected":
        case "on-merge-job-disconnected":
        case "update-merge-tracks-res":
        case "set-privileges-res":
        case "start-media-relay-res":
        case "update-media-relay-res":
        case "stop-media-relay-res":
        case "on-media-relay-state":
          _this18.emit(msgType, msgData);
          break;
      }
    };
    _this18.accessToken = token;
    _this18.capsdp = capsdp;
    _this18.reconnectTimes = reconnectTimes;
    _this18.wsConnectTimeout = timeout;
    _this18.playerdata = playerdata;
    _this18.privileges = privileges;
    _this18._state = SignalingState.CONNECTING;
    return _this18;
  }
  _createClass(SignalingWS, [{
    key: "onWsClose",
    value: function onWsClose(resolve, reject, e) {
      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }
      this._state = SignalingState.CLOSED;
      log.warning("signaling: websocket onclose", e);
      if (this.startAuthTime) {
        qos.addEvent("SignalAuth", {
          auth_start_time: this.startAuthTime,
          auth_dns_time: 0,
          auth_server_ip: this.url,
          auth_error_code: e.code,
          auth_error_message: e.toString(),
          auth_take_time: Date.now() - this.startAuthTime,
          access_token: this.accessToken,
          //-------Qos打点v2优化--------
          event_grade: QNEventGrade.NORMAL,
          event_category: QNEventCategory.CORE,
          auth_server_info: this.url,
          // 关闭ws auth_reason暂时记作 connect
          auth_reason: 'connect'
        });
      }
      var reconnectPromise = this.reconnectPromise;
      // See http://tools.ietf.org/html/rfc6455#section-7.4.1
      switch (e.code) {
        case 1000:
          {
            // Normal closure, meaning that the purpose for which the connection was established has been fulfilled.
            this.emit("@closed");
            break;
          }
        case 1001:
          {
            // An endpoint is "going away", such as a server going down or a browser having navigated away from a page.
            reconnectPromise = this.reconnect();
            break;
          }
        case 1005:
          {
            // No status code was actually present.
            reconnectPromise = this.reconnect();
            break;
          }
        case 1006:
          {
            // The connection was closed abnormally, e.g., without sending or receiving a Close control frame
            reconnectPromise = this.reconnect(this.wsConnectTimeout);
            break;
          }
        case 1007:
          {
            // An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).
            break;
          }
        case 1008:
          {
            // An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.
            break;
          }
        case 1009:
          {
            // An endpoint is terminating the connection because it has received a message that is too big for it to process.
            break;
          }
        case 1010:
          {
            // Note that this status code is not used by the server, because it can fail the WebSocket handshake instead.
            // An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake.
            // Specifically, the extensions that are needed are: " + e.reason
            break;
          }
        case 1011:
          {
            // A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.
            reconnectPromise = this.reconnect();
            break;
          }
        // https://www.ietf.org/mail-archive/web/hybi/current/msg09670.html
        case 1012:
          {
            // the service is restarted. a client may reconnect,
            // and if it choses to do, should reconnect using a randomized delay of 5 - 30s.
            reconnectPromise = this.reconnect(5000);
            break;
          }
        case 1013:
          {
            // The server is terminating the connection due to a temporary condition,
            // e.g. it is overloaded and is casting off some of its clients.
            reconnectPromise = this.reconnect();
            break;
          }
        case 1014:
          {
            // The server was acting as a gateway or proxy and received an invalid response from the upstream server.
            // This is similar to 502 HTTP Status Code.
            reconnectPromise = this.reconnect(5000);
            break;
          }
      }
      if (resolve && reject) {
        // 重连成功，则返回继续后续逻辑，重连失败不再抛出错误，通过事件错误码通知客户
        if (reconnectPromise) {
          reconnectPromise.then(resolve).catch(function (e) {
            log.warning("signaling: reconnect error", e);
          });
        } else {
          // 这里表示原生 ws 错误，且不主动重连的情况，直接抛出
          reject(e);
        }
      }
    }
  }, {
    key: "sendDisconnect",
    value: function sendDisconnect() {
      if (this.state !== SignalingState.OPEN) {
        return;
      }
      try {
        this.sendWsMsg("disconnect", {});
      } catch (error) {
        // abort error
      }
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this19 = this;
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      // 每次连接已经确认断开后，本地 heartbeat 都需要删除
      if (this.reconnectTimeoutID) {
        clearTimeout(this.reconnectTimeoutID);
      }
      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }
      if (this.reconnectPromise && this._state === SignalingState.CONNECTING) {
        return this.reconnectPromise;
      }
      if (this.currentLeftReconnectTimes <= 0) {
        /**
         * 注意这里的 10007 为自定义的 code，用于表示重连次数用完仍然无法成功建立 ws 连接
         * 与 server 返回的 code 不相通
         * 注意 10007 与 server 返回的 10004 的区别，10004 表示 reconnect token 过期
         */
        this.emit("@error", {
          code: 10007
        });
        return Promise.reject("websocket reconnectTimes run out, reconnect stops.");
      }
      this.currentLeftReconnectTimes -= 1;
      this._state = SignalingState.CONNECTING;
      log.debug("signaling: websocket reconnecting, currentLeftReconnectTimes remaining: ", this.currentLeftReconnectTimes);
      this.reconnectPromise = timeout(time).then(function () {
        return _this19.initWs();
      }).then(function (res) {
        _this19.reconnectPromise = undefined;
        _this19.currentLeftReconnectTimes = _this19.reconnectTimes;
        return res;
      }).catch(function (e) {
        _this19._state = SignalingState.CLOSED;
        _this19.emit("error", e);
        return Promise.reject(e);
      });
      return this.reconnectPromise;
    }
    /**
     * request
     */
  }, {
    key: "request",
    value: function request(method, data) {
      var _this20 = this;
      var rpcid = randomStringGen(8);
      data.rpcid = rpcid;
      log.log("ws request", rpcid, method, data);
      this.sendWsMsg(method, data);
      return new Promise(function (resolve) {
        var onres = function onres(data) {
          if (data.rpcid === rpcid) {
            log.log("ws response", rpcid, method, data);
            _this20.off("".concat(method, "-res"), onres);
            resolve(data);
          }
        };
        _this20.on("".concat(method, "-res"), onres);
      });
    }
  }, {
    key: "release",
    value: function release() {
      if (this.reconnectTimeoutID) {
        clearTimeout(this.reconnectTimeoutID);
      }
      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }
      this.removeAllListeners();
      if (this.ws) {
        this.ws.onopen = null;
        this.ws.onclose = null;
        this.ws.onerror = null;
        this.ws.close();
      }
    }
  }]);
  return SignalingWS;
}(EnhancedEventEmitter);
var MergerSessionController = function MergerSessionController() {
  _classCallCheck(this, MergerSessionController);
};
var Merger = /*#__PURE__*/function () {
  function Merger(width, height, controller, jobID) {
    var _this21 = this;
    _classCallCheck(this, Merger);
    this.videoTrackInfo = [];
    this.audioTrackInfo = [];
    this.layoutLevel = 0;
    this.width = width;
    this.height = height;
    this.jobID = jobID;
    this.controller = controller;
    this.controller.getCurrentTracks().forEach(function (track) {
      if (track.kind === "audio") {
        _this21.audioTrackInfo.push(track);
      } else {
        _this21.videoTrackInfo.push(track);
      }
    });
    this.controller.addMergeTrack(this.audioTrackInfo.map(function (t) {
      return {
        trackID: t.trackID
      };
    }), this.jobID);
    this.initLayout();
    this.controller.onAddTracks = function (tracks) {
      var audioTracks = tracks.filter(function (t) {
        return t.kind === "audio";
      });
      var videoTracks = tracks.filter(function (t) {
        return t.kind === "video";
      });
      _this21.controller.addMergeTrack(audioTracks.map(function (t) {
        return {
          trackID: t.trackID
        };
      }), _this21.jobID);
      videoTracks.forEach(_this21.handleAddVideoTrack.bind(_this21));
    };
    this.controller.onRemoveTracks = function (tracks) {
      var videoTracks = tracks.filter(function (t) {
        return t.kind === "video";
      });
      videoTracks.forEach(_this21.handleRemoveVideoTrack.bind(_this21));
    };
    log.log("init default merger, init layout: ", this.layout);
  }
  _createClass(Merger, [{
    key: "initLayout",
    value: function initLayout() {
      var streamCount = this.videoTrackInfo.length;
      this.layoutLevel = 0;
      this.layout = {
        "level-0": {
          items: {
            "item-0": {
              x: 0,
              y: 0,
              isExpand: false,
              isExpanded: false,
              index: 0
            }
          },
          itemWidth: this.width,
          itemHeight: this.height,
          maxItems: 1,
          currentItems: 0,
          splitWidthFlag: this.width < this.height
        }
      };
      var splitWidthFlag = this.width >= this.height;
      if (streamCount === 0) {
        return;
      }
      while (Math.pow(2, this.layoutLevel) < streamCount) {
        this.updateLayoutLevel(splitWidthFlag);
        splitWidthFlag = !splitWidthFlag;
      }
      this.setLevelLayoutStream();
    }
  }, {
    key: "updateLayoutLevel",
    value: function updateLayoutLevel(splitWidthFlag) {
      var _this22 = this;
      var currentLayout = this.layout["level-".concat(this.layoutLevel)];
      var currentWidth = currentLayout.itemWidth;
      var currentHeight = currentLayout.itemHeight;
      this.layoutLevel += 1;
      var maxItems = Math.pow(2, this.layoutLevel);
      var itemWidth = splitWidthFlag ? currentWidth / 2.0 : currentWidth;
      var itemHeight = splitWidthFlag ? currentHeight : currentHeight / 2.0;
      if (this.layoutLevel === 1) {
        this.layout["level-".concat(this.layoutLevel)] = {
          items: {
            "item-0": {
              x: 0,
              y: 0,
              isExpand: false,
              isExpanded: false,
              index: 0
            },
            "item-1": {
              x: this.width >= this.height ? itemWidth : 0,
              y: this.width < this.height ? itemHeight : 0,
              isExpand: false,
              isExpanded: false,
              index: 1
            }
          },
          maxItems: maxItems,
          currentItems: 0,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          splitWidthFlag: splitWidthFlag
        };
      } else {
        this.layout["level-".concat(this.layoutLevel)] = {
          items: {},
          maxItems: maxItems,
          currentItems: 0,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          splitWidthFlag: splitWidthFlag
        };
        var levelItems = this.layout["level-".concat(this.layoutLevel)].items;
        Object.keys(this.layout["level-".concat(this.layoutLevel - 1)].items).forEach(function (itemIndex) {
          var item = _this22.layout["level-".concat(_this22.layoutLevel - 1)].items[itemIndex];
          var newIndex = 2 * item.index;
          levelItems["item-".concat(newIndex)] = {
            x: item.x,
            y: item.y,
            isExpand: false,
            isExpanded: false,
            index: newIndex
          };
          if (splitWidthFlag) {
            levelItems["item-".concat(newIndex + 1)] = {
              x: item.x + itemWidth,
              y: item.y,
              isExpand: false,
              isExpanded: false,
              index: newIndex + 1
            };
          } else {
            levelItems["item-".concat(newIndex + 1)] = {
              x: item.x,
              y: item.y + itemHeight,
              isExpand: false,
              isExpanded: false,
              index: newIndex + 1
            };
          }
        });
      }
      log.log("merger: increase layout level, current level: ".concat(this.layoutLevel), this.layout);
    }
  }, {
    key: "setLevelLayoutStream",
    value: function setLevelLayoutStream() {
      var streamCount = this.videoTrackInfo.length;
      var currentLevelLayout = this.layout["level-".concat(this.layoutLevel)];
      var expandCount = currentLevelLayout.maxItems - streamCount;
      var streamIndex = 0;
      for (var i = 0; i < currentLevelLayout.maxItems; i += 1) {
        if (expandCount > 0) {
          if (i % 2 === 0) {
            currentLevelLayout.items["item-".concat(i)].isExpand = true;
            currentLevelLayout.items["item-".concat(i)].trackID = this.videoTrackInfo[streamIndex].trackID;
            this.sendMergeOpt(this.layoutLevel, i);
            streamIndex += 1;
          } else {
            currentLevelLayout.items["item-".concat(i)].isExpanded = true;
            expandCount -= 1;
          }
        } else {
          currentLevelLayout.items["item-".concat(i)].trackID = this.videoTrackInfo[streamIndex].trackID;
          this.sendMergeOpt(this.layoutLevel, i);
          streamIndex += 1;
        }
      }
      currentLevelLayout.currentItems = streamCount;
    }
  }, {
    key: "sendMergeOpt",
    value: function sendMergeOpt(level, index) {
      var levelLayout = this.layout["level-".concat(level)];
      var item = levelLayout.items["item-".concat(index)];
      if (!item.trackID || item.isExpanded) {
        return;
      }
      var width = levelLayout.itemWidth;
      var height = levelLayout.itemHeight;
      if (item.isExpand) {
        if (levelLayout.splitWidthFlag) {
          width = width * 2;
        } else {
          height = height * 2;
        }
      }
      var option = {
        x: item.x,
        y: item.y,
        w: width,
        h: height,
        z: 0,
        trackID: item.trackID
      };
      this.controller.addMergeTrack([option], this.jobID);
    }
  }, {
    key: "handleRemoveVideoTrack",
    value: function handleRemoveVideoTrack(track) {
      remove(this.videoTrackInfo, function (t) {
        return t.trackID === track.trackID;
      });
      var levelLayout = this.layout["level-".concat(this.layoutLevel)];
      if (this.layoutLevel > 0 && this.videoTrackInfo.length <= this.layout["level-".concat(this.layoutLevel - 1)].maxItems) {
        this.layoutLevel -= 1;
        log.log("merger: reduce layout level, current level: ".concat(this.layoutLevel), this.layout);
        this.setLevelLayoutStream();
      } else {
        for (var itemKey in levelLayout.items) {
          var item = levelLayout.items[itemKey];
          if (item.trackID === track.trackID) {
            if (item.index % 2 === 0) {
              if (levelLayout.items["item-".concat(item.index + 1)]) {
                item.isExpand = true;
                item.trackID = levelLayout.items["item-".concat(item.index + 1)].trackID;
                levelLayout.items["item-".concat(item.index + 1)].isExpanded = true;
                levelLayout.items["item-".concat(item.index + 1)].trackID = undefined;
              } else {
                item.trackID = undefined;
              }
              this.sendMergeOpt(this.layoutLevel, item.index);
            } else {
              item.isExpanded = true;
              item.trackID = undefined;
              levelLayout.items["item-".concat(item.index - 1)].isExpand = true;
              this.sendMergeOpt(this.layoutLevel, item.index - 1);
            }
            break;
          }
        }
      }
    }
  }, {
    key: "handleAddVideoTrack",
    value: function handleAddVideoTrack(track) {
      var lastLength = this.videoTrackInfo.length;
      this.videoTrackInfo.push(track);
      this.videoTrackInfo = uniqBy(this.videoTrackInfo, "trackID");
      // 如果重复添加了 trackID 就忽略
      if (this.videoTrackInfo.length === lastLength) {
        log.log("handle add video track ignore", track);
        return;
      }
      var levelLayout = this.layout["level-".concat(this.layoutLevel)];
      if (this.videoTrackInfo.length <= levelLayout.maxItems) {
        for (var itemKey in levelLayout.items) {
          var item = levelLayout.items[itemKey];
          if (!item.trackID) {
            item.trackID = track.trackID;
            if (item.isExpanded) {
              item.isExpanded = false;
              levelLayout.items["item-".concat(item.index - 1)].isExpand = false;
              this.sendMergeOpt(this.layoutLevel, item.index - 1);
            }
            this.sendMergeOpt(this.layoutLevel, item.index);
            break;
          }
        }
        levelLayout.currentItems = this.videoTrackInfo.length;
      } else {
        // 需要提升 level
        this.updateLayoutLevel(!levelLayout.splitWidthFlag);
        this.setLevelLayoutStream();
      }
    }
  }, {
    key: "release",
    value: function release() {
      this.controller.release();
    }
  }]);
  return Merger;
}();
var ImageUtils = /*#__PURE__*/function () {
  function ImageUtils() {
    _classCallCheck(this, ImageUtils);
  }
  _createClass(ImageUtils, null, [{
    key: "loadImage",
    value: function loadImage(source) {
      if (source instanceof File) {
        return ImageUtils.loadImageFromFile(source);
      } else if (source instanceof ArrayBuffer) {
        return ImageUtils.loadImageFromArrayBuffer(source);
      } else if (typeof source === "string") {
        return ImageUtils.loadImageFromUrl(source);
      } else {
        throw ERROR_NOT_SUPPORT("unsupported image source");
      }
    }
  }, {
    key: "loadImageFromUrl",
    value: function loadImageFromUrl(url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (error) {
          reject(error);
        };
      });
    }
  }, {
    key: "loadImageFromFile",
    value: function loadImageFromFile(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
          if (fileReader.result) {
            resolve(ImageUtils.loadImageFromUrl(fileReader.result));
          }
        };
        fileReader.onerror = function (e) {
          reject(e);
        };
        fileReader.readAsDataURL(file);
      });
    }
  }, {
    key: "loadImageFromArrayBuffer",
    value: function loadImageFromArrayBuffer(arrayBuffer) {
      return new Promise(function (resolve, reject) {
        var blob = new Blob([arrayBuffer]);
        var url = URL.createObjectURL(blob);
        resolve(ImageUtils.loadImageFromUrl(url));
      });
    }
  }]);
  return ImageUtils;
}();
var ImageStreamTrack = /*#__PURE__*/function () {
  function ImageStreamTrack() {
    _classCallCheck(this, ImageStreamTrack);
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
  }
  _createClass(ImageStreamTrack, [{
    key: "setSource",
    value: function setSource(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        return _regeneratorRuntime().wrap(function _callee26$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!(source === this.source)) {
                _context27.next = 2;
                break;
              }
              return _context27.abrupt("return");
            case 2:
              this.source = source;
              _context27.next = 5;
              return this.createImageStreamTrack(source);
            case 5:
            case "end":
              return _context27.stop();
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "createImageStreamTrack",
    value: function createImageStreamTrack(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this23 = this;
        var image, stream;
        return _regeneratorRuntime().wrap(function _callee27$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!(source instanceof File)) {
                _context28.next = 6;
                break;
              }
              _context28.next = 3;
              return ImageUtils.loadImageFromFile(source);
            case 3:
              image = _context28.sent;
              _context28.next = 15;
              break;
            case 6:
              if (!(source instanceof ArrayBuffer)) {
                _context28.next = 12;
                break;
              }
              _context28.next = 9;
              return ImageUtils.loadImageFromArrayBuffer(source);
            case 9:
              image = _context28.sent;
              _context28.next = 15;
              break;
            case 12:
              _context28.next = 14;
              return ImageUtils.loadImageFromUrl(source);
            case 14:
              image = _context28.sent;
            case 15:
              this.canvas.width = image.width;
              this.canvas.height = image.height;
              if (this.drawIntervalId) {
                clearInterval(this.drawIntervalId);
              }
              this.drawIntervalId = setInterval(function () {
                _this23.ctx.drawImage(image, 0, 0);
              }, 900);
              stream = this.canvas.captureStream(1);
              this.mediaTrack = stream.getTracks()[0];
            case 21:
            case "end":
              return _context28.stop();
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "release",
    value: function release() {
      if (this.drawIntervalId) {
        clearInterval(this.drawIntervalId);
      }
    }
  }, {
    key: "id",
    get: function get() {
      if (this.mediaTrack) {
        return this.mediaTrack.id;
      }
    }
  }]);
  return ImageStreamTrack;
}();
var Consumer = function Consumer(id, mid, kind, rtpParameters) {
  _classCallCheck(this, Consumer);
  this.id = id;
  this.mid = mid;
  // this._closed = false;
  this.kind = kind;
  this.rtpParameters = rtpParameters;
  // this._peer = peer;
  // this._supported = false;
  this.track = null;
};
var PCTrack = /*#__PURE__*/function () {
  function PCTrack(transport, direction, track, trackID, mid) {
    _classCallCheck(this, PCTrack);
    this._connectStatus = TrackConnectStatus.Idle;
    this.track = track;
    this.trackID = trackID;
    this.mid = mid;
    this.transport = transport;
    this.direction = direction;
  }
  _createClass(PCTrack, [{
    key: "startConnect",
    value: function startConnect() {
      var _this24 = this;
      this.connectStatus = TrackConnectStatus.Connecting;
      return new Promise(function (resolve, reject) {
        _this24.onConnectStatusChange = function (_, curr) {
          if (curr === TrackConnectStatus.Connect) {
            resolve();
          }
          if (curr === TrackConnectStatus.Idle) {
            reject();
          }
        };
      });
    }
  }, {
    key: "appendConsumner",
    value: function appendConsumner(rtpparms, kind) {
      this.consumer = new Consumer(this.trackID, this.mid, kind, rtpparms);
      this.transport.appendConsumer(this.consumer);
    }
  }, {
    key: "setMute",
    value: function setMute(muted) {
      if (!this.track) return;
      this.track.setMute(muted);
    }
  }, {
    key: "addTrackId",
    value: function addTrackId(trackid) {
      if (!this.track) return;
      this.trackID = trackid;
      this.track.setInfo({
        trackID: trackid
      });
    }
  }, {
    key: "release",
    value: function release() {
      if (this.consumer && this.transport) {
        // 如果释放这个 Track 时发现 pc 已经断开，就跳过
        if (this.transport.recvHandler.isPcReady) {
          this.transport.removeConsumers([this.consumer]);
        }
        // 只有订阅的 Track 才会自动释放
        if (this.track) {
          this.track.release();
        }
      } else {
        if (this.track) {
          this.track.reset();
        }
      }
    }
  }, {
    key: "connectStatus",
    get: function get() {
      return this._connectStatus;
    },
    set: function set(v) {
      var _this25 = this;
      if (v !== this._connectStatus) {
        var prev = this._connectStatus;
        this._connectStatus = v;
        nextTick(function () {
          if (_this25.onConnectStatusChange) {
            _this25.onConnectStatusChange(prev, _this25._connectStatus);
          }
        });
      }
    }
  }]);
  return PCTrack;
}();
var audioBufferProcessor = "\nclass AudioBufferProcessor extends AudioWorkletProcessor {\n  constructor(...args) {\n    super(...args);\n    this.signal = true;\n    this.port.onmessage = (e) => {\n      this.signal = false;\n    };\n  }\n  process (inputs, outputs, parameters) {\n    inputs.length && inputs[0].length && this.port.postMessage(inputs[0][0]);\n    return this.signal;\n  }\n}\nregisterProcessor('audio-buffer-processor', AudioBufferProcessor);\n";
var audioBufferProcessorUrl = "data:text/javascript;base64," + btoa(audioBufferProcessor);
// unsupport fallback
var AudioContext$1 = window.AudioContext || window.webkitAudioContext || window.Object;
var audioContext = browserReport.audioContextOptions ? new AudioContext$1({
  // 控制音频延迟，默认为 interactive，在 Chrome 下为 0.01s
  latencyHint: "interactive"
}) : new AudioContext$1();
window.audioContext = audioContext;
if (window.Promise) {
  var unlockWebAudio = function unlockWebAudio() {
    webAudioUnlock(audioContext).then(function (unlocked) {
      log.debug("web audio context unlocked", unlocked);
    }).catch(function (e) {
      log.warning("can not unlock web audio context", e);
    });
    window.removeEventListener("load", unlockWebAudio);
  };
  if (!document.body) {
    window.addEventListener("load", unlockWebAudio);
  } else {
    unlockWebAudio();
  }
  audioContext.onstatechange = function () {
    unlockWebAudio();
  };
}
var FFT_SIZE = 2048;
var BUFFER_SIZE = 4096;
var BUFFER_SAMPLE_RATE = audioContext.sampleRate;
var MediaElementEventList = ["play", "playing", "pause", "ended", "waiting", "seeking"];
var AudioManager = /*#__PURE__*/function (_EnhancedEventEmitter3) {
  _inherits(AudioManager, _EnhancedEventEmitter3);
  _createClass(AudioManager, [{
    key: "audioSourceState",
    get: function get() {
      return this._audioSourceState;
    },
    set: function set(newState) {
      if (newState === this._audioSourceState) return;
      this.emit("@audio-source-state-change", newState, this._audioSourceState);
      this._audioSourceState = newState;
    }
  }]);
  function AudioManager() {
    var _this26;
    _classCallCheck(this, AudioManager);
    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(AudioManager).call(this));
    // 麦克风音频源 或者 PCM音频源
    _this26.audioSource = null;
    _this26.sampleList = new Float32Array();
    _this26.isScriptNodeAvailable = 'createScriptProcessor' in audioContext;
    _this26._audioSourceState = AudioSourceState.IDLE;
    _this26.bufferSourceDuration = {
      startTime: 0,
      pauseTime: 0,
      lastPauseTime: 0,
      offsetTime: 0,
      stopTime: 0
    };
    _this26.handleMediaElementEvents = function (e) {
      switch (e.type) {
        case "playing":
        case "play":
          {
            _this26.audioSourceState = AudioSourceState.PLAY;
            break;
          }
        case "waiting":
        case "seeking":
          {
            _this26.audioSourceState = AudioSourceState.LOADING;
            break;
          }
        case "ended":
          {
            _this26.audioSourceElement && (_this26.audioSourceElement.currentTime = 0);
            _this26.audioSourceState = AudioSourceState.END;
            break;
          }
      }
    };
    return _this26;
  }
  _createClass(AudioManager, [{
    key: "initAudioContext",
    value: function initAudioContext() {
      log.log("init audio context", audioContext.state);
      // in chrome, audioContext maybe in suspended state after initialization
      if (audioContext.state === "suspended") {
        log.log("audio context suspended");
        audioContext.resume().catch(function (e) {
          log.warning("resume audiocontext failed! see: http://s.qnsdk.com/s/Txsdz", e);
        });
      }
      log.log("init audio finish", audioContext.state);
      this.analyserNode = audioContext.createAnalyser();
      this.analyserNode.fftSize = FFT_SIZE;
      this.gainNode = audioContext.createGain();
      polyfillAudioNode(this.gainNode);
      if (browserReport.mediaStreamDest) {
        this.audioStream = audioContext.createMediaStreamDestination();
      }
    }
  }, {
    key: "setMediaStreamSource",
    value: function setMediaStreamSource(originMediaStream) {
      this.audioSource = audioContext.createMediaStreamSource(originMediaStream);
      this.connect();
    }
  }, {
    key: "setAudioBufferSource",
    value: function setAudioBufferSource() {
      var _this27 = this;
      this.audioSource = audioContext.createBufferSource();
      // 播放结束后清空节点
      this.audioSource.onended = function () {
        _this27.audioSource.onended = null;
        _this27.audioSource.stop();
        _this27.audioSource.disconnect();
        _this27.audioSource = null;
        _this27.bufferSourceDuration.stopTime = audioContext.currentTime;
        _this27.audioSourceState = AudioSourceState.END;
      };
      this.connect();
    }
  }, {
    key: "setMediaElementSource",
    value: function setMediaElementSource(mediaElement) {
      this.audioSource = audioContext.createMediaElementSource(mediaElement);
      this.audioSourceElement = mediaElement;
      for (var _i = 0, _MediaElementEventLis = MediaElementEventList; _i < _MediaElementEventLis.length; _i++) {
        var eventItem = _MediaElementEventLis[_i];
        this.audioSourceElement.addEventListener(eventItem, this.handleMediaElementEvents);
      }
      this.connect();
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(isLoop) {
      this.audioSourceLoop = isLoop;
      if (this.isAudioSource()) {
        this.audioSource.loop = !!isLoop;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.loop = !!isLoop;
      }
    }
  }, {
    key: "setAudioBuffer",
    value: function setAudioBuffer(data) {
      if (!this.isAudioSource()) {
        return;
      }
      this.audioSource.buffer = data;
      this.audioSourceBuffer = data;
    }
  }, {
    key: "playAudioSource",
    value: function playAudioSource() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.isAudioSource()) {
        this.resetBufferSourceDuration();
        try {
          this.audioSource.start(0, offset);
          this.bufferSourceDuration.startTime = audioContext.currentTime;
          this.bufferSourceDuration.offsetTime = offset;
          this.audioSourceState = AudioSourceState.PLAY;
        } catch (e) {
          // 说明已经 start
          this.stopAudioSource();
          this.playAudioSource(offset);
        }
      } else if (this.audioSourceElement) {
        this.audioSourceElement.currentTime = 0;
        this.audioSourceElement.play().catch(showPlayWarn);
      } else if (this.audioSource === null && this.audioSourceBuffer) {
        this.resetBufferSourceDuration();
        // 说明原来的 AudioBufferSourceNode 被删掉了，重新创建
        this.setAudioBufferSource();
        this.setAudioBuffer(this.audioSourceBuffer);
        this.setAudioSourceLoop(!!this.audioSourceLoop);
        // fix ts error
        this.audioSource.start(0, offset);
        this.bufferSourceDuration.startTime = audioContext.currentTime;
        this.bufferSourceDuration.offsetTime = offset;
        this.audioSourceState = AudioSourceState.PLAY;
      }
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      if (this.isAudioSource()) {
        if (this.audioSourceState !== AudioSourceState.PAUSE) return;
        this.audioSource.playbackRate.value = 1;
        this.bufferSourceDuration.pauseTime += audioContext.currentTime - this.bufferSourceDuration.lastPauseTime;
        this.bufferSourceDuration.lastPauseTime = 0;
        this.audioSourceState = AudioSourceState.PLAY;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.play().catch(showPlayWarn);
      }
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      if (this.isAudioSource()) {
        // hack to pause, but firefox does not support MIN_VALUE
        if (isFirefox) {
          this.audioSource.playbackRate.value = 10e-8;
        } else {
          this.audioSource.playbackRate.value = Number.MIN_VALUE;
        }
        if (!this.bufferSourceDuration.lastPauseTime) {
          this.bufferSourceDuration.lastPauseTime = audioContext.currentTime;
        }
        this.audioSourceState = AudioSourceState.PAUSE;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.pause();
        if (this.audioSourceState !== AudioSourceState.END) {
          this.audioSourceState = AudioSourceState.PAUSE;
        }
      }
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      var useToSeek = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var noStopEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.isAudioSource()) {
        /**
         * 一个 AudioBufferSourceNode 节点在其生命周期只允许开始一次
         * 所以这里停止了之后是无法再次开始的
         * 我们就直接删掉这个 Node，等待下次开始的时候重新创建
         */
        this.audioSource.onended = null;
        this.audioSource.stop();
        this.audioSource.disconnect();
        this.audioSource = null;
        this.bufferSourceDuration.stopTime = audioContext.currentTime;
        if (!useToSeek && noStopEmit === false) {
          this.audioSourceState = AudioSourceState.STOP;
        }
      } else if (this.audioSourceElement) {
        if (noStopEmit === false) {
          this.audioSourceState = AudioSourceState.STOP;
        }
        this.audioSourceElement.pause();
        this.audioSourceElement.currentTime = 0;
      }
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      if (this.audioSourceElement) {
        return this.audioSourceElement.currentTime;
      } else if (this.isAudioSource()) {
        var baseTime = audioContext.currentTime;
        var duration = this.getAudioSourceDuration();
        if (this.bufferSourceDuration.lastPauseTime) {
          baseTime = this.bufferSourceDuration.lastPauseTime;
        }
        if (this.bufferSourceDuration.stopTime) {
          baseTime = this.bufferSourceDuration.stopTime;
        }
        var currentTime = this.bufferSourceDuration.offsetTime + baseTime - this.bufferSourceDuration.startTime - this.bufferSourceDuration.pauseTime;
        return Math.max(0, currentTime % duration);
      }
      return 0;
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(val) {
      if (this.audioSourceElement) {
        this.audioSourceElement.currentTime = val;
      } else if (this.isAudioSource()) {
        /**
         * audioBufferSource 的 seek 分 2 步
         * stop audioBuffer
         * 在指定位置 start
         */
        this.stopAudioSource(true);
        this.playAudioSource(val);
      }
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      if (this.audioSourceElement) return this.audioSourceElement.duration;
      if (this.audioSourceBuffer) return this.audioSourceBuffer.duration;
      return 0;
    }
  }, {
    key: "release",
    value: function release(isLocal) {
      // PILCS-11335 暂停远端的 track 会导致，再次订阅后 track 状态变成 ended，导致订阅后的音频无法正常播放
      // 远端的 track 不需要 stop，本地的 track 需要调用 stop 去释放，不然浏览器采集状态不能正常退出
      if (isLocal && this.audioSource instanceof MediaStreamAudioSourceNode) {
        if (this.audioSource.mediaStream) this.audioSource.mediaStream.getTracks().map(function (t) {
          return t.stop();
        });
      }
      if (this.audioSource) {
        this.audioSource.disconnect();
      }
      this.gainNode.disconnect();
      if (this.audioSourceElement) {
        for (var _i2 = 0, _MediaElementEventLis2 = MediaElementEventList; _i2 < _MediaElementEventLis2.length; _i2++) {
          var eventItem = _MediaElementEventLis2[_i2];
          this.audioSourceElement.removeEventListener(eventItem, this.handleMediaElementEvents);
        }
        this.audioSourceElement.src = "";
        this.audioSourceElement.load();
        this.audioSourceElement.remove();
        this.audioSourceElement = undefined;
      }
      if (this.scriptNode) {
        this.scriptNode.disconnect();
      }
      if (this.audioWorkletNode) {
        this.sampleList = new Float32Array();
        this.audioWorkletNode.port.postMessage("close");
        this.audioWorkletNode.disconnect();
      }
    }
  }, {
    key: "connect",
    value: function connect() {
      if (!this.audioSource) {
        log.warning("no audio source, can not connect");
        return;
      }
      this.audioSource.connect(this.analyserNode);
      this.audioSource.connect(this.gainNode);
      if (this.audioStream) {
        this.gainNode.connect(this.audioStream);
        this.onAudioBuffer();
      }
    }
  }, {
    key: "handleAudioBuffer",
    value: function handleAudioBuffer(audioEvent) {
      var input = audioEvent.inputBuffer;
      this.emit("audioBuffer", input);
      if (this.audioBufferCallback) {
        this.audioBufferCallback(input);
      }
    }
  }, {
    key: "handleAudioProcressBuffer",
    value: function handleAudioProcressBuffer(e) {
      var addSampleList = new Float32Array(e.data.length);
      for (var i = 0; i < e.data.length; i++) {
        addSampleList[i] = e.data[i];
      }
      var oldSampleList = this.sampleList;
      this.sampleList = new Float32Array(oldSampleList.length + addSampleList.length);
      this.sampleList.set(oldSampleList);
      this.sampleList.set(addSampleList, oldSampleList.length);
      if (this.sampleList.length === BUFFER_SIZE) {
        var audioBuffer = audioContext.createBuffer(2, BUFFER_SIZE, BUFFER_SAMPLE_RATE);
        for (var channel = 0; channel < 2; channel++) {
          var buffer = audioBuffer.getChannelData(channel);
          for (var _i3 = 0; _i3 < buffer.length; _i3++) {
            buffer[_i3] = this.sampleList[_i3];
          }
        }
        this.emit("audioBuffer", audioBuffer);
        if (this.audioBufferCallback) {
          this.audioBufferCallback(audioBuffer);
        }
        this.sampleList = new Float32Array();
      }
    }
  }, {
    key: "onAudioBuffer",
    value: function onAudioBuffer(audioBufferCallback) {
      var bufferSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BUFFER_SIZE;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              this.audioBufferCallback = audioBufferCallback;
              this.audioBufferSize = bufferSize;
              if (!(!this.audioStream || !this.audioSource)) {
                _context29.next = 4;
                break;
              }
              return _context29.abrupt("return");
            case 4:
              if (this.isScriptNodeAvailable) {
                _context29.next = 14;
                break;
              }
              if (this.audioWorkletNode) {
                _context29.next = 12;
                break;
              }
              _context29.next = 8;
              return audioContext.audioWorklet.addModule(audioBufferProcessorUrl);
            case 8:
              this.audioWorkletNode = new AudioWorkletNode(audioContext, 'audio-buffer-processor');
              this.audioSource.connect(this.audioWorkletNode);
              this.audioWorkletNode.connect(this.audioStream);
              this.audioWorkletNode.port.onmessage = this.handleAudioProcressBuffer.bind(this);
            case 12:
              _context29.next = 15;
              break;
            case 14:
              if (!this.scriptNode) {
                this.scriptNode = audioContext.createScriptProcessor(bufferSize);
                this.audioSource.connect(this.scriptNode);
                this.scriptNode.connect(this.audioStream);
                this.scriptNode.onaudioprocess = this.handleAudioBuffer.bind(this);
              }
            case 15:
            case "end":
              return _context29.stop();
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "resetBufferSourceDuration",
    value: function resetBufferSourceDuration() {
      this.bufferSourceDuration = {
        offsetTime: 0,
        startTime: 0,
        lastPauseTime: 0,
        pauseTime: 0,
        stopTime: 0
      };
    }
    /**
     * 判断当前的audioSource是否是AudioBufferSourceNode | AudioScheduledSourceNode
     * 非ios safari浏览器创建的实例是AudioBufferSourceNode
     * ios safari浏览器创建的实例是AudioScheduledSourceNode
     * @returns boolean
     */
  }, {
    key: "isAudioSource",
    value: function isAudioSource() {
      var audioSource = this.audioSource; // 非ios safari浏览器创建的实例是AudioBufferSourceNode
      if (audioSource instanceof AudioBufferSourceNode) {
        return true;
      }
      // ios safari浏览器创建的实例是AudioScheduledSourceNode
      if (audioSource instanceof AudioScheduledSourceNode) {
        return true;
      }
      return false;
    }
  }]);
  return AudioManager;
}(EnhancedEventEmitter);
/**
 * Safari 的 AudioNode.disconnect 不支持 disconnect 指定节点，只能操作全部节点
 * 这里的 polyfill 是通过 _inputNodes 保存全部已经 connect 的节点
 * 然后在 disconnect 后，将那些预期不应该被 disconnect 的节点重新 connect
 */
function polyfillAudioNode(node) {
  if (browserReport.disconnectAudioNode) return;
  var nativeConnect = node.connect;
  var nativeDisconnect = node.disconnect;
  node.connect = function (destination, outputIndex, inputIndex) {
    if (!node._inputNodes) {
      node._inputNodes = [];
    }
    if (destination instanceof AudioNode) {
      node._inputNodes.push(destination);
      node._inputNodes = uniqBy(node._inputNodes, function (s) {
        return s;
      });
      nativeConnect.call(node, destination, outputIndex, inputIndex);
    } else {
      nativeConnect.call(node, destination, outputIndex);
    }
    return node;
  };
  node.disconnect = function (destination, output, input) {
    if (!destination) {
      nativeDisconnect.call(node);
      node._inputNodes = [];
      return;
    }
    nativeDisconnect.call(node, destination, output, input);
    remove(node._inputNodes, function (node) {
      return node === destination;
    });
    var _iterator15 = _createForOfIteratorHelper(node._inputNodes),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var _n = _step15.value;
        node.connect(_n);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
  };
}
function aWeight(f) {
  var f2 = f * f;
  return 1.2588966 * 148840000 * f2 * f2 / ((f2 + 424.36) * Math.sqrt((f2 + 11599.29) * (f2 + 544496.41)) * (f2 + 148840000));
}
var AUDIO_WEIGHT_LIMIT = 0;
var AudioTrack = /*#__PURE__*/function (_Track) {
  _inherits(AudioTrack, _Track);
  function AudioTrack(track, userID, direction) {
    var _this28;
    _classCallCheck(this, AudioTrack);
    if (track.kind !== "audio") {
      throw new Error("audio track only!");
    }
    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(AudioTrack).call(this, track, userID, direction));
    _this28.mediaStream = new MediaStream();
    _this28.mediaStream.addTrack(track);
    return _this28;
  }
  /**
   * @inernal
   */
  _createClass(AudioTrack, [{
    key: "resume",
    value: function resume(track) {
      this.mediaTrack = track;
      this.removeAllListeners("@get-stats");
      this.resetStats();
      var stream = new MediaStream([track]);
      this.mediaStream = stream;
      if (this.mediaElement) {
        this.mediaElement.dataset.localid = track.id;
        this.mediaElement.srcObject = stream;
      }
      if (this.audioManager) {
        this.audioManager.release(this.direction === 'local');
        this.initAudioManager();
      }
    }
    /**
     * @internal
     * @param replaceOriginStream 是否使用 WebAudio 替换原来的输入
     * safari 不支持 webaudio 替换输入
     */
  }, {
    key: "initAudioManager",
    value: function initAudioManager(replaceOriginStream) {
      var _this29 = this;
      this.audioManager = new AudioManager();
      this.audioManager.initAudioContext();
      this.audioManager.setMediaStreamSource(this.mediaStream);
      this.audioManager.on("audioBuffer", function (buffer) {
        _this29.emit("audioBuffer", buffer);
      });
      if (replaceOriginStream && browserReport.mediaStreamDest) {
        this.mediaStream = this.audioManager.audioStream.stream;
        this.mediaTrack = this.mediaStream.getTracks()[0];
      }
    }
    /**
     * 设置音量，目前仅对采集到的 Track 用 audioManager 设置音量
     * 区分的，对于 远端的 Track 用 remoteAudioHelper 设置音量
     * @param value 增益值，0 静音，2，当前声音的 2 倍 0-1 缩小， 1-100 放大
     */
  }, {
    key: "setVolume",
    value: function setVolume(value) {
      // 如果声音值不在 0 - 100 范围内，不设置音量，打印告警日志。
      if (value < 0 || value > 100) {
        log.warning("available volume value is between 0 to 100 , current ".concat(value, " is unavailable"));
        return;
      }
      // 本地采集到的音频
      if (this.direction == "local") {
        this.audioManager.gainNode.gain.setValueAtTime(value, audioContext.currentTime);
        return;
      }
      this.mediaElement && (this.mediaElement.volume = value);
      // 远端音频
      // this.remoteAudioHelper!.setVolume(value);
    }
    /**
     * 获取当前 2048 位的时域数据
     */
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      var data = new Uint8Array(FFT_SIZE);
      this.audioManager.analyserNode.getByteTimeDomainData(data);
      return data;
    }
    /**
     * 获取当前 2048 位的频域数据
     */
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      var data = new Uint8Array(this.audioManager.analyserNode.frequencyBinCount);
      this.audioManager.analyserNode.getByteFrequencyData(data);
      return data;
    }
    /**
     * 获取这个 Track 的音量设置，默认为 1，也就是原始音量
     */
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.audioManager.gainNode.gain.value;
    }
    /**
     * 获取当前实时的音量等级，一般用来展示可视化音量数据
     */
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      var data = this.getCurrentFrequencyData();
      var sum = 0;
      var length = data.length;
      data.forEach(function (d, i) {
        var frequency = i * (audioContext.sampleRate || 44100) / data.length;
        if (frequency > 22050) {
          length -= 1;
          return;
        }
        var weight = aWeight(frequency) * d / 255.0;
        if (weight <= AUDIO_WEIGHT_LIMIT) {
          length -= 1;
          return;
        }
        sum += weight * weight;
      });
      return length === 0 ? 0 : Math.sqrt(sum / length);
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release");
      this.removeAllListeners();
      if (this.statsInterval) {
        window.clearInterval(this.statsInterval);
      }
      if (this.audioManager) {
        this.audioManager.release(this.direction === 'local');
      }
      this.removeMediaElement();
      // PILCS-11335 暂停远端的 track 会导致，再次订阅后 track 状态变成 ended，导致订阅后的音频无法正常播放
      // this.mediaTrack.stop();
    }
  }]);
  return AudioTrack;
}(Track);
var Handler = /*#__PURE__*/function (_EnhancedEventEmitter4) {
  _inherits(Handler, _EnhancedEventEmitter4);
  function Handler(direction, extendedRtpCapabilities, settings) {
    var _this30;
    _classCallCheck(this, Handler);
    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(Handler).call(this));
    _this30._isRestartingICE = false;
    _this30.isPcReady = false;
    _this30.midRidEncoding = {};
    _this30.removeMids = new Set();
    // last qos media statistic list
    _this30.lastMediaStatistics = [];
    // qos media statistic report interval
    _this30.intervalId = -1;
    // play quality interval
    _this30.playQualityIntervalId = -1;
    //   private qualityStats
    _this30.qualityStats = new Map();
    _this30._direction = direction;
    // RTCPeerConnection instance.
    _this30._pc = createPC();
    // Generic sending RTP parameters for audio and video.
    _this30._extendedRtpCapabilities = extendedRtpCapabilities;
    _this30._remoteSdp = new RemoteSdp(direction, extendedRtpCapabilities);
    _this30._simulcast = !!settings && settings.simulcast;
    _this30.coreInstance = settings && settings.core;
    // Handle RTCPeerConnection connection status.
    _this30._pc.addEventListener("iceconnectionstatechange", function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this30)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var protocol, stats, statsList, remoteCandidate;
        return _regeneratorRuntime().wrap(function _callee29$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              protocol = "";
              _context30.next = 3;
              return this._pc.getStats();
            case 3:
              stats = _context30.sent;
              statsList = _toConsumableArray(stats.values());
              remoteCandidate = statsList.find(function (item) {
                return item.type === "remote-candidate";
              });
              if (remoteCandidate !== undefined) {
                protocol = remoteCandidate.protocol;
              }
              _context30.t0 = this._pc.iceConnectionState;
              _context30.next = _context30.t0 === "checking" ? 10 : _context30.t0 === "connected" ? 12 : _context30.t0 === "completed" ? 12 : _context30.t0 === "failed" ? 16 : _context30.t0 === "disconnected" ? 20 : _context30.t0 === "closed" ? 24 : 28;
              break;
            case 10:
              this.emit("@connectionstatechange", "connecting", protocol);
              return _context30.abrupt("break", 28);
            case 12:
              this.emit("@connectionstatechange", "connected", protocol);
              this.registerMediaStatisticStatsReport();
              this.registerPlayQualityReport();
              return _context30.abrupt("break", 28);
            case 16:
              this.emit("@connectionstatechange", "failed", protocol);
              this.unregisterMediaStatisticStatsReport();
              this.unregisterPlayQualityReport();
              return _context30.abrupt("break", 28);
            case 20:
              this.emit("@connectionstatechange", "disconnected", protocol);
              this.unregisterMediaStatisticStatsReport();
              this.unregisterPlayQualityReport();
              return _context30.abrupt("break", 28);
            case 24:
              this.emit("@connectionstatechange", "closed", protocol);
              this.unregisterMediaStatisticStatsReport();
              this.unregisterPlayQualityReport();
              return _context30.abrupt("break", 28);
            case 28:
            case "end":
              return _context30.stop();
          }
        }, _callee29, this);
      }));
    });
    return _this30;
  }
  _createClass(Handler, [{
    key: "getStats",
    value: function getStats(track, lastReportList) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        return _regeneratorRuntime().wrap(function _callee30$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return getPCStats(this._pc, track, this._direction, lastReportList);
            case 2:
              return _context31.abrupt("return", _context31.sent);
            case 3:
            case "end":
              return _context31.stop();
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "registerPlayQualityReport",
    value: function registerPlayQualityReport() {
      var _this31 = this;
      if (this._direction === "send") return;
      this.unregisterPlayQualityReport();
      this.playQualityIntervalId = window.setInterval(function () {
        return __awaiter(_this31, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
          var stats, _iterator16, _step16, stat, trackStats;
          return _regeneratorRuntime().wrap(function _callee31$(_context32) {
            while (1) switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return getQualityStats(this._pc, this.coreInstance);
              case 2:
                stats = _context32.sent;
                _iterator16 = _createForOfIteratorHelper(stats);
                try {
                  for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                    stat = _step16.value;
                    trackStats = this.qualityStats.get(stat.trackID);
                    if (trackStats) {
                      trackStats.push(stat);
                    } else {
                      this.qualityStats.set(stat.trackID, [stat]);
                    }
                  }
                } catch (err) {
                  _iterator16.e(err);
                } finally {
                  _iterator16.f();
                }
                this.addQualityStats();
              case 6:
              case "end":
                return _context32.stop();
            }
          }, _callee31, this);
        }));
      }, 2000);
    }
  }, {
    key: "unregisterPlayQualityReport",
    value: function unregisterPlayQualityReport() {
      if (this._direction === "send") return;
      if (this.playQualityIntervalId !== -1) {
        window.clearInterval(this.playQualityIntervalId);
        this.addQualityStats(true);
        this.playQualityIntervalId = -1;
      }
    }
  }, {
    key: "addQualityStats",
    value: function addQualityStats() {
      var isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var statsList = _toConsumableArray(this.qualityStats.values());
      var isAddNeeded = statsList.some(function (v) {
        return v.length >= 30;
      }); // 30 * 2, 1min
      if (isAddNeeded || isForce) {
        log.log("quality stats", this.qualityStats);
        var _iterator17 = _createForOfIteratorHelper(statsList),
          _step17;
        try {
          var _loop8 = function _loop8() {
            var stats = _step17.value;
            if (stats.length === 0) return 1; // continue
            var track_id = stats[0].trackID;
            var total_duration = stats.length * 2 * 1000;
            if (stats[0].kind === "video") {
              var freeze_duration = stats.reduce(function (pre, _, idx) {
                if (idx >= 1 && stats[idx].framesDecoded === stats[idx - 1].framesDecoded) {
                  return pre + 2;
                } else {
                  return pre;
                }
              }, 0) * 1000;
              qos.addEvent("VideoPlayQuality", {
                track_id: track_id,
                freeze_duration: freeze_duration,
                total_duration: total_duration
              });
            } else {
              var _freeze_duration = stats.reduce(function (pre, _, idx) {
                if (idx >= 1 && stats[idx].totalSamplesReceived === stats[idx - 1].totalSamplesReceived) {
                  return pre + 2;
                } else {
                  return pre;
                }
              }, 0) * 1000;
              qos.addEvent("AudioPlayQuality", {
                track_id: track_id,
                freeze_duration: _freeze_duration,
                total_duration: total_duration
              });
            }
          };
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            if (_loop8()) continue;
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
        this.qualityStats = new Map();
      }
    }
  }, {
    key: "registerMediaStatisticStatsReport",
    value: function registerMediaStatisticStatsReport() {
      var _this32 = this;
      this.unregisterMediaStatisticStatsReport();
      this.intervalId = window.setInterval(function () {
        return __awaiter(_this32, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
          var mediaStatistics;
          return _regeneratorRuntime().wrap(function _callee32$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return getMediaStatisticStats(this._pc, this.coreInstance);
              case 2:
                mediaStatistics = _context33.sent;
                if (mediaStatistics && mediaStatistics.length > 0) {
                  this.addMediaStatistics(mediaStatistics, this.lastMediaStatistics);
                  this.lastMediaStatistics = mediaStatistics;
                }
              case 4:
              case "end":
                return _context33.stop();
            }
          }, _callee32, this);
        }));
      }, 3000);
    }
  }, {
    key: "unregisterMediaStatisticStatsReport",
    value: function unregisterMediaStatisticStatsReport() {
      if (this.intervalId !== -1) {
        window.clearInterval(this.intervalId);
        this.lastMediaStatistics = [];
        this.intervalId = -1;
      }
    }
  }, {
    key: "addMediaStatistics",
    value: function addMediaStatistics(reports, lastReports) {
      var statistics = reports.map(function (report) {
        var expFilter = getStatisticExpFilter(report.id, report.kind);
        var lastReport = lastReports.find(function (lastReport) {
          return lastReport.id === report.id;
        });
        if (!lastReport) return report;
        var lastCalculationStats = lastReport.calculation_stats;
        var calculation_stats = report.calculation_stats,
          otherStats = __rest(report, ["calculation_stats"]);
        return Object.assign(Object.assign({}, otherStats), calculationMediaStatisticReport(calculation_stats, lastCalculationStats, expFilter));
      });
      log.log("media statistics", statistics);
      qos.addEvent("MediaStatistics", {
        cpu_loading: 0,
        track_stats: statistics
      });
      var maxLostRate = statistics.sort(function (a, b) {
        return b.packet_lost_rate - a.packet_lost_rate;
      })[0].packet_lost_rate;
      var maxRtt = statistics.sort(function (a, b) {
        return b.rtt - a.rtt;
      })[0].rtt;
      var networkGrade = getNetworkGrade(maxLostRate, maxRtt);
      qnCheckNetworkChangeQos(networkGrade);
      var tracks_qos = statistics.map(function (s) {
        return {
          kind: s.kind,
          lostRate: s.packet_lost_rate,
          rtt: s.rtt,
          track: s.track_id
        };
      });
      this.emit("@send-qos-message", {
        qos: JSON.stringify({
          networkGrade: networkGrade,
          tracks_qos: tracks_qos
        })
      });
    }
  }, {
    key: "getCurrentIceConnectionState",
    value: function getCurrentIceConnectionState() {
      return this._pc.iceConnectionState;
    }
  }, {
    key: "close",
    value: function close() {
      log.log("handle", this._direction, "close");
      this.removeAllListeners();
      this.unregisterMediaStatisticStatsReport();
      this.unregisterPlayQualityReport();
      this._pc.close();
      this.isPcReady = false;
    }
  }]);
  return Handler;
}(EnhancedEventEmitter);
var SendHandler = /*#__PURE__*/function (_Handler) {
  _inherits(SendHandler, _Handler);
  function SendHandler(extendedRtpCapabilities, signaling, settings) {
    var _this33;
    _classCallCheck(this, SendHandler);
    _this33 = _possibleConstructorReturn(this, _getPrototypeOf(SendHandler).call(this, "send", extendedRtpCapabilities, settings));
    log.log("init send handler");
    // Got transport local and remote parameters.
    _this33._transportReady = false;
    // Local stream.
    _this33._stream = new MediaStream();
    _this33._signaling = signaling;
    signaling.on("on-pubpc-state", function (res) {
      if (_this33._remoteSdp.transportRemoteParameters && res.pcid === _this33._remoteSdp.transportRemoteParameters.pcid) {
        if (!res.connected) {
          _this33.emit("@connectionstatechange", "remote-disconnected");
        }
      }
    });
    return _this33;
  }
  _createClass(SendHandler, [{
    key: "getReady",
    value: function getReady(transportRemoteParameters) {
      var _this34 = this;
      return new Promise(function (resolve, reject) {
        var callback = function callback(res) {
          if (res.pcid === transportRemoteParameters.pcid) {
            _this34._signaling.off("on-pubpc-state", callback);
            if (res.connected) {
              _this34.isPcReady = true;
              resolve();
            } else {
              // 此时会被 constructor 中的时间监听捕获，触发重连，所以这里既不 reject 也不 resolve
              return;
            }
          }
        };
        _this34._signaling.on("on-pubpc-state", callback);
      });
    }
  }, {
    key: "addProducerTracks",
    value: function addProducerTracks(producerTracks) {
      var _this35 = this;
      log.debug("add producer", producerTracks);
      var tracks = producerTracks.filter(function (track) {
        return !_this35._stream.getTrackById(track.mediaTrack.id);
      });
      if (tracks.length === 0) {
        return Promise.reject(new Error("track already added"));
      }
      var rtpSenders;
      var transceivers = [];
      var localSdp;
      var shouldSendPubTracks = true;
      return Promise.resolve().then(function () {
        return __awaiter(_this35, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
          var _this36 = this;
          var _iterator18, _step18, _track, _iterator19, _step19, track, transceiver;
          return _regeneratorRuntime().wrap(function _callee33$(_context34) {
            while (1) switch (_context34.prev = _context34.next) {
              case 0:
                _iterator18 = _createForOfIteratorHelper(tracks);
                try {
                  for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                    _track = _step18.value;
                    this._stream.addTrack(_track.mediaTrack);
                  }
                } catch (err) {
                  _iterator18.e(err);
                } finally {
                  _iterator18.f();
                }
                if (!(browserReport.unifiedPlan && browserReport.supportTransceivers)) {
                  _context34.next = 25;
                  break;
                }
                _iterator19 = _createForOfIteratorHelper(tracks);
                _context34.prev = 4;
                _iterator19.s();
              case 6:
                if ((_step19 = _iterator19.n()).done) {
                  _context34.next = 15;
                  break;
                }
                track = _step19.value;
                _context34.next = 10;
                return addTransceiver(track.mediaTrack, this._pc, track.lowStreamConfig, track.info.kbps, this._stream);
              case 10:
                transceiver = _context34.sent;
                log.debug("add transceiver", transceiver, transceiver.mid);
                transceivers.push(transceiver);
              case 13:
                _context34.next = 6;
                break;
              case 15:
                _context34.next = 20;
                break;
              case 17:
                _context34.prev = 17;
                _context34.t0 = _context34["catch"](4);
                _iterator19.e(_context34.t0);
              case 20:
                _context34.prev = 20;
                _iterator19.f();
                return _context34.finish(20);
              case 23:
                _context34.next = 27;
                break;
              case 25:
                log.debug("add tracks", tracks);
                rtpSenders = tracks.map(function (track) {
                  return _this36._pc.addTrack(track.mediaTrack, _this36._stream);
                });
              case 27:
                return _context34.abrupt("return", createPcOffer(this._pc, this._simulcast));
              case 28:
              case "end":
                return _context34.stop();
            }
          }, _callee33, this, [[4, 17, 20, 23]]);
        }));
      }).then(function (offer) {
        var _offer;
        if (browserReport.needH264FmtpLine) {
          offer.sdp += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat(NEW_LINE);
        }
        _offer = {
          type: "offer",
          sdp: offer.sdp
        };
        localSdp = _offer.sdp;
        log.log("publish: set local offer", _offer);
        return _this35._pc.setLocalDescription(_offer);
      }).then(function () {
        var _loop9 = function _loop9() {
          var transceiver = _transceivers[_i4];
          if (!transceiver.sender.track) return 1; // continue
          var targetProducerTrack = producerTracks.find(function (t) {
            return t.mediaTrack === transceiver.sender.track;
          });
          if (!targetProducerTrack || !transceiver.mid) {
            throw ERROR_FATAL("can not get transceiver mid!");
          }
          targetProducerTrack.setInfo({
            mid: transceiver.mid
          });
          _this35.midRidEncoding[transceiver.mid] = targetProducerTrack.lowStreamConfig;
        };
        for (var _i4 = 0, _transceivers = transceivers; _i4 < _transceivers.length; _i4++) {
          if (_loop9()) continue;
        }
        if (!_this35._transportReady) {
          shouldSendPubTracks = false;
          return _this35._setupTransport(producerTracks);
        }
      }).then(function () {
        // localSdpObj = sdpTransform.parse((this._pc.localDescription as RTCSessionDescription).sdp);
        // genPubAnswer
        return _this35._remoteSdp.createRemoteAnswer(localSdp, _this35.midRidEncoding, _this35.removeMids);
      }).then(function (remoteSdp) {
        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        log.debug("addProducer answer", answer);
        // logger.debug(
        //   'addProducer() | calling pc.setRemoteDescription() [answer:%o]',
        //   answer);
        return _this35._pc.setRemoteDescription(answer);
      }).then(function () {
        return _this35._pcReady;
      }).then(function () {
        if (shouldSendPubTracks) {
          return _this35.safeEmitAsPromise("@needpubtracks", producerTracks, localSdp);
        } else {
          return Promise.resolve(_this35._remoteSdp.transportRemoteParameters);
        }
      }).catch(function (error) {
        // Panic here. Try to undo things.
        log.log("add producer error", error);
        try {
          var _iterator20 = _createForOfIteratorHelper(rtpSenders),
            _step20;
          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var rtpSender = _step20.value;
              _this35._pc.removeTrack(rtpSender);
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
          for (var _i5 = 0, _transceivers2 = transceivers; _i5 < _transceivers2.length; _i5++) {
            var transceiver = _transceivers2[_i5];
            transceiver.direction = "inactive";
          }
        } catch (error2) {}
        var _iterator21 = _createForOfIteratorHelper(tracks),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var track = _step21.value;
            _this35._stream.removeTrack(track.mediaTrack);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
        if (error instanceof QNRTCError) {
          throw error;
        } else {
          throw ERROR_FATAL(error);
        }
      });
    }
  }, {
    key: "removeProducerTracks",
    value: function removeProducerTracks(producerTracks) {
      var _this37 = this;
      log.debug("removeProducerTracks", producerTracks);
      var tracks = producerTracks.filter(function (pcTrack) {
        if (pcTrack.track === undefined) return false;
        if (!_this37._stream.getTrackById(pcTrack.track.mediaTrack.id)) {
          return false;
        }
        return true;
      }).map(function (pcTrack) {
        return pcTrack.track.isReplacedByImageTrack ? pcTrack.track.imageStreamTrack.mediaTrack : pcTrack.track.mediaTrack;
      });
      var localSdp;
      return Promise.resolve().then(function () {
        if (browserReport.unifiedPlan && browserReport.supportTransceivers) {
          _this37._pc.getTransceivers().forEach(function (transceiver) {
            if (transceiver.sender.track && transceiver.mid && tracks.includes(transceiver.sender.track)) {
              _this37.removeMids.add(transceiver.mid);
            }
            // use answer reject, no need stop
            // transceiver.stop();
          });
        }
        var rtpSenders = _this37._pc.getSenders().filter(function (s) {
          return s.track && tracks.includes(s.track);
        });
        if (rtpSenders.length === 0) {
          log.warning("removeProducerTracks [nothing to remove]");
          return Promise.reject("removeProducerTracks: nothing to remote");
        }
        // Remove the associated RtpSender.
        var _iterator22 = _createForOfIteratorHelper(rtpSenders),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var rtpSender = _step22.value;
            _this37._pc.removeTrack(rtpSender);
          }
          // Remove the track from the local stream.
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
        var _iterator23 = _createForOfIteratorHelper(tracks),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var track = _step23.value;
            _this37._stream.removeTrack(track);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
        return createPcOffer(_this37._pc, _this37._simulcast);
      }).then(function (offer) {
        var description = new RTCSessionDescription(offer);
        localSdp = description.sdp;
        log.log("unpublish: set local offer", description);
        return _this37._pc.setLocalDescription(description);
      }).then(function () {
        var remoteSdp = _this37._remoteSdp.createRemoteAnswer(localSdp, _this37.midRidEncoding, _this37.removeMids);
        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        log.log("unpublish: set remote answer", answer);
        return _this37._pc.setRemoteDescription(answer);
      }).catch(function (error) {
        // NOTE: If there are no sending tracks, setLocalDescription() will fail with
        // "Failed to create channels". If so, ignore it.
        if (_this37._stream.getTracks().length === 0) {
          log.debug("removeProducer() | ignoring expected error due no sending tracks: %s", error.toString());
          return;
        }
        if (error instanceof QNRTCError) {
          throw error;
        } else {
          throw ERROR_FATAL(error);
        }
      }).then(function () {
        // no need to wait response
        _this37.safeEmitAsPromise("@needunpubtracks", producerTracks);
      });
    }
  }, {
    key: "replaceTrack",
    value: function replaceTrack(producerTrack, newTrack) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var sender, oldTrack;
        return _regeneratorRuntime().wrap(function _callee34$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (this._pc.getSenders) {
                _context35.next = 2;
                break;
              }
              throw ERROR_FATAL("getSenders is not supported.");
            case 2:
              sender = this._pc.getSenders().find(function (sender) {
                if (!sender.track) return false;
                if (!producerTrack.track) return false;
                var sendTrackId = sender.track.id;
                if (producerTrack.track.mediaTrack && sendTrackId === producerTrack.track.mediaTrack.id) {
                  return true;
                }
                if (producerTrack.track.imageStreamTrack && sendTrackId === producerTrack.track.imageStreamTrack.id) {
                  return true;
                }
                return false;
              });
              if (sender) {
                _context35.next = 5;
                break;
              }
              throw ERROR_FATAL("sender not found when replaceTrack: ".concat(producerTrack.trackID));
            case 5:
              if (sender.replaceTrack) {
                _context35.next = 7;
                break;
              }
              throw ERROR_FATAL("replaceTrack is not supported.");
            case 7:
              if (producerTrack.track) {
                producerTrack.track.mediaTrack = newTrack;
                producerTrack.track.removeMediaElement();
              }
              oldTrack = sender.track;
              _context35.next = 11;
              return sender.replaceTrack(newTrack);
            case 11:
              this._stream.removeTrack(oldTrack);
              this._stream.addTrack(newTrack);
            case 13:
            case "end":
              return _context35.stop();
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "replaceProducerTrack",
    value: function replaceProducerTrack(producerTrack, target) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var sender;
        return _regeneratorRuntime().wrap(function _callee35$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (this._pc.getSenders) {
                _context36.next = 2;
                break;
              }
              throw ERROR_FATAL("getSenders is not supported.");
            case 2:
              // find the sender corresponding to producerTrack 
              sender = this._pc.getSenders().find(function (sender) {
                if (!sender.track) return false;
                if (!producerTrack.track) return false;
                var sendTrackId = sender.track.id;
                if (producerTrack.track.mediaTrack && sendTrackId === producerTrack.track.mediaTrack.id) {
                  return true;
                }
                if (producerTrack.track.imageStreamTrack && sendTrackId === producerTrack.track.imageStreamTrack.id) {
                  return true;
                }
                return false;
              });
              if (sender) {
                _context36.next = 5;
                break;
              }
              throw ERROR_FATAL("sender not found when replaceProducerTrack: ".concat(producerTrack.trackID));
            case 5:
              if (sender.replaceTrack) {
                _context36.next = 7;
                break;
              }
              throw ERROR_FATAL("replaceTrack is not supported.");
            case 7:
              if (!(target === "image")) {
                _context36.next = 13;
                break;
              }
              log.debug("replaceTrack", producerTrack.track.imageStreamTrack.mediaTrack);
              _context36.next = 11;
              return sender.replaceTrack(producerTrack.track.imageStreamTrack.mediaTrack);
            case 11:
              _context36.next = 17;
              break;
            case 13:
              if (!(target === "video")) {
                _context36.next = 17;
                break;
              }
              log.debug("replaceTrack", producerTrack.track.mediaTrack);
              _context36.next = 17;
              return sender.replaceTrack(producerTrack.track.mediaTrack);
            case 17:
            case "end":
              return _context36.stop();
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "restartICE",
    value: function restartICE(iceParameters, iceCandidates) {
      var _this38 = this;
      log.log("restart send ice");
      this._isRestartingICE = true;
      return Promise.resolve().then(function () {
        return _this38._remoteSdp.updateICEData(iceParameters, iceCandidates);
      }).then(function () {
        return createPcOffer(_this38._pc, _this38._simulcast, {
          iceRestart: true
        });
      }).then(function (offer) {
        return _this38._pc.setLocalDescription(offer);
      }).then(function () {
        var remoteSdp = _this38._remoteSdp.createRemoteAnswer(_this38._pc.localDescription.sdp, _this38.midRidEncoding, _this38.removeMids);
        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        return _this38._pc.setRemoteDescription(answer);
      });
    } // needpubpc
  }, {
    key: "_setupTransport",
    value: function _setupTransport(tracks) {
      var _this39 = this;
      var startTime = Date.now();
      return Promise.resolve().then(function () {
        if (!_this39._pc.localDescription) {
          return createPcOffer(_this39._pc, _this39._simulcast);
        }
        return _this39._pc.localDescription;
      }).then(function (localDescription) {
        // We need transport remote parameters.
        return _this39.safeEmitAsPromise("@needpubpc", localDescription.sdp, tracks);
      }).then(function (transportRemoteParameters) {
        qos.addEvent("PublisherPC", {
          signal_take_time: Date.now() - startTime,
          result_code: transportRemoteParameters.code,
          up_stream_ip: (transportRemoteParameters.iceCandidates || []).map(function (_ref) {
            var ip = _ref.ip;
            return ip;
          }).join(","),
          tracks: transportRemoteParameters.tracks.map(function (t) {
            var targetTrack = tracks.find(function (track) {
              return track.mediaTrack.id === t.localid;
            });
            if (!targetTrack) return undefined;
            return {
              local_id: t.localid,
              track_id: t.trackid,
              source_type: targetTrack.sourceType,
              kind: targetTrack.info.kind,
              tag: targetTrack.info.tag || "",
              muted: !!targetTrack.info.muted,
              master: !!targetTrack.master,
              kbps: targetTrack.info.kbps || -1,
              encode_video_width: 0,
              encode_video_height: 0
            };
          }).filter(function (t) {
            return t !== undefined;
          })
        });
        _this39.pcid = transportRemoteParameters.pcid;
        _this39._transportReady = true;
        _this39._pcReady = _this39.getReady(transportRemoteParameters);
        // Provide the remote SDP handler with transport remote parameters.
        return _this39._remoteSdp.setTransportRemoteParameters(transportRemoteParameters);
      });
    }
  }]);
  return SendHandler;
}(Handler);
var RecvHandler = /*#__PURE__*/function (_Handler2) {
  _inherits(RecvHandler, _Handler2);
  function RecvHandler(extendedRtpCapabilities, signaling, settings) {
    var _this40;
    _classCallCheck(this, RecvHandler);
    _this40 = _possibleConstructorReturn(this, _getPrototypeOf(RecvHandler).call(this, "recv", extendedRtpCapabilities, settings));
    _this40._transportCreated = false;
    _this40._consumerInfos = new Map();
    _this40._signaling = signaling;
    signaling.on("on-subpc-state", function (res) {
      if (_this40._remoteSdp.transportRemoteParameters && res.pcid === _this40._remoteSdp.transportRemoteParameters.pcid) {
        if (!res.connected) {
          _this40.emit("@connectionstatechange", "remote-disconnected");
        }
      }
    });
    log.log("init recvhandler", _assertThisInitialized(_assertThisInitialized(_this40)));
    return _this40;
  }
  _createClass(RecvHandler, [{
    key: "getReady",
    value: function getReady(transportRemoteParameters) {
      var _this41 = this;
      return new Promise(function (resolve, reject) {
        var callback = function callback(res) {
          if (res.pcid === transportRemoteParameters.pcid) {
            _this41._signaling.off("on-subpc-state", callback);
            if (res.connected) {
              _this41.isPcReady = true;
              resolve();
            } else {
              // 此时会被 constructor 中的时间监听捕获，触发重连，所以这里既不 reject 也不 resolve
              return;
            }
          }
        };
        _this41._signaling.on("on-subpc-state", callback);
      });
    }
    /**
     * 如果发生了重复订阅的情况，策略是直接返回已经保存的 track 信息
     * 也就是无论传入的 consumer 是否重复，都返回和传入数量一致的 MediaStreamTrack
     */
  }, {
    key: "addConsumerTracks",
    value: function addConsumerTracks(consumers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var _this42 = this;
        var tracks, _iterator24, _step24, consumer, track, consumerInfoList, _consumerInfoArray, _iterator25, _step25, _loop11;
        return _regeneratorRuntime().wrap(function _callee36$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (!(browserReport.unifiedPlan && isFirefox)) {
                _context38.next = 22;
                break;
              }
              tracks = [];
              _iterator24 = _createForOfIteratorHelper(consumers);
              _context38.prev = 3;
              _iterator24.s();
            case 5:
              if ((_step24 = _iterator24.n()).done) {
                _context38.next = 13;
                break;
              }
              consumer = _step24.value;
              _context38.next = 9;
              return this.addConsumerTrack(consumer);
            case 9:
              track = _context38.sent;
              tracks.push(track);
            case 11:
              _context38.next = 5;
              break;
            case 13:
              _context38.next = 18;
              break;
            case 15:
              _context38.prev = 15;
              _context38.t0 = _context38["catch"](3);
              _iterator24.e(_context38.t0);
            case 18:
              _context38.prev = 18;
              _iterator24.f();
              return _context38.finish(18);
            case 21:
              return _context38.abrupt("return", tracks);
            case 22:
              log.log("add consumers", consumers);
              consumerInfoList = [];
              _consumerInfoArray = Array.from(this._consumerInfos.values());
              _iterator25 = _createForOfIteratorHelper(consumers);
              _context38.prev = 26;
              _loop11 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop11() {
                var consumer, info, newInfo, mid;
                return _regeneratorRuntime().wrap(function _loop11$(_context37) {
                  while (1) switch (_context37.prev = _context37.next) {
                    case 0:
                      consumer = _step25.value;
                      info = _consumerInfoArray.find(function (i) {
                        return i.consumerId === consumer.id;
                      });
                      if (info && !info.closed) {
                        consumerInfoList.push(info);
                      } else {
                        newInfo = _this42.genNewConsumerInfo(consumer);
                        if (browserReport.unifiedPlan) {
                          // 递增 mid, plan-b 模式下不会使用到这个参数
                          mid = consumer.mid;
                          newInfo.mid = mid;
                          _this42._consumerInfos.set(mid, newInfo);
                        } else {
                          _this42._consumerInfos.set(consumer.id, newInfo);
                        }
                        consumerInfoList.push(newInfo);
                      }
                    case 3:
                    case "end":
                      return _context37.stop();
                  }
                }, _loop11);
              });
              _iterator25.s();
            case 29:
              if ((_step25 = _iterator25.n()).done) {
                _context38.next = 33;
                break;
              }
              return _context38.delegateYield(_loop11(), "t1", 31);
            case 31:
              _context38.next = 29;
              break;
            case 33:
              _context38.next = 38;
              break;
            case 35:
              _context38.prev = 35;
              _context38.t2 = _context38["catch"](26);
              _iterator25.e(_context38.t2);
            case 38:
              _context38.prev = 38;
              _iterator25.f();
              return _context38.finish(38);
            case 41:
              return _context38.abrupt("return", Promise.resolve().then(function () {
                // createremoteSdp
                var remoteSdp = _this42._remoteSdp.createRemoteOffer(Array.from(_this42._consumerInfos.values()));
                var offer = {
                  type: "offer",
                  sdp: remoteSdp
                };
                log.debug("subscribe: set remote offer", offer);
                return _this42._pc.setRemoteDescription(offer);
              }).then(function () {
                if (browserReport.unifiedPlan) {
                  return _this42._pc.createAnswer();
                }
                return _this42._pc.createAnswer();
              }).then(function (answer) {
                log.debug("subscribe, set local answer", answer);
                return _this42._pc.setLocalDescription(answer);
              })
              // .then(() => {
              //   if (!this._transportUpdated) { return this._updateTransport(); }
              // })
              .then(function () {
                return _this42._pcReady;
              }).then(function () {
                var _loop10 = function _loop10() {
                  var consumerInfo = consumerInfoList[i];
                  var consumer = consumers[i];
                  if (consumer.track) return 1; // continue
                  if (browserReport.unifiedPlan) {
                    var transceiver = _this42._pc.getTransceivers().find(function (transceiver) {
                      if (!transceiver.receiver.track) {
                        return false;
                      }
                      if (transceiver.receiver.track.id === consumerInfo.trackID || transceiver.mid === consumerInfo.mid) {
                        return true;
                      }
                      return false;
                    });
                    if (transceiver) {
                      consumer.track = transceiver.receiver.track;
                    }
                  } else {
                    // chrome 55 以下不支持 getReceivers，使用 getRemoteStreams
                    if (browserReport.getReceivers) {
                      var receiver = _this42._pc.getReceivers().find(function (rtpReceiver) {
                        var track = rtpReceiver.track;
                        if (!track) {
                          return false;
                        }
                        if (consumerInfo.trackID === track.id) {
                          return true;
                        }
                        return false;
                      });
                      if (receiver) {
                        consumer.track = receiver.track;
                      }
                    } else {
                      var stream = _this42._pc.getRemoteStreams().find(function (s) {
                        return s.id === consumerInfo.streamId;
                      });
                      if (stream) {
                        consumer.track = stream.getTrackById(consumerInfo.trackID);
                      }
                    }
                  }
                  if (!consumer.track) {
                    throw ERROR_FATAL("remote track not found");
                  }
                  log.log("subscribe: get new track", consumer.track);
                };
                for (var i = 0; i < consumerInfoList.length; i += 1) {
                  if (_loop10()) continue;
                }
                return consumers.map(function (c) {
                  return c.track;
                });
              }));
            case 42:
            case "end":
              return _context38.stop();
          }
        }, _callee36, this, [[3, 15, 18, 21], [26, 35, 38, 41]]);
      }));
    }
  }, {
    key: "genNewConsumerInfo",
    value: function genNewConsumerInfo(consumer) {
      var encoding = consumer.rtpParameters.encodings[0];
      var cname = consumer.rtpParameters.rtcp.cname;
      var mid = consumer.mid;
      var newInfo = {
        kind: consumer.kind,
        streamId: browserReport.unifiedPlan ? consumer.rtpParameters.msid : "recv-stream-".concat(encoding.ssrc),
        trackID: browserReport.unifiedPlan ? "consumer-".concat(consumer.kind, "-").concat(mid) : "consumer-".concat(consumer.kind, "-").concat(encoding.ssrc),
        ssrc: encoding.ssrc,
        rtxSsrc: encoding.rtx ? encoding.rtx.ssrc : undefined,
        cname: cname,
        consumerId: consumer.id,
        closed: false
      };
      return newInfo;
    }
  }, {
    key: "addConsumerTrack",
    value: function addConsumerTrack(consumer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var _this43 = this;
        var consumerInfo, _consumerInfoArray, info, newInfo, mid;
        return _regeneratorRuntime().wrap(function _callee37$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              log.log("add consumer", consumer);
              consumerInfo = null;
              _consumerInfoArray = Array.from(this._consumerInfos.values());
              info = _consumerInfoArray.find(function (i) {
                return i.consumerId === consumer.id;
              });
              if (info && !info.closed) {
                consumerInfo = info;
              } else {
                newInfo = this.genNewConsumerInfo(consumer);
                if (browserReport.unifiedPlan) {
                  // plan-b 模式下不会使用到这个参数
                  mid = consumer.mid;
                  newInfo.mid = mid;
                  this._consumerInfos.set(mid, newInfo);
                } else {
                  this._consumerInfos.set(consumer.id, newInfo);
                }
                consumerInfo = newInfo;
              }
              return _context39.abrupt("return", Promise.resolve().then(function () {
                // createremoteSdp
                var remoteSdp = _this43._remoteSdp.createRemoteOffer(Array.from(_this43._consumerInfos.values()));
                var offer = {
                  type: "offer",
                  sdp: remoteSdp
                };
                log.log("set ontrack");
                _this43._pc.ontrack = function (e) {
                  log.log("ontrack", e.receiver.track);
                };
                log.debug("subscribe: set remote offer", offer);
                return _this43._pc.setRemoteDescription(offer);
              }).then(function () {
                return _this43._pc.createAnswer();
              }).then(function (answer) {
                log.debug("subscribe, set local answer", answer);
                return _this43._pc.setLocalDescription(answer);
              })
              // .then(() => {
              //   if (!this._transportUpdated) { return this._updateTransport(); }
              // })
              .then(function () {
                return _this43._pcReady;
              }).then(function () {
                var newTrack = null;
                if (browserReport.unifiedPlan && browserReport.supportTransceivers && !!consumer && !!consumerInfo) {
                  var transceiver = _this43._pc.getTransceivers().find(function (transceiver) {
                    if (!transceiver.receiver.track) {
                      return false;
                    }
                    if (transceiver.receiver.track.id === consumerInfo.trackID || transceiver.mid === consumerInfo.mid) {
                      consumer.track = transceiver.receiver.track;
                      return true;
                    }
                    return false;
                  });
                  if (transceiver) {
                    newTrack = transceiver.receiver.track;
                  }
                } else if (!!consumer && !!consumerInfo) {
                  var receiver = _this43._pc.getReceivers().find(function (rtpReceiver) {
                    var track = rtpReceiver.track;
                    if (!track) {
                      return false;
                    }
                    if (consumerInfo.trackID === track.id) {
                      consumer.track = track;
                      return true;
                    }
                    return false;
                  });
                  if (receiver) {
                    newTrack = receiver.track;
                  }
                }
                if (!newTrack && !!consumer) {
                  throw ERROR_FATAL("remote track not found");
                }
                log.log("subscribe: get new track", newTrack, newTrack.readyState);
                return newTrack;
              }));
            case 6:
            case "end":
              return _context39.stop();
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "removeConsumerTracks",
    value: function removeConsumerTracks(consumers) {
      var _this44 = this;
      log.log("remove consumer", consumers);
      var needToUpdateOffer = false;
      var _iterator26 = _createForOfIteratorHelper(consumers),
        _step26;
      try {
        var _loop12 = function _loop12() {
          var consumer = _step26.value;
          var info = Array.from(_this44._consumerInfos.values()).find(function (i) {
            return i.consumerId === consumer.id && !i.closed;
          });
          if (!info) {
            log.log("can not find unpublish track target, ignore");
            return 1; // continue
          }
          needToUpdateOffer = true;
          /**
           * 对于 unified-plan 不能直接删除 consumer
           * 因为重协商必须保证前后 mid 只增不减，这里将 consumer 置为 closed
           * 使得生成 sdp 的时候改 mid 不会带上 ssrc 和 ext，也就不会产生订阅
           */
          if (browserReport.unifiedPlan) {
            consumer.track = null;
            info.closed = true;
          } else {
            _this44._consumerInfos.delete(consumer.id);
          }
        };
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          if (_loop12()) continue;
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      if (!needToUpdateOffer) return Promise.resolve();
      return Promise.resolve().then(function () {
        var remoteSdp = _this44._remoteSdp.createRemoteOffer(Array.from(_this44._consumerInfos.values()));
        var offer = {
          type: "offer",
          sdp: remoteSdp
        };
        log.log("unsubscribe set remote offer", offer);
        return _this44._pc.setRemoteDescription(offer);
      }).then(function () {
        return _this44._pc.createAnswer();
      }).then(function (answer) {
        log.log("unsubscribe set local answer", answer);
        return _this44._pc.setLocalDescription(answer);
      });
    }
  }, {
    key: "restartICE",
    value: function restartICE(iceParameters, iceCandidates) {
      var _this45 = this;
      log.log("recv restart ice");
      this._isRestartingICE = true;
      return Promise.resolve().then(function () {
        return _this45._remoteSdp.updateICEData(iceParameters, iceCandidates);
      }).then(function () {
        var remoteSdp = _this45._remoteSdp.createRemoteOffer(Array.from(_this45._consumerInfos.values()));
        var offer = {
          type: "offer",
          sdp: remoteSdp
        };
        return _this45._pc.setRemoteDescription(offer);
      }).then(function () {
        return _this45._pc.createAnswer();
      }).then(function (answer) {
        _this45._pc.setLocalDescription(answer);
      });
    }
  }, {
    key: "setupTransport",
    value: function setupTransport(trackIDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var startTime, transportRemoteParameters;
        return _regeneratorRuntime().wrap(function _callee38$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              if (!this._transportCreated) {
                _context40.next = 4;
                break;
              }
              _context40.next = 3;
              return this._pcReady;
            case 3:
              return _context40.abrupt("return", _context40.sent);
            case 4:
              startTime = Date.now();
              _context40.next = 7;
              return this.safeEmitAsPromise("@needsubpc", trackIDs);
            case 7:
              transportRemoteParameters = _context40.sent;
              qos.addEvent("SubscriberPC", {
                signal_take_time: Date.now() - startTime,
                result_code: transportRemoteParameters.code,
                down_stream_ip: (transportRemoteParameters.iceCandidates || []).map(function (_ref2) {
                  var ip = _ref2.ip;
                  return ip;
                }).join(","),
                tracks: transportRemoteParameters.tracks.map(function (t) {
                  return {
                    track_id: t.trackid,
                    status: t.status
                  };
                })
              });
              this.pcid = transportRemoteParameters.pcid;
              this._transportCreated = true;
              this._pcReady = this.getReady(transportRemoteParameters);
              log.log("init subscribe, get transport remote", transportRemoteParameters);
              _context40.next = 15;
              return this._remoteSdp.setTransportRemoteParameters(transportRemoteParameters);
            case 15:
              return _context40.abrupt("return", transportRemoteParameters);
            case 16:
            case "end":
              return _context40.stop();
          }
        }, _callee38, this);
      }));
    }
  }]);
  return RecvHandler;
}(Handler);
function createPcOffer(pc, simulcast, offerOptions) {
  return pc.createOffer(offerOptions).then(function (offer) {
    var type = offer.type,
      sdp = offer.sdp;
    if (!sdp) {
      return offer;
    }
    // 注释移除 red 编码器的逻辑，服务端已提供支持
    // sdp = removeAudioREDLine(sdp);
    sdp = removeVideOrientation(sdp);
    if (browser.name === 'chrome' && simulcast) {
      sdp = transformOfferSdp(sdp, 3);
    }
    return {
      type: type,
      sdp: sdp
    };
  });
}
function getHandler(direction, extendedRtpCapabilities, signaling, settings) {
  // let rtpParametersByKind;
  switch (direction) {
    case "send":
      {
        return new SendHandler(extendedRtpCapabilities, signaling, settings);
      }
    case "recv":
      {
        return new RecvHandler(extendedRtpCapabilities, signaling, settings);
      }
  }
}
var TaskCommandEnum;
(function (TaskCommandEnum) {
  TaskCommandEnum["SEND_TRACKS"] = "@transport:send-tracks";
  TaskCommandEnum["RESTART_SEND_ICE"] = "@transport:send-restart-ice";
  TaskCommandEnum["REMOVE_TRACKS"] = "@transport:remove-tracks";
  TaskCommandEnum["INIT_RECV"] = "@transport:init-recv";
  TaskCommandEnum["RESTART_RECV_ICE"] = "@transport:recv-restart-ice";
  TaskCommandEnum["ADD_CONUMERS"] = "@transport:add-consumers";
  TaskCommandEnum["REMOVE_CONSUMERS"] = "@transport:remove-consumers";
})(TaskCommandEnum || (TaskCommandEnum = {}));
var ConnectionTransport = /*#__PURE__*/function (_EnhancedEventEmitter5) {
  _inherits(ConnectionTransport, _EnhancedEventEmitter5);
  _createClass(ConnectionTransport, [{
    key: "publishTracks",
    get: function get() {
      return Array.from(this._publishTracks.values());
    }
  }]);
  function ConnectionTransport(rtpcap, signaling, core, simulcast) {
    var _this46;
    _classCallCheck(this, ConnectionTransport);
    _this46 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionTransport).call(this));
    _this46.sendCommandQueue = new TaskQueue("SendQueue");
    _this46.recvCommandQueue = new TaskQueue("RecvQueue");
    _this46.simulcast = false;
    /**
     * sub-pc 创建单独走一个 queue
     */
    _this46.recvInitCommandQueue = new TaskQueue("RecvInitQueue");
    _this46.sendTrackQueue = [];
    _this46.consumerQueue = [];
    _this46._publishTracks = new Map();
    _this46.extendedRtpCapabilities = rtpcap;
    _this46.signaling = signaling;
    _this46.simulcast = !!simulcast;
    _this46.coreInstance = core;
    _this46.sendHandler = getHandler("send", rtpcap, signaling, {
      simulcast: _this46.simulcast,
      core: _this46.coreInstance
    });
    _this46.recvHandler = getHandler("recv", rtpcap, signaling, {
      simulcast: _this46.simulcast,
      core: _this46.coreInstance
    });
    _this46.handleSendHandler();
    _this46.handleRecvHandler();
    _this46.sendCommandQueue.on("exec", _this46.handleSendCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this46))));
    _this46.recvCommandQueue.on("exec", _this46.handleRecvCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this46))));
    _this46.recvInitCommandQueue.on("exec", _this46.handleRecvInitCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this46))));
    _this46.initSubPcPromise = new Promise(function (resolve) {
      _this46.initSubPcPromiseResolve = resolve;
    });
    return _this46;
  }
  _createClass(ConnectionTransport, [{
    key: "resolveInitSubPcPromise",
    value: function resolveInitSubPcPromise() {
      if (!this.initSubPcPromiseResolve) return;
      this.initSubPcPromiseResolve();
      this.initSubPcPromiseResolve = undefined;
    }
  }, {
    key: "handleSendHandler",
    value: function handleSendHandler() {
      var _this47 = this;
      this.sendHandler.on("@needpubpc", function (sdp, tracks, cb, errcb) {
        _this47.safeEmitAsPromise("@needpubpc", sdp, tracks).then(cb).catch(errcb);
      }).on("@connectionstatechange", function (state, protocol) {
        log.log("pubpc connectionstatechange", state);
        qos.addEvent("ICEConnectionState", {
          pc_type: 0,
          state: state,
          id: _this47.sendHandler.pcid,
          protocol: protocol,
          //-------Qos打点v2优化--------
          //若 state 为 FAILED，则等级为 SERVERE，否则为 NORMAL
          event_grade: state === "failed" ? QNEventGrade.SERVERE : QNEventGrade.NORMAL,
          event_category: QNEventCategory.CORE
        });
        switch (state) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            {
              if (_this47.signaling.state === SignalingState.OPEN) {
                _this47.reconnectProducer();
              } else {
                _this47.sendHandler.close();
              }
              break;
            }
          case "disconnected":
            {
              if (_this47.sendHandler._isRestartingICE || !_this47.sendHandler.pcid) return;
              if (_this47.signaling.state === SignalingState.OPEN) {
                _this47.restartSendICE(_this47.sendHandler.pcid);
              } else {
                _this47.signaling.once("@signalingauth", function (data) {
                  if (_this47.sendHandler.getCurrentIceConnectionState() !== "disconnected") return;
                  _this47.extendedRtpCapabilities = data.rtpcaps;
                  _this47.restartSendICE(_this47.sendHandler.pcid);
                });
              }
              break;
            }
        }
      }).on("@needpubtracks", function (targetTracks, sdp, cb, errcb) {
        var publishTrackData = targetTracks.map(transferTrackToPublishTrack);
        var startTime = Date.now();
        _this47.signaling.request("pub-tracks", {
          tracks: publishTrackData,
          sdp: sdp
        }).then(function (data) {
          qos.addEvent("PublishTracks", {
            signal_take_time: Date.now() - startTime,
            result_code: data.code,
            tracks: data.tracks.map(function (t) {
              var targetTrack = targetTracks.find(function (track) {
                return track.mediaTrack.id === t.localid;
              });
              if (!targetTrack) return undefined;
              return {
                local_id: t.localid,
                track_id: t.trackid,
                source_type: targetTrack.sourceType,
                kind: targetTrack.info.kind,
                tag: targetTrack.info.tag || "",
                muted: !!targetTrack.info.muted,
                master: !!targetTrack.master,
                kbps: targetTrack.info.kbps || -1,
                encode_video_width: 0,
                encode_video_height: 0
              };
            }).filter(function (t) {
              return t !== undefined;
            })
          });
          switch (data.code) {
            case 0:
              break;
            case 10052:
              return errcb(SERVER_UNAVAILABLE());
            // pc 断开，重新走 pub-pc 的过程
            case 10061:
              _this47.reconnectProducer();
              return errcb(PUBLISH_ERROR(10061, data.error));
            default:
              return errcb(PUBLISH_ERROR(data.code, data.error));
          }
          var _iterator27 = _createForOfIteratorHelper(data.tracks),
            _step27;
          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var track = _step27.value;
              if (!track.status) {
                errcb(PUBLISH_ERROR(data.code, data.error));
                return;
              }
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
          cb(data);
        }, errcb);
      }).on("@needunpubtracks", function (targetPCTracks, cb, errcb) {
        qos.addEvent("UnPublishTracks", {
          tracks: targetPCTracks.map(function (p) {
            return {
              track_id: p.trackID
            };
          })
        });
        _this47.signaling.request("unpub-tracks", {
          tracks: targetPCTracks.map(function (t) {
            return {
              trackid: t.trackID
            };
          })
        }).then(function (data) {
          cb(data);
        });
      }).on("@send-qos-message", function (qos) {
        _this47.signaling.request("send-qos-message", qos);
      });
    }
  }, {
    key: "sendTracks",
    value: function sendTracks(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        return _regeneratorRuntime().wrap(function _callee39$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              if (!(tracks.length === 0)) {
                _context41.next = 2;
                break;
              }
              return _context41.abrupt("return", Promise.resolve());
            case 2:
              return _context41.abrupt("return", this.sendCommandQueue.push(TaskCommandEnum.SEND_TRACKS, tracks));
            case 3:
            case "end":
              return _context41.stop();
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "removeTracks",
    value: function removeTracks(tracks) {
      if (tracks.length === 0) return Promise.resolve();
      return this.sendCommandQueue.push(TaskCommandEnum.REMOVE_TRACKS, tracks);
    }
  }, {
    key: "restartSendICE",
    value: function restartSendICE(pcid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        return _regeneratorRuntime().wrap(function _callee40$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              if (browserReport.supportRestartICE) {
                _context42.next = 2;
                break;
              }
              return _context42.abrupt("return", Promise.resolve(this.reconnectProducer()));
            case 2:
              return _context42.abrupt("return", this.sendCommandQueue.push(TaskCommandEnum.RESTART_SEND_ICE, pcid));
            case 3:
            case "end":
              return _context42.stop();
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "handleSendCommandTask",
    value: function handleSendCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.SEND_TRACKS:
          {
            ph.promise = this._execAddProducerTracks(command.data);
            return;
          }
        case TaskCommandEnum.REMOVE_TRACKS:
          {
            ph.promise = this._execRemoveTracks(command.data);
            return;
          }
        case TaskCommandEnum.RESTART_SEND_ICE:
          {
            ph.promise = this._execRestartSendICE(command.data);
            return;
          }
      }
    }
    /**
     * 将 Track 添加到 transport 的 PCTrack 列表中
     * 将这一步抽成同步方法是为了保证多个 publish 操作同时触发时
     * 上层能够正确监测到非法订阅操作并及时抛出错误
     */
  }, {
    key: "addTrackToPublishTracks",
    value: function addTrackToPublishTracks(tracks) {
      var _this48 = this;
      var pcTracks = tracks.map(function (t) {
        return new PCTrack(_this48, "send", t);
      });
      var _iterator28 = _createForOfIteratorHelper(pcTracks),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var pcTrack = _step28.value;
          this._publishTracks.set(pcTrack.track.mediaTrack.id, pcTrack);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      return pcTracks;
    }
    /**
     * 当发布任务遇到无法重试的失败时清理添加的 Tracks
     */
  }, {
    key: "removeTrackFromPublishTracks",
    value: function removeTrackFromPublishTracks(tracks) {
      var _iterator29 = _createForOfIteratorHelper(tracks),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var track = _step29.value;
          this._publishTracks.delete(track.mediaTrack.id);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "_execAddProducerTracks",
    value: function _execAddProducerTracks(pcTracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var data, _iterator30, _step30, pcTrack, trackData;
        return _regeneratorRuntime().wrap(function _callee41$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.sendHandler.addProducerTracks(pcTracks.map(function (t) {
                return t.track;
              }));
            case 2:
              data = _context43.sent;
              _iterator30 = _createForOfIteratorHelper(pcTracks);
              try {
                for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                  pcTrack = _step30.value;
                  trackData = getElementFromArray(data.tracks, "localid", pcTrack.track.mediaTrack.id);
                  if (trackData) {
                    pcTrack.addTrackId(trackData.trackid);
                    pcTrack.track.setInfo({
                      versionid: trackData.versionid
                    });
                    pcTrack.track.resetStats();
                  }
                }
              } catch (err) {
                _iterator30.e(err);
              } finally {
                _iterator30.f();
              }
              pcTracks.map(function (p) {
                return p.connectStatus = TrackConnectStatus.Connect;
              });
              return _context43.abrupt("return", data);
            case 7:
            case "end":
              return _context43.stop();
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "_execRemoveTracks",
    value: function _execRemoveTracks(pcTracks) {
      this.removeTrackFromPublishTracks(pcTracks.map(function (p) {
        return p.track;
      }));
      pcTracks.map(function (p) {
        return p.release();
      });
      return this.sendHandler.removeProducerTracks(pcTracks);
    }
  }, {
    key: "_execRestartSendICE",
    value: function _execRestartSendICE(pcid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var res;
        return _regeneratorRuntime().wrap(function _callee42$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              this.sendHandler._isRestartingICE = true;
              _context44.next = 3;
              return this.signaling.request("pubpc-restart", {
                pcid: pcid
              });
            case 3:
              res = _context44.sent;
              if (!(res.code !== 0)) {
                _context44.next = 9;
                break;
              }
              this.sendHandler._isRestartingICE = false;
              log.debug("restart ice faild", res.code, res.error);
              this.reconnectProducer();
              return _context44.abrupt("return");
            case 9:
              _context44.prev = 9;
              _context44.next = 12;
              return this.sendHandler.restartICE(res.iceParameters, res.iceCandidates);
            case 12:
              this.sendHandler._isRestartingICE = false;
              _context44.next = 20;
              break;
            case 15:
              _context44.prev = 15;
              _context44.t0 = _context44["catch"](9);
              log.debug("restart ice faild", res.code, res.error);
              this.sendHandler._isRestartingICE = false;
              this.reconnectProducer();
            case 20:
            case "end":
              return _context44.stop();
          }
        }, _callee42, this, [[9, 15]]);
      }));
    }
  }, {
    key: "reconnectProducer",
    value: function reconnectProducer() {
      this.resetSendCommandQueue();
      this.sendHandler.close();
      var targetPCTracks = this.publishTracks;
      this.sendHandler = getHandler("send", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      });
      this.handleSendHandler();
      targetPCTracks.forEach(function (t) {
        t.connectStatus = TrackConnectStatus.Connecting;
      });
      this.emit("@needrepub", targetPCTracks);
    }
  }, {
    key: "handleRecvHandler",
    value: function handleRecvHandler() {
      var _this49 = this;
      this.recvHandler.on("@needsubpc", function (d, cb, errcb) {
        _this49.safeEmitAsPromise("@needsubpc", d).then(cb, errcb);
      }).on("@connectionstatechange", function (state, protocol) {
        log.log("sub pc connection state change", state);
        qos.addEvent("ICEConnectionState", {
          pc_type: 1,
          state: state,
          id: _this49.recvHandler.pcid,
          protocol: protocol,
          //-------Qos打点v2优化--------
          //若 state 为 FAILED，则等级为 SERVERE，否则为 NORMAL
          event_grade: state === "failed" ? QNEventGrade.SERVERE : QNEventGrade.NORMAL,
          event_category: QNEventCategory.CORE
        });
        switch (state) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            {
              if (_this49.signaling.state === SignalingState.OPEN) {
                _this49.resetRecvHandler();
              } else {
                // 置为 close，等待信令重连完成后统一重新创建
                _this49.recvHandler.close();
              }
              break;
            }
          case "disconnected":
            {
              if (_this49.recvHandler._isRestartingICE || !_this49.recvHandler.pcid) return;
              if (_this49.signaling.state === SignalingState.OPEN) {
                _this49.restartRecvICE(_this49.recvHandler.pcid);
              } else {
                _this49.signaling.once("@signalingauth", function (data) {
                  if (_this49.recvHandler.getCurrentIceConnectionState() !== "disconnected") return;
                  _this49.extendedRtpCapabilities = data.rtpcaps;
                  _this49.restartRecvICE(_this49.recvHandler.pcid);
                });
              }
              break;
            }
        }
      });
    }
  }, {
    key: "appendConsumer",
    value: function appendConsumer(consumer) {
      this.consumerQueue.push(consumer);
    }
  }, {
    key: "addConsumers",
    value: function addConsumers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var consumers;
        return _regeneratorRuntime().wrap(function _callee43$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              consumers = this.consumerQueue;
              this.consumerQueue = [];
              return _context45.abrupt("return", this.recvCommandQueue.push(TaskCommandEnum.ADD_CONUMERS, consumers));
            case 3:
            case "end":
              return _context45.stop();
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "initRecvHandler",
    value: function initRecvHandler(trackIDs) {
      return this.recvInitCommandQueue.push(TaskCommandEnum.INIT_RECV, trackIDs);
    }
  }, {
    key: "removeConsumers",
    value: function removeConsumers(consumers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        return _regeneratorRuntime().wrap(function _callee44$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return this.recvCommandQueue.push(TaskCommandEnum.REMOVE_CONSUMERS, consumers);
            case 2:
            case "end":
              return _context46.stop();
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "restartRecvICE",
    value: function restartRecvICE(pcid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        return _regeneratorRuntime().wrap(function _callee45$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (browserReport.supportRestartICE) {
                _context47.next = 2;
                break;
              }
              return _context47.abrupt("return", this.resetRecvHandler());
            case 2:
              return _context47.abrupt("return", this.recvCommandQueue.push(TaskCommandEnum.RESTART_RECV_ICE, pcid));
            case 3:
            case "end":
              return _context47.stop();
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "_removeConsumers",
    value: function _removeConsumers(consumers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        return _regeneratorRuntime().wrap(function _callee46$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return this.recvHandler.removeConsumerTracks(consumers);
            case 2:
            case "end":
              return _context48.stop();
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "_initRecvHandler",
    value: function _initRecvHandler(trackIDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        return _regeneratorRuntime().wrap(function _callee47$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (this.recvHandler.isPcReady) {
                _context49.next = 4;
                break;
              }
              _context49.next = 3;
              return this.recvHandler.setupTransport(trackIDs);
            case 3:
              return _context49.abrupt("return", _context49.sent);
            case 4:
              _context49.next = 6;
              return this.initSubPcPromise;
            case 6:
              return _context49.abrupt("return", null);
            case 7:
            case "end":
              return _context49.stop();
          }
        }, _callee47, this);
      }));
    }
  }, {
    key: "_addConsumers",
    value: function _addConsumers(consumers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var tracks;
        return _regeneratorRuntime().wrap(function _callee48$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!(consumers.length === 0)) {
                _context50.next = 2;
                break;
              }
              return _context50.abrupt("return", Promise.resolve([]));
            case 2:
              _context50.next = 4;
              return this.recvHandler.addConsumerTracks(consumers);
            case 4:
              tracks = _context50.sent;
              return _context50.abrupt("return", tracks);
            case 6:
            case "end":
              return _context50.stop();
          }
        }, _callee48, this);
      }));
    }
  }, {
    key: "_execRestartRecvICE",
    value: function _execRestartRecvICE(pcid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var res;
        return _regeneratorRuntime().wrap(function _callee49$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              this.recvHandler._isRestartingICE = true;
              _context51.next = 3;
              return this.signaling.request("subpc-restart", {
                pcid: pcid
              });
            case 3:
              res = _context51.sent;
              if (!(res.code !== 0)) {
                _context51.next = 9;
                break;
              }
              this.recvHandler._isRestartingICE = false;
              log.debug("restart ice faild", res.code, res.error);
              this.resetRecvHandler();
              return _context51.abrupt("return");
            case 9:
              _context51.prev = 9;
              _context51.next = 12;
              return this.recvHandler.restartICE(res.iceParameters, res.iceCandidates);
            case 12:
              this.recvHandler._isRestartingICE = false;
              _context51.next = 20;
              break;
            case 15:
              _context51.prev = 15;
              _context51.t0 = _context51["catch"](9);
              this.recvHandler._isRestartingICE = false;
              log.debug("restart ice faild", res.code, res.error);
              this.resetRecvHandler();
            case 20:
            case "end":
              return _context51.stop();
          }
        }, _callee49, this, [[9, 15]]);
      }));
    }
  }, {
    key: "handleRecvCommandTask",
    value: function handleRecvCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.ADD_CONUMERS:
          {
            ph.promise = this._addConsumers(command.data);
            return;
          }
        case TaskCommandEnum.REMOVE_CONSUMERS:
          {
            ph.promise = this._removeConsumers(command.data);
            return;
          }
        case TaskCommandEnum.RESTART_RECV_ICE:
          {
            ph.promise = this._execRestartRecvICE(command.data);
            return;
          }
      }
    }
  }, {
    key: "handleRecvInitCommandTask",
    value: function handleRecvInitCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.INIT_RECV:
          {
            ph.promise = this._initRecvHandler(command.data);
            return;
          }
      }
    }
  }, {
    key: "resetSendCommandQueue",
    value: function resetSendCommandQueue() {
      log.log("reset send queue");
      this.sendCommandQueue = new TaskQueue("SendQueue");
      this.sendCommandQueue.on("exec", this.handleSendCommandTask.bind(this));
    }
  }, {
    key: "resetRecvCommandQueue",
    value: function resetRecvCommandQueue() {
      log.log("reset recv queue");
      this.recvCommandQueue = new TaskQueue("RecvQueue");
      this.recvInitCommandQueue = new TaskQueue("RecvInitQueue");
      this.recvCommandQueue.on("exec", this.handleRecvCommandTask.bind(this));
      this.recvInitCommandQueue.on("exec", this.handleRecvInitCommandTask.bind(this));
    }
  }, {
    key: "resetRecvHandler",
    value: function resetRecvHandler() {
      var _this50 = this;
      this.resetRecvCommandQueue();
      // 重置 RecvHandler 时外层 track 需要做一些操作
      this.emit("@needresetrecv");
      this.recvHandler.close();
      this.recvHandler = getHandler("recv", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      });
      this.initSubPcPromise = new Promise(function (resolve) {
        _this50.initSubPcPromiseResolve = resolve;
      });
      this.handleRecvHandler();
      // 重连Consumer需要对比服务端的变化，抛出事件
      this.emit("@needresub");
    }
  }, {
    key: "release",
    value: function release() {
      this.recvHandler.close();
      this.sendHandler.close();
      this.publishTracks.forEach(function (t) {
        return t.release();
      });
    }
  }]);
  return ConnectionTransport;
}(EnhancedEventEmitter);
var qnevents = new EnhancedEventEmitter();

/**
 * ws 连接 url，返回结果
 */
function wsConnect(url, timeout) {
  return new Promise(function (resolve) {
    var timeoutID;
    var startTime = Date.now();
    var ws = new WebSocket(url);
    ws.onopen = function () {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: true,
        reason: "ok",
        connectTime: connectTime
      });
    };
    ws.onerror = function () {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: false,
        reason: 'onerror',
        connectTime: connectTime
      });
    };
    timeoutID = setTimeout(function () {
      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: false,
        reason: 'timeout',
        connectTime: connectTime
      });
      ws.close();
    }, timeout);
  });
}
/**
 * 并发连接 urls，返回第一个成功建立连接的 ws 对象，所有结果做打点
 * 后返回的 ws，不管是否连接成功（默认几秒内不发 auth，服务端会自动关闭），直接忽略。
 */
function wsCreate(urls, timeout) {
  var results = [];
  var isSucess = false;
  return new Promise(function (resolve, reject) {
    var _iterator31 = _createForOfIteratorHelper(urls),
      _step31;
    try {
      for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
        var url = _step31.value;
        wsConnect(url, timeout).then(function (res) {
          results.push(res);
          if (res.status) {
            resolve({
              ws: res.ws,
              url: res.url
            });
            isSucess = true;
          }
          qos.addEvent("WebsocketConnect", {
            happy_dns_resolve_time: 0,
            happy_dns_take_effect: false,
            socket_node_info: res.url,
            socket_connect_time: res.connectTime,
            socket_connect_success: res.status,
            socket_connect_error_message: res.reason,
            event_grade: isSucess ? QNEventGrade.NORMAL : QNEventGrade.SERVERE,
            event_category: QNEventCategory.CORE,
            dns_resolve_time: 0,
            dns_take_effect: false,
            dns_resolved_ip: "",
            // 创建ws走的是加房流程默认为"connect"
            socket_connect_reason: "connect"
          });
          if (results.length === urls.length && !isSucess) {
            reject(ERROR_AUTH_FAILED("websocket connect failed."));
          }
        });
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }
  });
}
var RoomState;
(function (RoomState) {
  RoomState[RoomState["Idle"] = 0] = "Idle";
  RoomState[RoomState["Connecting"] = 1] = "Connecting";
  RoomState[RoomState["Connected"] = 2] = "Connected";
  RoomState[RoomState["Reconnecting"] = 3] = "Reconnecting";
})(RoomState || (RoomState = {}));
var DEFAULT_CONFIG = {
  transportPolicy: "preferUdp",
  simulcast: false,
  reconnectTimes: 3,
  requestTimeout: 5 * 1000,
  mcuServerHosts: []
};
var QNRTCCore = /*#__PURE__*/function (_EventEmitter4) {
  _inherits(QNRTCCore, _EventEmitter4);
  _createClass(QNRTCCore, [{
    key: "users",
    get: function get() {
      return Array.from(this._users.values());
    }
    /**
     * 房间内所有 Track 的信息列表，包括未订阅的，用 TrackBaseInfo 表示
     */
  }, {
    key: "trackInfoList",
    get: function get() {
      return this._trackInfo.map(transferSignalingTrackToTrackBaseInfo);
    }
  }, {
    key: "roomState",
    get: function get() {
      return this._roomState;
    },
    set: function set(state) {
      if (this._roomState !== state) {
        this._roomState = state;
        log.debug("roomState change", this._roomState);
        this.emit("room-state-change", this._roomState);
        qos.addEvent("RoomStateChanged", {
          room_state: state,
          //-------Qos打点v2优化--------
          event_grade: this._roomState === RoomState.Reconnecting ? QNEventGrade.SERVERE : QNEventGrade.NORMAL,
          event_category: QNEventCategory.CORE
        });
      }
    }
  }]);
  function QNRTCCore(config) {
    var _this51;
    _classCallCheck(this, QNRTCCore);
    var _this;
    _this51 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCCore).call(this));
    _this = _assertThisInitialized(_assertThisInitialized(_this51));
    _this51.profiles = new Map();
    _this51._trackInfo = [];
    _this51.volumeIndicatorHistory = [];
    /**
     * 所有订阅的 PCTrack，需要注意的是这些 PCTrack 可能有 2 种状态
     * 1. Connecting 表示正在进行连接过程
     * 2. Conncted 表示连接已经建立（subscribe 已经 resolve）
     */
    _this51.subscribeTracks = [];
    // userid -> User
    _this51._users = new Map();
    _this51._roomState = RoomState.Idle;
    _this51.mergeJobMerger = {};
    _this51.defaultMergeJobTracks = [];
    _this51.mergeJobTracks = {};
    _this51.forwardJobTracks = {};
    _this51._mode = QNClientMode.RTC;
    _this51._role = QNClientRole.AUDIENCE;
    _this51._privileges = ["subscribe", "publish"];
    _this51._publish = function (tracks, isReconnect) {
      return new Promise(function (resolve, reject) {
        return __awaiter(_assertThisInitialized(_assertThisInitialized(_this51)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
          var _this52 = this;
          var transport, signaling, pcTracks, localIds, currentLocalIds, targetTracks, connectPromise, user;
          return _regeneratorRuntime().wrap(function _callee50$(_context52) {
            while (1) switch (_context52.prev = _context52.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context52.next = 3;
                  break;
                }
                reject(ERROR_FATAL("not connected to the room, please run joinRoom first"));
                return _context52.abrupt("return");
              case 3:
                if (tracks.length === 0) {
                  resolve();
                }
                if (!(this._mode === QNClientMode.LIVE && this._role === QNClientRole.AUDIENCE)) {
                  _context52.next = 7;
                  break;
                }
                reject(ERROR_FATAL("no permission. Audience in Live mode has no permission to publish."));
                return _context52.abrupt("return");
              case 7:
                tracks.forEach(function (t) {
                  return t.userID = _this52.userID;
                });
                tracks.forEach(function (t) {
                  return t.selfEndedCallback = _this52.unpublish.bind(_this52);
                });
                transport = this.connectionTransport;
                signaling = this.signaling;
                if (!isReconnect) {
                  _context52.next = 16;
                  break;
                }
                localIds = tracks.map(function (t) {
                  return t.mediaTrack.id;
                });
                pcTracks = transport.publishTracks.filter(function (t) {
                  return localIds.indexOf(t.track.mediaTrack.id) !== -1;
                });
                _context52.next = 22;
                break;
              case 16:
                currentLocalIds = transport.publishTracks.map(function (t) {
                  return t.track.mediaTrack.id;
                });
                targetTracks = tracks.filter(function (t) {
                  return currentLocalIds.indexOf(t.mediaTrack.id) === -1;
                }); // 这里表示传入的 track 包含已经发布过的 track，直接抛出错误，简化逻辑
                if (!(targetTracks.length !== tracks.length)) {
                  _context52.next = 21;
                  break;
                }
                reject(ERROR_FATAL("there are already published tracks in the provided tracks"));
                return _context52.abrupt("return");
              case 21:
                pcTracks = transport.addTrackToPublishTracks(tracks);
              case 22:
                log.debug("start publish", pcTracks, isReconnect);
                if (!isReconnect) {
                  connectPromise = pcTracks.map(function (p) {
                    return p.startConnect();
                  });
                  Promise.all(connectPromise).then(function () {
                    return resolve();
                  }).catch(function () {
                    // 表示调用了 unpublish 中止了发布
                    reject(SUB_PUB_ABORT());
                  });
                }
                _context52.prev = 24;
                _context52.next = 27;
                return transport.sendTracks(pcTracks);
              case 27:
                signaling.sendWsMsg("mute-tracks", {
                  tracks: pcTracks.map(function (track) {
                    return {
                      trackid: track.trackID,
                      muted: !!track.track.info.muted
                    };
                  })
                });
                user = getElementFromArray(this.users, "userID", this.userID);
                if (user) {
                  user.addTracks(pcTracks.map(function (p) {
                    return p.track;
                  }));
                  user.addPublishedTrackInfo(pcTracks.map(function (t) {
                    return {
                      trackID: t.trackID,
                      muted: !!t.track.info.muted,
                      kind: t.track.info.kind,
                      tag: t.track.info.tag,
                      userID: _this52.userID,
                      versionid: t.track.info.versionid,
                      profiles: t.track.info.profiles
                    };
                  }));
                }
                tracks.forEach(function (t) {
                  t.on("@get-stats", function (lastReportList, cb, errorcb) {
                    if (!_this52.connectionTransport) return cb([]);
                    var targetTrack = t.isReplacedByImageTrack ? t.imageStreamTrack.mediaTrack : t.mediaTrack;
                    _this52.connectionTransport.sendHandler.getStats(targetTrack, lastReportList).then(cb, errorcb);
                  });
                });
                this.getAllMerger().forEach(function (m) {
                  return m.controller.onAddTracks(tracks.map(function (t) {
                    return t.info;
                  }));
                });
                _context52.next = 50;
                break;
              case 34:
                _context52.prev = 34;
                _context52.t0 = _context52["catch"](24);
                if (!(_context52.t0 instanceof QNRTCError)) {
                  _context52.next = 48;
                  break;
                }
                _context52.t1 = _context52.t0.code;
                _context52.next = _context52.t1 === 10061 ? 40 : _context52.t1 === 30001 ? 40 : _context52.t1 === 10052 ? 41 : 44;
                break;
              case 40:
                return _context52.abrupt("return");
              case 41:
                log.warning(_context52.t0, "republish");
                setTimeout(function () {
                  return _this52._publish(tracks, true);
                }, 1000);
                return _context52.abrupt("return");
              case 44:
                transport.removeTrackFromPublishTracks(tracks);
                reject(_context52.t0);
              case 46:
                _context52.next = 50;
                break;
              case 48:
                log.warning(_context52.t0, "republish");
                setTimeout(function () {
                  return _this52._publish(tracks, true);
                }, 1000);
              case 50:
              case "end":
                return _context52.stop();
            }
          }, _callee50, this, [[24, 34]]);
        }));
      });
    };
    _this51._subscribe = function (trackIDs, isReconnect) {
      var strictMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var trackProfiles = arguments.length > 3 ? arguments[3] : undefined;
      return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
          var _this53 = this;
          var availableTrackInfo, pcTracks, transport, signaling, currentTrackIds, targetTrackInfo, connectPromise, data, startTime, successTracks, faildTrackIds, removedPcTracks, _iterator32, _step32, _loop13, _iterator33, _step33, _loop14, _ret, tracks, consumers;
          return _regeneratorRuntime().wrap(function _callee52$(_context56) {
            while (1) switch (_context56.prev = _context56.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context56.next = 3;
                  break;
                }
                reject(ERROR_FATAL("can not connected to the room, please joinRoom first"));
                return _context56.abrupt("return");
              case 3:
                if (!(trackIDs.length === 0)) {
                  _context56.next = 6;
                  break;
                }
                resolve([]);
                return _context56.abrupt("return");
              case 6:
                log.debug("subscribe", trackIDs, isReconnect);
                availableTrackInfo = this._trackInfo.filter(function (info) {
                  return trackIDs.includes(info.trackid);
                });
                if (!(availableTrackInfo.length !== trackIDs.length)) {
                  _context56.next = 11;
                  break;
                }
                reject(SUB_ERROR(10041, "can not find track in room ".concat(trackIDs)));
                return _context56.abrupt("return");
              case 11:
                transport = this.connectionTransport;
                signaling = this.signaling;
                if (isReconnect) {
                  pcTracks = this.subscribeTracks.filter(function (t) {
                    return trackIDs.indexOf(t.trackID) !== -1;
                  });
                } else {
                  currentTrackIds = this.subscribeTracks.map(function (t) {
                    return t.trackID;
                  });
                  targetTrackInfo = availableTrackInfo.filter(function (t) {
                    return !currentTrackIds.includes(t.trackid);
                  });
                  pcTracks = targetTrackInfo.map(function (t) {
                    return new PCTrack(transport, "recv", undefined, t.trackid, t.mid);
                  });
                  this.subscribeTracks = this.subscribeTracks.concat(pcTracks);
                }
                if (trackProfiles) {
                  Object.entries(trackProfiles).forEach(function (_ref) {
                    var _ref8 = _slicedToArray(_ref, 2),
                      key = _ref8[0],
                      value = _ref8[1];
                    _this53.profiles.set(key, value);
                  });
                }
                log.log("sub tracks", pcTracks, trackProfiles);
                _context56.prev = 16;
                if (!isReconnect) {
                  connectPromise = pcTracks.map(function (t) {
                    return t.startConnect();
                  });
                  Promise.all(connectPromise).then(function () {
                    return resolve(pcTracks.map(function (p) {
                      return p.track;
                    }));
                  }).catch(function () {
                    // 表示调用 unsubscribe 中止了订阅
                    reject(SUB_PUB_ABORT());
                  });
                }
                _context56.next = 20;
                return transport.initRecvHandler(pcTracks.map(function (t) {
                  return t.trackID;
                }));
              case 20:
                data = _context56.sent;
                if (data) {
                  _context56.next = 27;
                  break;
                }
                startTime = Date.now();
                _context56.next = 25;
                return signaling.request("sub-tracks", {
                  tracks: pcTracks.map(function (track) {
                    var trackId = track.trackID;
                    return _this53.profiles.get(trackId) ? {
                      trackid: trackId,
                      profile: _this53.profiles.get(trackId)
                    } : {
                      trackid: trackId
                    };
                  })
                });
              case 25:
                data = _context56.sent;
                qos.addEvent("SubscribeTracks", {
                  result_code: data.code,
                  signal_take_time: Date.now() - startTime,
                  tracks: data.tracks.map(function (t) {
                    return {
                      track_id: t.trackid,
                      status: t.status
                    };
                  })
                });
              case 27:
                log.log("get sub res data", data);
                _context56.t0 = data.code;
                _context56.next = _context56.t0 === 0 ? 31 : _context56.t0 === 10052 ? 32 : _context56.t0 === 10062 ? 33 : 35;
                break;
              case 31:
                return _context56.abrupt("break", 36);
              case 32:
                throw SERVER_UNAVAILABLE();
              case 33:
                transport.resetRecvHandler();
                throw SUB_ERROR(10062, data.error);
              case 35:
                throw SUB_ERROR(data.code, data.error);
              case 36:
                successTracks = data.tracks.filter(function (t) {
                  return !!t.status;
                });
                faildTrackIds = data.tracks.filter(function (t) {
                  return !t.status;
                }).map(function (t) {
                  return t.trackid;
                }); // 在严格模式下，直接抛出错误，取消之后的订阅流程
                if (!(successTracks.length < data.tracks.length && strictMode)) {
                  _context56.next = 40;
                  break;
                }
                throw SUB_ERROR(10041, "can not find target track id: ".concat(faildTrackIds.join(" ")));
              case 40:
                if (successTracks && !strictMode) {
                  log.debug("can not find target track id: ".concat(faildTrackIds.join(""), ", continue"));
                  removedPcTracks = remove(pcTracks, function (t) {
                    return faildTrackIds.indexOf(t.trackID) !== -1;
                  });
                  remove(this.subscribeTracks, function (t) {
                    return faildTrackIds.indexOf(t.trackID) !== -1;
                  });
                  removedPcTracks.map(function (t) {
                    return t.release();
                  });
                }
                data.tracks = successTracks;
                // 先检查后设置
                _iterator32 = _createForOfIteratorHelper(data.tracks || []);
                _context56.prev = 43;
                _loop13 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop13() {
                  var track, pcTrack, info, rtpparams;
                  return _regeneratorRuntime().wrap(function _loop13$(_context53) {
                    while (1) switch (_context53.prev = _context53.next) {
                      case 0:
                        track = _step32.value;
                        pcTrack = pcTracks.find(function (t) {
                          return t.trackID === track.trackid;
                        });
                        info = availableTrackInfo.find(function (t) {
                          return t.trackid === track.trackid;
                        });
                        if (!(!pcTrack || !info)) {
                          _context53.next = 5;
                          break;
                        }
                        return _context53.abrupt("return", 1);
                      case 5:
                        rtpparams = track.rtpparams;
                        pcTrack.appendConsumner(rtpparams, info.kind);
                      case 7:
                      case "end":
                        return _context53.stop();
                    }
                  }, _loop13);
                });
                _iterator32.s();
              case 46:
                if ((_step32 = _iterator32.n()).done) {
                  _context56.next = 52;
                  break;
                }
                return _context56.delegateYield(_loop13(), "t1", 48);
              case 48:
                if (!_context56.t1) {
                  _context56.next = 50;
                  break;
                }
                return _context56.abrupt("continue", 50);
              case 50:
                _context56.next = 46;
                break;
              case 52:
                _context56.next = 57;
                break;
              case 54:
                _context56.prev = 54;
                _context56.t2 = _context56["catch"](43);
                _iterator32.e(_context56.t2);
              case 57:
                _context56.prev = 57;
                _iterator32.f();
                return _context56.finish(57);
              case 60:
                _context56.next = 62;
                return transport.addConsumers();
              case 62:
                transport.resolveInitSubPcPromise();
                _iterator33 = _createForOfIteratorHelper(pcTracks);
                _context56.prev = 64;
                _loop14 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop14() {
                  var pcTrack, consumer, t, track, info, user;
                  return _regeneratorRuntime().wrap(function _loop14$(_context55) {
                    while (1) switch (_context55.prev = _context55.next) {
                      case 0:
                        pcTrack = _step33.value;
                        consumer = pcTrack.consumer;
                        if (!(!consumer || !consumer.track)) {
                          _context55.next = 4;
                          break;
                        }
                        return _context55.abrupt("return", 0);
                      case 4:
                        t = consumer.track;
                        track = pcTrack.track;
                        info = availableTrackInfo.find(function (t) {
                          return t.trackid === consumer.id;
                        });
                        if (info) {
                          _context55.next = 9;
                          break;
                        }
                        return _context55.abrupt("return", 0);
                      case 9:
                        if (!track) {
                          if (t.kind === "audio") {
                            track = new AudioTrack(t, info.playerid, "remote");
                            track.initAudioManager();
                          } else {
                            track = new Track(t, info.playerid, "remote", info.profiles || []);
                          }
                        } else {
                          track.resume(t);
                        }
                        track.setInfo({
                          trackID: info.trackid,
                          userID: info.playerid,
                          tag: info.tag,
                          kind: info.kind,
                          muted: info.muted,
                          versionid: info.versionid
                        });
                        track.setMaster(info.master);
                        track.removeAllListeners("@get-stats");
                        track.removeAllListeners("@ended");
                        track.on("@get-stats", function (lastReportList, cb, errcb) {
                          if (!_this53.connectionTransport) return cb([]);
                          _this53.connectionTransport.recvHandler.getStats(track.mediaTrack, lastReportList).then(cb, errcb);
                        });
                        // 如果远端 track ended，重新订阅
                        track.once("@ended", function () {
                          return __awaiter(_this53, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
                            return _regeneratorRuntime().wrap(function _callee51$(_context54) {
                              while (1) switch (_context54.prev = _context54.next) {
                                case 0:
                                  if (!(!track || !track.info.trackID)) {
                                    _context54.next = 2;
                                    break;
                                  }
                                  return _context54.abrupt("return");
                                case 2:
                                  log.warning("remote track ended, try to resubscribe");
                                  _context54.prev = 3;
                                  _context54.next = 6;
                                  return this._unsubscribe([track.info.trackID], true);
                                case 6:
                                  _context54.next = 10;
                                  break;
                                case 8:
                                  _context54.prev = 8;
                                  _context54.t0 = _context54["catch"](3);
                                case 10:
                                  _context54.next = 12;
                                  return this._subscribe([track.info.trackID], true);
                                case 12:
                                case "end":
                                  return _context54.stop();
                              }
                            }, _callee51, this, [[3, 8]]);
                          }));
                        });
                        pcTrack.track = track;
                        user = _this53.users.find(function (u) {
                          return u.userID === info.playerid;
                        });
                        if (user) {
                          user.addTracks([track]);
                        }
                      case 19:
                      case "end":
                        return _context55.stop();
                    }
                  }, _loop14);
                });
                _iterator33.s();
              case 67:
                if ((_step33 = _iterator33.n()).done) {
                  _context56.next = 74;
                  break;
                }
                return _context56.delegateYield(_loop14(), "t3", 69);
              case 69:
                _ret = _context56.t3;
                if (!(_ret === 0)) {
                  _context56.next = 72;
                  break;
                }
                return _context56.abrupt("continue", 72);
              case 72:
                _context56.next = 67;
                break;
              case 74:
                _context56.next = 79;
                break;
              case 76:
                _context56.prev = 76;
                _context56.t4 = _context56["catch"](64);
                _iterator33.e(_context56.t4);
              case 79:
                _context56.prev = 79;
                _iterator33.f();
                return _context56.finish(79);
              case 82:
                pcTracks.forEach(function (t) {
                  return t.connectStatus = TrackConnectStatus.Connect;
                });
                // sub 数据中，缺少 muted 属性，此时手动通过 trackid 使用 this._trackInfo 赋值，
                // 防止在 handleMute 中将 muted 属性设置为了 undefined
                tracks = data.tracks.map(function (subTrack) {
                  if (subTrack.muted === undefined) {
                    for (var _i6 = 0; _i6 < _this53._trackInfo.length; _i6++) {
                      if (subTrack.trackid === _this53._trackInfo[_i6].trackid) {
                        subTrack.muted = _this53._trackInfo[_i6].muted;
                      }
                    }
                  }
                  return subTrack;
                });
                this.handleMute({
                  tracks: tracks
                });
                _context56.next = 109;
                break;
              case 87:
                _context56.prev = 87;
                _context56.t5 = _context56["catch"](16);
                log.log(_context56.t5);
                consumers = [];
                pcTracks.forEach(function (t) {
                  if (t.consumer) {
                    consumers.push(t.consumer);
                  }
                });
                _context56.next = 94;
                return transport.removeConsumers(consumers);
              case 94:
                if (!(_context56.t5 instanceof QNRTCError)) {
                  _context56.next = 106;
                  break;
                }
                _context56.t6 = _context56.t5.code;
                _context56.next = _context56.t6 === 10062 ? 98 : _context56.t6 === 30001 ? 98 : _context56.t6 === 10052 ? 99 : 102;
                break;
              case 98:
                return _context56.abrupt("return");
              case 99:
                log.warning(_context56.t5, "resubscribe");
                setTimeout(function () {
                  return _this53._subscribe(trackIDs, true);
                }, 1000);
                return _context56.abrupt("return");
              case 102:
                remove(this.subscribeTracks, function (t) {
                  return trackIDs.indexOf(t.trackID) !== -1;
                });
                reject(_context56.t5);
              case 104:
                _context56.next = 109;
                break;
              case 106:
                log.warning(_context56.t5, "resubscribe");
                setTimeout(function () {
                  return _this53._subscribe(trackIDs, true);
                }, 1000);
                return _context56.abrupt("return");
              case 109:
                resolve(pcTracks.map(function (p) {
                  return p.track;
                }));
              case 110:
              case "end":
                return _context56.stop();
            }
          }, _callee52, this, [[16, 87], [43, 54, 57, 60], [64, 76, 79, 82]]);
        }));
      });
    };
    // update config for potential missing property
    _this51.config = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);
    log.log("config", _this51.config);
    log.log("version", version);
    log.log("browser report", browserReport, browser);
    return _this51;
  }
  _createClass(QNRTCCore, [{
    key: "_setReconnectTimes",
    value: function _setReconnectTimes(reconnectTimes) {
      this.config.reconnectTimes = reconnectTimes;
      if (this.signaling) {
        this.signaling.reconnectTimes = reconnectTimes;
      }
    }
  }, {
    key: "_getReconnectTimes",
    value: function _getReconnectTimes() {
      return this.config.reconnectTimes || DEFAULT_CONFIG.reconnectTimes;
    }
  }, {
    key: "setRequestTimeout",
    value: function setRequestTimeout(timeout) {
      this.config.requestTimeout = timeout;
      if (this.signaling) {
        this.signaling.requestTimeout = timeout;
      }
    }
  }, {
    key: "_setProfile",
    value: function _setProfile(trackID, profile) {
      this.profile = profile;
      this.profiles.set(trackID, profile);
      if (!this.subscribeTracks.some(function (track) {
        return track.trackID === trackID;
      })) return;
      var signaling = this.signaling;
      signaling.sendWsMsg('set-sub-profile', {
        tracks: [{
          trackid: trackID,
          profile: this.profile
        }]
      });
    }
    /**
     * 获取当前用户单路转推 Job 信息
     */
  }, {
    key: "getForwardJobTracks",
    value: function getForwardJobTracks() {
      return this.forwardJobTracks;
    }
    /**
     * 房间中已经发布的 Track 列表
     */
  }, {
    key: "setClientMode",
    value: function setClientMode(mode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        return _regeneratorRuntime().wrap(function _callee53$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              if (!(this.roomState !== RoomState.Idle)) {
                _context57.next = 2;
                break;
              }
              throw ERROR_FATAL("can not setClientMode, room state is not idle");
            case 2:
              this._mode = mode;
              this._setPrivileges();
            case 4:
            case "end":
              return _context57.stop();
          }
        }, _callee53, this);
      }));
    }
  }, {
    key: "_setPrivileges",
    value: function _setPrivileges() {
      if (this._mode === QNClientMode.RTC || this._mode === QNClientMode.LIVE && this._role === QNClientRole.BROADCASTER) {
        this._privileges = ["subscribe", "publish"];
      } else {
        this._privileges = ["subscribe"];
      }
    }
  }, {
    key: "setClientRole",
    value: function setClientRole(role) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        var res;
        return _regeneratorRuntime().wrap(function _callee54$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              if (!(this._mode === QNClientMode.RTC)) {
                _context58.next = 2;
                break;
              }
              throw ERROR_FATAL("client role can only be set in client mode LIVE.");
            case 2:
              if (!(role === QNClientRole.AUDIENCE)) {
                _context58.next = 5;
                break;
              }
              if (!(this.publishedTracks.length > 0 && role === QNClientRole.AUDIENCE)) {
                _context58.next = 5;
                break;
              }
              throw ERROR_FATAL("cannot change to audience, please unpublish all tracks first.");
            case 5:
              this._role = role;
              this._setPrivileges();
              if (!(this.roomState !== RoomState.Connected)) {
                _context58.next = 9;
                break;
              }
              return _context58.abrupt("return");
            case 9:
              _context58.next = 11;
              return this.signaling.request("set-privileges", {
                privileges: this._privileges
              });
            case 11:
              res = _context58.sent;
              qos.addEvent("SetClientRole", {
                "result_code": res.code,
                "user_role": role === QNClientRole.BROADCASTER ? 0 : 1,
                "audience_latency_level": 0
              });
              if (!(res.code !== 0)) {
                _context58.next = 15;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 15:
            case "end":
              return _context58.stop();
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "joinRoomWithToken",
    value: function joinRoomWithToken(roomToken, userData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var joinRoomStartTime, room_type, user_role, roomAccess, authRes, sessionId, res, e;
        return _regeneratorRuntime().wrap(function _callee55$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              joinRoomStartTime = Date.now(); // 房间类型， 0 为通信场景，1 为直播场景
              room_type = 0;
              if (this._mode === QNClientMode.LIVE) {
                room_type = 1;
              }
              // 用户角色 0:主播 ，1：观众
              user_role = this._role === QNClientRole.BROADCASTER ? 0 : 1;
              qos.addEvent("JoinRoom", {
                room_token: roomToken,
                user_data: userData,
                room_type: room_type,
                user_role: user_role,
                //（直播场景必填）观众延迟级别， 0 ：低延时，1 ：超低延时
                audience_latency_level: 0
              });
              if (!(this.roomState !== RoomState.Idle)) {
                _context59.next = 7;
                break;
              }
              throw ERROR_FATAL("roomState is not idle! Do not repeat join room, please run leaveRoom first");
            case 7:
              this.roomState = RoomState.Connecting;
              _context59.prev = 8;
              this.roomToken = roomToken;
              this.userData = userData;
              roomAccess = getRoomAccessFromToken(roomToken);
              this.userID = roomAccess.userId;
              this.roomName = roomAccess.roomName;
              this.appId = roomAccess.appId;
              qos.setUserBase(this.userID, this.roomName, this.appId);
              log.log("join room, token:", roomToken);
              log.debug("join room, roomName: ".concat(this.roomName, ", userID: ").concat(this.userID));
              if (this.roomName.match(/^[a-zA-Z0-9_-]{1,64}$/)) {
                _context59.next = 21;
                break;
              }
              this.roomState = RoomState.Idle;
              throw ERROR_FATAL("invalid roomname. roomname must match /^[a-zA-Z0-9_-]{1,64}$/");
            case 21:
              if (this.userID.match(/^[a-zA-Z0-9_-]{1,50}$/)) {
                _context59.next = 24;
                break;
              }
              this.roomState = RoomState.Idle;
              throw ERROR_FATAL("invalid userID. userID must match /^[a-zA-Z0-9_-]{1,50}$/");
            case 24:
              _context59.prev = 24;
              _context59.next = 27;
              return getAccessToken(roomAccess, roomToken, this.config.requestTimeout);
            case 27:
              authRes = _context59.sent;
              this.accessToken = authRes.accessToken;
              sessionId = (Date.now() + Math.floor(Math.random() * 100)).toString();
              qos.setSessionId(sessionId);
              qos.setUserBase(this.userID, this.roomName, this.appId);
              _context59.next = 37;
              break;
            case 34:
              _context59.prev = 34;
              _context59.t0 = _context59["catch"](24);
              throw _context59.t0;
            case 37:
              _context59.next = 39;
              return this.joinRoomWithAccess(this.accessToken);
            case 39:
              res = _context59.sent;
              qos.addEvent("JoinRoomResult", {
                join_start_time: joinRoomStartTime,
                join_take_time: Date.now() - joinRoomStartTime,
                join_result_code: 0,
                join_node_info: this.signaling.url,
                join_error_message: "",
                event_grade: QNEventGrade.NORMAL,
                event_category: QNEventCategory.CORE
              });
              if (!(this._mode === QNClientMode.LIVE)) {
                _context59.next = 44;
                break;
              }
              _context59.next = 44;
              return this.setClientRole(this._role);
            case 44:
              return _context59.abrupt("return", res);
            case 47:
              _context59.prev = 47;
              _context59.t1 = _context59["catch"](8);
              e = _context59.t1;
              this.roomState = RoomState.Idle;
              log.debug("joinRoomWithToken fail: " + e.message);
              qos.addEvent("JoinRoomResult", {
                join_start_time: joinRoomStartTime,
                join_take_time: Date.now() - joinRoomStartTime,
                join_result_code: e.code ? e.code : -1,
                join_node_info: this.signaling ? this.signaling.url : "",
                join_error_message: e.message || e.error || "",
                event_grade: QNEventGrade.SERVERE,
                event_category: QNEventCategory.CORE
              });
              throw e;
            case 54:
            case "end":
              return _context59.stop();
          }
        }, _callee55, this, [[8, 47], [24, 34]]);
      }));
    }
  }, {
    key: "joinRoomWithAccess",
    value: function joinRoomWithAccess(accessToken) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var _this54 = this;
        var accessPayload, _yield$getClientCapab, capsdp, signaling, urls, _yield$wsCreate, ws, url, authResData, _iterator34, _step34, user;
        return _regeneratorRuntime().wrap(function _callee56$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              accessPayload = getPayloadFromJwt(accessToken);
              _context60.next = 3;
              return getClientCapabilitiesSdp();
            case 3:
              _yield$getClientCapab = _context60.sent;
              capsdp = _yield$getClientCapab.capsdp;
              if (!(this._roomState === RoomState.Idle)) {
                _context60.next = 7;
                break;
              }
              throw ERROR_FATAL("roomState is idle, maybe because you left the room.");
            case 7:
              signaling = new SignalingWS(accessToken, capsdp, this._getReconnectTimes(), this.config.requestTimeout, this.userData, this._privileges);
              signaling.on("@error", this.handleDisconnect.bind(this)).on("@ws-state-change", function (prev, curr) {
                switch (curr) {
                  case SignalingState.CONNECTING:
                    if (_this54.roomState === RoomState.Connected) {
                      _this54.roomState = RoomState.Reconnecting;
                    } else if (_this54.roomState !== RoomState.Reconnecting) {
                      _this54.roomState = RoomState.Connecting;
                    }
                    break;
                }
              }).on("@needupdateaccesstoken", function (cb, errcb) {
                _this54.updateAccessToken().then(cb).catch(errcb);
              }).on("on-player-in", this.handlePlayerIn.bind(this)).on("on-player-out", this.handlePlayerOut.bind(this)).on("on-add-tracks", function (d) {
                _this54.filterSignalTracks(d);
                _this54.handleAddTracks(d);
              }).on("on-remove-tracks", function (d) {
                _this54.filterSignalTracks(d);
                _this54.handleRemoveTracks(d);
              }).on("mute-tracks", function (d) {
                _this54.filterSignalTracks(d);
                _this54.handleMute(d);
              }).on("on-messages", this.handleCustomMessages.bind(this)).on("on-qos-messages", this.handleQosMessages.bind(this)).on("on-pubpc-restart-notify", function (d) {
                var transport = _this54.connectionTransport;
                qos.addEvent("AbnormalDisconnect", {
                  event_reason: "on-pubpc-restart-notify",
                  event_description: d.error,
                  event_grade: QNEventGrade.SERVERE,
                  event_category: QNEventCategory.CORE,
                  event_reason_code: 0,
                  // 连接节点信息
                  socket_node_info: signaling.url
                });
                if (!transport || !browserReport.supportRestartICE) return;
                transport.restartSendICE(d.pcid).catch(log.debug);
              }).on("on-subpc-restart-notify", function (d) {
                var transport = _this54.connectionTransport;
                qos.addEvent("AbnormalDisconnect", {
                  event_reason: "on-subpc-restart-notify",
                  event_description: d.error,
                  event_grade: QNEventGrade.SERVERE,
                  event_category: QNEventCategory.CORE,
                  event_reason_code: 0,
                  // 连接节点信息
                  socket_node_info: signaling.url
                });
                if (!transport || !browserReport.supportRestartICE) return;
                transport.restartRecvICE(d.pcid).catch(log.debug);
              }).on("on-sub-profile-changed", function (d) {
                _this54.emit("on-sub-profile-changed", d);
              }).on("on-job-connected", function (d) {
                _this54.emit('forward-job-connected', {
                  jobId: d.id
                });
              }).on("on-job-disconnected", function (d) {
                _this54.emit('forward-job-disconnected', {
                  jobId: d.id
                });
              }).on("on-merge-job-connected", function (d) {
                _this54.emit('merge-job-connected', {
                  jobId: d.id
                });
              }).on("on-merge-job-disconnected", function (d) {
                _this54.emit('merge-job-disconnected', {
                  jobId: d.id
                });
              }).on("on-command", function (d) {
                _this54.emit('command', {
                  content: d.content,
                  command: d.command
                });
              }).on("on-media-relay-state", function (d) {
                var roomName = d.roomid.slice(d.roomid.indexOf(":") + 1);
                _this54.emit("media-relay-state-changed", roomName, d.state);
              }).on("disconnect", this.handleDisconnect.bind(this)).on("on-player-reconnect", this.handleRemoteUserReconnecting.bind(this)).on("on-player-reconnect-in", this.handleRemoteUserReconnected.bind(this));
              log.log("init signaling websocket");
              this.signaling = signaling;
              _context60.prev = 11;
              if (accessPayload.roomServers && accessPayload.roomServers.length > 0) {
                urls = accessPayload.roomServers.sort(function (a, b) {
                  return b.score - a.score;
                }).map(function (x) {
                  return x.url;
                });
              } else {
                urls = [accessPayload.signalingurl2];
              }
              _context60.next = 15;
              return wsCreate(urls, this.config.requestTimeout);
            case 15:
              _yield$wsCreate = _context60.sent;
              ws = _yield$wsCreate.ws;
              url = _yield$wsCreate.url;
              _context60.next = 20;
              return signaling.initWs(true, ws, url);
            case 20:
              authResData = _context60.sent;
              signaling.on("@signalingauth", this.handleAuth.bind(this));
              _context60.next = 24;
              return this.handleAuth(authResData);
            case 24:
              _context60.next = 34;
              break;
            case 26:
              _context60.prev = 26;
              _context60.t0 = _context60["catch"](11);
              if (this.signaling) {
                this.signaling.release();
                this.signaling = undefined;
              }
              if (!(_context60.t0.code === 10052)) {
                _context60.next = 33;
                break;
              }
              _context60.next = 32;
              return timeout(1000);
            case 32:
              return _context60.abrupt("return", this.joinRoomWithToken(this.roomToken, this.userData));
            case 33:
              throw _context60.t0;
            case 34:
              // 成功加入房间，emit 当前房间已有的 users
              _iterator34 = _createForOfIteratorHelper(this.users);
              try {
                for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                  user = _step34.value;
                  if (user.userID !== this.userID) {
                    this.emit("user-join", user);
                  }
                }
                // 成功加入房间，emit 当前房间已有的 trackInfoList
              } catch (err) {
                _iterator34.e(err);
              } finally {
                _iterator34.f();
              }
              if (this.trackInfoList.length > 0) {
                this.emit("track-add", this.trackInfoList);
              }
              return _context60.abrupt("return", this.users);
            case 38:
            case "end":
              return _context60.stop();
          }
        }, _callee56, this, [[11, 26]]);
      }));
    }
  }, {
    key: "_unpublish",
    value: function _unpublish(trackIDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var transport, targetTracks, user;
        return _regeneratorRuntime().wrap(function _callee57$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context61.next = 2;
                break;
              }
              throw ERROR_FATAL("not connected to the room");
            case 2:
              if (!(trackIDs.length === 0)) {
                _context61.next = 4;
                break;
              }
              return _context61.abrupt("return");
            case 4:
              log.debug("unpublish", trackIDs);
              transport = this.connectionTransport;
              targetTracks = transport.publishTracks.filter(function (t) {
                return trackIDs.indexOf(t.trackID) !== -1;
              });
              if (!(targetTracks.length !== trackIDs.length)) {
                _context61.next = 9;
                break;
              }
              throw ERROR_FATAL("can not find target trackid to unpublish");
            case 9:
              _context61.next = 11;
              return transport.removeTracks(targetTracks);
            case 11:
              this.getAllMerger().forEach(function (m) {
                return m.controller.onRemoveTracks(targetTracks.map(function (t) {
                  return t.track.info;
                }));
              });
              user = getElementFromArray(this.users, "userID", this.userID);
              if (user) {
                user.removeTracksByTrackId(trackIDs);
                user.removePublishedTrackInfo(trackIDs);
              }
              this.cleanTrackIdsFromMergeJobs(trackIDs);
            case 15:
            case "end":
              return _context61.stop();
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "createMergeJob",
    value: function createMergeJob(id, option) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var mergeJob, startTime, data;
        return _regeneratorRuntime().wrap(function _callee58$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context62.next = 2;
                break;
              }
              throw ERROR_FATAL("can not createMergeJob, room state is not connected");
            case 2:
              mergeJob = Object.assign(Object.assign(Object.assign({}, defaultMergeJob), option), {
                id: id
              });
              log.debug("send create merge job", mergeJob, id);
              startTime = Date.now();
              _context62.next = 7;
              return this.signaling.request("create-merge-job", mergeJob);
            case 7:
              data = _context62.sent;
              qos.addEvent("CreateMergeJob", {
                signal_take_time: Date.now() - startTime,
                id: id,
                result_code: data.code
              });
              if (!(data.code !== 0)) {
                _context62.next = 11;
                break;
              }
              throw CREATE_MERGE_JOB_ERROR(data.code, data.error);
            case 11:
              if (this.mergeJobTracks[id]) {
                log.warning("merge job id already exist", id);
              } else {
                this.mergeJobTracks[id] = [];
              }
            case 12:
            case "end":
              return _context62.stop();
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "createForwardJob",
    value: function createForwardJob(option) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var audioOnly, tracks, forwardJob, startTime, data;
        return _regeneratorRuntime().wrap(function _callee59$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context63.next = 2;
                break;
              }
              throw ERROR_FATAL("can not createForwardJob, room state is not connected");
            case 2:
              audioOnly = !!option.audioTrackId && !option.videoTrackId;
              tracks = [option.audioTrackId, option.videoTrackId].filter(Boolean).map(function (t) {
                return {
                  trackid: t
                };
              });
              forwardJob = {
                id: option.jobId,
                publishUrl: option.publishUrl,
                audioOnly: audioOnly,
                tracks: tracks
              };
              if (!(option && option.userConfigExtraInfo)) {
                _context63.next = 11;
                break;
              }
              if (!(calcCharacterLength(option.userConfigExtraInfo) <= 1000)) {
                _context63.next = 10;
                break;
              }
              forwardJob.seiTemplate = {
                value: option.userConfigExtraInfo
              };
              _context63.next = 11;
              break;
            case 10:
              throw ERROR_FATAL("userConfigExtraInfo Up to 1000 Bytes");
            case 11:
              startTime = Date.now();
              _context63.next = 14;
              return this.signaling.request("create-forward-job", forwardJob);
            case 14:
              data = _context63.sent;
              qos.addEvent("CreateForwardJob", {
                signal_take_time: Date.now() - startTime,
                id: option.jobId,
                result_code: data.code
              });
              if (!(data.code !== 0)) {
                _context63.next = 18;
                break;
              }
              throw CREATE_FORWARD_JOB_ERROR(data.code, data.error);
            case 18:
              if (this.forwardJobTracks[option.jobId]) {
                log.warning("forward job id already exist", option.jobId);
              } else {
                this.forwardJobTracks[option.jobId] = [];
                if (option.audioTrackId) this.forwardJobTracks[option.jobId].push(option.audioTrackId);
                if (option.videoTrackId) this.forwardJobTracks[option.jobId].push(option.videoTrackId);
              }
            case 19:
            case "end":
              return _context63.stop();
          }
        }, _callee59, this);
      }));
    }
  }, {
    key: "stopForwardJob",
    value: function stopForwardJob(jobId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
        return _regeneratorRuntime().wrap(function _callee60$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context64.next = 2;
                break;
              }
              throw ERROR_FATAL("can not stopForwardJob, room state is not connected");
            case 2:
              if (!(jobId && !this.forwardJobTracks[jobId])) {
                _context64.next = 4;
                break;
              }
              throw ERROR_FATAL("no forward job id ".concat(jobId));
            case 4:
              qos.addEvent("StopForwardJob", {
                id: jobId || ""
              });
              _context64.next = 7;
              return this.signaling.request("stop-forward", {
                id: jobId,
                delayMillisecond: 0
              });
            case 7:
              delete this.forwardJobTracks[jobId];
            case 8:
            case "end":
              return _context64.stop();
          }
        }, _callee60, this);
      }));
    }
  }, {
    key: "setDefaultMergeStream",
    value: function setDefaultMergeStream(width, height, jobID) {
      if (jobID && !this.mergeJobTracks[jobID]) {
        throw NO_MERGE_JOB(jobID);
      }
      if (this.merger && !jobID) {
        this.merger.release();
        this.merger = undefined;
      }
      if (jobID && this.mergeJobMerger[jobID]) {
        this.mergeJobMerger[jobID].release();
        delete this.mergeJobMerger[jobID];
      }
      var controller = this.CreateMergerSessionController();
      if (!jobID) {
        this.merger = new Merger(width, height, controller, jobID);
      } else {
        this.mergeJobMerger[jobID] = new Merger(width, height, controller, jobID);
      }
    }
  }, {
    key: "_stopMerge",
    value: function _stopMerge(jobID) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("can not addMergeTracks, room state is not connected");
      }
      if (jobID && !this.mergeJobTracks[jobID]) {
        throw NO_MERGE_JOB(jobID);
      }
      qos.addEvent("StopMerge", {
        id: jobID || ""
      });
      this.signaling.sendWsMsg("stop-merge", {
        id: jobID
      });
      if (jobID) {
        delete this.mergeJobTracks[jobID];
        if (this.mergeJobMerger[jobID]) {
          this.mergeJobMerger[jobID].release();
          delete this.mergeJobMerger[jobID];
        }
      } else {
        this.defaultMergeJobTracks = [];
        if (this.merger) {
          this.merger.release();
          this.merger = undefined;
        }
      }
    }
  }, {
    key: "_addMergeTracks",
    value: function _addMergeTracks(mergeOpts, jobID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var addTraget, config, res;
        return _regeneratorRuntime().wrap(function _callee61$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context65.next = 2;
                break;
              }
              throw ERROR_FATAL("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(jobID && !this.mergeJobTracks[jobID])) {
                _context65.next = 4;
                break;
              }
              throw NO_MERGE_JOB(jobID);
            case 4:
              addTraget = mergeOpts.map(function (opt) {
                return {
                  trackid: opt.trackID,
                  x: opt.x,
                  y: opt.y,
                  w: opt.w,
                  h: opt.h,
                  z: opt.z,
                  stretchMode: opt.stretchMode
                };
              });
              config = {
                id: jobID,
                add: addTraget
              };
              log.debug("addMergeTracks", config);
              if (jobID) {
                this.mergeJobTracks[jobID] = this.mergeJobTracks[jobID].concat(mergeOpts.map(function (t) {
                  return t.trackID;
                }));
                this.mergeJobTracks[jobID] = uniqBy(this.mergeJobTracks[jobID], function (s) {
                  return s;
                });
              } else {
                this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(mergeOpts.map(function (t) {
                  return t.trackID;
                }));
                this.defaultMergeJobTracks = uniqBy(this.defaultMergeJobTracks, function (s) {
                  return s;
                });
              }
              _context65.next = 10;
              return this.signaling.request("update-merge-tracks", config);
            case 10:
              res = _context65.sent;
              qos.addEvent("UpdateMergeTracks", {
                id: jobID || "",
                add: addTraget.map(function (t) {
                  return {
                    track_id: t.trackid,
                    x: t.x || 0,
                    y: t.y || 0,
                    w: t.w || 0,
                    h: t.h || 0,
                    z: t.z || 0,
                    stretchMode: t.stretchMode || ""
                  };
                }),
                result_code: res.code
              });
              if (!(res.code !== 0)) {
                _context65.next = 14;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 14:
            case "end":
              return _context65.stop();
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "_removeMergeTracks",
    value: function _removeMergeTracks(trackIDs, jobID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
        var config, res;
        return _regeneratorRuntime().wrap(function _callee62$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context66.next = 2;
                break;
              }
              throw ERROR_FATAL("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(jobID && !this.mergeJobTracks[jobID])) {
                _context66.next = 4;
                break;
              }
              throw NO_MERGE_JOB(jobID);
            case 4:
              config = {
                id: jobID,
                remove: trackIDs.map(function (t) {
                  return {
                    trackid: t
                  };
                })
              };
              log.debug("removeMergeTracks", config);
              if (jobID) {
                remove(this.mergeJobTracks[jobID], function (t) {
                  return trackIDs.indexOf(t) !== -1;
                });
              } else {
                remove(this.defaultMergeJobTracks, function (t) {
                  return trackIDs.indexOf(t) !== -1;
                });
              }
              _context66.next = 9;
              return this.signaling.request("update-merge-tracks", config);
            case 9:
              res = _context66.sent;
              qos.addEvent("UpdateMergeTracks", {
                id: jobID || "",
                remove: config.remove.map(function (t) {
                  return {
                    track_id: t.trackid
                  };
                }),
                result_code: res.code
              });
              if (!(res.code !== 0)) {
                _context66.next = 13;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 13:
            case "end":
              return _context66.stop();
          }
        }, _callee62, this);
      }));
    } // 这里走全量更新的逻辑
    // 后端后修改为暂不支持，暂时废弃
  }, {
    key: "updateMergeTracks",
    value: function updateMergeTracks(mergeOpts, jobID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var target, config;
        return _regeneratorRuntime().wrap(function _callee63$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context67.next = 2;
                break;
              }
              throw ERROR_FATAL("can not addMergeTracks, room state is not connected");
            case 2:
              if (!(jobID && !this.mergeJobTracks[jobID])) {
                _context67.next = 4;
                break;
              }
              throw NO_MERGE_JOB(jobID);
            case 4:
              target = mergeOpts.map(function (opt) {
                return {
                  trackid: opt.trackID,
                  x: opt.x,
                  y: opt.y,
                  w: opt.w,
                  h: opt.h,
                  z: opt.z,
                  stretchMode: opt.stretchMode
                };
              });
              config = {
                id: jobID,
                all: target,
                mode: 1
              };
              log.debug("updateMergeTracks", config);
              if (jobID) {
                this.mergeJobTracks[jobID] = this.mergeJobTracks[jobID].concat(mergeOpts.map(function (t) {
                  return t.trackID;
                }));
                this.mergeJobTracks[jobID] = uniqBy(this.mergeJobTracks[jobID], function (s) {
                  return s;
                });
              } else {
                this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(mergeOpts.map(function (t) {
                  return t.trackID;
                }));
                this.defaultMergeJobTracks = uniqBy(this.defaultMergeJobTracks, function (s) {
                  return s;
                });
              }
              qos.addEvent("UpdateMergeTracks", {
                id: jobID || "",
                all: target.map(function (t) {
                  return {
                    track_id: t.trackid,
                    x: t.x || 0,
                    y: t.y || 0,
                    w: t.w || 0,
                    h: t.h || 0,
                    z: t.z || 0,
                    stretchMode: t.stretchMode || ""
                  };
                })
              });
              _context67.next = 11;
              return this.signaling.request("update-merge-tracks", config);
            case 11:
            case "end":
              return _context67.stop();
          }
        }, _callee63, this);
      }));
    }
    /**
     * @param isReconnect 代表这次 unsub 是否是为了重新订阅，如果是 pcTrack 不需要释放
     */
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(trackIDs, isReconnect) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        var targetTracks, startTime, data;
        return _regeneratorRuntime().wrap(function _callee64$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context68.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              targetTracks = this.subscribeTracks.filter(function (t) {
                return trackIDs.indexOf(t.trackID) !== -1;
              });
              log.debug("unsubscribe", targetTracks);
              if (!(targetTracks.length === 0)) {
                _context68.next = 6;
                break;
              }
              return _context68.abrupt("return");
            case 6:
              startTime = Date.now();
              _context68.next = 9;
              return this.signaling.request("unsub-tracks", {
                tracks: targetTracks.map(function (t) {
                  return {
                    trackid: t.trackID
                  };
                })
              });
            case 9:
              data = _context68.sent;
              // qos打点增加 signal_take_time, result_code属性
              qos.addEvent("UnSubscribeTracks", {
                tracks: trackIDs.map(function (t) {
                  return {
                    track_id: t
                  };
                }),
                result_code: data.code,
                signal_take_time: Date.now() - startTime
              });
              if (!isReconnect) {
                targetTracks.forEach(function (t) {
                  return t.release();
                });
                remove(this.subscribeTracks, function (t) {
                  return trackIDs.indexOf(t.trackID) !== -1;
                });
              }
              _context68.next = 14;
              return this.connectionTransport.removeConsumers(targetTracks.map(function (p) {
                return p.consumer;
              }));
            case 14:
            case "end":
              return _context68.stop();
          }
        }, _callee64, this);
      }));
    }
  }, {
    key: "_muteTracks",
    value: function _muteTracks(tracks) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
      }
      var transport = this.connectionTransport;
      var trackMuteMap = {};
      tracks.forEach(function (t) {
        trackMuteMap[t.trackID] = t.muted;
      });
      var targetTracks = transport.publishTracks.filter(function (t) {
        return trackMuteMap[t.trackID] !== undefined;
      });
      targetTracks.forEach(function (t) {
        t.setMute(trackMuteMap[t.trackID]);
      });
      qos.addEvent("MuteTracks", {
        tracks: targetTracks.map(function (t) {
          return {
            track_id: t.trackID,
            muted: t.track.info.muted,
            kind: t.track.info.kind
          };
        })
      });
      this.signaling.sendWsMsg("mute-tracks", {
        tracks: tracks.map(function (t) {
          return {
            trackid: t.trackID,
            muted: t.muted
          };
        })
      });
    }
  }, {
    key: "kickoutUser",
    value: function kickoutUser(userID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        return _regeneratorRuntime().wrap(function _callee65$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              log.log("kickoutUser", userID);
              _context69.next = 3;
              return this.control("kickplayer", userID);
            case 3:
            case "end":
              return _context69.stop();
          }
        }, _callee65, this);
      }));
    }
    /**
     * 向房间中指定目标发送自定义消息
     * @param message string 自定义消息内容
     * @param userIDs Array<string> 目标用户名列表，如果为空，则在全房间广播
     * @param messageID string 消息ID
     */
  }, {
    key: "sendCustomMessage",
    value: function sendCustomMessage(message, userIDs, messageID) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("room state is not connected, can not send message");
      }
      var msgid = messageID || randomStringGen(8);
      var target = !userIDs || userIDs.length === 0 ? undefined : userIDs;
      this.signaling.sendWsMsg("send-message", {
        msgid: msgid,
        target: target,
        type: "normal",
        text: message
      });
      log.debug("send custom message", message, target, msgid);
    }
  }, {
    key: "replaceTrack",
    value: function replaceTrack(trackID, newTrack) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        var targetPCTrack;
        return _regeneratorRuntime().wrap(function _callee66$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context70.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              log.log("replaceTrack", trackID, newTrack);
              targetPCTrack = this.connectionTransport.publishTracks.find(function (pcTrack) {
                return pcTrack.trackID === trackID;
              });
              if (!(targetPCTrack === undefined || targetPCTrack.track === undefined)) {
                _context70.next = 6;
                break;
              }
              throw ERROR_FATAL("track not exist: ".concat(trackID));
            case 6:
              return _context70.abrupt("return", this.connectionTransport.sendHandler.replaceTrack(targetPCTrack, newTrack));
            case 7:
            case "end":
              return _context70.stop();
          }
        }, _callee66, this);
      }));
    }
    /**
     * @description 使用图片 track 替换 video track，如果 source 为空，表示切换回来
     * @param trackID 要替换的 trackID
     * @param source 图片来源
     */
  }, {
    key: "pushCameraTrackWithImage",
    value: function pushCameraTrackWithImage(trackID, source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var targetPCTrack;
        return _regeneratorRuntime().wrap(function _callee67$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context71.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              log.log("pushCameraTrackWithImage", {
                trackID: trackID,
                source: source
              });
              targetPCTrack = this.connectionTransport.publishTracks.find(function (pcTrack) {
                return pcTrack.trackID === trackID;
              });
              if (!(targetPCTrack === undefined || targetPCTrack.track === undefined)) {
                _context71.next = 6;
                break;
              }
              throw ERROR_FATAL("track not exist: ".concat(trackID));
            case 6:
              if (!(targetPCTrack.track.info.kind !== 'video')) {
                _context71.next = 8;
                break;
              }
              throw ERROR_FATAL("track kind is not video: ".concat(trackID));
            case 8:
              if (!targetPCTrack.track.imageStreamTrack) {
                targetPCTrack.track.imageStreamTrack = new ImageStreamTrack();
              }
              // source 为空，切换回来
              if (!(source === undefined && targetPCTrack.track.isReplacedByImageTrack)) {
                _context71.next = 15;
                break;
              }
              _context71.next = 12;
              return this.connectionTransport.sendHandler.replaceProducerTrack(targetPCTrack, "video");
            case 12:
              targetPCTrack.track.isReplacedByImageTrack = false;
              targetPCTrack.track.switchPlayingTrack();
              return _context71.abrupt("return");
            case 15:
              if (!(source !== undefined && targetPCTrack.track && !targetPCTrack.track.isReplacedByImageTrack)) {
                _context71.next = 23;
                break;
              }
              _context71.next = 18;
              return targetPCTrack.track.imageStreamTrack.setSource(source);
            case 18:
              _context71.next = 20;
              return this.connectionTransport.sendHandler.replaceProducerTrack(targetPCTrack, "image");
            case 20:
              targetPCTrack.track.isReplacedByImageTrack = true;
              targetPCTrack.track.switchPlayingTrack();
              return _context71.abrupt("return");
            case 23:
            case "end":
              return _context71.stop();
          }
        }, _callee67, this);
      }));
    }
    /**
     * leaveRoom 将不会本地的发布流，如果想清除本地的发布流
     * 或者手动调用 Track 对象的 release 方法
     */
  }, {
    key: "leaveRoom",
    value: function leaveRoom() {
      var _this55 = this;
      if (this.roomState === RoomState.Idle) {
        log.log("can not leave room, please join room first");
        return;
      }
      log.log("leave room");
      qos.addEvent("LeaveRoom", {
        leave_reason_code: 0
      });
      if (this.signaling) {
        Object.keys(this.forwardJobTracks).forEach(function (jobId) {
          return _this55.stopForwardJob(jobId);
        });
        this.signaling.sendDisconnect();
      }
      this.releaseRoom();
    }
  }, {
    key: "_releasePublishTracks",
    value: function _releasePublishTracks() {}
  }, {
    key: "control",
    value: function control(command, userID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
        var data;
        return _regeneratorRuntime().wrap(function _callee68$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context72.next = 2;
                break;
              }
              throw ERROR_FATAL("can not connected to the room, please run joinRoom first");
            case 2:
              _context72.next = 4;
              return this.signaling.request("control", {
                command: command,
                playerid: userID
              });
            case 4:
              data = _context72.sent;
              if (!data.error) {
                _context72.next = 7;
                break;
              }
              throw CONTROL_ERROR(data.code, data.error);
            case 7:
            case "end":
              return _context72.stop();
          }
        }, _callee68, this);
      }));
    }
  }, {
    key: "handlePlayerOut",
    value: function handlePlayerOut(data) {
      var _this56 = this;
      var removeElement = this._users.get(data.playerid);
      if (removeElement) {
        this._users.delete(data.playerid);
        remove(this._trackInfo, function (info) {
          return info.playerid === data.playerid;
        });
        var targetTracks = remove(this.subscribeTracks, function (t) {
          return t.track.userID === removeElement.userID;
        });
        targetTracks.forEach(function (t) {
          return t.release();
        });
        nextTick(function () {
          log.debug("user-leave", removeElement);
          _this56.emit("user-leave", removeElement);
        });
      }
    }
  }, {
    key: "handlePlayerIn",
    value: function handlePlayerIn(signalUser) {
      var _this57 = this;
      var user = transferSignalingUserToUser(signalUser);
      this._users.set(user.userID, user);
      nextTick(function () {
        log.debug("user-join", user);
        _this57.emit("user-join", user);
      });
    }
  }, {
    key: "handleAddTracks",
    value: function handleAddTracks(_ref2) {
      var _this58 = this;
      var tracks = _ref2.tracks;
      log.log("receive track-add", tracks, Object.assign({}, this._trackInfo));
      var publishedUsers = new Set();
      var _iterator35 = _createForOfIteratorHelper(tracks),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var track = _step35.value;
          var user = getElementFromArray(this.users, "userID", track.playerid);
          if (!user) continue;
          // 如果在收到这个 master track 之前已经有了 master track
          // 就翻译为 unpublish 后再 publish
          if (user.published && !publishedUsers.has(user.userID) && this.sessionMode === "stream") {
            var publishedTracks = user.publishedTrackInfo.map(function (t) {
              return transferTrackBaseInfoToSignalingTrack(t, true);
            });
            this.handleRemoveTracks({
              tracks: publishedTracks
            });
            publishedTracks.push(track);
            this.handleAddTracks({
              tracks: publishedTracks
            });
          } else {
            this._trackInfo.push(track);
            user.addPublishedTrackInfo([transferSignalingTrackToTrackBaseInfo(track)]);
            publishedUsers.add(user.userID);
          }
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      if (this.sessionMode === "stream") {
        var _loop15 = function _loop15() {
          var userID = _Array$from[_i7];
          nextTick(function () {
            log.debug("user-publish", _this58._users.get(userID));
            _this58.emit("user-publish", _this58._users.get(userID));
          });
        };
        for (var _i7 = 0, _Array$from = Array.from(publishedUsers); _i7 < _Array$from.length; _i7++) {
          _loop15();
        }
      }
      nextTick(function () {
        log.debug("track-add", tracks.map(transferSignalingTrackToTrackBaseInfo));
        _this58.emit("track-add", tracks.map(transferSignalingTrackToTrackBaseInfo));
      });
    }
  }, {
    key: "handleRemoveTracks",
    value: function handleRemoveTracks(_ref3) {
      var _this59 = this;
      var tracks = _ref3.tracks;
      log.log("receive track-remove", tracks, Object.assign({}, this._trackInfo));
      var targetTracks = remove(this._trackInfo, function (t) {
        return tracks.map(function (t) {
          return t.trackid;
        }).includes(t.trackid);
      });
      var unpublishedUsers = new Set();
      var _iterator36 = _createForOfIteratorHelper(targetTracks),
        _step36;
      try {
        var _loop17 = function _loop17() {
          var track = _step36.value;
          var user = _this59._users.get(track.playerid);
          if (!user) return 1; // continue
          user.removePublishedTrackInfo([track.trackid]);
          user.removeTracksByTrackId([track.trackid]);
          unpublishedUsers.add(user.userID);
          var subscribeTrack = remove(_this59.subscribeTracks, function (t) {
            return t.trackID === track.trackid;
          })[0];
          if (subscribeTrack) {
            subscribeTrack.release();
          }
        };
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          if (_loop17()) continue;
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      this.cleanTrackIdsFromMergeJobs(tracks.map(function (t) {
        return t.trackid;
      }));
      if (this.sessionMode === "stream") {
        var _loop16 = function _loop16() {
          var userID = _Array$from2[_i8];
          var user = _this59._users.get(userID);
          // 如果收到 master track remove 后还留有 master track
          // 翻译为先取消发布再重新发布
          if (user.published) {
            var publishedTracks = user.publishedTrackInfo.map(function (t) {
              return transferTrackBaseInfoToSignalingTrack(t, true);
            });
            _this59.handleRemoveTracks({
              tracks: publishedTracks
            });
            _this59.handleAddTracks({
              tracks: publishedTracks
            });
          } else {
            nextTick(function () {
              log.debug("user-unpublish", user);
              _this59.emit("user-unpublish", user);
            });
          }
        };
        for (var _i8 = 0, _Array$from2 = Array.from(unpublishedUsers); _i8 < _Array$from2.length; _i8++) {
          _loop16();
        }
      }
      nextTick(function () {
        log.debug("track-remove", targetTracks.map(transferSignalingTrackToTrackBaseInfo));
        _this59.emit("track-remove", targetTracks.map(transferSignalingTrackToTrackBaseInfo));
      });
    }
  }, {
    key: "handleMute",
    value: function handleMute(_ref4) {
      var _this60 = this;
      var tracks = _ref4.tracks;
      var _iterator37 = _createForOfIteratorHelper(tracks),
        _step37;
      try {
        var _loop18 = function _loop18() {
            var sigTrack = _step37.value;
            var trackid = sigTrack.trackid;
            var muted = sigTrack.muted;
            var trackInfo = getElementFromArray(_this60._trackInfo, "trackid", trackid);
            if (!trackInfo) {
              return {
                v: void 0
              };
            }
            var user = _this60._users.get(trackInfo.playerid);
            if (!user) {
              return {
                v: void 0
              };
            }
            var info = user.publishedTrackInfo.find(function (t) {
              return t.trackID === trackid;
            });
            if (info) {
              info.muted = muted;
            }
            var track = user.tracks.find(function (t) {
              return t.info.trackID === trackid;
            });
            if (track) {
              track.info.muted = muted;
              track.setMute(muted);
            }
            trackInfo.muted = muted;
            var pcTrack = _this60.subscribeTracks.filter(function (t) {
              return t.trackID === trackid;
            })[0];
            if (pcTrack) {
              pcTrack.setMute(muted);
            }
            var anotherTrackInfo = undefined;
            for (var _i9 = 0; _i9 < _this60._trackInfo.length; _i9 += 1) {
              if (_this60._trackInfo[_i9].playerid === trackInfo.playerid && _this60._trackInfo[_i9].kind !== trackInfo.kind) {
                anotherTrackInfo = _this60._trackInfo[_i9];
              }
            }
            var data = {
              userID: trackInfo.playerid,
              muteAudio: false,
              muteVideo: false
            };
            if (trackInfo.kind === "audio") {
              data.muteAudio = muted;
              data.muteVideo = anotherTrackInfo ? anotherTrackInfo.muted : false;
            } else {
              data.muteVideo = muted;
              data.muteAudio = anotherTrackInfo ? anotherTrackInfo.muted : false;
            }
            if (_this60.sessionMode === "stream") {
              nextTick(function () {
                log.log("user-mute", data);
                _this60.emit("user-mute", data);
              });
            }
          },
          _ret2;
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          _ret2 = _loop18();
          if (_ret2) return _ret2.v;
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      nextTick(function () {
        log.log("mute-tracks", tracks.map(function (t) {
          return {
            trackID: t.trackid,
            muted: t.muted
          };
        }));
        _this60.emit("mute-tracks", tracks.map(function (t) {
          return {
            trackID: t.trackid,
            muted: t.muted
          };
        }));
      });
    }
  }, {
    key: "handleCustomMessages",
    value: function handleCustomMessages(_ref5) {
      var messages = _ref5.messages;
      this.emit("messages-received", messages.map(transferSignalingCustomMessageToCustomMessage));
    }
  }, {
    key: "handleQosMessages",
    value: function handleQosMessages(_ref6) {
      var messages = _ref6.messages;
      var remoteTrackStats = [];
      messages.forEach(function (msg) {
        try {
          var _qos = JSON.parse(msg.qos);
          _qos.tracks_qos.forEach(function (track_qos) {
            remoteTrackStats.push({
              userID: msg.playerid,
              networkGrade: _qos.networkGrade,
              kind: track_qos.kind,
              trackID: track_qos.track,
              packetLossRate: track_qos.lostRate,
              rtt: track_qos.rtt
            });
          });
        } catch (error) {
          log.warning("parse SignalingQosMessage error: ", error);
        }
      });
      qnevents.emit("remote-track-stats", remoteTrackStats);
      this.emit("remote-track-stats", remoteTrackStats);
    }
  }, {
    key: "handleDisconnect",
    value: function handleDisconnect(data) {
      var _this61 = this;
      log.log("handle disconnect", data.code, data);
      // 0, 10005, 10006 是正常的断开 code
      if ([0, 10005, 10006].indexOf(data.code) === -1) {
        qos.addEvent("AbnormalDisconnect", {
          event_reason: "websocket_error",
          event_description: data.error,
          event_grade: QNEventGrade.SERVERE,
          event_category: QNEventCategory.CORE,
          // (ping/pong 超时），websocket 异常错误 code记作-1
          event_reason_code: -1,
          // 连接节点信息
          socket_node_info: this.signaling.url
        });
      }
      qos.addEvent("LeaveRoom", {
        leave_reason_code: data.code
      });
      if (data.code === 10052 && this.roomToken) {
        this.roomState = RoomState.Reconnecting;
        setTimeout(function () {
          return _this61.signaling.initWs();
        }, 1000);
        return;
      }
      switch (data.code) {
        case 10006:
          {
            this.emit("disconnect", {
              code: data.code,
              data: {
                userID: data.kickedid
              }
            });
            break;
          }
        default:
          {
            this.emit("disconnect", {
              code: data.code
            });
            break;
          }
      }
      this.releaseRoom();
    }
  }, {
    key: "handleRemoteUserReconnecting",
    value: function handleRemoteUserReconnecting(data) {
      var user = this.users.find(function (user) {
        return user.userID === data.playerid;
      });
      if (user) {
        log.debug("remote-user-reconnecting", user);
        this.emit("remote-user-reconnecting", user);
      }
    }
  }, {
    key: "handleRemoteUserReconnected",
    value: function handleRemoteUserReconnected(data) {
      var user = this.users.find(function (user) {
        return user.userID === data.playerid;
      });
      if (user) {
        log.debug("remote-user-reconnected", user);
        this.emit("remote-user-reconnected", user);
      }
    } /** 更新 AccessToken  */
  }, {
    key: "updateAccessToken",
    value: function updateAccessToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var roomAccess, authRes, sessionId, accessPayload;
        return _regeneratorRuntime().wrap(function _callee69$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              roomAccess = getRoomAccessFromToken(this.roomToken);
              _context73.next = 3;
              return getAccessToken(roomAccess, this.roomToken, this.config.requestTimeout);
            case 3:
              authRes = _context73.sent;
              sessionId = (Date.now() + Math.floor(Math.random() * 100)).toString();
              qos.setSessionId(sessionId);
              this.accessToken = authRes.accessToken;
              accessPayload = getPayloadFromJwt(authRes.accessToken);
              if (!this.signaling) {
                _context73.next = 13;
                break;
              }
              this.signaling.accessToken = this.accessToken;
              this.signaling.setUrl(accessPayload.signalingurl2);
              _context73.next = 14;
              break;
            case 13:
              throw ERROR_FATAL("room state is idle when updateAccessToken");
            case 14:
            case "end":
              return _context73.stop();
          }
        }, _callee69, this);
      }));
    }
  }, {
    key: "handleAuth",
    value: function handleAuth(authData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        var _this62 = this;
        var isGetMissingEvent, missingEvents, lastUsers, currentUsers, _iterator38, _step38, _loop19, publishingTracks, subscribingTracks;
        return _regeneratorRuntime().wrap(function _callee70$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              this.filterSignalTracks(authData);
              // auth 鉴权失败，一般是 token 过期，或者长时间断线导致房间被关闭，
              // 直接重新走加入房间的流程
              log.debug("handleAuth", authData);
              if (!authData.error) {
                _context75.next = 6;
                break;
              }
              _context75.next = 5;
              return this.joinRoomWithToken(this.roomToken, this.userData);
            case 5:
              return _context75.abrupt("return");
            case 6:
              authData.tracks = authData.tracks || [];
              // 只保留除自己以外的 trackInfo，防止补事件出错
              authData.tracks = authData.tracks.filter(function (t) {
                return t.playerid !== _this62.userID;
              });
              authData.players = authData.players || [];
              isGetMissingEvent = this.roomState === RoomState.Reconnecting;
              missingEvents = {
                join: [],
                leave: [],
                add: [],
                remove: [],
                mute: []
              };
              lastUsers = Array.from(this._users.keys());
              currentUsers = authData.players.map(function (player) {
                return player.playerid;
              });
              missingEvents = getMissingUserEvent(this.userID, this._trackInfo, authData.tracks, lastUsers, currentUsers);
              // connected 的唯一标准是收到 error 为 0 的 auth-res
              this.roomState = RoomState.Connected;
              // 仅在第一次处理的时候设置用户和 TrackInfo, 其余通过补事件来更新
              if (isGetMissingEvent) {
                _context75.next = 36;
                break;
              }
              this._trackInfo = authData.tracks;
              this._users.clear();
              _iterator38 = _createForOfIteratorHelper(authData.players || []);
              _context75.prev = 19;
              _loop19 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop19() {
                var player, user, userTracks;
                return _regeneratorRuntime().wrap(function _loop19$(_context74) {
                  while (1) switch (_context74.prev = _context74.next) {
                    case 0:
                      player = _step38.value;
                      user = transferSignalingUserToUser(player);
                      userTracks = _this62._trackInfo.filter(function (trackInfo) {
                        return trackInfo.playerid === user.userID;
                      });
                      user.addPublishedTrackInfo(userTracks.map(transferSignalingTrackToTrackBaseInfo));
                      _this62._users.set(user.userID, user);
                    case 5:
                    case "end":
                      return _context74.stop();
                  }
                }, _loop19);
              });
              _iterator38.s();
            case 22:
              if ((_step38 = _iterator38.n()).done) {
                _context75.next = 26;
                break;
              }
              return _context75.delegateYield(_loop19(), "t0", 24);
            case 24:
              _context75.next = 22;
              break;
            case 26:
              _context75.next = 31;
              break;
            case 28:
              _context75.prev = 28;
              _context75.t1 = _context75["catch"](19);
              _iterator38.e(_context75.t1);
            case 31:
              _context75.prev = 31;
              _iterator38.f();
              return _context75.finish(31);
            case 34:
              _context75.next = 42;
              break;
            case 36:
              log.debug("get missing events", missingEvents);
              if (missingEvents.remove.length > 0) {
                this.handleRemoveTracks({
                  tracks: missingEvents.remove
                });
              }
              if (missingEvents.leave.length > 0) {
                missingEvents.leave.forEach(this.handlePlayerOut.bind(this));
              }
              if (missingEvents.join.length > 0) {
                missingEvents.join.forEach(this.handlePlayerIn.bind(this));
              }
              if (missingEvents.add.length > 0) {
                this.handleAddTracks({
                  tracks: missingEvents.add
                });
              }
              if (missingEvents.mute.length > 0) {
                this.handleMute({
                  tracks: missingEvents.mute
                });
              }
            case 42:
              if (!this.connectionTransport) {
                this.connectionTransport = this.createConnectionTransport(authData.rtpcaps);
              } else {
                publishingTracks = this.connectionTransport.publishTracks.filter(function (p) {
                  return p.connectStatus === TrackConnectStatus.Connecting;
                });
                subscribingTracks = this.subscribeTracks.filter(function (p) {
                  return p.connectStatus === TrackConnectStatus.Connecting;
                });
                this.connectionTransport.extendedRtpCapabilities = authData.rtpcaps;
                if (!this.connectionTransport.sendHandler.isPcReady || this.connectionTransport.sendHandler._isRestartingICE || publishingTracks.length > 0) {
                  this.connectionTransport.reconnectProducer();
                }
                if (!this.connectionTransport.recvHandler.isPcReady || this.connectionTransport.recvHandler._isRestartingICE || subscribingTracks.length > 0) {
                  this.connectionTransport.resetRecvHandler();
                }
              }
            case 43:
            case "end":
              return _context75.stop();
          }
        }, _callee70, this, [[19, 28, 31, 34]]);
      }));
    }
  }, {
    key: "createConnectionTransport",
    value: function createConnectionTransport(rtpcaps) {
      var _this63 = this;
      var coreInstance = this;
      var signaling = this.signaling;
      var transport = new ConnectionTransport(rtpcaps, signaling, coreInstance, this.config.simulcast);
      transport.on("@needpubpc", function (sdp, tracks, cb, errcb) {
        signaling.request("pubpc", {
          sdp: sdp,
          tracks: tracks.map(transferTrackToPublishTrack),
          policy: _this63.config.transportPolicy
        }).then(function (d) {
          switch (d.code) {
            case 0:
              {
                _this63.emit("refresh-track-info", d.tracks);
                cb(d);
                return;
              }
            case 10052:
              {
                throw SERVER_UNAVAILABLE();
              }
            default:
              {
                throw ERROR_FATAL(d.error);
              }
          }
        }).catch(errcb);
      });
      transport.on("@needsubpc", function (trackIDs, cb, errcb) {
        signaling.request("subpc", {
          tracks: trackIDs.map(function (t) {
            return _this63.profiles.get(t) ? {
              trackid: t,
              profile: _this63.profiles.get(t)
            } : {
              trackid: t
            };
          }),
          policy: _this63.config.transportPolicy
        }).then(function (d) {
          switch (d.code) {
            case 0:
              {
                cb(d);
                return;
              }
            case 10052:
              {
                throw SERVER_UNAVAILABLE();
              }
            default:
              {
                throw ERROR_FATAL(d.error);
              }
          }
        }).catch(errcb);
      }).on("@needresub", function () {
        var allTrackIds = _this63.subscribeTracks.map(function (t) {
          return t.trackID;
        });
        _this63.subscribeTracks.forEach(function (t) {
          return t.connectStatus = TrackConnectStatus.Connecting;
        });
        _this63._subscribe(allTrackIds, true);
      }).on("@needrepub", function (tracks) {
        _this63._publish(tracks.map(function (t) {
          return t.track;
        }), true);
      }).on("@needresetrecv", function () {
        _this63.subscribeTracks.filter(function (p) {
          return !!p.track;
        }).forEach(function (p) {
          p.track.removeAllListeners("@ended");
        });
      });
      return transport;
    }
  }, {
    key: "cleanTrackIdsFromMergeJobs",
    value: function cleanTrackIdsFromMergeJobs(trackIDs) {
      remove(this.defaultMergeJobTracks, function (t) {
        return trackIDs.indexOf(t) !== -1;
      });
      for (var tracks in this.mergeJobTracks) {
        remove(tracks, function (t) {
          return trackIDs.indexOf(t) !== -1;
        });
      }
    }
  }, {
    key: "CreateMergerSessionController",
    value: function CreateMergerSessionController() {
      var _this64 = this;
      var controller = new MergerSessionController();
      var handleTrackAdd = function handleTrackAdd(tracks) {
        controller.onAddTracks(tracks);
      };
      var handleTrackRemove = function handleTrackRemove(tracks) {
        controller.onRemoveTracks(tracks);
      };
      this.on("track-add", handleTrackAdd);
      this.on("track-remove", handleTrackRemove);
      controller.getCurrentTracks = function () {
        if (!_this64.connectionTransport) return [];
        var tracks = _this64._trackInfo.map(transferSignalingTrackToTrackBaseInfo);
        var selfPublishedTracks = _this64.connectionTransport.publishTracks.map(function (t) {
          return t.track.info;
        });
        return tracks.concat(selfPublishedTracks);
      };
      controller.addMergeTrack = function (mergeOpt, jobID) {
        _this64._addMergeTracks(mergeOpt, jobID);
      };
      controller.release = function () {
        _this64.off("track-add", handleTrackAdd);
        _this64.off("track-remove", handleTrackRemove);
      };
      return controller;
    }
  }, {
    key: "getAllMerger",
    value: function getAllMerger() {
      var mergers = [];
      if (this.merger) {
        mergers.push(this.merger);
      }
      for (var jobID in this.mergeJobMerger) {
        mergers.push(this.mergeJobMerger[jobID]);
      }
      return mergers;
    } // 退出房间后清空房间状态
  }, {
    key: "releaseRoom",
    value: function releaseRoom() {
      this.releaseSession();
      if (this.signaling) {
        this.signaling.release();
        this.signaling = undefined;
      }
      qos.addEvent("UnInit", {
        id: "".concat(this.sessionMode, "_").concat(Date.now())
      }, true);
      if (this.connectionTransport) {
        this.connectionTransport.release();
        this.connectionTransport = undefined;
      }
      this.getAllMerger().map(function (merger) {
        merger.release();
      });
      this.defaultMergeJobTracks = [];
      this.mergeJobTracks = {};
      this.forwardJobTracks = {};
      this.merger = undefined;
      this.mergeJobMerger = {};
      this.roomState = RoomState.Idle;
      this._trackInfo = [];
      this._users.clear();
      this.userID = undefined;
      this.subscribeTracks.forEach(function (t) {
        t.release();
      });
      this.subscribeTracks = [];
      this.profile = undefined;
      this.profiles.clear();
      clearInterval(this.volumeIndicatorTimer);
      this._mode = QNClientMode.RTC;
      this._role = QNClientRole.AUDIENCE;
      this._privileges = ["subscribe", "publish"];
    }
    /**
     * @internal
     * 报告频道内正在说话的远端用户及其音量的回调。
     */
  }, {
    key: "registerVolumeIndicatorEvent",
    value: function registerVolumeIndicatorEvent() {
      var _this65 = this;
      var _minVolume = 0.1;
      var _time = 2000 / 4;
      clearInterval(this.volumeIndicatorTimer);
      this.volumeIndicatorTimer = setInterval(function () {
        if (!_this65.connectionTransport) {
          return false;
        }
        // 遍历过滤符合条件的数组数据
        var nowAudioVolumeIndicator = [].concat(_toConsumableArray(_this65.subscribedTracks), _toConsumableArray(_this65.publishedTracks)).filter(function (item) {
          return item.info.kind === "audio" && !item.info.muted;
        }).map(function (item) {
          return {
            trackID: item.info.trackID,
            userID: item.userID,
            level: item.getCurrentVolumeLevel() || 0,
            muted: item.info.muted
          };
        });
        // 将本次采集传入 volumeIndicatorHistory
        if (_this65.volumeIndicatorHistory.length === 0) {
          // 第一次采集直接传入 volumeIndicatorHistory 数组
          _this65.volumeIndicatorHistory.push(nowAudioVolumeIndicator.filter(function (item) {
            return item.level >= _minVolume;
          }));
        } else {
          var lastAudioVolumeIndicator = _this65.volumeIndicatorHistory[_this65.volumeIndicatorHistory.length - 1];
          var volumeHashmap = {};
          // 将上一次采集的数据生成 hashmap
          lastAudioVolumeIndicator.forEach(function (item) {
            return volumeHashmap[item.trackID] = item.level;
          });
          var filterAudioVolumeIndicator = [];
          var _iterator39 = _createForOfIteratorHelper(nowAudioVolumeIndicator),
            _step39;
          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var _i10 = _step39.value;
              if (_i10.level >= _minVolume) {
                if (volumeHashmap[_i10.trackID]) {
                  _i10.level > volumeHashmap[_i10.trackID] ? filterAudioVolumeIndicator.push(_i10) : filterAudioVolumeIndicator.push(Object.assign(Object.assign({}, _i10), {
                    level: volumeHashmap[_i10.trackID]
                  }));
                } else {
                  filterAudioVolumeIndicator.push(_i10);
                }
              } else {
                volumeHashmap[_i10.trackID] && filterAudioVolumeIndicator.push(Object.assign(Object.assign({}, _i10), {
                  level: volumeHashmap[_i10.trackID]
                }));
              }
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }
          _this65.volumeIndicatorHistory.push(filterAudioVolumeIndicator);
          // 采集了四次数据后，清空采集记录，重新采集
          if (_this65.volumeIndicatorHistory.length === 4) {
            _this65.emit("volume-indicator", filterAudioVolumeIndicator.filter(function (item) {
              return !item.muted;
            }).map(function (item) {
              return {
                trackID: item.trackID,
                userID: item.userID,
                level: item.level
              };
            }));
            _this65.volumeIndicatorHistory = [];
          }
        }
      }, _time);
    }
  }, {
    key: "startMediaRelay",
    value: function startMediaRelay(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
        var _this66 = this;
        var destinationInfos, res, status, result;
        return _regeneratorRuntime().wrap(function _callee72$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context77.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === QNClientMode.RTC)) {
                _context77.next = 4;
                break;
              }
              throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === QNClientRole.AUDIENCE)) {
                _context77.next = 6;
                break;
              }
              throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context77.prev = 6;
              _context77.next = 9;
              return Promise.all(config.destRoomInfos.map(function (dest) {
                return __awaiter(_this66, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
                  var roomAccess, relayRes;
                  return _regeneratorRuntime().wrap(function _callee71$(_context76) {
                    while (1) switch (_context76.prev = _context76.next) {
                      case 0:
                        roomAccess = getRoomAccessFromToken(dest.roomToken);
                        _context76.prev = 1;
                        _context76.next = 4;
                        return getRelayToken(roomAccess, dest.roomToken, this.config.requestTimeout);
                      case 4:
                        relayRes = _context76.sent;
                        return _context76.abrupt("return", {
                          roomName: dest.roomName,
                          playerId: roomAccess.userId,
                          token: relayRes.relayToken
                        });
                      case 8:
                        _context76.prev = 8;
                        _context76.t0 = _context76["catch"](1);
                        return _context76.abrupt("return", {
                          roomName: '',
                          playerId: '',
                          token: ''
                        });
                      case 11:
                      case "end":
                        return _context76.stop();
                    }
                  }, _callee71, this, [[1, 8]]);
                }));
              }));
            case 9:
              destinationInfos = _context77.sent.filter(function (item) {
                return item.token;
              });
              _context77.next = 12;
              return this.signaling.request("start-media-relay", {
                destinationInfos: destinationInfos.reduce(function (pre, cur) {
                  return Object.assign(Object.assign({}, pre), _defineProperty({}, cur.roomName, Object.assign({}, cur)));
                }, {})
              });
            case 12:
              res = _context77.sent;
              qos.addEvent("StartMediaRelay", {
                "result_code": res.code,
                "destination_infos": destinationInfos.map(function (dest) {
                  return {
                    room_name: dest.roomName,
                    room_token: dest.token,
                    uid: dest.playerId
                  };
                })
              });
              if (!(res.code !== 0)) {
                _context77.next = 16;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 16:
              status = res.status;
              result = Object.keys(status).reduce(function (pre, roomName) {
                return Object.assign(Object.assign({}, pre), _defineProperty({}, roomName, status[roomName].state));
              }, {});
              return _context77.abrupt("return", result);
            case 21:
              _context77.prev = 21;
              _context77.t0 = _context77["catch"](6);
              if (!(_context77.t0 instanceof QNRTCError)) {
                _context77.next = 27;
                break;
              }
              throw _context77.t0;
            case 27:
              throw ERROR_FATAL(_context77.t0 instanceof Error ? _context77.t0.message : String(_context77.t0));
            case 28:
            case "end":
              return _context77.stop();
          }
        }, _callee72, this, [[6, 21]]);
      }));
    }
  }, {
    key: "updateMediaRelay",
    value: function updateMediaRelay(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
        var _this67 = this;
        var destinationInfos, res, status, result;
        return _regeneratorRuntime().wrap(function _callee74$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context79.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === QNClientMode.RTC)) {
                _context79.next = 4;
                break;
              }
              throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === QNClientRole.AUDIENCE)) {
                _context79.next = 6;
                break;
              }
              throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context79.prev = 6;
              _context79.next = 9;
              return Promise.all(config.destRoomInfos.map(function (dest) {
                return __awaiter(_this67, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
                  var roomAccess, relayRes;
                  return _regeneratorRuntime().wrap(function _callee73$(_context78) {
                    while (1) switch (_context78.prev = _context78.next) {
                      case 0:
                        roomAccess = getRoomAccessFromToken(dest.roomToken);
                        _context78.prev = 1;
                        _context78.next = 4;
                        return getRelayToken(roomAccess, dest.roomToken, this.config.requestTimeout);
                      case 4:
                        relayRes = _context78.sent;
                        return _context78.abrupt("return", {
                          roomName: dest.roomName,
                          playerId: roomAccess.userId,
                          token: relayRes.relayToken
                        });
                      case 8:
                        _context78.prev = 8;
                        _context78.t0 = _context78["catch"](1);
                        return _context78.abrupt("return", {
                          roomName: '',
                          playerId: '',
                          token: ''
                        });
                      case 11:
                      case "end":
                        return _context78.stop();
                    }
                  }, _callee73, this, [[1, 8]]);
                }));
              }));
            case 9:
              destinationInfos = _context79.sent.filter(function (item) {
                return item.token;
              });
              _context79.next = 12;
              return this.signaling.request("update-media-relay", {
                destinationInfos: destinationInfos.reduce(function (pre, cur) {
                  return Object.assign(Object.assign({}, pre), _defineProperty({}, cur.roomName, Object.assign({}, cur)));
                }, {})
              });
            case 12:
              res = _context79.sent;
              qos.addEvent("UpdateMediaRelay", {
                "result_code": res.code,
                "destination_infos": destinationInfos.map(function (dest) {
                  return {
                    room_name: dest.roomName,
                    room_token: dest.token,
                    uid: dest.playerId
                  };
                })
              });
              if (!(res.code !== 0)) {
                _context79.next = 16;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 16:
              status = res.status;
              result = Object.keys(status).reduce(function (pre, roomName) {
                return Object.assign(Object.assign({}, pre), _defineProperty({}, roomName, status[roomName].state));
              }, {});
              return _context79.abrupt("return", result);
            case 21:
              _context79.prev = 21;
              _context79.t0 = _context79["catch"](6);
              if (!(_context79.t0 instanceof QNRTCError)) {
                _context79.next = 27;
                break;
              }
              throw _context79.t0;
            case 27:
              throw ERROR_FATAL(_context79.t0 instanceof Error ? _context79.t0.message : String(_context79.t0));
            case 28:
            case "end":
              return _context79.stop();
          }
        }, _callee74, this, [[6, 21]]);
      }));
    }
  }, {
    key: "stopMediaRelay",
    value: function stopMediaRelay() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
        var res, status, result;
        return _regeneratorRuntime().wrap(function _callee75$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              if (!(this.roomState !== RoomState.Connected)) {
                _context80.next = 2;
                break;
              }
              throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
            case 2:
              if (!(this._mode === QNClientMode.RTC)) {
                _context80.next = 4;
                break;
              }
              throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 4:
              if (!(this._role === QNClientRole.AUDIENCE)) {
                _context80.next = 6;
                break;
              }
              throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");
            case 6:
              _context80.prev = 6;
              _context80.next = 9;
              return this.signaling.request("stop-media-relay", {});
            case 9:
              res = _context80.sent;
              qos.addEvent("StopMediaRelay", {
                "result_code": res.code
              });
              if (!(res.code !== 0)) {
                _context80.next = 13;
                break;
              }
              throw SERVER_ERROR(res.code, res.error);
            case 13:
              status = res.status;
              result = Object.keys(status).reduce(function (pre, roomName) {
                return Object.assign(Object.assign({}, pre), _defineProperty({}, roomName, status[roomName].state));
              }, {});
              return _context80.abrupt("return", result);
            case 18:
              _context80.prev = 18;
              _context80.t0 = _context80["catch"](6);
              if (!(_context80.t0 instanceof QNRTCError)) {
                _context80.next = 24;
                break;
              }
              throw _context80.t0;
            case 24:
              throw ERROR_FATAL(_context80.t0 instanceof Error ? _context80.t0.message : String(_context80.t0));
            case 25:
            case "end":
              return _context80.stop();
          }
        }, _callee75, this, [[6, 18]]);
      }));
    }
  }, {
    key: "simulcast",
    set: function set(simulcast) {
      this.config.simulcast = simulcast;
      if (this.connectionTransport) {
        this.connectionTransport.simulcast = simulcast;
        this.connectionTransport.sendHandler._simulcast = simulcast;
        this.connectionTransport.recvHandler._simulcast = simulcast;
      }
    }
  }, {
    key: "publishedTracks",
    get: function get() {
      if (!this.connectionTransport) return [];
      return this.connectionTransport.publishTracks.filter(function (p) {
        return p.connectStatus === TrackConnectStatus.Connect;
      }).map(function (p) {
        return p.track;
      });
    }
    /**
     * 房间中已经订阅的 Track 列表
     */
  }, {
    key: "subscribedTracks",
    get: function get() {
      return this.subscribeTracks.filter(function (p) {
        return p.connectStatus === TrackConnectStatus.Connect;
      }).map(function (t) {
        return t.track;
      });
    }
  }]);
  return QNRTCCore;
}(EventEmitter);
var TrackModeSession = /*#__PURE__*/function (_QNRTCCore) {
  _inherits(TrackModeSession, _QNRTCCore);
  _createClass(TrackModeSession, [{
    key: "mergeStreamTracks",
    /**
     * 已经添加进合流的 Track 列表（只有 trackid 信息）
     */
    get: function get() {
      return this.defaultMergeJobTracks;
    }
    /**
     * 除了默认合流 job 之外的其他 job 的 合流 Track 列表
     */
  }, {
    key: "mergeStreamJobTracks",
    get: function get() {
      return this.mergeJobTracks;
    }
  }]);
  function TrackModeSession(config) {
    var _this68;
    _classCallCheck(this, TrackModeSession);
    _this68 = _possibleConstructorReturn(this, _getPrototypeOf(TrackModeSession).call(this, config));
    // 是否已发布 master audio track
    _this68.isAudioMastered = false;
    // 是否已发布 master video track
    _this68.isVideoMastered = false;
    _this68.sessionMode = "track";
    qos.addEvent("Init", {
      id: "".concat(_this68.sessionMode, "_").concat(Date.now())
    });
    return _this68;
  }
  /**
   * 加入房间
   * @param roomToken 房间 token
   * @param userData 用户自定义数据
   */
  _createClass(TrackModeSession, [{
    key: "join",
    value: function join(roomToken, userData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
        return _regeneratorRuntime().wrap(function _callee76$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return this.joinRoomWithToken(roomToken, userData);
            case 2:
              return _context81.abrupt("return", _context81.sent);
            case 3:
            case "end":
              return _context81.stop();
          }
        }, _callee76, this);
      }));
    }
    /**
     * 离开房间
     */
  }, {
    key: "leave",
    value: function leave() {
      this.leaveRoom();
      this.isAudioMastered = false;
      this.isVideoMastered = false;
    }
  }, {
    key: "publish",
    value: function publish(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
        var isAudioMastered, isVideoMastered, _iterator40, _step40, track;
        return _regeneratorRuntime().wrap(function _callee77$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              isAudioMastered = this.isAudioMastered;
              isVideoMastered = this.isVideoMastered;
              _iterator40 = _createForOfIteratorHelper(tracks);
              try {
                for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                  track = _step40.value;
                  if (track.info.kind === "audio") {
                    if (this.isAudioMastered) {
                      track.setMaster(false);
                    } else {
                      track.setMaster(true);
                      this.isAudioMastered = true;
                    }
                  }
                  if (track.info.kind === "video") {
                    if (this.isVideoMastered) {
                      track.setMaster(false);
                    } else {
                      track.setMaster(true);
                      this.isVideoMastered = true;
                    }
                  }
                }
              } catch (err) {
                _iterator40.e(err);
              } finally {
                _iterator40.f();
              }
              _context82.prev = 4;
              _context82.next = 7;
              return this._publish(tracks);
            case 7:
              return _context82.abrupt("return", _context82.sent);
            case 10:
              _context82.prev = 10;
              _context82.t0 = _context82["catch"](4);
              // publish error, restore master state
              this.isAudioMastered = isAudioMastered;
              this.isVideoMastered = isVideoMastered;
              throw _context82.t0;
            case 15:
            case "end":
              return _context82.stop();
          }
        }, _callee77, this, [[4, 10]]);
      }));
    }
  }, {
    key: "unpublish",
    value: function unpublish(trackIDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
        var res;
        return _regeneratorRuntime().wrap(function _callee78$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return this._unpublish(trackIDs);
            case 2:
              res = _context83.sent;
              this.isAudioMastered = this.publishedTracks.some(function (t) {
                return !!(t.info.kind === "audio" && t.master);
              });
              this.isVideoMastered = this.publishedTracks.some(function (t) {
                return !!(t.info.kind === "video" && t.master);
              });
              return _context83.abrupt("return", res);
            case 6:
            case "end":
              return _context83.stop();
          }
        }, _callee78, this);
      }));
    }
    /**
     * 传入 trackID 列表订阅指定 Track
     * @param trackIDs trackID 列表
     * @param strictMode 是否开启严格模式
     * @param profiles 指定每路 track 的 profile
     * 如果开启严格模式，订阅过程中只要有一个 Track 出现错误就会导致整个订阅失败
     * 默认不开启严格模式
     */
  }, {
    key: "subscribe",
    value: function subscribe(trackIDs) {
      var strictMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var trackProfiles = arguments.length > 2 ? arguments[2] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
        return _regeneratorRuntime().wrap(function _callee79$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              _context84.next = 2;
              return this._subscribe(trackIDs, false, strictMode, trackProfiles);
            case 2:
              return _context84.abrupt("return", _context84.sent);
            case 3:
            case "end":
              return _context84.stop();
          }
        }, _callee79, this);
      }));
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(trackIDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        return _regeneratorRuntime().wrap(function _callee80$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 2;
              return this._unsubscribe(trackIDs);
            case 2:
              return _context85.abrupt("return", _context85.sent);
            case 3:
            case "end":
              return _context85.stop();
          }
        }, _callee80, this);
      }));
    }
  }, {
    key: "setProfile",
    value: function setProfile(trackID, profile) {
      this._setProfile(trackID, profile);
    }
  }, {
    key: "setReconnectTimes",
    value: function setReconnectTimes(reconnectTimes) {
      this._setReconnectTimes(reconnectTimes);
    }
  }, {
    key: "getReconnectTimes",
    value: function getReconnectTimes() {
      return this._getReconnectTimes();
    }
  }, {
    key: "muteTracks",
    value: function muteTracks(tracks) {
      this._muteTracks(tracks);
    }
  }, {
    key: "addMergeStreamTracks",
    value: function addMergeStreamTracks(mergeOpts, jobID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
        return _regeneratorRuntime().wrap(function _callee81$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              _context86.next = 2;
              return this._addMergeTracks(mergeOpts, jobID);
            case 2:
            case "end":
              return _context86.stop();
          }
        }, _callee81, this);
      }));
    }
  }, {
    key: "removeMergeStreamTracks",
    value: function removeMergeStreamTracks(trackIDs, jobID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
        return _regeneratorRuntime().wrap(function _callee82$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              _context87.next = 2;
              return this._removeMergeTracks(trackIDs, jobID);
            case 2:
            case "end":
              return _context87.stop();
          }
        }, _callee82, this);
      }));
    }
  }, {
    key: "stopMergeStream",
    value: function stopMergeStream(id) {
      this._stopMerge(id);
    }
  }, {
    key: "filterSignalTracks",
    value: function filterSignalTracks() {}
  }, {
    key: "releaseSession",
    value: function releaseSession() {}
  }]);
  return TrackModeSession;
}(QNRTCCore);
var appId = "fk6fk2rnb";
var HOST = 'https://api-demo.qnsdk.com';
var PREFIX = '/v1';
var PATH = function PATH(roomName, user, appId) {
  return "/rtc/token/app/".concat(appId, "/room/").concat(roomName, "/user/").concat(user);
};
function getTestRoomName() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
    var deviceId, rpcid;
    return _regeneratorRuntime().wrap(function _callee83$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          deviceId = "unknow";
          _context88.prev = 1;
          _context88.next = 4;
          return getDeviceId();
        case 4:
          deviceId = _context88.sent;
          _context88.next = 9;
          break;
        case 7:
          _context88.prev = 7;
          _context88.t0 = _context88["catch"](1);
        case 9:
          rpcid = randomStringGen(8);
          return _context88.abrupt("return", deviceId + "_" + rpcid);
        case 11:
        case "end":
          return _context88.stop();
      }
    }, _callee83, null, [[1, 7]]);
  }));
}
function getTestUserAId() {
  return "userA";
}
function getTestUserBId() {
  return "userB";
}
function getRoomToken(roomName, userID) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
    var requestURL, res, abortController;
    return _regeneratorRuntime().wrap(function _callee84$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          requestURL = "".concat(HOST).concat(PREFIX).concat(PATH(roomName, userID, appId));
          _context89.prev = 1;
          if (!("AbortController" in window)) {
            _context89.next = 10;
            break;
          }
          abortController = new AbortController();
          setTimeout(function () {
            return abortController.abort();
          }, 5 * 1000);
          _context89.next = 7;
          return fetch(requestURL, {
            signal: abortController.signal,
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 7:
          res = _context89.sent;
          _context89.next = 13;
          break;
        case 10:
          _context89.next = 12;
          return fetch(requestURL, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 12:
          res = _context89.sent;
        case 13:
          if (res.ok) {
            _context89.next = 15;
            break;
          }
          throw new Error(res.statusText);
        case 15:
          return _context89.abrupt("return", res.text());
        case 18:
          _context89.prev = 18;
          _context89.t0 = _context89["catch"](1);
          throw _context89.t0;
        case 21:
        case "end":
          return _context89.stop();
      }
    }, _callee84, null, [[1, 18]]);
  }));
}
function _checkSystemRequirements() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
    var startTestTime, ok, reason, testRoomA, userA, testRoomB, userB, roomName, timeoutId, statsId, audioTrack, videoTrack, avgRTT, avgPacketLossRate, avgAudioBitrate, avgVideoBitrate, avgVolumnLevel, tracks, joinRoom, subTrack, rtts, packetLossRates, audioBitrates, videoBitrates, volumnLevels, maxStatsIntervalTime, statsIntervalTime;
    return _regeneratorRuntime().wrap(function _callee85$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          log.log("start checkSystemRequirements");
          startTestTime = Date.now();
          ok = false;
          reason = "";
          testRoomA = new TrackModeSession(DEFAULT_CONFIG);
          userA = getTestUserAId();
          testRoomB = new TrackModeSession(DEFAULT_CONFIG);
          userB = getTestUserBId();
          _context90.next = 10;
          return getTestRoomName();
        case 10:
          roomName = _context90.sent;
          avgRTT = -1;
          avgPacketLossRate = -1;
          avgAudioBitrate = -1;
          avgVideoBitrate = -1;
          avgVolumnLevel = -1;
          _context90.prev = 16;
          _context90.next = 19;
          return deviceManager.getLocalTracks({
            video: {
              enabled: true
            },
            audio: {
              enabled: true
            }
          });
        case 19:
          tracks = _context90.sent;
          videoTrack = tracks.find(function (t) {
            return t.info.kind === "video";
          });
          audioTrack = tracks.find(function (t) {
            return t.info.kind === "audio";
          });
          if (!(videoTrack === undefined || audioTrack === undefined)) {
            _context90.next = 24;
            break;
          }
          throw ERROR_FATAL("getLocalTracks failed.");
        case 24:
          joinRoom = function joinRoom(userID, testRoom) {
            return new Promise(function (resolve, reject) {
              getRoomToken(roomName, userID).then(function (token) {
                return testRoom.joinRoomWithToken(token);
              }).then(resolve).catch(reject);
            });
          };
          _context90.next = 27;
          return Promise.all([joinRoom(userA, testRoomA), joinRoom(userB, testRoomB)]);
        case 27:
          subTrack = function subTrack(room) {
            return new Promise(function (resolve, reject) {
              if (room.trackInfoList.length > 0) {
                room.subscribe(room.trackInfoList.map(function (info) {
                  return info.trackID;
                })).then(resolve).catch(reject);
              } else {
                room.on("track-add", function (trackInfoList) {
                  room.subscribe(trackInfoList.map(function (info) {
                    return info.trackID;
                  })).then(resolve).catch(reject);
                });
              }
            });
          };
          _context90.next = 30;
          return Promise.all([testRoomA.publish([videoTrack]), testRoomB.publish([audioTrack]), subTrack(testRoomA), subTrack(testRoomB)]);
        case 30:
          // 采集 15 条有效流状态数据
          rtts = [];
          packetLossRates = [];
          audioBitrates = [];
          videoBitrates = [];
          volumnLevels = [];
          maxStatsIntervalTime = 30;
          statsIntervalTime = 0;
          _context90.next = 39;
          return new Promise(function (resolve) {
            statsId = setInterval(function () {
              var testRoomAPubs = testRoomA.publishedTracks[0].getStats();
              var testRoomBPubs = testRoomB.publishedTracks[0].getStats();
              if (testRoomAPubs.length > 0 && testRoomBPubs.length > 0 && audioTrack) {
                rtts.push(testRoomAPubs[0].rtt);
                packetLossRates.push(testRoomAPubs[0].packetLossRate);
                audioBitrates.push(testRoomBPubs[0].bitrate);
                videoBitrates.push(testRoomAPubs[0].bitrate);
                volumnLevels.push(audioTrack.getCurrentVolumeLevel());
              }
              // TODO: 检测视频：1、是否有数据；2、是否正常渲染
              if (rtts.length > 15) {
                clearInterval(statsId);
                resolve();
              }
              if (statsIntervalTime > maxStatsIntervalTime) {
                log.warning("abnormal track stats: less than 15 valid stats in 30s");
                clearInterval(statsId);
                resolve();
              }
              statsIntervalTime += 1;
            }, 1000);
          });
        case 39:
          log.log(JSON.stringify({
            detailTestResult: {
              rtts: rtts,
              packetLossRates: packetLossRates,
              audioBitrates: audioBitrates,
              videoBitrates: videoBitrates,
              volumnLevels: volumnLevels
            }
          }));
          if (rtts.length > 0) {
            avgRTT = Math.ceil(rtts.reduce(function (pre, cur) {
              return pre + cur;
            }, 0) / rtts.length);
            avgPacketLossRate = packetLossRates.reduce(function (pre, cur) {
              return pre + cur;
            }, 0) / packetLossRates.length;
            avgAudioBitrate = audioBitrates.reduce(function (pre, cur) {
              return pre + cur;
            }, 0) / audioBitrates.length;
            avgVideoBitrate = videoBitrates.reduce(function (pre, cur) {
              return pre + cur;
            }, 0) / videoBitrates.length;
            avgVolumnLevel = volumnLevels.reduce(function (pre, cur) {
              return pre + cur;
            }, 0) / volumnLevels.length;
          }
          ok = true;
          _context90.next = 48;
          break;
        case 44:
          _context90.prev = 44;
          _context90.t0 = _context90["catch"](16);
          ok = false;
          if (typeof _context90.t0 === "string") {
            reason = _context90.t0;
          } else if (_context90.t0 instanceof QNRTCError) {
            reason = JSON.stringify(_context90.t0);
          } else {
            reason = _context90.t0 instanceof Error ? _context90.t0.message : "";
          }
        case 48:
          _context90.prev = 48;
          if (!(testRoomA.roomState === RoomState.Connected)) {
            _context90.next = 53;
            break;
          }
          _context90.next = 52;
          return testRoomA.unpublish(testRoomA.publishedTracks.map(function (t) {
            return t.info.trackID;
          }));
        case 52:
          testRoomA.leaveRoom();
        case 53:
          if (!(testRoomB.roomState === RoomState.Connected)) {
            _context90.next = 57;
            break;
          }
          _context90.next = 56;
          return testRoomB.unpublish(testRoomB.publishedTracks.map(function (t) {
            return t.info.trackID;
          }));
        case 56:
          testRoomB.leaveRoom();
        case 57:
          if (videoTrack) {
            videoTrack.release();
          }
          if (audioTrack) {
            audioTrack.release();
          }
          clearTimeout(timeoutId);
          clearInterval(statsId);
          qos.addEvent("SystemRequirementsTest", {
            room_name: roomName,
            ok: ok,
            reason: reason,
            avg_rtt: avgRTT,
            avg_packet_loss_rate: avgPacketLossRate,
            avg_volumn_level: avgVolumnLevel,
            avg_audio_bitrate: avgAudioBitrate,
            avg_video_bitrate: avgVideoBitrate,
            test_take_time: Date.now() - startTestTime,
            // 测试失败为 SERVERE，否则为 NORMAL
            event_grade: !ok ? QNEventGrade.SERVERE : QNEventGrade.NORMAL
          }, true);
          return _context90.abrupt("return", {
            roomName: roomName,
            ok: ok,
            reason: reason,
            avgRTT: avgRTT,
            avgPacketLossRate: avgPacketLossRate,
            avgVolumnLevel: avgVolumnLevel,
            avgAudioBitrate: avgAudioBitrate,
            avgVideoBitrate: avgVideoBitrate
          });
        case 64:
        case "end":
          return _context90.stop();
      }
    }, _callee85, null, [[16, 44, 48, 64]]);
  }));
}

/**
 * 如果音频来源不是麦克风，而是通过在线音频或者自定义 buffer，将会使用这个类
 */
var AudioSourceTrack = /*#__PURE__*/function (_AudioTrack) {
  _inherits(AudioSourceTrack, _AudioTrack);
  function AudioSourceTrack(source, userID) {
    var _this69;
    _classCallCheck(this, AudioSourceTrack);
    if (!browserReport.mediaStreamDest) {
      throw ERROR_NOT_SUPPORT("your browser does not support audio buffer input!");
    }
    var audioManager = new AudioManager();
    audioManager.initAudioContext();
    if (source instanceof AudioBuffer) {
      audioManager.setAudioBufferSource();
      audioManager.setAudioBuffer(source);
    } else if (source instanceof HTMLAudioElement) {
      audioManager.setMediaElementSource(source);
    }
    var mediaStream = audioManager.audioStream.stream;
    var audioMediaTrack = mediaStream.getTracks()[0];
    _this69 = _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceTrack).call(this, audioMediaTrack, userID, "local"));
    _this69.sourceType = TrackSourceType.EXTERNAL;
    _this69.isLoop = false;
    _this69.originSource = source;
    _this69.audioManager = audioManager;
    _this69.handleAudioManagerEvents();
    return _this69;
  }
  /**
   * 设置循环播放模式
   */
  _createClass(AudioSourceTrack, [{
    key: "setLoop",
    value: function setLoop(isLoop) {
      this.isLoop = isLoop;
      this.audioManager.setAudioSourceLoop(isLoop);
    }
    /**
     * 播放自定义的 Source
     */
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      this.audioManager.playAudioSource();
    }
    /**
     * 暂停播放自定义的 Source
     */
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      this.audioManager.pauseAudioSource();
    }
    /**
     * 恢复播放自定义的 Source
     */
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      this.audioManager.resumeAudioSource();
    }
    /**
     * 停止播放 AudioBuffer 数据
     */
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      var noStopEmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.audioManager.stopAudioSource(false, noStopEmit);
    }
    /**
     * 获取当前的播放时间
     */
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.audioManager.getAudioSourceCurrentTime() || 0;
    }
    /**
     * 设置当前的时间
     */
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(val) {
      this.audioManager.setAudioSourceCurrentTime(val);
    }
    /**
     * 获取播放总时长，对于在线音乐
     * 只有当 audio-state-change 第一次触发 PLAY 后才能获取到
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.audioManager.getAudioSourceDuration() || 0;
    }
  }, {
    key: "handleAudioManagerEvents",
    value: function handleAudioManagerEvents() {
      var _this70 = this;
      this.audioManager.on("@audio-source-state-change", function (newState, lastState) {
        _this70.emit("audio-state-change", newState, lastState);
      });
    }
  }]);
  return AudioSourceTrack;
}(AudioTrack);
/**
 * v1 版本的 Stream，只会拥有最多一个 videoTrack 以及一个 audioTrack
 */
var Stream = /*#__PURE__*/function (_EventEmitter5) {
  _inherits(Stream, _EventEmitter5);
  _createClass(Stream, [{
    key: "audioSourceIsLoop",
    get: function get() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return false;
      }
      return this._audioTrack.isLoop;
    }
  }]);
  function Stream(tracks) {
    var _this71;
    _classCallCheck(this, Stream);
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "send";
    var userID = arguments.length > 2 ? arguments[2] : undefined;
    _this71 = _possibleConstructorReturn(this, _getPrototypeOf(Stream).call(this));
    /**
     * 表示这个流下所包含的所有 Track 的信息，用于精细控制每个 Track 的行为
     * 详细结构可以查阅 TrackInfo
     */
    _this71.trackList = [];
    /**
     * 用于标记这个流是否调用了 release 方法，即表示这个流已经被释放
     */
    _this71.isDestroyed = false;
    _this71.enableAudio = true;
    _this71.enableVideo = true;
    _this71.muteAudio = false;
    _this71.muteVideo = false;
    _this71.onAudioEnded = function (event) {
      _this71.emit("audio-ended", event);
    };
    _this71.onVideoEnded = function (event) {
      _this71.emit("video-ended", event);
    };
    _this71.onAudioSourceStateChange = function (curr, last) {
      _this71.emit("audio-source-state-change", curr, last);
    };
    _this71.direction = direction;
    _this71.userID = userID;
    tracks.forEach(function (track) {
      track.setMaster(true);
      track.on("mute", function () {
        _this71.updateTrackState();
      });
      // 监听 track 的 release 事件，更新自己的状态
      track.on("release", function () {
        remove(_this71.trackList, function (t) {
          return t === track;
        });
        _this71.updateTrackState();
        // 如果自己所有的 track 都 release 了，自己也 release
        if (_this71.trackList.length === 0) {
          _this71.release();
        }
      });
      _this71.trackList.push(track);
    });
    _this71.updateTrackState();
    return _this71;
  }
  /**
   * 目前只对采集的流有效
   */
  _createClass(Stream, [{
    key: "setVolume",
    value: function setVolume(v) {
      if (this._audioTrack) {
        this._audioTrack.setVolume(v);
      }
    }
    /**
     * 将一个 Stream 对象置于页面上指定的元素下播放
     * 会将将所有 track 都置于一个元素下播放
     *
     * 如果想单独控制每一个 track 的播放行为
     * 通过 trackList 获取 Track 对象，调用它的 play 方法
     * @param container 指定一个 HTML 元素用于放置媒体元素
     * @param muted 是否使用静音模式，如果为 true 就不会播放音频，仅播放视频，默认为 false。
     */
  }, {
    key: "play",
    value: function play(container, muted) {
      this.trackList.forEach(function (track) {
        return track.play(container, muted);
      });
      if (this._audioTrack) {
        this.audio = this._audioTrack.mediaElement;
      }
      if (this._videoTrack) {
        this.video = this._videoTrack.mediaElement;
      }
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentTimeDomainData();
      }
      return new Uint8Array(0);
    }
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentFrequencyData();
      }
      return new Uint8Array(0);
    }
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentVolumeLevel();
      }
      return 0;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var audioReport = defaultTrackStatsReport();
      if (this._audioTrack) {
        var audioReportList = this._audioTrack.getStats();
        if (audioReportList.length > 0) {
          audioReport = audioReportList[0];
        }
      }
      var videoReport = defaultTrackStatsReport();
      if (this._videoTrack) {
        var videoReportList = this._videoTrack.getStats();
        if (videoReportList.length > 0) {
          videoReport = videoReportList[0];
        }
      }
      return {
        timestamp: Date.now(),
        videoBitrate: videoReport.bitrate,
        audioBitrate: audioReport.bitrate,
        videoPacketLoss: videoReport.packetLoss,
        audioPacketLoss: audioReport.packetLoss,
        videoPackets: videoReport.packets,
        audioPackets: audioReport.packets,
        videoPacketLossRate: videoReport.packetLossRate,
        audioPacketLossRate: audioReport.packetLossRate,
        videoBytes: videoReport.bytes,
        audioBytes: audioReport.bytes,
        pctype: this.direction
      };
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      if (!this._videoTrack) {
        return "data:,";
      }
      return this._videoTrack.getCurrentFrameDataURL();
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(isLoop) {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      this._audioTrack.setLoop(isLoop);
    }
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      this._audioTrack.startAudioSource();
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      this._audioTrack.pauseAudioSource();
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      this._audioTrack.resumeAudioSource();
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      this._audioTrack.stopAudioSource();
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return 0;
      }
      return this._audioTrack.getCurrentTime();
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return 0;
      }
      return this._audioTrack.getDuration();
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(val) {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }
      return this._audioTrack.setCurrentTime(val);
    }
    /**
     * @internal
     */
  }, {
    key: "setKbps",
    value: function setKbps(video, audio) {
      if (video && this._videoTrack) {
        this._videoTrack.setKbps(video);
      }
      if (audio && this._audioTrack) {
        this._audioTrack.setKbps(audio);
      }
    } /* @internal */
  }, {
    key: "updateTrackState",
    value: function updateTrackState() {
      var _this72 = this;
      this.trackList.forEach(function (track) {
        if (track.info.kind === "audio") {
          if (_this72._audioTrack) {
            _this72._audioTrack.off("ended", _this72.onAudioEnded);
            _this72._audioTrack.off("audio-state-change", _this72.onAudioSourceStateChange);
          }
          _this72.audioTrack = track.mediaTrack;
          _this72._audioTrack = track;
          _this72._audioTrack.on("ended", _this72.onAudioEnded);
          if (_this72._audioTrack instanceof AudioSourceTrack) {
            _this72._audioTrack.on("audio-state-change", _this72.onAudioSourceStateChange);
          }
        } else {
          if (_this72._videoTrack) {
            _this72._videoTrack.off("ended", _this72.onVideoEnded);
          }
          _this72.videoTrack = track.mediaTrack;
          _this72._videoTrack = track;
          _this72._videoTrack.on("ended", _this72.onVideoEnded);
        }
      });
      if (this.audioTrack) {
        this.enableAudio = true;
        this.muteAudio = !this.audioTrack.enabled;
      } else {
        this.enableAudio = false;
      }
      if (this.videoTrack) {
        this.enableVideo = true;
        this.muteVideo = !this.videoTrack.enabled;
      } else {
        this.enableVideo = false;
      }
    }
    /**
     * 释放这个流下的所有资源，包括流和用于播放流的媒体元素
     */
  }, {
    key: "release",
    value: function release() {
      if (this.isDestroyed) {
        return;
      }
      for (var _i11 = 0; _i11 < this.trackList.length; _i11 += 1) {
        var track = this.trackList[_i11];
        track.removeAllListeners("release");
        track.release();
      }
      this.trackList = [];
      this.isDestroyed = true;
      this.emit("release");
      this.removeAllListeners();
    }
    /**
     * @internal
     * 释放流下一个 track，包括媒体元素
     * 如果 Track 被 Stream 包裹，不要直接调用 Track 的 release 方法
     * @param track 标记要释放的 track
     */
  }, {
    key: "releaseTrack",
    value: function releaseTrack(track) {
      var _removeElementFromArr = removeElementFromArray(this.trackList, "mediaTrack", track.mediaTrack),
        removeElement = _removeElementFromArr.removeElement,
        newArray = _removeElementFromArr.newArray;
      if (!removeElement) {
        return;
      }
      track.release();
      this.trackList = newArray;
      if (this.trackList.length === 0) {
        this.isDestroyed = true;
      }
    }
  }]);
  return Stream;
}(EventEmitter);
var AudioUtils;
(function (AudioUtils) {
  function createAudioTrackFromURL(url) {
    var crossorigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "anonymous";
    var tag = arguments.length > 2 ? arguments[2] : undefined;
    var bitrate = arguments.length > 3 ? arguments[3] : undefined;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
      return _regeneratorRuntime().wrap(function _callee86$(_context91) {
        while (1) switch (_context91.prev = _context91.next) {
          case 0:
            return _context91.abrupt("return", new Promise(function (resolve, reject) {
              var audioElement = document.createElement("audio");
              audioElement.addEventListener("error", function () {
                reject(ERROR_AUDIO_MIXING_IO_EXCEPTION());
              });
              var playHandle = function playHandle() {
                audioElement.removeEventListener("canplay", playHandle);
                var track = new AudioSourceTrack(audioElement);
                if (bitrate) {
                  track.setKbps(bitrate);
                }
                track.setInfo({
                  tag: tag
                });
                resolve(track);
              };
              audioElement.addEventListener("canplay", playHandle);
              audioElement.preload = "auto";
              audioElement.src = url;
              audioElement.load();
              audioElement.crossOrigin = crossorigin;
            }));
          case 1:
          case "end":
            return _context91.stop();
        }
      }, _callee86);
    }));
  }
  AudioUtils.createAudioTrackFromURL = createAudioTrackFromURL;
  function createAudioTrackFromFile(file, tag, bitrate) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        decodeAudioData(data).then(function (buffer) {
          var track = new AudioSourceTrack(buffer);
          if (bitrate) {
            track.setKbps(bitrate);
          }
          track.setInfo({
            tag: tag
          });
          resolve(track);
        }).catch(function () {
          reject(ERROR_AUDIO_MIXING_IO_EXCEPTION());
        });
      };
      reader.readAsArrayBuffer(file);
    });
  }
  AudioUtils.createAudioTrackFromFile = createAudioTrackFromFile;
  function createAudioTrackFromBuffer(buffer, tag, bitrate) {
    var track = new AudioSourceTrack(buffer);
    if (bitrate) {
      track.setKbps(bitrate);
    }
    track.setInfo({
      tag: tag
    });
    return track;
  }
  AudioUtils.createAudioTrackFromBuffer = createAudioTrackFromBuffer;
  function createAudioTrackFromSource(source, tag, bitrate) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
      return _regeneratorRuntime().wrap(function _callee87$(_context92) {
        while (1) switch (_context92.prev = _context92.next) {
          case 0:
            if (!(source instanceof File)) {
              _context92.next = 6;
              break;
            }
            _context92.next = 3;
            return createAudioTrackFromFile(source, tag, bitrate);
          case 3:
            return _context92.abrupt("return", _context92.sent);
          case 6:
            if (!(source instanceof AudioBuffer)) {
              _context92.next = 10;
              break;
            }
            return _context92.abrupt("return", createAudioTrackFromBuffer(source, tag, bitrate));
          case 10:
            if (!(typeof source === "string")) {
              _context92.next = 16;
              break;
            }
            _context92.next = 13;
            return createAudioTrackFromURL(source, "anonymous", tag, bitrate);
          case 13:
            return _context92.abrupt("return", _context92.sent);
          case 16:
            return _context92.abrupt("return", Promise.reject(ERROR_AUDIO_MIXING_IO_EXCEPTION()));
          case 17:
          case "end":
            return _context92.stop();
        }
      }, _callee87);
    }));
  }
  AudioUtils.createAudioTrackFromSource = createAudioTrackFromSource;
  function decodeAudioData(data) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
      var decodePromise;
      return _regeneratorRuntime().wrap(function _callee88$(_context93) {
        while (1) switch (_context93.prev = _context93.next) {
          case 0:
            if (!(audioContext.state === "suspended")) {
              _context93.next = 3;
              break;
            }
            _context93.next = 3;
            return audioContext.resume();
          case 3:
            decodePromise = function decodePromise() {
              return new Promise(function (resolve, reject) {
                audioContext.decodeAudioData(data, function (buffer) {
                  resolve(buffer);
                }, function (e) {
                  reject(ERROR_AUDIO_DECODE_ERROR(e));
                });
              });
            };
            _context93.next = 6;
            return decodePromise();
          case 6:
            return _context93.abrupt("return", _context93.sent);
          case 7:
          case "end":
            return _context93.stop();
        }
      }, _callee88);
    }));
  }
  AudioUtils.decodeAudioData = decodeAudioData;
})(AudioUtils || (AudioUtils = {}));
var DEFAULT_RECORD_CONFIG = {
  audio: {
    enabled: true
  },
  video: {
    enabled: true,
    bitrate: 600
  }
};
function setMediaStreamTrackOpMode(track, op) {
  if (track.kind !== 'video') return;
  if (!("contentHint" in track)) {
    log.warning("optimizationMode not support in this browser");
    return;
  }
  track.contentHint = op;
  if (track.contentHint !== op) {
    log.warning("invalid optimizationMode ", op);
  }
  return;
}
var DeviceManager = /*#__PURE__*/function (_EventEmitter6) {
  _inherits(DeviceManager, _EventEmitter6);
  function DeviceManager() {
    var _this73;
    _classCallCheck(this, DeviceManager);
    _this73 = _possibleConstructorReturn(this, _getPrototypeOf(DeviceManager).call(this));
    // 记录每个 device 存在的 tick 数量
    _this73.deviceMap = {};
    if (!browserReport.support) {
      return _possibleConstructorReturn(_this73);
    }
    _this73.updateDeivceInfo();
    // safari 11 不支持 ondevicechange，使用 setInterval
    if (!browserReport.ondevicechange) {
      window.setInterval(_this73.updateDeivceInfo.bind(_assertThisInitialized(_assertThisInitialized(_this73))), 1000);
    } else {
      navigator.mediaDevices.addEventListener('devicechange', function () {
        _this73.updateDeivceInfo();
      });
    }
    return _this73;
  }
  _createClass(DeviceManager, [{
    key: "getDeviceInfo",
    value: function getDeviceInfo(skipPermissionCheck, deviceType) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
        var config, stream, tracks, _i12;
        return _regeneratorRuntime().wrap(function _callee89$(_context94) {
          while (1) switch (_context94.prev = _context94.next) {
            case 0:
              if (skipPermissionCheck) {
                _context94.next = 28;
                break;
              }
              config = {
                audio: false,
                video: false
              };
              _context94.t0 = deviceType;
              _context94.next = _context94.t0 === "all" ? 5 : _context94.t0 === "cameras" ? 8 : _context94.t0 === "microphones" ? 10 : _context94.t0 === "playback" ? 10 : 12;
              break;
            case 5:
              config.audio = true;
              config.video = true;
              return _context94.abrupt("break", 12);
            case 8:
              config.video = true;
              return _context94.abrupt("break", 12);
            case 10:
              config.audio = true;
              return _context94.abrupt("break", 12);
            case 12:
              _context94.prev = 12;
              _context94.next = 15;
              return navigator.mediaDevices.getUserMedia(config);
            case 15:
              stream = _context94.sent;
              this.updateDeivceInfo();
              tracks = stream.getTracks();
              for (_i12 = 0; _i12 < tracks.length; _i12++) {
                tracks[_i12].stop();
              }
              _context94.next = 28;
              break;
            case 21:
              _context94.prev = 21;
              _context94.t1 = _context94["catch"](12);
              if (!(_context94.t1.name === "NotAllowedError")) {
                _context94.next = 27;
                break;
              }
              throw ERROR_DEVICE_NOT_ALLOWED("");
            case 27:
              throw _context94.t1;
            case 28:
              if (this.deviceInfo) {
                _context94.next = 30;
                break;
              }
              return _context94.abrupt("return", []);
            case 30:
              _context94.t2 = deviceType;
              _context94.next = _context94.t2 === "all" ? 33 : _context94.t2 === "cameras" ? 34 : _context94.t2 === "microphones" ? 35 : _context94.t2 === "playback" ? 36 : 37;
              break;
            case 33:
              return _context94.abrupt("return", this.deviceInfo);
            case 34:
              return _context94.abrupt("return", this.deviceInfo.filter(function (info) {
                return info.kind === "videoinput";
              }));
            case 35:
              return _context94.abrupt("return", this.deviceInfo.filter(function (info) {
                return info.kind === "audioinput";
              }));
            case 36:
              return _context94.abrupt("return", this.deviceInfo.filter(function (info) {
                return info.kind === "audiooutput";
              }));
            case 37:
            case "end":
              return _context94.stop();
          }
        }, _callee89, this, [[12, 21]]);
      }));
    }
  }, {
    key: "getElectronScreenSources",
    value: function getElectronScreenSources(type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
        var desktopCapturer, _window$require, ipcRenderer, config, rawSources;
        return _regeneratorRuntime().wrap(function _callee90$(_context95) {
          while (1) switch (_context95.prev = _context95.next) {
            case 0:
              _context95.prev = 0;
              _window$require = window.require('electron'), ipcRenderer = _window$require.ipcRenderer;
              desktopCapturer = {
                getSources: function getSources(opts) {
                  return ipcRenderer.invoke('QNRTC_DESKTOP_CAPTURER_GET_SOURCES', opts);
                }
              };
              _context95.next = 9;
              break;
            case 5:
              _context95.prev = 5;
              _context95.t0 = _context95["catch"](0);
              log.warning(_context95.t0);
              throw ERROR_ELECTRON_REQUIRE_ERROR(_context95.t0 instanceof Error ? _context95.t0.message : String(_context95.t0));
            case 9:
              config = {
                types: [],
                thumbnailSize: {
                  width: 150,
                  height: 150
                }
              };
              _context95.t1 = type;
              _context95.next = _context95.t1 === undefined ? 13 : _context95.t1 === QNElectronScreenSourceType.ALL ? 13 : _context95.t1 === QNElectronScreenSourceType.SCREEN ? 15 : _context95.t1 === QNElectronScreenSourceType.WINDOW ? 17 : 19;
              break;
            case 13:
              config.types.push('window', 'screen');
              return _context95.abrupt("break", 19);
            case 15:
              config.types.push('screen');
              return _context95.abrupt("break", 19);
            case 17:
              config.types.push('window');
              return _context95.abrupt("break", 19);
            case 19:
              _context95.prev = 19;
              _context95.next = 22;
              return desktopCapturer.getSources(config);
            case 22:
              rawSources = _context95.sent;
              return _context95.abrupt("return", rawSources.map(function (s) {
                return {
                  ID: s.id,
                  name: s.name,
                  url: s.thumbnail.toDataURL()
                };
              }));
            case 26:
              _context95.prev = 26;
              _context95.t2 = _context95["catch"](19);
              log.warning(_context95.t2);
              throw ERROR_FATAL("Electron getSources error, ".concat(_context95.t2 instanceof Error ? _context95.t2.message : String(_context95.t2)));
            case 30:
            case "end":
              return _context95.stop();
          }
        }, _callee90, null, [[0, 5], [19, 26]]);
      }));
    }
  }, {
    key: "createElectronScreenTrack",
    value: function createElectronScreenTrack() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
        var constraints, sources, sourceID, stream, tracks, _iterator41, _step41, track;
        return _regeneratorRuntime().wrap(function _callee91$(_context96) {
          while (1) switch (_context96.prev = _context96.next) {
            case 0:
              // 系统声音，目前仅 window 系统支持采集系统声音
              if (config.audio === true) {
                constraints = {
                  audio: {
                    mandatory: {
                      chromeMediaSource: 'desktop'
                    }
                  },
                  video: {
                    mandatory: {
                      chromeMediaSource: 'desktop'
                    }
                  }
                };
              }
              if (!config.sourceID) {
                _context96.next = 5;
                break;
              }
              constraints = {
                video: {
                  mandatory: {
                    chromeMediaSourceId: config.sourceID,
                    chromeMediaSource: 'desktop'
                  }
                }
              };
              _context96.next = 14;
              break;
            case 5:
              _context96.next = 7;
              return this.getElectronScreenSources();
            case 7:
              sources = _context96.sent;
              if (!(sources.length === 0)) {
                _context96.next = 10;
                break;
              }
              return _context96.abrupt("return", []);
            case 10:
              _context96.next = 12;
              return createScreenSelectionUI(sources);
            case 12:
              sourceID = _context96.sent;
              constraints = {
                video: {
                  mandatory: {
                    chromeMediaSourceId: sourceID,
                    chromeMediaSource: 'desktop'
                  }
                }
              };
            case 14:
              if (config.width) {
                constraints.video.maxWidth = config.width;
                constraints.video.minWidth = config.width;
              }
              if (config.height) {
                constraints.video.maxHeight = config.height;
                constraints.video.minHeight = config.height;
              }
              _context96.prev = 16;
              log.log("electron getUserMedia constraints: ", constraints);
              _context96.next = 20;
              return navigator.mediaDevices.getUserMedia(constraints);
            case 20:
              stream = _context96.sent;
              _context96.next = 26;
              break;
            case 23:
              _context96.prev = 23;
              _context96.t0 = _context96["catch"](16);
              throw ERROR_FATAL("Electron getUserMedia error, ".concat(_context96.t0 instanceof Error ? _context96.t0.message : "", ", config: ").concat(JSON.stringify(constraints)));
            case 26:
              tracks = [];
              _iterator41 = _createForOfIteratorHelper(stream.getTracks());
              try {
                for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                  track = _step41.value;
                  if (track.kind === 'audio') {
                    tracks.push(createCustomTrack(track, config.audioTag, config.bitrate));
                  } else {
                    if (config.optimizationMode) {
                      setMediaStreamTrackOpMode(track, config.optimizationMode);
                    }
                    tracks.push(createCustomTrack(track, config.tag, config.bitrate));
                  }
                }
              } catch (err) {
                _iterator41.e(err);
              } finally {
                _iterator41.f();
              }
              return _context96.abrupt("return", tracks);
            case 30:
            case "end":
              return _context96.stop();
          }
        }, _callee91, this, [[16, 23]]);
      }));
    }
  }, {
    key: "getLocalTracks",
    value: function getLocalTracks() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_RECORD_CONFIG;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
        var subConfig, subConfig2, values, constraints, mediaStream, videoKbps, audioKbps, videoTag, audioTag, mediaTracks, tracks, _iterator42, _step42, mediaTrack, optimizationMode, _iterator43, _step43, _mediaTrack, _track2, track;
        return _regeneratorRuntime().wrap(function _callee92$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              log.debug("get local tracks", config);
              /**
               * 如果同时开启了摄像头和屏幕采集，分 2 次采集完成
               */
              if (!(REC_SCREEN_ENABLE(config) && REC_VIDEO_ENABLE(config))) {
                _context97.next = 8;
                break;
              }
              subConfig = {
                screen: config.screen
              };
              subConfig2 = {
                video: config.video,
                audio: config.audio
              };
              _context97.next = 6;
              return Promise.all([this.getLocalTracks(subConfig), this.getLocalTracks(subConfig2)]);
            case 6:
              values = _context97.sent;
              return _context97.abrupt("return", values[0].concat(values[1]));
            case 8:
              _context97.next = 10;
              return transferRecordOptionToMediaConstraints(config);
            case 10:
              constraints = _context97.sent;
              if (constraints.video && typeof constraints.video === "object" && constraints.video.deviceId) {
                qos.addEvent("DeviceChanged", {
                  type: 0,
                  desc: constraints.video.deviceId,
                  event_grade: QNEventGrade.GENERAL,
                  event_category: QNEventCategory.VIDEO
                });
              }
              if (constraints.audio && typeof constraints.audio === "object" && constraints.audio.deviceId) {
                qos.addEvent("DeviceChanged", {
                  type: 1,
                  desc: constraints.audio.deviceId,
                  event_grade: QNEventGrade.GENERAL,
                  event_category: QNEventCategory.AUDIO
                });
              }
              _context97.prev = 13;
              _context97.next = 16;
              return this.getUserMedia(config, constraints, true);
            case 16:
              mediaStream = _context97.sent;
              _context97.next = 26;
              break;
            case 19:
              _context97.prev = 19;
              _context97.t0 = _context97["catch"](13);
              if (!(_context97.t0.name === "NotAllowedError")) {
                _context97.next = 25;
                break;
              }
              throw ERROR_DEVICE_NOT_ALLOWED("");
            case 25:
              throw _context97.t0;
            case 26:
              videoKbps = undefined;
              audioKbps = undefined;
              videoTag = undefined;
              audioTag = undefined;
              if (REC_AUDIO_ENABLE(config)) {
                audioKbps = config.audio.bitrate;
                audioTag = config.audio.tag;
              }
              if (REC_SCREEN_ENABLE(config)) {
                videoKbps = config.screen.bitrate;
                videoTag = config.screen.tag;
                audioTag = config.screen.audioTag;
              }
              if (REC_VIDEO_ENABLE(config)) {
                videoKbps = config.video.bitrate;
                videoTag = config.video.tag;
              }
              mediaTracks = mediaStream ? mediaStream.getTracks() : [];
              tracks = []; // 前面 screen 和 video 是分两次采集的，所以这里的 config 里面，只有一个是有效的
              _iterator42 = _createForOfIteratorHelper(mediaTracks);
              _context97.prev = 36;
              _iterator42.s();
            case 38:
              if ((_step42 = _iterator42.n()).done) {
                _context97.next = 48;
                break;
              }
              mediaTrack = _step42.value;
              optimizationMode = void 0;
              if (config.video && config.video.optimizationMode) {
                optimizationMode = config.video.optimizationMode;
              }
              if (config.screen && config.screen.optimizationMode) {
                optimizationMode = config.screen.optimizationMode;
              }
              if (optimizationMode) {
                _context97.next = 45;
                break;
              }
              return _context97.abrupt("continue", 46);
            case 45:
              setMediaStreamTrackOpMode(mediaTrack, optimizationMode);
            case 46:
              _context97.next = 38;
              break;
            case 48:
              _context97.next = 53;
              break;
            case 50:
              _context97.prev = 50;
              _context97.t1 = _context97["catch"](36);
              _iterator42.e(_context97.t1);
            case 53:
              _context97.prev = 53;
              _iterator42.f();
              return _context97.finish(53);
            case 56:
              _iterator43 = _createForOfIteratorHelper(mediaTracks);
              try {
                for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                  _mediaTrack = _step43.value;
                  _track2 = void 0;
                  if (_mediaTrack.kind === "audio") {
                    _track2 = createCustomTrack(_mediaTrack, audioTag, audioKbps);
                  } else {
                    _track2 = createCustomTrack(_mediaTrack, videoTag, videoKbps);
                  }
                  tracks.push(_track2);
                }
              } catch (err) {
                _iterator43.e(err);
              } finally {
                _iterator43.f();
              }
              if (!(config.audio && !!config.audio.source)) {
                _context97.next = 63;
                break;
              }
              _context97.next = 61;
              return AudioUtils.createAudioTrackFromSource(config.audio.source, audioTag, audioKbps);
            case 61:
              track = _context97.sent;
              tracks.push(track);
            case 63:
              this.updateDeivceInfo();
              return _context97.abrupt("return", tracks);
            case 65:
            case "end":
              return _context97.stop();
          }
        }, _callee92, this, [[13, 19], [36, 50, 53, 56]]);
      }));
    }
  }, {
    key: "getLocalStream",
    value: function getLocalStream(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
        var tracks;
        return _regeneratorRuntime().wrap(function _callee93$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              if (!(config && REC_SCREEN_ENABLE(config) && REC_VIDEO_ENABLE(config))) {
                _context98.next = 2;
                break;
              }
              throw ERROR_FATAL("can not get local stream with video and screen");
            case 2:
              _context98.next = 4;
              return this.getLocalTracks(config);
            case 4:
              tracks = _context98.sent;
              return _context98.abrupt("return", new Stream(tracks, "send"));
            case 6:
            case "end":
              return _context98.stop();
          }
        }, _callee93, this);
      }));
    }
  }, {
    key: "getUserMedia",
    value: function getUserMedia(config, constraints) {
      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
        var mediaStream, videoConstraint, videoWidth, videoHeight, tracks, firstTrack, _firstTrack$getSettin, _firstTrack$getSettin2, height, _firstTrack$getSettin3, width, diffProduct, ratio;
        return _regeneratorRuntime().wrap(function _callee94$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              log.debug("request to get user media, config", config);
              log.debug("request to get user media, constraints", constraints);
              if (!(!constraints.audio && !constraints.video)) {
                _context99.next = 4;
                break;
              }
              return _context99.abrupt("return", null);
            case 4:
              if (!REC_SCREEN_ENABLE(config)) {
                _context99.next = 10;
                break;
              }
              _context99.next = 7;
              return this.getDisplayMedia(constraints, config);
            case 7:
              mediaStream = _context99.sent;
              _context99.next = 30;
              break;
            case 10:
              _context99.next = 12;
              return navigator.mediaDevices.getUserMedia(constraints);
            case 12:
              mediaStream = _context99.sent;
              if (!(!isMobile && supportGetSettings() && init)) {
                _context99.next = 30;
                break;
              }
              videoConstraint = constraints.video;
              if (!(videoConstraint && typeof videoConstraint !== "boolean")) {
                _context99.next = 30;
                break;
              }
              videoWidth = videoConstraint.width;
              videoHeight = videoConstraint.height;
              if (!(typeof videoWidth === "number" && typeof videoHeight === "number")) {
                _context99.next = 30;
                break;
              }
              tracks = mediaStream.getVideoTracks();
              firstTrack = tracks && tracks[0];
              _firstTrack$getSettin = firstTrack.getSettings(), _firstTrack$getSettin2 = _firstTrack$getSettin.height, height = _firstTrack$getSettin2 === void 0 ? videoHeight : _firstTrack$getSettin2, _firstTrack$getSettin3 = _firstTrack$getSettin.width, width = _firstTrack$getSettin3 === void 0 ? videoWidth : _firstTrack$getSettin3;
              if (!(width && height)) {
                _context99.next = 30;
                break;
              }
              diffProduct = (videoHeight - height) * (videoWidth - width);
              if (!(diffProduct * diffProduct > 10)) {
                _context99.next = 30;
                break;
              }
              ratio = videoHeight / videoWidth;
              if (height / width < ratio) {
                videoConstraint.height = height;
                videoConstraint.width = height / ratio;
              } else {
                videoConstraint.width = width;
                videoConstraint.height = width * ratio;
              }
              log.debug("justified constraint constraintHeight, contraintWidth, constraintRatio, screenHeight, screenWidth:", videoHeight, videoWidth, ratio, height, width, videoConstraint);
              // 递归前将所有tracks全部停用
              mediaStream.getTracks().forEach(function (item) {
                return item.stop();
              });
              return _context99.abrupt("return", this.getUserMedia(config, Object.assign(Object.assign({}, constraints), {
                video: videoConstraint
              }), false));
            case 30:
              return _context99.abrupt("return", mediaStream);
            case 31:
            case "end":
              return _context99.stop();
          }
        }, _callee94, this);
      }));
    }
    /**
     * getDisplayMedia 不支持同时录制屏幕和麦克风
     * 在这种情况下分 2 次请求 stream 之后合并
     */
  }, {
    key: "getDisplayMedia",
    value: function getDisplayMedia(constraints, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
        var audioStream, screenStream, displayConstraints;
        return _regeneratorRuntime().wrap(function _callee95$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              if (!constraints.audio) {
                _context100.next = 4;
                break;
              }
              _context100.next = 3;
              return navigator.mediaDevices.getUserMedia({
                audio: constraints.audio
              });
            case 3:
              audioStream = _context100.sent;
            case 4:
              displayConstraints = config.screen && config.screen.audio && !constraints.audio ? {
                video: constraints.video,
                audio: config.screen.audio
              } : {
                video: constraints.video
              };
              if (!(browserReport.getDisplayMedia && config.screen && !config.screen.forceChromePlugin)) {
                _context100.next = 11;
                break;
              }
              _context100.next = 8;
              return navigator.mediaDevices.getDisplayMedia(displayConstraints);
            case 8:
              screenStream = _context100.sent;
              _context100.next = 14;
              break;
            case 11:
              _context100.next = 13;
              return navigator.mediaDevices.getUserMedia(displayConstraints);
            case 13:
              screenStream = _context100.sent;
            case 14:
              if (audioStream) {
                screenStream.addTrack(audioStream.getAudioTracks()[0]);
              }
              return _context100.abrupt("return", screenStream);
            case 16:
            case "end":
              return _context100.stop();
          }
        }, _callee95);
      }));
    }
  }, {
    key: "updateDeivceInfo",
    value: function updateDeivceInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var _this74 = this;
        var currentDeviceIds, lastDeviceIds, updateFlag;
        return _regeneratorRuntime().wrap(function _callee96$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              _context101.next = 2;
              return navigator.mediaDevices.enumerateDevices();
            case 2:
              this.deviceInfo = _context101.sent;
              currentDeviceIds = this.deviceInfo.map(function (d) {
                return d.deviceId;
              });
              lastDeviceIds = Object.keys(this.deviceMap);
              updateFlag = false;
              lastDeviceIds.forEach(function (deviceId) {
                // device 被拔出
                if (currentDeviceIds.indexOf(deviceId) === -1 && deviceId !== "@default") {
                  _this74.emit("device-remove", _this74.deviceMap[deviceId].device);
                  var device = _this74.deviceMap[deviceId].device;
                  _this74.emit("device-changed", {
                    device: device,
                    state: QNDeviceState.INACTIVE
                  });
                  var eventType = device.kind === "audioinput" || device.kind === "audiooutput" ? "AudioDeviceInOut" : "VideoDeviceInOut";
                  // 根据video audio的事件类型设置eventCategory
                  var eventCategory = eventType === "AudioDeviceInOut" ? QNEventCategory.AUDIO : QNEventCategory.VIDEO;
                  qos.addEvent(eventType, {
                    device_type: device.kind === "audiooutput" ? 1 : 0,
                    device_state: 0,
                    device_label: device.label,
                    device_id: device.deviceId,
                    device_info: device.label,
                    event_grade: QNEventGrade.GENERAL,
                    event_category: eventCategory
                  });
                  delete _this74.deviceMap[deviceId];
                  updateFlag = true;
                } else {
                  _this74.deviceMap[deviceId].tick += 1;
                }
              });
              currentDeviceIds.forEach(function (deviceId, index) {
                // device 插入
                if (lastDeviceIds.indexOf(deviceId) === -1 && deviceId !== "@default") {
                  _this74.deviceMap[deviceId] = {
                    device: _this74.deviceInfo[index],
                    tick: 0
                  };
                  var device = _this74.deviceMap[deviceId].device;
                  _this74.emit("device-changed", {
                    device: device,
                    state: QNDeviceState.ACTIVE
                  });
                  _this74.emit("device-add", device);
                  var eventType = device.kind === "audioinput" || device.kind === "audiooutput" ? "AudioDeviceInOut" : "VideoDeviceInOut";
                  // 根据video audio的事件类型设置eventCategory
                  var eventCategory = eventType === "AudioDeviceInOut" ? QNEventCategory.AUDIO : QNEventCategory.VIDEO;
                  qos.addEvent(eventType, {
                    device_type: device.kind === "audiooutput" ? 1 : 0,
                    device_state: 1,
                    device_label: device.label,
                    device_id: device.deviceId,
                    event_grade: QNEventGrade.GENERAL,
                    event_category: eventCategory
                  });
                  updateFlag = true;
                }
              });
              if (updateFlag) {
                this.emit("device-update", this.deviceInfo);
              }
            case 9:
            case "end":
              return _context101.stop();
          }
        }, _callee96, this);
      }));
    }
  }]);
  return DeviceManager;
}(EventEmitter);
var deviceManager = new DeviceManager();

/**
 * @public
 */
var QNRemoteUser = /*#__PURE__*/function () {
  // @internal
  function QNRemoteUser(client, user) {
    _classCallCheck(this, QNRemoteUser);
    // @internal
    this.networkQuality = QNNetworkQuality.UNKNOWN;
    this._client = client;
    this._user = user;
    this.userID = user.userID;
    this.userData = user.userData;
  }
  /**
   * 该用户发布的视频 track
   */
  _createClass(QNRemoteUser, [{
    key: "getVideoTracks",
    value: function getVideoTracks() {
      var videoTracks = [];
      var _iterator44 = _createForOfIteratorHelper(this._client._remoteTracks),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var track = _step44.value;
          if (track.isVideo() && track.userID === this.userID) {
            videoTracks.push(track);
          }
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return videoTracks;
    }
    /**
     * 该用户发布的音频 track
     */
  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      var audioTracks = [];
      var _iterator45 = _createForOfIteratorHelper(this._client._remoteTracks),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var track = _step45.value;
          if (track.isAudio() && track.userID === this.userID) {
            audioTracks.push(track);
          }
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      return audioTracks;
    }
  }]);
  return QNRemoteUser;
}();
/**
 * @public
 */
var QNTrack = /*#__PURE__*/function (_EventEmitter7) {
  _inherits(QNTrack, _EventEmitter7);
  function QNTrack() {
    var _this75;
    _classCallCheck(this, QNTrack);
    _this75 = _possibleConstructorReturn(this, _getPrototypeOf(QNTrack).apply(this, arguments));
    // @internal
    _this75._isMuted = false;
    return _this75;
  }
  _createClass(QNTrack, [{
    key: "eventNames",
    value: function eventNames() {
      return _get(_getPrototypeOf(QNTrack.prototype), "eventNames", this).call(this);
    }
    /**
     * 当前播放元素
     */
  }, {
    key: "play",
    /**
     * 播放
     */
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._track) return Promise.reject();
      // 兼容老的 muted 接口
      if (typeof config === "boolean") {
        return this._track.play(container, config, {});
      }
      return this._track.play(container, undefined, config);
    }
    /**
     * 是否是音频
     */
  }, {
    key: "isAudio",
    value: function isAudio() {
      return this._kind === "audio";
    }
    /**
     * 是否是视频
     */
  }, {
    key: "isVideo",
    value: function isVideo() {
      return this._kind === "video";
    }
    /**
     * 是否 mute
     */
  }, {
    key: "isMuted",
    value: function isMuted() {
      return this._isMuted;
    }
    /**
     * 获取 webrtc 原生的 track 对象
     */
  }, {
    key: "getMediaStreamTrack",
    value: function getMediaStreamTrack() {
      if (this.track) {
        return this.track.mediaTrack;
      } else {
        return undefined;
      }
    }
  }, {
    key: "mediaElement",
    get: function get() {
      return this._track && this._track.mediaElement;
    } // @internal
  }, {
    key: "track",
    get: function get() {
      return this._track;
    } // @internal
    ,
    set: function set(track) {
      if (track) {
        this._track = track;
        this._track.on("ended", function () {
          qnevents.emit("trackEnded", track.mediaTrack.id);
        });
        this._track.on("audioBuffer", function (buffer) {
          qnevents.emit("audioBuffer", buffer, track.mediaTrack.id);
        });
        this.trackID = this._track.info.trackID;
        this.userID = this._track.info.userID;
        this.tag = this._track.info.tag;
        this._kind = this._track.info.kind;
        this._isMuted = !!this._track.info.muted;
      }
    }
  }]);
  return QNTrack;
}(EventEmitter);
/**
 * @public
 */
var QNRemoteTrack = /*#__PURE__*/function (_QNTrack) {
  _inherits(QNRemoteTrack, _QNTrack);
  // @internal
  function QNRemoteTrack(trackInfo) {
    var _this76;
    _classCallCheck(this, QNRemoteTrack);
    _this76 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteTrack).call(this));
    // @internal
    _this76._isSubScribed = false;
    // @internal
    _this76.uplinkStats = {
      uplinkRTT: 0,
      uplinkLostRate: 0
    };
    _this76._kind = trackInfo.kind;
    _this76.trackID = trackInfo.trackID;
    _this76.userID = trackInfo.userID;
    _this76.tag = trackInfo.tag;
    qnevents.on("remote-track-stats", function (remoteTrackStats) {
      var _iterator46 = _createForOfIteratorHelper(remoteTrackStats),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var stat = _step46.value;
          if (stat.trackID === _this76.trackID) {
            _this76.uplinkStats.uplinkLostRate = stat.packetLossRate;
            _this76.uplinkStats.uplinkRTT = stat.rtt;
          }
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    });
    qnevents.on("mute-tracks", function (tracks) {
      var _iterator47 = _createForOfIteratorHelper(tracks),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var track = _step47.value;
          if (track.trackID === _this76.trackID) {
            _this76._isMuted = track.muted;
            _this76.emit("mute-state-changed", track.muted);
          }
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    });
    return _this76;
  }
  /**
   * 是否已订阅
   */
  _createClass(QNRemoteTrack, [{
    key: "isSubscribed",
    value: function isSubscribed() {
      return this._isSubScribed;
    }
  }]);
  return QNRemoteTrack;
}(QNTrack);
/**
 * @public
 */
var QNRemoteVideoTrack = /*#__PURE__*/function (_QNRemoteTrack) {
  _inherits(QNRemoteVideoTrack, _QNRemoteTrack);
  // @internal
  function QNRemoteVideoTrack(trackInfo) {
    var _this77;
    _classCallCheck(this, QNRemoteVideoTrack);
    _this77 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteVideoTrack).call(this, trackInfo));
    /**
     * 是否开启大小流
     * @deprecated use isLowStreamEnabled instead
     */
    _this77.isMultiProfileEnabled = false;
    /**
     * 该路远端 video track 是否开启了大小流
     */
    _this77.isLowStreamEnabled = false;
    // @internal
    _this77.profile = QNTrackProfile.HIGH;
    if (trackInfo.profiles.length > 0) {
      _this77.isMultiProfileEnabled = true;
      _this77.isLowStreamEnabled = true;
    }
    qnevents.on("sub-profile-changed", function (trackID, profile) {
      if (trackID !== _this77.trackID) return;
      switch (profile) {
        case "high":
          _this77.profile = QNTrackProfile.HIGH;
          _this77.emit("profile-changed", QNTrackProfile.HIGH);
          _this77.emit("low-stream-state-changed", false);
          break;
        case "medium":
          _this77.profile = QNTrackProfile.MEDIUM;
          _this77.emit("profile-changed", QNTrackProfile.MEDIUM);
          break;
        case "low":
          _this77.profile = QNTrackProfile.LOW;
          _this77.emit("profile-changed", QNTrackProfile.LOW);
          _this77.emit("low-stream-state-changed", true);
          break;
      }
    });
    return _this77;
  }
  /**
   * 选择订阅视频的清晰度
   * @deprecated use setLowStream instead
   */
  _createClass(QNRemoteVideoTrack, [{
    key: "setProfile",
    value: function setProfile(profile) {
      qnevents.emit("set-profile", this.trackID, profile);
    }
    /**
     * 是否使用小流
     */
  }, {
    key: "setLowStream",
    value: function setLowStream(useLowStream) {
      if (!this.isLowStreamEnabled) {
        throw ERROR_FATAL("isLowStreamEnabled is false, do not setLowStream on normal track");
      }
      var profile = useLowStream ? QNTrackProfile.LOW : QNTrackProfile.HIGH;
      qnevents.emit("set-profile", this.trackID, profile);
    }
    /**
     * 截取当前视频流数据
     */
  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      if (!this._track) return "data:,";
      return this._track.getCurrentFrameDataURL();
    }
    /**
     * 获取流状态数据
     */
  }, {
    key: "getStats",
    value: function getStats() {
      var defaultRemoteVideoStats = {
        downlinkFrameRate: 0,
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultRemoteVideoStats;
      var stats = this._track.getStats();
      if (stats.length === 0) return defaultRemoteVideoStats;
      defaultRemoteVideoStats.downlinkBitrate = stats[0].bitrate;
      defaultRemoteVideoStats.downlinkFrameRate = stats[0].frameRate;
      defaultRemoteVideoStats.downlinkLostRate = stats[0].packetLossRate;
      defaultRemoteVideoStats.uplinkLostRate = this.uplinkStats.uplinkLostRate;
      defaultRemoteVideoStats.uplinkRTT = this.uplinkStats.uplinkRTT;
      if (this.isMultiProfileEnabled) defaultRemoteVideoStats.profile = this.profile;
      return defaultRemoteVideoStats;
    }
  }]);
  return QNRemoteVideoTrack;
}(QNRemoteTrack);
/**
 * @public
 */
var QNRemoteAudioTrack = /*#__PURE__*/function (_QNRemoteTrack2) {
  _inherits(QNRemoteAudioTrack, _QNRemoteTrack2);
  // @internal
  function QNRemoteAudioTrack(trackInfo) {
    var _this78;
    _classCallCheck(this, QNRemoteAudioTrack);
    _this78 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteAudioTrack).call(this, trackInfo));
    qnevents.on("audioBuffer", function (buffer, trackLocalID) {
      if (_this78._track && trackLocalID === _this78._track.mediaTrack.id) {
        _this78.emit("audioFrame", buffer);
      }
    });
    return _this78;
  }
  /**
   * 设置音量
   */
  _createClass(QNRemoteAudioTrack, [{
    key: "setVolume",
    value: function setVolume(volume) {
      if (!this.track) return;
      this.track.setVolume(volume);
    }
    /**
     * 获取当前音量
     */
  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (!this.track) return;
      return this.track.getCurrentVolumeLevel();
    }
    /**
     * 获取当前时域数据
     */
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (!this.track) return;
      return this.track.getCurrentTimeDomainData();
    }
    /**
     * 获取当前频域数据
     */
  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (!this.track) return;
      return this.track.getCurrentFrequencyData();
    }
    /**
     * 设置音频输出设备
     * deviceId 可以从 QNRTC.getPlaybackDevices 接口中获取
     * 该功能仅 chrome 支持，如果在不支持功能的浏览器中调用，会抛出 ERROR_NOT_SUPPORT 错误
     */
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(deviceId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        return _regeneratorRuntime().wrap(function _callee97$(_context102) {
          while (1) switch (_context102.prev = _context102.next) {
            case 0:
              if (this.track) {
                _context102.next = 2;
                break;
              }
              return _context102.abrupt("return");
            case 2:
              return _context102.abrupt("return", this.track.setPlaybackDevice(deviceId));
            case 3:
            case "end":
              return _context102.stop();
          }
        }, _callee97, this);
      }));
    }
    /**
     * 获取流状态
     */
  }, {
    key: "getStats",
    value: function getStats() {
      var defaultRemoteAudioStats = {
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultRemoteAudioStats;
      var stats = this._track.getStats();
      if (stats.length === 0) return defaultRemoteAudioStats;
      defaultRemoteAudioStats.downlinkBitrate = stats[0].bitrate;
      defaultRemoteAudioStats.downlinkLostRate = stats[0].packetLossRate;
      defaultRemoteAudioStats.uplinkLostRate = this.uplinkStats.uplinkLostRate;
      defaultRemoteAudioStats.uplinkRTT = this.uplinkStats.uplinkRTT;
      return defaultRemoteAudioStats;
    }
  }]);
  return QNRemoteAudioTrack;
}(QNRemoteTrack);
var DB = /*#__PURE__*/function () {
  function DB(dbName, storeConfigs) {
    _classCallCheck(this, DB);
    this.dbName = dbName;
    this.storeConfigs = storeConfigs;
    this.db = undefined;
  }
  _createClass(DB, [{
    key: "getDB",
    value: function getDB() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
        var _this79 = this;
        return _regeneratorRuntime().wrap(function _callee98$(_context103) {
          while (1) switch (_context103.prev = _context103.next) {
            case 0:
              if (!(this.db != null)) {
                _context103.next = 2;
                break;
              }
              return _context103.abrupt("return", this.db);
            case 2:
              return _context103.abrupt("return", new Promise(function (resolve) {
                var request = indexedDB.open(_this79.dbName);
                request.addEventListener("upgradeneeded", function () {
                  var _iterator48 = _createForOfIteratorHelper(_this79.storeConfigs),
                    _step48;
                  try {
                    for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                      var storeConfig = _step48.value;
                      var store = request.result.createObjectStore(storeConfig.name);
                      var _iterator49 = _createForOfIteratorHelper(storeConfig.indexes),
                        _step49;
                      try {
                        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                          var indexConfig = _step49.value;
                          store.createIndex(indexConfig.name, indexConfig.keyPath);
                        }
                      } catch (err) {
                        _iterator49.e(err);
                      } finally {
                        _iterator49.f();
                      }
                    }
                  } catch (err) {
                    _iterator48.e(err);
                  } finally {
                    _iterator48.f();
                  }
                });
                resolve(promisifyRequest(request));
              }));
            case 3:
            case "end":
              return _context103.stop();
          }
        }, _callee98, this);
      }));
    }
  }, {
    key: "get",
    value: function get(storeName, key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
        var db, request;
        return _regeneratorRuntime().wrap(function _callee99$(_context104) {
          while (1) switch (_context104.prev = _context104.next) {
            case 0:
              _context104.next = 2;
              return this.getDB();
            case 2:
              db = _context104.sent;
              request = db.transaction(storeName, "readonly").objectStore(storeName).get(key);
              return _context104.abrupt("return", promisifyRequest(request));
            case 5:
            case "end":
              return _context104.stop();
          }
        }, _callee99, this);
      }));
    }
  }, {
    key: "getAll",
    value: function getAll(storeName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
        var db, request;
        return _regeneratorRuntime().wrap(function _callee100$(_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              _context105.next = 2;
              return this.getDB();
            case 2:
              db = _context105.sent;
              request = db.transaction(storeName, "readonly").objectStore(storeName).getAll();
              return _context105.abrupt("return", promisifyRequest(request));
            case 5:
            case "end":
              return _context105.stop();
          }
        }, _callee100, this);
      }));
    }
  }, {
    key: "count",
    value: function count(storeName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
        var db, request;
        return _regeneratorRuntime().wrap(function _callee101$(_context106) {
          while (1) switch (_context106.prev = _context106.next) {
            case 0:
              _context106.next = 2;
              return this.getDB();
            case 2:
              db = _context106.sent;
              request = db.transaction(storeName, "readonly").objectStore(storeName).count();
              return _context106.abrupt("return", promisifyRequest(request));
            case 5:
            case "end":
              return _context106.stop();
          }
        }, _callee101, this);
      }));
    }
  }, {
    key: "set",
    value: function set(storeName, key, value) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
        var db, transaction;
        return _regeneratorRuntime().wrap(function _callee102$(_context107) {
          while (1) switch (_context107.prev = _context107.next) {
            case 0:
              _context107.next = 2;
              return this.getDB();
            case 2:
              db = _context107.sent;
              transaction = db.transaction(storeName, "readwrite");
              transaction.objectStore(storeName).put(value, key);
              return _context107.abrupt("return", promisifyTransaction(transaction));
            case 6:
            case "end":
              return _context107.stop();
          }
        }, _callee102, this);
      }));
    }
  }, {
    key: "remove",
    value: function remove(storeName, key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
        var db, transaction;
        return _regeneratorRuntime().wrap(function _callee103$(_context108) {
          while (1) switch (_context108.prev = _context108.next) {
            case 0:
              _context108.next = 2;
              return this.getDB();
            case 2:
              db = _context108.sent;
              transaction = db.transaction(storeName, "readwrite");
              transaction.objectStore(storeName).delete(key);
              return _context108.abrupt("return", promisifyTransaction(transaction));
            case 6:
            case "end":
              return _context108.stop();
          }
        }, _callee103, this);
      }));
    }
  }, {
    key: "removeRange",
    value: function removeRange(storeName, start, end) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
        var _this80 = this;
        var index, db, request;
        return _regeneratorRuntime().wrap(function _callee105$(_context110) {
          while (1) switch (_context110.prev = _context110.next) {
            case 0:
              index = 0;
              _context110.next = 3;
              return this.getDB();
            case 3:
              db = _context110.sent;
              request = db.transaction(storeName, "readwrite").objectStore(storeName).openCursor(undefined, "next");
              return _context110.abrupt("return", new Promise(function (resolve, reject) {
                request.addEventListener("error", function () {
                  return reject(new IndexedDBError(request.error));
                });
                request.addEventListener("success", function () {
                  return __awaiter(_this80, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
                    var cursor;
                    return _regeneratorRuntime().wrap(function _callee104$(_context109) {
                      while (1) switch (_context109.prev = _context109.next) {
                        case 0:
                          cursor = request.result;
                          if (!(cursor == null || index >= end)) {
                            _context109.next = 4;
                            break;
                          }
                          resolve();
                          return _context109.abrupt("return");
                        case 4:
                          if (!(index >= start && index < end)) {
                            _context109.next = 7;
                            break;
                          }
                          _context109.next = 7;
                          return promisifyRequest(cursor.delete());
                        case 7:
                          ++index;
                          cursor.continue();
                        case 9:
                        case "end":
                          return _context109.stop();
                      }
                    }, _callee104);
                  }));
                });
              }));
            case 6:
            case "end":
              return _context110.stop();
          }
        }, _callee105, this);
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
        var db;
        return _regeneratorRuntime().wrap(function _callee106$(_context111) {
          while (1) switch (_context111.prev = _context111.next) {
            case 0:
              _context111.next = 2;
              return this.getDB();
            case 2:
              db = _context111.sent;
              _context111.next = 5;
              return Promise.all(this.storeConfigs.map(function (_ref) {
                var storeName = _ref.name;
                var transaction = db.transaction(storeName, "readwrite");
                transaction.objectStore(storeName).clear();
                return promisifyTransaction(transaction);
              }));
            case 5:
            case "end":
              return _context111.stop();
          }
        }, _callee106, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.db && this.db.close();
    }
  }]);
  return DB;
}();
/** indexedDB 异常（比如 open 失败） */
var IndexedDBError = /*#__PURE__*/function (_Error3) {
  _inherits(IndexedDBError, _Error3);
  function IndexedDBError( /** 作为起因的原 error */
  cause) {
    var _this81;
    _classCallCheck(this, IndexedDBError);
    _this81 = _possibleConstructorReturn(this, _getPrototypeOf(IndexedDBError).call(this, cause + ""));
    _this81.cause = cause;
    _this81.name = "IndexedDBError";
    return _this81;
  }
  return IndexedDBError;
}(_wrapNativeSuper(Error));
function promisifyRequest(request) {
  return new Promise(function (resolve, reject) {
    request.addEventListener("success", function () {
      return resolve(request.result);
    });
    request.addEventListener("error", function () {
      return reject(new IndexedDBError(request.error));
    });
  });
}
function promisifyTransaction(transaction) {
  return new Promise(function (resolve, reject) {
    transaction.addEventListener("complete", function () {
      return resolve();
    });
    transaction.addEventListener("error", function () {
      return reject(new IndexedDBError(transaction.error));
    });
    transaction.addEventListener("abort", function () {
      return reject(new IndexedDBError(transaction.error));
    });
  });
}
var namespace = "qnwebrtc/dc/v1";
var itemStoreName = "log";
var UPLOAD_ACTION = "https://upload.qiniup.com";
var ERROR_CODE;
(function (ERROR_CODE) {
  ERROR_CODE[ERROR_CODE["Err_Fetch_Token"] = 25001] = "Err_Fetch_Token";
  ERROR_CODE[ERROR_CODE["Err_Read_File"] = 25002] = "Err_Read_File";
})(ERROR_CODE || (ERROR_CODE = {}));
var itemStoreConfig = {
  name: itemStoreName,
  indexes: []
};
var QNLog = /*#__PURE__*/function () {
  function QNLog() {
    _classCallCheck(this, QNLog);
    this.taskq = new TaskQueue("log", false);
    this.useLog = false;
    this.db = new DB(namespace, [itemStoreConfig]);
    this.initLogQueue();
  }
  /** 设置日志参数 */
  _createClass(QNLog, [{
    key: "setLogConfig",
    value: function setLogConfig(config) {
      this.useLog = true;
      this.config = Object.assign(Object.assign({}, config), {
        maxCount: config.maxCount > 3000 ? 3000 : config.maxCount
      });
    }
  }, {
    key: "uploadLog",
    value: function uploadLog(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
        var _this82 = this;
        return _regeneratorRuntime().wrap(function _callee107$(_context112) {
          while (1) switch (_context112.prev = _context112.next) {
            case 0:
              if (this.useLog) {
                _context112.next = 2;
                break;
              }
              return _context112.abrupt("return");
            case 2:
              return _context112.abrupt("return", new Promise(function (resolve) {
                _this82.taskq.push("uploadLog", {
                  token: token,
                  resolve: resolve
                });
              }));
            case 3:
            case "end":
              return _context112.stop();
          }
        }, _callee107, this);
      }));
    }
  }, {
    key: "_uploadLog",
    value: function _uploadLog(_ref) {
      var token = _ref.token,
        resolve = _ref.resolve;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
        var logList, log, insertLog, size, maxSize, _i13, blob, file, submitToken, result, userID, deviceId, formData, res;
        return _regeneratorRuntime().wrap(function _callee108$(_context113) {
          while (1) switch (_context113.prev = _context113.next) {
            case 0:
              _context113.prev = 0;
              _context113.next = 3;
              return this.db.getAll(itemStoreName);
            case 3:
              logList = _context113.sent;
              _context113.next = 9;
              break;
            case 6:
              _context113.prev = 6;
              _context113.t0 = _context113["catch"](0);
              return _context113.abrupt("return", {
                code: ERROR_CODE.Err_Read_File
              });
            case 9:
              log = logList.map(function (item) {
                return item.map(function (inner) {
                  return JSON.stringify(inner);
                }).join(" ") + "\n";
              });
              insertLog = [];
              size = 0;
              maxSize = 10 * 1024 * 1024;
              _i13 = log.length - 1;
            case 14:
              if (!(_i13 >= 0)) {
                _context113.next = 24;
                break;
              }
              if (!(size + log[_i13].length <= maxSize)) {
                _context113.next = 20;
                break;
              }
              size += log[_i13].length;
              insertLog.unshift(log[_i13]);
              _context113.next = 21;
              break;
            case 20:
              return _context113.abrupt("break", 24);
            case 21:
              _i13--;
              _context113.next = 14;
              break;
            case 24:
              blob = new Blob(insertLog, {
                type: "text/plain;charset=utf-8"
              });
              file = new File([blob], "log.text", {
                type: "text/plain"
              });
              /** 获取 token */
              if (!(token === undefined)) {
                _context113.next = 39;
                break;
              }
              _context113.prev = 27;
              _context113.next = 30;
              return requestMcu('/v4/sdk/log/upload/token');
            case 30:
              result = _context113.sent;
              submitToken = result.uploadToken;
              _context113.next = 37;
              break;
            case 34:
              _context113.prev = 34;
              _context113.t1 = _context113["catch"](27);
              return _context113.abrupt("return", {
                code: ERROR_CODE.Err_Fetch_Token
              });
            case 37:
              _context113.next = 40;
              break;
            case 39:
              submitToken = token;
            case 40:
              /** 日志上传 */
              userID = QNRTC$1._clients.map(function (item) {
                return item.userID;
              }).join("_");
              _context113.next = 43;
              return getDeviceId();
            case 43:
              deviceId = _context113.sent;
              formData = new FormData();
              formData.append("action", UPLOAD_ACTION);
              formData.append("key", "QNLog_".concat(Date.now(), "_").concat(this.config.tag, "_").concat(deviceId, "_").concat(userID));
              formData.append("token", submitToken);
              formData.append("file", file);
              _context113.prev = 49;
              _context113.next = 52;
              return fetch(UPLOAD_ACTION, {
                method: "POST",
                body: formData
              });
            case 52:
              res = _context113.sent;
              if (!(res.status === 200)) {
                _context113.next = 56;
                break;
              }
              _context113.next = 56;
              return this.db.clear();
            case 56:
              resolve({
                code: res.status
              });
              _context113.next = 62;
              break;
            case 59:
              _context113.prev = 59;
              _context113.t2 = _context113["catch"](49);
              resolve({
                code: -1
              });
            case 62:
            case "end":
              return _context113.stop();
          }
        }, _callee108, this, [[0, 6], [27, 34], [49, 59]]);
      }));
    }
    /**
     * 添加日志
     */
  }, {
    key: "addLog",
    value: function addLog(type, message) {
      var _this83 = this;
      if (!this.useLog) {
        return;
      }
      var logStr = [type].concat(_toConsumableArray(message)).map(function (item) {
        return _this83.pretty(item, 2);
      });
      this.taskq.push("add", logStr);
    }
  }, {
    key: "_addLog",
    value: function _addLog(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
        var count, logStr;
        return _regeneratorRuntime().wrap(function _callee109$(_context114) {
          while (1) switch (_context114.prev = _context114.next) {
            case 0:
              _context114.next = 2;
              return this.db.count(itemStoreName);
            case 2:
              count = _context114.sent;
              if (!(count >= this.config.maxCount)) {
                _context114.next = 6;
                break;
              }
              _context114.next = 6;
              return this.db.removeRange(itemStoreName, 0, 1);
            case 6:
              logStr = data;
              _context114.next = 9;
              return this.db.set(itemStoreName, Date.now().toString(), logStr);
            case 9:
            case "end":
              return _context114.stop();
          }
        }, _callee109, this);
      }));
    }
    /**
     * 监听任务队列
     */
  }, {
    key: "initLogQueue",
    value: function initLogQueue() {
      var _this84 = this;
      this.taskq.on("exec", function (command, ph) {
        switch (command.method) {
          case "add":
            {
              ph.promise = _this84._addLog(command.data);
              return;
            }
          case "uploadLog":
            {
              ph.promise = _this84._uploadLog(command.data);
              return;
            }
        }
      });
    }
    /**
     * 去除循环对象的引用
     */
  }, {
    key: "pretty",
    value: function pretty(data, deep) {
      var toString = function toString(data) {
        if (data) {
          if (typeof data === "function" || typeof data === "object") {
            return "[native code]";
          } else {
            return data.toString();
          }
        } else {
          return "";
        }
      };
      if (typeof data === "object") {
        var obj = {};
        for (var key in data) {
          if (deep === 0) {
            obj[key] = toString(data[key]);
          } else {
            if (typeof data[key] === "object") {
              obj[key] = this.pretty(data[key], deep - 1);
            } else {
              obj[key] = toString(data[key]);
            }
          }
        }
        return obj;
      } else {
        return data;
      }
    }
  }]);
  return QNLog;
}();
var savedLog = new QNLog();

/**
 * @public
 * QNRTCClient
 */
var QNRTCClient = /*#__PURE__*/function (_EventEmitter8) {
  _inherits(QNRTCClient, _EventEmitter8);
  // @internal
  function QNRTCClient(config) {
    var _this85;
    _classCallCheck(this, QNRTCClient);
    _this85 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCClient).call(this));
    _this85.readyUploadLog = false;
    /**
     * 当前房间连接状态
     */
    _this85.connectionState = QNConnectionState.DISCONNECTED;
    // @internal
    _this85._localTracks = []; // 已发布
    // @internal
    _this85._remoteTracks = []; // 未订阅 + 已订阅
    // @internal
    _this85._disconnectedInfo = {
      code: 0
    };
    /**
     * 房间当前的远端用户列表
     */
    _this85.remoteUsers = [];
    _this85.session = new TrackModeSession(config);
    _this85.session.on("refresh-track-info", function (tracks) {
      var _iterator50 = _createForOfIteratorHelper(tracks),
        _step50;
      try {
        var _loop20 = function _loop20() {
          var track = _step50.value;
          _this85._localTracks.forEach(function (localTrack) {
            if (localTrack._track && localTrack._track.mediaTrack.id === track.localid) {
              localTrack.trackID = track.trackid;
            }
          });
        };
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          _loop20();
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    });
    _this85.session.on("user-join", function (user) {
      var qnuser = new QNRemoteUser(_assertThisInitialized(_assertThisInitialized(_this85)), user);
      _this85.remoteUsers.push(qnuser);
      _this85.emit("user-joined", user.userID, user.userData);
    });
    _this85.session.on("user-leave", function (user) {
      _this85.remoteUsers = _this85.remoteUsers.filter(function (remoteUser) {
        return remoteUser.userID !== user.userID;
      });
      _this85.emit("user-left", user.userID);
    });
    _this85.session.on("track-add", function (trackInfos) {
      var _this85$_remoteTracks;
      if (trackInfos.length === 0) return;
      var qntracks = trackInfos.map(function (trackInfo) {
        if (trackInfo.kind === "audio") {
          return new QNRemoteAudioTrack(trackInfo);
        } else {
          return new QNRemoteVideoTrack(trackInfo);
        }
      });
      (_this85$_remoteTracks = _this85._remoteTracks).push.apply(_this85$_remoteTracks, _toConsumableArray(qntracks));
      var grouped = groupBy(qntracks, function (t) {
        return t.userID;
      });
      Object.entries(grouped).forEach(function (_ref) {
        var _ref9 = _slicedToArray(_ref, 2),
          userID = _ref9[0],
          qntracks = _ref9[1];
        _this85.emit("user-published", userID, qntracks);
      });
    });
    _this85.session.on("track-remove", function (trackInfos) {
      if (trackInfos.length === 0) return;
      var userID = trackInfos[0].userID;
      var trackIDs = new Set();
      var _iterator51 = _createForOfIteratorHelper(trackInfos),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var trackInfo = _step51.value;
          trackIDs.add(trackInfo.trackID);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
      var unpublishedTracks = [];
      var remainedTracks = [];
      var _iterator52 = _createForOfIteratorHelper(_this85._remoteTracks),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var remoteTrack = _step52.value;
          if (trackIDs.has(remoteTrack.trackID)) {
            unpublishedTracks.push(remoteTrack);
          } else {
            remainedTracks.push(remoteTrack);
          }
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      _this85._remoteTracks = remainedTracks;
      _this85.emit("user-unpublished", userID, unpublishedTracks);
    });
    _this85.session.on("mute-tracks", function (tracks) {
      if (tracks.length === 0) return;
      qnevents.emit("mute-tracks", tracks);
    });
    qnevents.on("set-mute-tracks", function (trackID, isMuted, client) {
      if (client === _this85.getClientKey()) {
        _this85.session.muteTracks([{
          trackID: trackID,
          muted: isMuted
        }]);
      } else if (client === "") {
        throw ERROR_FATAL('can not setMuted，please publish track first');
      }
    });
    _this85.session.on("room-state-change", function (state) {
      switch (state) {
        case RoomState.Idle:
          _this85.connectionState = QNConnectionState.DISCONNECTED;
          break;
        case RoomState.Connecting:
          _this85.connectionState = QNConnectionState.CONNECTING;
          break;
        case RoomState.Reconnecting:
          _this85.connectionState = QNConnectionState.RECONNECTING;
          break;
        case RoomState.Connected:
          _this85.connectionState = _this85.connectionState === QNConnectionState.CONNECTING ? QNConnectionState.CONNECTED : QNConnectionState.RECONNECTED;
          break;
        default:
          log.warning("Invalid roomState: ", state);
          break;
      }
      if (_this85.connectionState === QNConnectionState.DISCONNECTED) {
        var reason;
        switch (_this85._disconnectedInfo.code) {
          case 0:
            reason = QNConnectionDisconnectedReason.LEAVE;
            break;
          case 10006:
            reason = QNConnectionDisconnectedReason.KICKED_OUT;
            break;
          default:
            reason = QNConnectionDisconnectedReason.ERROR;
            break;
        }
        var info = {
          reason: reason
        };
        if (reason === QNConnectionDisconnectedReason.ERROR) {
          info.errorCode = _this85._disconnectedInfo.code;
          switch (info.errorCode) {
            case 10001:
              info.errorMessage = "token 错误";
              break;
            case 10002:
              info.errorMessage = "token 过期";
              break;
            case 10004:
              info.errorMessage = "reconnect token 过期";
              break;
            case 10007:
              info.errorMessage = "断线重连失败";
              break;
            case 10022:
              info.errorMessage = "该用户在其他页面或终端登录";
              break;
            case 10011:
              info.errorMessage = "房间人数已满";
              break;
            case 10012:
              info.errorMessage = "房间已关闭";
              break;
            default:
              info.errorMessage = "unexpected error";
              break;
          }
        }
        _this85.release();
        _this85.emit("connection-state-changed", _this85.connectionState, info);
      } else {
        _this85.emit("connection-state-changed", _this85.connectionState);
      }
    });
    _this85.session.on("messages-received", function (messages) {
      var _iterator53 = _createForOfIteratorHelper(messages),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var message = _step53.value;
          var ms = {
            ID: message.msgid,
            userID: message.userID,
            content: message.data,
            timestamp: message.timestamp
          };
          _this85.emit("message-received", ms);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    });
    _this85.session.on("media-relay-state-changed", function (roomName, state) {
      _this85.emit("media-relay-state-changed", roomName, state);
    });
    _this85.session.on("remote-user-reconnecting", function (user) {
      _this85.emit("user-reconnecting", user.userID);
    });
    _this85.session.on("remote-user-reconnected", function (user) {
      _this85.emit("user-reconnected", user.userID);
    });
    _this85.session.on("forward-job-connected", function (info) {
      _this85.emit("direct-livestreaming-state-changed", info.jobId, QNLiveStreamingState.STARTED);
    });
    _this85.session.on("forward-job-disconnected", function (info) {
      // TODO: 等待后端增加能力后，emit 出第三个参数 reason，表示异常断开的原因
      _this85.emit("direct-livestreaming-state-changed", info.jobId, QNLiveStreamingState.STOPPED);
    });
    _this85.session.on("merge-job-connected", function (info) {
      _this85.emit("transcoding-livestreaming-state-changed", info.jobId, QNLiveStreamingState.STARTED);
    });
    _this85.session.on("merge-job-disconnected", function (info) {
      // TODO: 等待后端增加能力后，emit 出第三个参数 reason，表示异常断开的原因
      _this85.emit("transcoding-livestreaming-state-changed", info.jobId, QNLiveStreamingState.STOPPED);
    });
    _this85.session.on("command", function (info) {
      if (info.command === "upload-log") {
        try {
          var detail = JSON.parse(info.content);
          if (detail.auto_upload_log && detail.auto_upload_log === 1) {
            _this85.readyUploadLog = true;
          }
        } catch (e) {}
      }
    });
    _this85.session.on("disconnect", function (d) {
      _this85._disconnectedInfo = d;
    });
    _this85.session.on("on-sub-profile-changed", function (d) {
      qnevents.emit("sub-profile-changed", d.trackid, d.profile);
    });
    _this85.session.on("volume-indicator", function (volumes) {
      _this85.emit("volume-indicator", volumes);
    });
    qnevents.on("remote-track-stats", function (remoteTrackStats) {
      var _iterator54 = _createForOfIteratorHelper(remoteTrackStats),
        _step54;
      try {
        var _loop21 = function _loop21() {
            var stat = _step54.value;
            var user = _this85.remoteUsers.filter(function (user) {
              return user.userID === stat.userID;
            })[0];
            if (!user) {
              return {
                v: void 0
              };
            }
            switch (stat.networkGrade) {
              case NetworkGrade.INVALID:
                user.networkQuality = QNNetworkQuality.UNKNOWN;
                break;
              case NetworkGrade.POOR:
                user.networkQuality = QNNetworkQuality.POOR;
                break;
              case NetworkGrade.FAIR:
                user.networkQuality = QNNetworkQuality.FAIR;
                break;
              case NetworkGrade.GOOD:
                user.networkQuality = QNNetworkQuality.GOOD;
                break;
              case NetworkGrade.EXCELLENT:
                user.networkQuality = QNNetworkQuality.EXCELLENT;
                break;
              default:
                log.warning("unkonw network grade: ", stat.networkGrade);
                break;
            }
          },
          _ret3;
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          _ret3 = _loop21();
          if (_ret3) return _ret3.v;
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
    });
    qnevents.on("set-profile", function (trackID, profile) {
      switch (profile) {
        case QNTrackProfile.HIGH:
          _this85.session.setProfile(trackID, 'high');
          break;
        case QNTrackProfile.MEDIUM:
          _this85.session.setProfile(trackID, 'medium');
          break;
        case QNTrackProfile.LOW:
          _this85.session.setProfile(trackID, 'low');
          break;
      }
    });
    qnevents.on("setMediaStreamTrack", function (trackID, newTrack, client, cb, errcb) {
      if (client === _this85.getClientKey()) {
        _this85.session.replaceTrack(trackID, newTrack).then(cb).catch(errcb);
      } else if (client === "") {
        throw ERROR_FATAL('can not setMediaStreamTrack，please publish track first');
      }
    });
    return _this85;
  }
  // @internal
  _createClass(QNRTCClient, [{
    key: "setTransportPolicy",
    // @internal
    value: function setTransportPolicy(transportPolicy) {
      this.session.config.transportPolicy = transportPolicy;
    }
    /**
     * 本地用户的用户 ID
     */
  }, {
    key: "getRemoteUser",
    /**
     * 获取远端用户
     */
    value: function getRemoteUser(userID) {
      return this.remoteUsers.find(function (user) {
        return user.userID === userID;
      });
    }
    /**
     * 设置场景
     * 仅可 join room 前调用
     */
  }, {
    key: "setClientMode",
    value: function setClientMode(mode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
        return _regeneratorRuntime().wrap(function _callee110$(_context115) {
          while (1) switch (_context115.prev = _context115.next) {
            case 0:
              this.session.setClientMode(mode);
            case 1:
            case "end":
              return _context115.stop();
          }
        }, _callee110, this);
      }));
    }
    /**
     * 设置角色
     * join room 前后均可以调用
     */
  }, {
    key: "setClientRole",
    value: function setClientRole(role) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
        return _regeneratorRuntime().wrap(function _callee111$(_context116) {
          while (1) switch (_context116.prev = _context116.next) {
            case 0:
              _context116.next = 2;
              return this.session.setClientRole(role);
            case 2:
            case "end":
              return _context116.stop();
          }
        }, _callee111, this);
      }));
    }
    /**
     * 加入房间
     */
  }, {
    key: "join",
    value: function join(token, userData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
        var _this86 = this;
        var cacheConfig, configList, configItem, device_model, device_name, osversion, appid, userid, data, config, content, refreshConfig, lastItemIndex;
        return _regeneratorRuntime().wrap(function _callee112$(_context117) {
          while (1) switch (_context117.prev = _context117.next) {
            case 0:
              _context117.next = 2;
              return this.session.joinRoomWithToken(token, userData);
            case 2:
              cacheConfig = localStorage.getItem("QNConfig");
              if (cacheConfig) {
                try {
                  configList = JSON.parse(cacheConfig);
                  configItem = configList.find(function (item) {
                    return item.appid === _this86.session.appId && item.userid === _this86.session.userID;
                  });
                  if (configItem) {
                    if (configItem.auto_upload_log === "1") {
                      this.readyUploadLog = true;
                    }
                  }
                } catch (e) {}
              }
              device_model = "".concat(browser.name, " ").concat(browser.version);
              _context117.next = 7;
              return getDeviceId();
            case 7:
              device_name = _context117.sent;
              osversion = browser.os;
              appid = this.session.appId;
              userid = this.session.userID;
              _context117.prev = 11;
              _context117.next = 14;
              return requestMcu("/v4/sdk/config?platform=Web&appid=".concat(appid, "&osversion=").concat(osversion, "&device_model=").concat(device_model, "&device_name=").concat(device_name, "&user_id=").concat(userid));
            case 14:
              data = _context117.sent;
              config = {};
              content = data.content;
              content.split(";").filter(function (item) {
                return item;
              }).forEach(function (item) {
                var list = item.split(":");
                config[list[0]] = list[1];
              });
              appid && (config.appid = appid);
              userid && (config.userid = userid);
              if (cacheConfig) {
                refreshConfig = JSON.parse(cacheConfig);
                lastItemIndex = refreshConfig.findIndex(function (item) {
                  return item.appid === config.appid && item.userid === config.userid;
                });
                if (lastItemIndex > -1) {
                  refreshConfig[lastItemIndex] = config;
                } else {
                  refreshConfig.push(config);
                }
                localStorage.setItem("QNConfig", JSON.stringify(refreshConfig));
              } else {
                localStorage.setItem("QNConfig", JSON.stringify([config]));
              }
              _context117.next = 26;
              break;
            case 23:
              _context117.prev = 23;
              _context117.t0 = _context117["catch"](11);
              log.warning(_context117.t0);
            case 26:
            case "end":
              return _context117.stop();
          }
        }, _callee112, this, [[11, 23]]);
      }));
    }
    /**
     * 离开房间
     */
  }, {
    key: "leave",
    value: function leave() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
        var _this87 = this;
        return _regeneratorRuntime().wrap(function _callee114$(_context119) {
          while (1) switch (_context119.prev = _context119.next) {
            case 0:
              _context119.next = 2;
              return Promise.resolve().then(function () {
                return _this87.session.leave();
              });
            case 2:
              this.release();
              if (this.readyUploadLog) {
                setTimeout(function () {
                  return __awaiter(_this87, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
                    return _regeneratorRuntime().wrap(function _callee113$(_context118) {
                      while (1) switch (_context118.prev = _context118.next) {
                        case 0:
                          _context118.next = 2;
                          return savedLog.uploadLog();
                        case 2:
                          this.readyUploadLog = false;
                        case 3:
                        case "end":
                          return _context118.stop();
                      }
                    }, _callee113, this);
                  }));
                }, 0);
              }
            case 4:
            case "end":
              return _context119.stop();
          }
        }, _callee114, this);
      }));
    }
  }, {
    key: "release",
    value: function release() {
      this._localTracks = [];
      this._remoteTracks = [];
      this._disconnectedInfo = {
        code: 0
      };
      this.remoteUsers = [];
    }
    /**
     * 发布
     */
  }, {
    key: "publish",
    value: function publish(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
        var _this$_localTracks, _iterator55, _step55, t;
        return _regeneratorRuntime().wrap(function _callee115$(_context120) {
          while (1) switch (_context120.prev = _context120.next) {
            case 0:
              if (!Array.isArray(tracks)) {
                _context120.next = 9;
                break;
              }
              if (tracks.find(function (t) {
                return t.isVideo();
              })) {
                this.session.simulcast = !!tracks.filter(function (t) {
                  return t.isVideo();
                }).find(function (t) {
                  return t.isMultiProfileEnabled;
                });
              }
              _context120.next = 4;
              return this.session.publish(tracks.map(function (t) {
                return t.track;
              }));
            case 4:
              _iterator55 = _createForOfIteratorHelper(tracks);
              try {
                for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                  t = _step55.value;
                  t.trackID = t.track.info.trackID;
                  t.userID = this.session.userID;
                  t.client = this.getClientKey();
                }
              } catch (err) {
                _iterator55.e(err);
              } finally {
                _iterator55.f();
              }
              (_this$_localTracks = this._localTracks).push.apply(_this$_localTracks, _toConsumableArray(tracks));
              _context120.next = 16;
              break;
            case 9:
              if (tracks.isVideo() && tracks.isMultiProfileEnabled) {
                this.session.config.simulcast = true;
              }
              _context120.next = 12;
              return this.session.publish([tracks.track]);
            case 12:
              tracks.trackID = tracks.track.info.trackID;
              tracks.userID = this.session.userID;
              tracks.client = this.getClientKey();
              this._localTracks.push(tracks);
            case 16:
            case "end":
              return _context120.stop();
          }
        }, _callee115, this);
      }));
    }
    /**
     * 获取 client 唯一 id
     */
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return md5("".concat(this.roomName ? this.roomName : "").concat(this.userID ? this.userID : "").concat(this.session.appId ? this.session.appId : ""));
    }
    /**
     * 取消发布
     */
  }, {
    key: "unpublish",
    value: function unpublish(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
        var ts;
        return _regeneratorRuntime().wrap(function _callee116$(_context121) {
          while (1) switch (_context121.prev = _context121.next) {
            case 0:
              if (!Array.isArray(tracks)) {
                _context121.next = 9;
                break;
              }
              ts = this._localTracks.filter(function (t) {
                return tracks.includes(t);
              });
              if (!(ts.length !== tracks.length)) {
                _context121.next = 4;
                break;
              }
              throw ERROR_FATAL("target tracks has not published");
            case 4:
              _context121.next = 6;
              return this.session.unpublish(tracks.map(function (t) {
                return t.trackID;
              }));
            case 6:
              this._localTracks = this._localTracks.filter(function (t) {
                return !tracks.includes(t);
              });
              _context121.next = 14;
              break;
            case 9:
              if (this._localTracks.includes(tracks)) {
                _context121.next = 11;
                break;
              }
              throw ERROR_FATAL("target tracks has not published");
            case 11:
              _context121.next = 13;
              return this.session.unpublish([tracks.trackID]);
            case 13:
              this._localTracks = this._localTracks.filter(function (t) {
                return t !== tracks;
              });
            case 14:
            case "end":
              return _context121.stop();
          }
        }, _callee116, this);
      }));
    }
    /**
     * 订阅
     */
  }, {
    key: "subscribe",
    value: function subscribe(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee117() {
        var subscribedTracks, videoTracks, audioTracks, _iterator56, _step56, _loop22, t;
        return _regeneratorRuntime().wrap(function _callee117$(_context123) {
          while (1) switch (_context123.prev = _context123.next) {
            case 0:
              if (!Array.isArray(tracks)) {
                _context123.next = 27;
                break;
              }
              _context123.next = 3;
              return this.session.subscribe(tracks.map(function (t) {
                return t.trackID;
              }));
            case 3:
              subscribedTracks = _context123.sent;
              videoTracks = [];
              audioTracks = [];
              _iterator56 = _createForOfIteratorHelper(subscribedTracks);
              _context123.prev = 7;
              _loop22 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop22() {
                var subscribedTrack, targetTracks, targetTrack;
                return _regeneratorRuntime().wrap(function _loop22$(_context122) {
                  while (1) switch (_context122.prev = _context122.next) {
                    case 0:
                      subscribedTrack = _step56.value;
                      targetTracks = tracks.filter(function (t) {
                        return t.trackID === subscribedTrack.info.trackID;
                      });
                      if (!(targetTracks.length === 0)) {
                        _context122.next = 4;
                        break;
                      }
                      return _context122.abrupt("return", 1);
                    case 4:
                      targetTrack = targetTracks[0];
                      targetTrack.track = subscribedTrack;
                      targetTrack._isSubScribed = true;
                      if (subscribedTrack.info.kind === "audio") {
                        audioTracks.push(targetTrack);
                      } else {
                        videoTracks.push(targetTrack);
                      }
                    case 8:
                    case "end":
                      return _context122.stop();
                  }
                }, _loop22);
              });
              _iterator56.s();
            case 10:
              if ((_step56 = _iterator56.n()).done) {
                _context123.next = 16;
                break;
              }
              return _context123.delegateYield(_loop22(), "t0", 12);
            case 12:
              if (!_context123.t0) {
                _context123.next = 14;
                break;
              }
              return _context123.abrupt("continue", 14);
            case 14:
              _context123.next = 10;
              break;
            case 16:
              _context123.next = 21;
              break;
            case 18:
              _context123.prev = 18;
              _context123.t1 = _context123["catch"](7);
              _iterator56.e(_context123.t1);
            case 21:
              _context123.prev = 21;
              _iterator56.f();
              return _context123.finish(21);
            case 24:
              return _context123.abrupt("return", {
                audioTracks: audioTracks,
                videoTracks: videoTracks
              });
            case 27:
              _context123.next = 29;
              return this.session.subscribe([tracks.trackID]);
            case 29:
              subscribedTracks = _context123.sent;
              if (!(subscribedTracks.length > 0)) {
                _context123.next = 39;
                break;
              }
              t = subscribedTracks[0];
              tracks.track = t;
              tracks._isSubScribed = true;
              if (!(t.info.kind === "audio")) {
                _context123.next = 38;
                break;
              }
              return _context123.abrupt("return", {
                videoTracks: [],
                audioTracks: [tracks]
              });
            case 38:
              return _context123.abrupt("return", {
                audioTracks: [],
                videoTracks: [tracks]
              });
            case 39:
              return _context123.abrupt("return", {
                audioTracks: [],
                videoTracks: []
              });
            case 40:
            case "end":
              return _context123.stop();
          }
        }, _callee117, this, [[7, 18, 21, 24]]);
      }));
    }
    /**
     * 取消订阅
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(tracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee118() {
        return _regeneratorRuntime().wrap(function _callee118$(_context124) {
          while (1) switch (_context124.prev = _context124.next) {
            case 0:
              if (!Array.isArray(tracks)) {
                _context124.next = 6;
                break;
              }
              _context124.next = 3;
              return this.session.unsubscribe(tracks.map(function (t) {
                return t.trackID;
              }));
            case 3:
              tracks.forEach(function (t) {
                t._isSubScribed = false;
              });
              _context124.next = 9;
              break;
            case 6:
              _context124.next = 8;
              return this.session.unsubscribe([tracks.trackID]);
            case 8:
              tracks._isSubScribed = false;
            case 9:
            case "end":
              return _context124.stop();
          }
        }, _callee118, this);
      }));
    }
    /**
     * 发送自定义消息
     */
  }, {
    key: "sendMessage",
    value: function sendMessage(messageID, message, users) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
        var _this88 = this;
        return _regeneratorRuntime().wrap(function _callee119$(_context125) {
          while (1) switch (_context125.prev = _context125.next) {
            case 0:
              if (!(typeof messageID !== "string")) {
                _context125.next = 2;
                break;
              }
              throw ERROR_FATAL("messageID should be type of string, receive type ".concat(typeof messageID));
            case 2:
              if (!(typeof message !== "string")) {
                _context125.next = 4;
                break;
              }
              throw ERROR_FATAL("message should be type of string, receive type ".concat(typeof message));
            case 4:
              if (!Array.isArray(users)) {
                _context125.next = 9;
                break;
              }
              _context125.next = 7;
              return Promise.resolve().then(function () {
                return _this88.session.sendCustomMessage(message, users.map(function (user) {
                  return user.userID;
                }), messageID);
              });
            case 7:
              _context125.next = 11;
              break;
            case 9:
              _context125.next = 11;
              return Promise.resolve().then(function () {
                return _this88.session.sendCustomMessage(message, [], messageID);
              });
            case 11:
            case "end":
              return _context125.stop();
          }
        }, _callee119);
      }));
    }
    /**
     * 开启单路转推
     */
  }, {
    key: "startDirectLiveStreaming",
    value: function startDirectLiveStreaming(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
        return _regeneratorRuntime().wrap(function _callee120$(_context126) {
          while (1) switch (_context126.prev = _context126.next) {
            case 0:
              if (!(config.audioTrack == undefined && config.videoTrack == undefined)) {
                _context126.next = 2;
                break;
              }
              throw ERROR_INVALID_PARAMETER('No track provided. Please check the parameter.');
            case 2:
              _context126.next = 4;
              return this.session.createForwardJob(removeUndefinedKey({
                userConfigExtraInfo: config.userConfigExtraInfo,
                jobId: config.streamID,
                publishUrl: config.url,
                audioTrackId: config.audioTrack && config.audioTrack.trackID,
                videoTrackId: config.videoTrack && config.videoTrack.trackID
              }));
            case 4:
            case "end":
              return _context126.stop();
          }
        }, _callee120, this);
      }));
    }
    /**
     * 停止单路转推
     */
  }, {
    key: "stopDirectLiveStreaming",
    value: function stopDirectLiveStreaming(streamID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
        return _regeneratorRuntime().wrap(function _callee121$(_context127) {
          while (1) switch (_context127.prev = _context127.next) {
            case 0:
              _context127.next = 2;
              return this.session.stopForwardJob(streamID);
            case 2:
            case "end":
              return _context127.stop();
          }
        }, _callee121, this);
      }));
    }
    /**
     * 开启合流转推
     */
  }, {
    key: "startTranscodingLiveStreaming",
    value: function startTranscodingLiveStreaming(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
        return _regeneratorRuntime().wrap(function _callee122$(_context128) {
          while (1) switch (_context128.prev = _context128.next) {
            case 0:
              _context128.next = 2;
              return this.session.createMergeJob(config.streamID, removeUndefinedKey({
                publishUrl: config.url,
                height: config.height,
                width: config.width,
                fps: config.videoFrameRate,
                kbps: config.bitrate,
                stretchMode: config.renderMode,
                watermarks: config.watermarks && config.watermarks.map(function (watermark) {
                  return {
                    x: watermark.x,
                    y: watermark.y,
                    w: watermark.width,
                    h: watermark.height,
                    url: watermark.url
                  };
                }),
                background: config.background && {
                  x: config.background.x,
                  y: config.background.y,
                  w: config.background.width,
                  h: config.background.height,
                  url: config.background.url
                },
                maxRate: config.maxBitrate,
                minRate: config.minBitrate,
                holdLastFrame: config.holdLastFrame
              }));
            case 2:
              if (!config.transcodingTracks) {
                _context128.next = 5;
                break;
              }
              _context128.next = 5;
              return this.setTranscodingLiveStreamingTracks(config.streamID, config.transcodingTracks);
            case 5:
            case "end":
              return _context128.stop();
          }
        }, _callee122, this);
      }));
    }
    /**
     * 停止合流转推
     */
  }, {
    key: "stopTranscodingLiveStreaming",
    value: function stopTranscodingLiveStreaming(streamID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
        return _regeneratorRuntime().wrap(function _callee123$(_context129) {
          while (1) switch (_context129.prev = _context129.next) {
            case 0:
              _context129.next = 2;
              return this.session.stopMergeStream(streamID);
            case 2:
            case "end":
              return _context129.stop();
          }
        }, _callee123, this);
      }));
    }
    /**
     * 新增、更新合流转推的布局
     */
  }, {
    key: "setTranscodingLiveStreamingTracks",
    value: function setTranscodingLiveStreamingTracks(streamID, transcodingTracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
        var mergeOpts;
        return _regeneratorRuntime().wrap(function _callee124$(_context130) {
          while (1) switch (_context130.prev = _context130.next) {
            case 0:
              mergeOpts = transcodingTracks.map(function (t) {
                return removeUndefinedKey({
                  trackID: t.trackID,
                  x: t.x,
                  y: t.y,
                  w: t.width,
                  h: t.height,
                  z: t.zOrder,
                  stretchMode: t.renderMode
                });
              });
              if (!streamID) {
                _context130.next = 6;
                break;
              }
              _context130.next = 4;
              return this.session.addMergeStreamTracks(mergeOpts, streamID);
            case 4:
              _context130.next = 8;
              break;
            case 6:
              _context130.next = 8;
              return this.session.addMergeStreamTracks(mergeOpts);
            case 8:
            case "end":
              return _context130.stop();
          }
        }, _callee124, this);
      }));
    }
    /**
     * 移除合流转推的布局
     */
  }, {
    key: "removeTranscodingLiveStreamingTracks",
    value: function removeTranscodingLiveStreamingTracks(streamID, transcodingTracks) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee125() {
        return _regeneratorRuntime().wrap(function _callee125$(_context131) {
          while (1) switch (_context131.prev = _context131.next) {
            case 0:
              if (!streamID) {
                _context131.next = 5;
                break;
              }
              _context131.next = 3;
              return this.session.removeMergeStreamTracks(transcodingTracks.map(function (t) {
                return t.trackID;
              }), streamID);
            case 3:
              _context131.next = 7;
              break;
            case 5:
              _context131.next = 7;
              return this.session.removeMergeStreamTracks(transcodingTracks.map(function (t) {
                return t.trackID;
              }));
            case 7:
            case "end":
              return _context131.stop();
          }
        }, _callee125, this);
      }));
    }
    /**
     * 获取自己的网络质量等级
     */
  }, {
    key: "getNetworkQuality",
    value: function getNetworkQuality() {
      var quality = QNNetworkQuality.UNKNOWN;
      // 取最差的那个返回
      var reduceStart = [];
      var gradeArray = this._localTracks.reduce(function (pre, cur) {
        if (!cur.track) return _toConsumableArray(pre);
        return [].concat(_toConsumableArray(pre), _toConsumableArray(cur.track.getStats().map(function (stat) {
          return stat.networkGrade;
        })));
      }, reduceStart);
      if (gradeArray.includes(NetworkGrade.POOR)) {
        quality = QNNetworkQuality.POOR;
        return quality;
      }
      if (gradeArray.includes(NetworkGrade.FAIR)) {
        quality = QNNetworkQuality.FAIR;
        return quality;
      }
      if (gradeArray.includes(NetworkGrade.GOOD)) {
        quality = QNNetworkQuality.GOOD;
        return quality;
      }
      if (gradeArray.includes(NetworkGrade.EXCELLENT)) {
        quality = QNNetworkQuality.EXCELLENT;
        return quality;
      }
      return quality;
    }
    /**
     * 获取远端用户的网络质量等级
     */
  }, {
    key: "getUserNetworkQuality",
    value: function getUserNetworkQuality(userID) {
      var quality = QNNetworkQuality.UNKNOWN;
      var subscribedTrask = this._remoteTracks.find(function (item) {
        return item.userID === userID && item.isSubscribed();
      });
      if (subscribedTrask) {
        var user = this.remoteUsers.filter(function (user) {
          return user.userID === userID;
        })[0];
        if (!user) {
          log.warning("cannot find userID: ", userID);
          return quality;
        }
        quality = user.networkQuality;
      }
      return quality;
    }
    /**
     * 启用说话者音量提示。
     * 该方法允许 SDK 定期报告正在说话的远端用户及其音量。
     * 启用音量提示后，无论频道中有没有人说话，SDK 都会每两秒触发 QNRTCClient.on("volume-indicator") 回调。
     */
  }, {
    key: "enableAudioVolumeIndicator",
    value: function enableAudioVolumeIndicator() {
      this.session.registerVolumeIndicatorEvent();
    }
    /**
     * @internal
     * 踢用户出房间
     */
  }, {
    key: "kickOutUser",
    value: function kickOutUser(userID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
        var user;
        return _regeneratorRuntime().wrap(function _callee126$(_context132) {
          while (1) switch (_context132.prev = _context132.next) {
            case 0:
              user = this.remoteUsers.find(function (user) {
                return user.userID === userID;
              });
              if (user) {
                _context132.next = 4;
                break;
              }
              log.warning("cannot find userID: ", userID);
              return _context132.abrupt("return");
            case 4:
              _context132.next = 6;
              return this.session.kickoutUser(userID);
            case 6:
            case "end":
              return _context132.stop();
          }
        }, _callee126, this);
      }));
    }
    /**
     * 开始跨房
     */
  }, {
    key: "startMediaRelay",
    value: function startMediaRelay(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
        return _regeneratorRuntime().wrap(function _callee127$(_context133) {
          while (1) switch (_context133.prev = _context133.next) {
            case 0:
              return _context133.abrupt("return", this.session.startMediaRelay(config));
            case 1:
            case "end":
              return _context133.stop();
          }
        }, _callee127, this);
      }));
    }
    /**
     * 更新跨房
     */
  }, {
    key: "updateMediaRelay",
    value: function updateMediaRelay(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee128() {
        return _regeneratorRuntime().wrap(function _callee128$(_context134) {
          while (1) switch (_context134.prev = _context134.next) {
            case 0:
              return _context134.abrupt("return", this.session.updateMediaRelay(config));
            case 1:
            case "end":
              return _context134.stop();
          }
        }, _callee128, this);
      }));
    }
    /**
     * 结束跨房
     */
  }, {
    key: "stopMediaRelay",
    value: function stopMediaRelay() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
        return _regeneratorRuntime().wrap(function _callee129$(_context135) {
          while (1) switch (_context135.prev = _context135.next) {
            case 0:
              return _context135.abrupt("return", this.session.stopMediaRelay());
            case 1:
            case "end":
              return _context135.stop();
          }
        }, _callee129, this);
      }));
    }
  }, {
    key: "config",
    set: function set(config) {
      this.session.config = config;
      this.setTransportPolicy(config.transportPolicy);
      if (config.simulcast) {
        this.session.simulcast = config.simulcast;
      }
      if (config.reconnectTimes) {
        this.session.setReconnectTimes(config.reconnectTimes);
      }
      if (config.requestTimeout) {
        this.session.setRequestTimeout(config.requestTimeout);
      }
    }
  }, {
    key: "userID",
    get: function get() {
      return this.session.userID;
    }
    /**
     * 用户自定义数据
     */
  }, {
    key: "userData",
    get: function get() {
      return this.session.userData;
    }
    /**
     * 当前房间的名称
     */
  }, {
    key: "roomName",
    get: function get() {
      return this.session.roomName;
    }
  }]);
  return QNRTCClient;
}(EventEmitter);
/**
 * @public
 */
var QNLocalTrack = /*#__PURE__*/function (_QNTrack2) {
  _inherits(QNLocalTrack, _QNTrack2);
  // @internal
  function QNLocalTrack(track) {
    var _this89;
    _classCallCheck(this, QNLocalTrack);
    _this89 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalTrack).call(this));
    _this89.track = track;
    _this89.client = "";
    qnevents.on("trackEnded", function (trackLocalID) {
      if (_this89._track && trackLocalID === _this89._track.mediaTrack.id) {
        _this89.emit("ended");
      }
    });
    return _this89;
  }
  /**
   * 设置 mute 状态
   */
  _createClass(QNLocalTrack, [{
    key: "setMuted",
    value: function setMuted(isMuted) {
      this._isMuted = isMuted;
      qnevents.emit("set-mute-tracks", this.trackID, isMuted, this.client);
    }
    /**
     * 销毁当前流
     */
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.track) return;
      this.track.release();
    }
  }]);
  return QNLocalTrack;
}(QNTrack);
/**
 * @public
 */
var QNLocalVideoTrack = /*#__PURE__*/function (_QNLocalTrack) {
  _inherits(QNLocalVideoTrack, _QNLocalTrack);
  // @internal
  function QNLocalVideoTrack(track) {
    var _this90;
    _classCallCheck(this, QNLocalVideoTrack);
    _this90 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalVideoTrack).call(this, track));
    /**
     * 是否开启大小流
     * @deprecated use getLowStreamConfig instead
     */
    _this90.isMultiProfileEnabled = false;
    return _this90;
  }
  _createClass(QNLocalVideoTrack, [{
    key: "getLowStreamConfig",
    value: function getLowStreamConfig() {
      if (!this._track) return undefined;
      return this._track.lowStreamConfig;
    }
    /**
     * 截取当前视频流画面
     */
  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      if (!this._track) return "data:,";
      return this._track.getCurrentFrameDataURL();
    }
    /**
     * 获取流状态数据
     */
  }, {
    key: "getStats",
    value: function getStats() {
      if (!this._track) return [];
      var stats = this._track.getStats();
      if (stats.length === 0) return [];
      if (stats.length === 1) {
        var qnstats = stats.map(function (stat) {
          return {
            uplinkBitrate: stat.bitrate,
            uplinkFrameRate: stat.frameRate,
            uplinkLostRate: stat.packetLossRate,
            uplinkRTT: stat.rtt
          };
        });
        return qnstats;
      } else {
        // 通过码率排序升序，低中高，码率为0去除
        stats = stats.filter(function (s) {
          return s.bitrate !== 0;
        }).sort(function (a, b) {
          return a.bitrate - b.bitrate;
        });
        var _qnstats = stats.map(function (stat) {
          return {
            uplinkBitrate: stat.bitrate,
            uplinkFrameRate: stat.frameRate,
            uplinkLostRate: stat.packetLossRate,
            uplinkRTT: stat.rtt
          };
        });
        if (_qnstats[0]) {
          _qnstats[0].profile = QNTrackProfile.LOW;
        }
        if (_qnstats[1]) {
          _qnstats[1].profile = QNTrackProfile.MEDIUM;
        }
        if (_qnstats[2]) {
          _qnstats[2].profile = QNTrackProfile.HIGH;
        }
        // 新版本大小流，高的那一路为 HIGH
        if (_qnstats.length == 2 && _qnstats[1].profile === QNTrackProfile.MEDIUM) {
          _qnstats[1].profile = QNTrackProfile.HIGH;
        }
        return _qnstats;
      }
    }
    /**
     * 设置传输优化模式
     */
  }, {
    key: "setOptimizationMode",
    value: function setOptimizationMode(mode) {
      if (!this._track) return false;
      var mediaTrack = this._track.mediaTrack;
      if (!("contentHint" in mediaTrack)) {
        return false;
      }
      mediaTrack.contentHint = mode;
      if (mediaTrack.contentHint !== mode) {
        return false;
      }
      return true;
    }
  }]);
  return QNLocalVideoTrack;
}(QNLocalTrack);
/**
 * @public
 */
var QNCameraVideoTrack = /*#__PURE__*/function (_QNLocalVideoTrack) {
  _inherits(QNCameraVideoTrack, _QNLocalVideoTrack);
  _createClass(QNCameraVideoTrack, [{
    key: "facingMode",
    get: function get() {
      var _a;
      return (_a = this._track) === null || _a === void 0 ? void 0 : _a.mediaTrack.getSettings().facingMode;
    } // @internal
  }]);
  function QNCameraVideoTrack(track) {
    _classCallCheck(this, QNCameraVideoTrack);
    return _possibleConstructorReturn(this, _getPrototypeOf(QNCameraVideoTrack).call(this, track));
  }
  _createClass(QNCameraVideoTrack, [{
    key: "setMuted",
    value: function setMuted(isMuted) {
      if (isSafari151) {
        throw ERROR_FATAL("iOS 15.1 mute interface causes Safari crash, please upgrade to iOS 15.2+");
      }
      _get(_getPrototypeOf(QNCameraVideoTrack.prototype), "setMuted", this).call(this, isMuted);
    }
  }, {
    key: "play",
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _a;
      if (typeof config === "object" && config.mirror === undefined) {
        config.mirror = true;
      }
      log.debug("cam play:", config, (_a = this.track) === null || _a === void 0 ? void 0 : _a.mediaTrack.getSettings());
      return _get(_getPrototypeOf(QNCameraVideoTrack.prototype), "play", this).call(this, container, config);
    }
    /**
     * 通过设备 ID 或设备 Constraints 切换摄像头
     * @param arg 切换到的 cameraId 或 CameraConstraints
     */
  }, {
    key: "switchCamera",
    value: function switchCamera(arg) {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee130() {
        var before, constraints, cameraId, srcObject, newConstraints, MAX_RETRY, retries, stream, track, after;
        return _regeneratorRuntime().wrap(function _callee130$(_context136) {
          while (1) switch (_context136.prev = _context136.next) {
            case 0:
              if (!this.track) {
                _context136.next = 52;
                break;
              }
              // const parentNode = this.mediaElement?.parentNode;
              before = {
                settings: this.track.mediaTrack.getSettings(),
                constraints: this.track.mediaTrack.getConstraints()
              };
              constraints = this.track.mediaTrack.getConstraints();
              if (!(typeof arg === "string")) {
                _context136.next = 9;
                break;
              }
              cameraId = arg; // 以 deviceId 切换摄像头
              delete constraints.facingMode;
              constraints.deviceId = {
                exact: cameraId
              };
              _context136.next = 20;
              break;
            case 9:
              if (!(typeof arg === "object")) {
                _context136.next = 13;
                break;
              }
              constraints = Object.assign(Object.assign({}, constraints), arg);
              _context136.next = 20;
              break;
            case 13:
              if (!(typeof arg === "undefined")) {
                _context136.next = 18;
                break;
              }
              // 以 facingMode 切换摄像头
              delete constraints.deviceId;
              constraints.facingMode = this.facingMode === "user" ? "environment" : "user";
              _context136.next = 20;
              break;
            case 18:
              log.error(this, "invalid argument calling `switchCamera` with arg: ", arg);
              return _context136.abrupt("return");
            case 20:
              srcObject = (_a = this.track.mediaElement) === null || _a === void 0 ? void 0 : _a.srcObject;
              if (srcObject instanceof MediaStream) {
                this.track.mediaElement.style.display = "none";
                srcObject.getTracks().forEach(function (track) {
                  track.stop();
                  srcObject.removeTrack(track);
                });
              }
              newConstraints = Object.assign({}, constraints);
              log.debug("switching camera with new constraints", newConstraints);
              MAX_RETRY = 3;
              retries = 0;
            case 26:
              if (!true) {
                _context136.next = 52;
                break;
              }
              _context136.prev = 27;
              _context136.next = 30;
              return navigator.mediaDevices.getUserMedia({
                video: newConstraints
              });
            case 30:
              stream = _context136.sent;
              track = stream.getVideoTracks()[0];
              after = {
                settings: track.getSettings(),
                constraints: track.getConstraints()
              };
              log.debug("switchCamera", {
                before: before,
                after: after
              });
              _context136.next = 36;
              return qnevents.safeEmitAsPromise("setMediaStreamTrack", this.trackID, track, this.client);
            case 36:
              return _context136.abrupt("break", 52);
            case 39:
              _context136.prev = 39;
              _context136.t0 = _context136["catch"](27);
              if (!(retries < MAX_RETRY && _context136.t0 instanceof DOMException && _context136.t0.name == "NotFoundError")) {
                _context136.next = 49;
                break;
              }
              retries++;
              log.debug("retrying switching camera (".concat(retries, "/").concat(MAX_RETRY, ")"));
              _context136.next = 46;
              return timeout(300);
            case 46:
              return _context136.abrupt("continue", 26);
            case 49:
              throw _context136.t0;
            case 50:
              _context136.next = 26;
              break;
            case 52:
            case "end":
              return _context136.stop();
          }
        }, _callee130, this, [[27, 39]]);
      }));
    }
  }]);
  return QNCameraVideoTrack;
}(QNLocalVideoTrack);
var AudioMixingTrack = /*#__PURE__*/function (_AudioTrack2) {
  _inherits(AudioMixingTrack, _AudioTrack2);
  function AudioMixingTrack(userID) {
    var _this91;
    _classCallCheck(this, AudioMixingTrack);
    var destination = audioContext.createMediaStreamDestination();
    var audioTrack = destination.stream.getAudioTracks()[0];
    _this91 = _possibleConstructorReturn(this, _getPrototypeOf(AudioMixingTrack).call(this, audioTrack, userID, "local"));
    _this91.sourceType = TrackSourceType.MIXING;
    _this91.initAudioManager(true);
    _this91.destination = destination;
    _this91.inputList = [];
    return _this91;
  }
  _createClass(AudioMixingTrack, [{
    key: "appendAudioSource",
    value: function appendAudioSource(track) {
      var _this92 = this;
      if (this.inputList.find(function (input) {
        return input.track === track;
      })) {
        log.warning("track is already in the track list");
        return;
      }
      this.inputList.push({
        track: track
      });
      track.on("ended", function () {
        _this92.emit("ended");
      });
      track.audioManager.gainNode.connect(this.destination);
    }
  }, {
    key: "removeAudioSource",
    value: function removeAudioSource(track) {
      var targetInput = this.inputList.find(function (input) {
        return input.track === track;
      });
      if (!targetInput) {
        return;
      }
      try {
        targetInput.track.audioManager.gainNode.disconnect(this.destination);
      } catch (_a) {
        // if already disconnected, just ignore
      }
      remove(this.inputList, function (i) {
        return i === targetInput;
      });
    }
  }, {
    key: "release",
    value: function release() {
      // remove all audio source
      var _iterator57 = _createForOfIteratorHelper(this.inputList),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var input = _step57.value;
          this.removeAudioSource(input.track);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
      _get(_getPrototypeOf(AudioMixingTrack.prototype), "release", this).call(this);
    }
  }]);
  return AudioMixingTrack;
}(AudioTrack);
var QNLocalAudioTrack = /*#__PURE__*/function (_QNLocalTrack2) {
  _inherits(QNLocalAudioTrack, _QNLocalTrack2);
  function QNLocalAudioTrack(track) {
    var _this93;
    _classCallCheck(this, QNLocalAudioTrack);
    var outputTrack = new AudioMixingTrack();
    outputTrack.info = track.info;
    outputTrack.appendAudioSource(track);
    _this93 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalAudioTrack).call(this, outputTrack));
    /**
     * filter 列表
     */
    _this93.filterList = [];
    _this93.sourceTrack = track;
    _this93.outputTrack = outputTrack;
    qnevents.on("audioBuffer", function (buffer, trackLocalID) {
      if (trackLocalID === track.mediaTrack.id) {
        _this93.emit("audioFrame", buffer);
      }
    });
    return _this93;
  }
  /**
   * 添加各种音频模块
   * @param mixer 特效
   */
  _createClass(QNLocalAudioTrack, [{
    key: "addAudioFilter",
    value: function addAudioFilter(mixer) {
      this.filterList.push(mixer);
      mixer.add(this.outputTrack);
    }
    /**
     * 移除各种音频特效
     * @param mixer 特效
     */
  }, {
    key: "removeAudioFilter",
    value: function removeAudioFilter(mixer) {
      mixer.remove(this.outputTrack);
      var index = this.filterList.findIndex(function (item) {
        return item === mixer;
      });
      if (index >= 0) {
        this.filterList.splice(index, 1);
      }
    }
    /**
     * 设置音量
     * @param volume 音量大小，默认 1
     */
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if (!this.sourceTrack) return;
      this.sourceTrack.setVolume(volume);
    }
    /**
     * 获取当前音量
     */
  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (!this.track) return;
      return this.track.getCurrentVolumeLevel();
    }
    /**
     * 获取当前时域数据
     */
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (!this.track) return;
      return this.track.getCurrentTimeDomainData();
    }
    /**
     * 获取当前频域数据
     */
  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (!this.track) return;
      return this.track.getCurrentFrequencyData();
    }
    /**
     * 设置音频输出设备
     * deviceId 可以从 QNRTC.getPlaybackDevices 接口中获取
     * 该功能仅 chrome 支持，如果在不支持功能的浏览器中调用，会抛出 ERROR_NOT_SUPPORT 错误
     */
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(deviceId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
        return _regeneratorRuntime().wrap(function _callee131$(_context137) {
          while (1) switch (_context137.prev = _context137.next) {
            case 0:
              if (this.track) {
                _context137.next = 2;
                break;
              }
              return _context137.abrupt("return");
            case 2:
              return _context137.abrupt("return", this.track.setPlaybackDevice(deviceId));
            case 3:
            case "end":
              return _context137.stop();
          }
        }, _callee131, this);
      }));
    }
    /**
     * 获取流状态
     */
  }, {
    key: "getStats",
    value: function getStats() {
      var defaultLocalAudioTrackStats = {
        uplinkBitrate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultLocalAudioTrackStats;
      var stats = this._track.getStats();
      if (stats.length === 0) return defaultLocalAudioTrackStats;
      defaultLocalAudioTrackStats.uplinkBitrate = stats[0].bitrate;
      defaultLocalAudioTrackStats.uplinkRTT = stats[0].rtt;
      defaultLocalAudioTrackStats.uplinkLostRate = stats[0].packetLossRate;
      return defaultLocalAudioTrackStats;
    }
  }, {
    key: "setEarMonitorEnabled",
    value: function setEarMonitorEnabled(enabled) {
      throw new Error("setEarMonitorEnabled not supported.");
    }
    /**
     * 销毁 track
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var _this94 = this;
      this.outputTrack.removeAudioSource(this.sourceTrack);
      this.outputTrack.release();
      this.filterList.forEach(function (mixer) {
        mixer.remove(_this94.outputTrack);
      });
      this.sourceTrack.release();
    }
  }]);
  return QNLocalAudioTrack;
}(QNLocalTrack);
var AudioPlaybackEngine = /*#__PURE__*/function () {
  function AudioPlaybackEngine() {
    _classCallCheck(this, AudioPlaybackEngine);
    this.gainNode = audioContext.createGain();
    this.gainNode.connect(audioContext.destination);
  }
  _createClass(AudioPlaybackEngine, [{
    key: "setPlayingVolume",
    value: function setPlayingVolume(value) {
      this.gainNode.gain.setValueAtTime(value, audioContext.currentTime);
    }
  }, {
    key: "addAudioNode",
    value: function addAudioNode(audioNode) {
      audioNode.connect(this.gainNode);
    }
  }, {
    key: "removeAudioNode",
    value: function removeAudioNode(audioNode) {
      audioNode.disconnect(this.gainNode);
    }
  }, {
    key: "release",
    value: function release() {
      this.gainNode.disconnect();
    }
  }]);
  return AudioPlaybackEngine;
}();
var QNMicrophoneAudioTrack = /*#__PURE__*/function (_QNLocalAudioTrack) {
  _inherits(QNMicrophoneAudioTrack, _QNLocalAudioTrack);
  function QNMicrophoneAudioTrack(track) {
    var _this95;
    _classCallCheck(this, QNMicrophoneAudioTrack);
    _this95 = _possibleConstructorReturn(this, _getPrototypeOf(QNMicrophoneAudioTrack).call(this, track));
    _this95.playbackEngine = new AudioPlaybackEngine();
    _this95.earMonitorEnable = false;
    return _this95;
  }
  /**
   * 获取当前是否开启、关闭返听
   * @since 4.2.0
   * @returns 返听开启状态
   */
  _createClass(QNMicrophoneAudioTrack, [{
    key: "isEarMonitorEnabled",
    value: function isEarMonitorEnabled() {
      return this.earMonitorEnable;
    }
    /**
     * 开启、关闭返听
     * @since 4.2.0
     * @remarks 为达到最佳体验，建议佩戴耳机的场景下，使用该功能
     * @param enabled 是否开启返听，默认 false
     */
  }, {
    key: "setEarMonitorEnabled",
    value: function setEarMonitorEnabled(enabled) {
      this.earMonitorEnable = enabled;
      if (this.earMonitorEnable) {
        this.playbackEngine.addAudioNode(this.sourceTrack.audioManager.gainNode);
      } else {
        this.playbackEngine.removeAudioNode(this.sourceTrack.audioManager.gainNode);
      }
    }
    /**
     * 销毁 track
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(QNMicrophoneAudioTrack.prototype), "destroy", this).call(this);
      this.playbackEngine.release();
    }
  }]);
  return QNMicrophoneAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */
var QNScreenVideoTrack = /*#__PURE__*/function (_QNLocalVideoTrack2) {
  _inherits(QNScreenVideoTrack, _QNLocalVideoTrack2);
  // @internal
  function QNScreenVideoTrack(track) {
    _classCallCheck(this, QNScreenVideoTrack);
    return _possibleConstructorReturn(this, _getPrototypeOf(QNScreenVideoTrack).call(this, track));
  }
  return QNScreenVideoTrack;
}(QNLocalVideoTrack);
/**
 * @public
 */
var QNBufferSourceAudioTrack = /*#__PURE__*/function (_QNLocalAudioTrack2) {
  _inherits(QNBufferSourceAudioTrack, _QNLocalAudioTrack2);
  // @internal
  function QNBufferSourceAudioTrack(track, source) {
    var _this96;
    _classCallCheck(this, QNBufferSourceAudioTrack);
    _this96 = _possibleConstructorReturn(this, _getPrototypeOf(QNBufferSourceAudioTrack).call(this, track));
    _this96.rawTrack = track;
    _this96.source = source;
    track.on("audio-state-change", function (state) {
      switch (state) {
        case AudioSourceState.IDLE:
          return;
        case AudioSourceState.LOADING:
          return;
        case AudioSourceState.PLAY:
          _this96.emit("state-changed", QNAudioSourceState.PlAYING);
          return;
        case AudioSourceState.PAUSE:
          _this96.emit("state-changed", QNAudioSourceState.PAUSED);
          return;
        case AudioSourceState.END:
          _this96.emit("state-changed", QNAudioSourceState.STOPPED);
          return;
      }
    });
    return _this96;
  }
  /**
   * 开始
   */
  _createClass(QNBufferSourceAudioTrack, [{
    key: "start",
    value: function start(loop) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee132() {
        return _regeneratorRuntime().wrap(function _callee132$(_context138) {
          while (1) switch (_context138.prev = _context138.next) {
            case 0:
              if (loop) this.rawTrack.setLoop(loop);
              this.rawTrack.startAudioSource();
            case 2:
            case "end":
              return _context138.stop();
          }
        }, _callee132, this);
      }));
    }
    /**
     * 停止
     */
  }, {
    key: "stop",
    value: function stop() {
      this.rawTrack.stopAudioSource();
    }
    /**
     * 恢复
     */
  }, {
    key: "resume",
    value: function resume() {
      this.rawTrack.resumeAudioSource();
    }
    /**
     * 暂停
     */
  }, {
    key: "pause",
    value: function pause() {
      this.rawTrack.pauseAudioSource();
    }
    /**
     * 获取音频时长
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.rawTrack.getDuration();
    }
    /**
     * 获取当前位置
     */
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.rawTrack.getCurrentTime();
    }
    /**
     * 跳转到指定位置
     */
  }, {
    key: "seekTo",
    value: function seekTo(time) {
      this.rawTrack.setCurrentTime(time);
    }
  }]);
  return QNBufferSourceAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */
var QNCustomAudioTrack = /*#__PURE__*/function (_QNLocalAudioTrack3) {
  _inherits(QNCustomAudioTrack, _QNLocalAudioTrack3);
  // @internal
  function QNCustomAudioTrack(track) {
    _classCallCheck(this, QNCustomAudioTrack);
    return _possibleConstructorReturn(this, _getPrototypeOf(QNCustomAudioTrack).call(this, track));
  }
  /**
   * @internal
   * 切换原生 mediaStreamTrack
   */
  _createClass(QNCustomAudioTrack, [{
    key: "setMediaStreamTrack",
    value: function setMediaStreamTrack(newTrack) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
        return _regeneratorRuntime().wrap(function _callee133$(_context139) {
          while (1) switch (_context139.prev = _context139.next) {
            case 0:
              return _context139.abrupt("return", qnevents.safeEmitAsPromise("setMediaStreamTrack", this.trackID, newTrack, this.client));
            case 1:
            case "end":
              return _context139.stop();
          }
        }, _callee133, this);
      }));
    }
  }]);
  return QNCustomAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */
var QNCustomVideoTrack = /*#__PURE__*/function (_QNLocalVideoTrack3) {
  _inherits(QNCustomVideoTrack, _QNLocalVideoTrack3);
  // @internal
  function QNCustomVideoTrack(track) {
    _classCallCheck(this, QNCustomVideoTrack);
    return _possibleConstructorReturn(this, _getPrototypeOf(QNCustomVideoTrack).call(this, track));
  }
  /**
   * @internal
   * 切换原生 mediaStreamTrack
   */
  _createClass(QNCustomVideoTrack, [{
    key: "setMediaStreamTrack",
    value: function setMediaStreamTrack(newTrack) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
        return _regeneratorRuntime().wrap(function _callee134$(_context140) {
          while (1) switch (_context140.prev = _context140.next) {
            case 0:
              return _context140.abrupt("return", qnevents.safeEmitAsPromise("setMediaStreamTrack", this.trackID, newTrack, this.client));
            case 1:
            case "end":
              return _context140.stop();
          }
        }, _callee134, this);
      }));
    }
  }]);
  return QNCustomVideoTrack;
}(QNLocalVideoTrack);
var audioData = "data:audio/mpeg;base64,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";
/**
 * @public
 */
var QNCanvasVideoTrack = /*#__PURE__*/function (_QNLocalVideoTrack4) {
  _inherits(QNCanvasVideoTrack, _QNLocalVideoTrack4);
  // @internal
  function QNCanvasVideoTrack(track, canvas, ctx, sources) {
    var _this97;
    _classCallCheck(this, QNCanvasVideoTrack);
    _this97 = _possibleConstructorReturn(this, _getPrototypeOf(QNCanvasVideoTrack).call(this, track));
    // @internal
    _this97.drawImage = function () {
      _this97.drawImageOnce();
      requestAnimationFrame(_this97.drawImage);
    };
    // @internal
    _this97.drawImageOnce = function () {
      if (!_this97.ctx) return;
      var _iterator58 = _createForOfIteratorHelper(_this97.canvasSources),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var item = _step58.value;
          _this97.ctx.drawImage(item.source, item.x, item.y, item.width, item.heigth);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
    };
    _this97.canvas = canvas;
    _this97.ctx = ctx;
    _this97.updateSources(sources).then(_this97.drawImage).catch(function (e) {
      log.warning(e);
    });
    var audio = new Audio();
    audio.src = audioData;
    audio.autoplay = true;
    audio.loop = true;
    audio.muted = true;
    audio.ontimeupdate = function () {
      _this97.drawImageOnce();
    };
    _this97.audioElement = audio;
    return _this97;
  }
  /**
   * 修改画布内容
   */
  _createClass(QNCanvasVideoTrack, [{
    key: "updateSources",
    value: function updateSources(sources) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee135() {
        var resSources, _i14;
        return _regeneratorRuntime().wrap(function _callee135$(_context141) {
          while (1) switch (_context141.prev = _context141.next) {
            case 0:
              this.sources = sources;
              this.canvasSources = [];
              _context141.next = 4;
              return Promise.all(sources.map(function (item) {
                return ImageUtils.loadImage(item.source);
              }));
            case 4:
              resSources = _context141.sent;
              if (this.ctx) {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
              }
              for (_i14 = 0; _i14 < sources.length; _i14++) {
                this.canvasSources.push({
                  source: resSources[_i14],
                  x: sources[_i14].x,
                  y: sources[_i14].y,
                  width: sources[_i14].width || resSources[_i14].width,
                  heigth: sources[_i14].height || resSources[_i14].height
                });
              }
            case 7:
            case "end":
              return _context141.stop();
          }
        }, _callee135, this);
      }));
    }
  }, {
    key: "play",
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // 图片 track 默认不镜像
      if (config.mirror === undefined) {
        config.mirror = false;
      }
      return _get(_getPrototypeOf(QNCanvasVideoTrack.prototype), "play", this).call(this, container, config);
    }
    /**
     * 销毁当前流
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.ctx = null;
      this.canvas.remove();
      this.sources = [];
      this.canvasSources = [];
      this.audioElement.ontimeupdate = null;
      this.audioElement.src = "";
      this.audioElement.remove();
      _get(_getPrototypeOf(QNCanvasVideoTrack.prototype), "destroy", this).call(this);
    }
  }]);
  return QNCanvasVideoTrack;
}(QNLocalVideoTrack);
var QNRecorderState;
(function (QNRecorderState) {
  /**
   * 初始状态
   */
  QNRecorderState["IDLE"] = "IDLE";
  /**
   * 录制中
   */
  QNRecorderState["RECORDING"] = "RECORDING";
  /**
   * 停止录制
   */
  QNRecorderState["STOPPED"] = "STOPPED";
})(QNRecorderState || (QNRecorderState = {}));
/**
 * 视频&音频类型保护
 * @param config 录制轨参数
 * @returns
 */
var isVideoSource = function isVideoSource(config) {
  return config.track.kind === "video";
};
var QNMediaRecorder = /*#__PURE__*/function (_EventEmitter9) {
  _inherits(QNMediaRecorder, _EventEmitter9);
  function QNMediaRecorder(source, config) {
    var _this98;
    _classCallCheck(this, QNMediaRecorder);
    var _a, _b;
    _this98 = _possibleConstructorReturn(this, _getPrototypeOf(QNMediaRecorder).call(this));
    _this98.source = source;
    _this98.config = config;
    /** TODO 通过 jsonschema 检查参数类型 ERROR_RECORDER_PARAMS_EXCEPTION */
    _this98.maxDurationMs = (_a = config.maxDurationMs) !== null && _a !== void 0 ? _a : 120000;
    _this98.recorderInfoUpdateInterval = (_b = config.recorderInfoUpdateInterval) !== null && _b !== void 0 ? _b : 1000;
    return _this98;
  }
  _createClass(QNMediaRecorder, [{
    key: "startRecording",
    /**
     * 开始录制
     * @throws {@link ERROR_RECORDER_STATE_EXCEPTION} 当前状态不支持该操作，可能因为录制正在进行中或录制出错停止
     * @throws {@link ERROR_RECORDER_WRITE} 录制文件写入失败
     * @throws {@link ERROR_RECORDER_EXCEEDING_TIME} 录制时长超出上限
     * @throws {@link ERROR_RECORDER_SOURCE_EXCEPTION} 音视频资源不存在
     */
    value: function startRecording() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
        var _this99 = this;
        var _error2, storagePath, videoRecorderSource, audioRecorderSource, tracks, _error3, mediaStream, handle, _error4, file;
        return _regeneratorRuntime().wrap(function _callee137$(_context143) {
          while (1) switch (_context143.prev = _context143.next) {
            case 0:
              if (!(this.state === QNRecorderState.RECORDING)) {
                _context143.next = 4;
                break;
              }
              _error2 = ERROR_RECORDER_STATE_EXCEPTION();
              this.emit(QNMediaRecorder.ERROR, ERROR_RECORDER_STATE_EXCEPTION());
              throw _error2;
            case 4:
              storagePath = this.config.storagePath;
              videoRecorderSource = [];
              audioRecorderSource = [];
              this.source.forEach(function (item) {
                return isVideoSource(item) ? videoRecorderSource.push(item) : audioRecorderSource.push(item);
              });
              tracks = [];
              if (audioRecorderSource.length) {
                tracks.push(this.processAudioTracks(audioRecorderSource));
              }
              if (videoRecorderSource.length) {
                tracks.push(this.processVideoTracks(videoRecorderSource));
              }
              if (!(tracks.length === 0)) {
                _context143.next = 15;
                break;
              }
              _error3 = ERROR_RECORDER_SOURCE_EXCEPTION();
              this.emit(QNMediaRecorder.ERROR, _error3);
              throw _error3;
            case 15:
              mediaStream = new MediaStream(tracks);
              this.mediaRecorder = new MediaRecorder(mediaStream);
              _context143.prev = 17;
              _context143.next = 20;
              return window.showSaveFilePicker({
                excludeAcceptAllOption: true,
                suggestedName: storagePath,
                types: [{
                  description: 'qnweb-rtc-record',
                  accept: {
                    'video/webm': ['.webm'],
                    'audio/webm': ['.weba']
                  }
                }]
              });
            case 20:
              handle = _context143.sent;
              _context143.next = 28;
              break;
            case 23:
              _context143.prev = 23;
              _context143.t0 = _context143["catch"](17);
              _error4 = ERROR_RECORDER_WRITE();
              this.emit(QNMediaRecorder.ERROR, _error4);
              throw _error4;
            case 28:
              _context143.next = 30;
              return handle.getFile();
            case 30:
              file = _context143.sent;
              _context143.next = 33;
              return handle.createWritable();
            case 33:
              this.writer = _context143.sent;
              this.mediaRecorder.onstart = function (evt) {
                var now = evt.timeStamp;
                var size = 0;
                var lastUpdateTime = performance.now();
                _this99.mediaRecorder.ondataavailable = function (evt) {
                  return __awaiter(_this99, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
                    var _error5, duration, _error6;
                    return _regeneratorRuntime().wrap(function _callee136$(_context142) {
                      while (1) switch (_context142.prev = _context142.next) {
                        case 0:
                          if (!(evt.data.size >= 1000)) {
                            _context142.next = 4;
                            break;
                          }
                          lastUpdateTime = performance.now();
                          _context142.next = 9;
                          break;
                        case 4:
                          if (!(performance.now() - lastUpdateTime >= 5000)) {
                            _context142.next = 9;
                            break;
                          }
                          _error5 = ERROR_RECORDER_SOURCE_EXCEPTION();
                          this.emit(QNMediaRecorder.ERROR, _error5);
                          this.releaseRecoreding();
                          throw _error5;
                        case 9:
                          duration = evt.timeStamp - now;
                          if (!(duration > this.maxDurationMs)) {
                            _context142.next = 15;
                            break;
                          }
                          _error6 = ERROR_RECORDER_EXCEEDING_TIME();
                          this.emit(QNMediaRecorder.ERROR, _error6);
                          this.releaseRecoreding();
                          throw _error6;
                        case 15:
                          size += evt.data.size;
                          this.emit(QNMediaRecorder.INFO_UPDATED, {
                            durationMs: duration,
                            fileSize: size,
                            fileName: file.name
                          });
                          this.writer.write(evt.data);
                        case 18:
                        case "end":
                          return _context142.stop();
                      }
                    }, _callee136, this);
                  }));
                };
              };
              this.mediaRecorder.start(this.recorderInfoUpdateInterval);
              this.state = QNRecorderState.RECORDING;
            case 37:
            case "end":
              return _context143.stop();
          }
        }, _callee137, this, [[17, 23]]);
      }));
    }
    /**
     * 停止录制
     * @throws {@link ERROR_RECORDER_STATE_EXCEPTION} 当前状态不支持该操作，可能因为录制正在进行中或录制出错停止
     */
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee138() {
        var _this100 = this;
        var _error7;
        return _regeneratorRuntime().wrap(function _callee138$(_context144) {
          while (1) switch (_context144.prev = _context144.next) {
            case 0:
              if (!(this.state === QNRecorderState.IDLE || this.state === QNRecorderState.STOPPED)) {
                _context144.next = 4;
                break;
              }
              _error7 = ERROR_RECORDER_STATE_EXCEPTION();
              this.emit(QNMediaRecorder.ERROR, _error7);
              throw _error7;
            case 4:
              return _context144.abrupt("return", new Promise(function (resolve) {
                _this100.mediaRecorder.stop();
                setTimeout(function () {
                  _this100.writer.close();
                  _this100.state = QNRecorderState.STOPPED;
                  resolve();
                }, 1000);
              }));
            case 5:
            case "end":
              return _context144.stop();
          }
        }, _callee138, this);
      }));
    }
    /**
     * 销毁实例
     * @throws {@link ERROR_RECORDER_STATE_EXCEPTION} 当前状态不支持该操作，可能因为录制正在进行中或录制出错停止
     */
  }, {
    key: "releaseRecoreding",
    value: function releaseRecoreding() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee139() {
        var _this101 = this;
        var _error8;
        return _regeneratorRuntime().wrap(function _callee139$(_context145) {
          while (1) switch (_context145.prev = _context145.next) {
            case 0:
              if (!(this.state === QNRecorderState.IDLE)) {
                _context145.next = 4;
                break;
              }
              _error8 = ERROR_RECORDER_STATE_EXCEPTION();
              this.emit(QNMediaRecorder.ERROR, _error8);
              throw _error8;
            case 4:
              return _context145.abrupt("return", new Promise(function (resolve) {
                _this101.mediaRecorder.stop();
                setTimeout(function () {
                  _this101.writer.close();
                  _this101.state = QNRecorderState.IDLE;
                  _this101.removeAllListeners();
                  resolve();
                }, 1000);
              }));
            case 5:
            case "end":
              return _context145.stop();
          }
        }, _callee139, this);
      }));
    }
    /**
     * 处理视频轨
     * @param videoRecorderSource 视频频设置参数
     * @throws {@link ERROR_RECORDER_SOURCE_EXCEPTION} 音视频资源不存在
     * @returns 合流后的视频轨
     */
  }, {
    key: "processVideoTracks",
    value: function processVideoTracks(videoRecorderSource) {
      var _this$config = this.config,
        width = _this$config.width,
        height = _this$config.height,
        frameRate = _this$config.frameRate,
        storagePath = _this$config.storagePath;
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      /** 根据物理像素与 css 像素确认 canvas @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio} */
      var dpr = window.devicePixelRatio || 1;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = "".concat(width, "px");
      canvas.style.height = "".concat(height, "px");
      context.scale(dpr, dpr);
      var sortedVideoRecorderSource = videoRecorderSource.sort(function (a, b) {
        return (a.zOrder || 0) - (b.zOrder || 0);
      });
      var config = [];
      var _iterator59 = _createForOfIteratorHelper(sortedVideoRecorderSource),
        _step59;
      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var streamingTrack = _step59.value;
          /** TODO MediaStreamTrackProcessor 兼容性太差，后续新增背景或者水印再考虑 */
          var video = document.createElement("video");
          video.srcObject = new MediaStream([streamingTrack.track]);
          config.push(Object.assign({
            elt: video
          }, streamingTrack));
          video.play();
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
      this.renderVideoCanvas(context, config);
      var mediaStream = canvas.captureStream(frameRate);
      var videoTrack = mediaStream.getVideoTracks().pop();
      if (videoTrack === undefined) {
        var _error9 = ERROR_RECORDER_SOURCE_EXCEPTION();
        this.emit(QNMediaRecorder.ERROR, _error9);
        this.releaseRecoreding();
        throw _error9;
      } else {
        return videoTrack;
      }
    }
    /**
     * 处理音频轨
     * @param audioRecorderSource 音频设置参数
     * @throws {@link ERROR_RECORDER_SOURCE_EXCEPTION} 音视频资源不存在
     * @returns 混音后的音频轨
     */
  }, {
    key: "processAudioTracks",
    value: function processAudioTracks(audioRecorderSource) {
      var context = new AudioContext();
      var mediaStreamDestination = context.createMediaStreamDestination();
      var _iterator60 = _createForOfIteratorHelper(audioRecorderSource),
        _step60;
      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var config = _step60.value;
          var mediaStreamSource = context.createMediaStreamSource(new MediaStream([config.track]));
          mediaStreamSource.connect(mediaStreamDestination);
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
      var audioTrack = mediaStreamDestination.stream.getAudioTracks().pop();
      if (audioTrack === undefined) {
        var _error10 = ERROR_RECORDER_SOURCE_EXCEPTION();
        this.emit(QNMediaRecorder.ERROR, _error10);
        this.releaseRecoreding();
        throw _error10;
      } else {
        return audioTrack;
      }
    }
    /**
     * 实时绘制
     * @param context canvas context
     * @param config 配置信息
     */
  }, {
    key: "renderVideoCanvas",
    value: function renderVideoCanvas(context, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
        var _iterator61, _step61, item;
        return _regeneratorRuntime().wrap(function _callee140$(_context146) {
          while (1) switch (_context146.prev = _context146.next) {
            case 0:
              _iterator61 = _createForOfIteratorHelper(config);
              try {
                for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
                  item = _step61.value;
                  context.drawImage(item.elt, item.x, item.y, item.width, item.height);
                }
              } catch (err) {
                _iterator61.e(err);
              } finally {
                _iterator61.f();
              }
              requestAnimationFrame(this.renderVideoCanvas.bind(this, context, config));
            case 3:
            case "end":
              return _context146.stop();
          }
        }, _callee140, this);
      }));
    }
  }, {
    key: "state",
    set: function set(val) {
      this._state = val;
      this.emit(QNMediaRecorder.STATE_CHANGED, val);
    },
    get: function get() {
      return this._state;
    }
  }]);
  return QNMediaRecorder;
}(EventEmitter);
/**
 * 录制状态发生改变回调
 * @event
 */
QNMediaRecorder.STATE_CHANGED = "state-changed";
/**
 * 录制信息更新回调
 * @event
 */
QNMediaRecorder.INFO_UPDATED = "info-updated";
/**
 * 发生错误回调
 * @event
 */
QNMediaRecorder.ERROR = "error";
var QNDeviceManager = /*#__PURE__*/function (_EventEmitter10) {
  _inherits(QNDeviceManager, _EventEmitter10);
  function QNDeviceManager() {
    var _this102;
    _classCallCheck(this, QNDeviceManager);
    _this102 = _possibleConstructorReturn(this, _getPrototypeOf(QNDeviceManager).call(this));
    _this102.handleDeviceManager();
    return _this102;
  }
  /**
   * 设置连麦使用的音频录制设备
   * @remarks
   * 不调用则使用系统默认录制设备
   * 连麦过程中设置无效，需在发布音频 Track 前调用
   * @param deviceID 设备 ID
   */
  _createClass(QNDeviceManager, [{
    key: "setRecordingDevice",
    value: function setRecordingDevice(deviceID) {
      this.currentRecordingDeviceID = deviceID;
    }
    /**
     * 设置连麦使用的音频播放设备
     * @remarks
     * 不调用则使用系统默认播放设备
     * 连麦过程中设置无效，需在订阅任何音频 Track 前调用
     * @see 由于浏览器兼容性问题，只有部分版本支持，详情可见 {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/sinkId}
     * @param deviceID 设备 ID
     */
  }, {
    key: "setPlaybackDevice",
    value: function setPlaybackDevice(deviceID) {
      this.currentPlaybackDeviceID = deviceID;
    }
    /**
     * 设置连麦使用的视频录制设备
     * @remarks
     * 不调用则使用系统默认录制设备
     * 连麦过程中设置无效，需在发布视频 Track 前调用
     * @param deviceID 设备 ID
     */
  }, {
    key: "setCameraDevice",
    value: function setCameraDevice(deviceID) {
      this.currentCameraDeviceID = deviceID;
    }
    /**
     * 开始麦克风测试
     * @param interval 麦克风音量的回调间隔，单位毫秒
     * @param playback 是否开启回播麦克风声音，开启后用户测试麦克风时会听到自己的声音
     */
  }, {
    key: "startRecordingDeviceTest",
    value: function startRecordingDeviceTest(interval, playback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee141() {
        var _this103 = this;
        var emitTestRcordingDeviceVolume;
        return _regeneratorRuntime().wrap(function _callee141$(_context147) {
          while (1) switch (_context147.prev = _context147.next) {
            case 0:
              if (!(this.recordingDeviceTrack instanceof QNMicrophoneAudioTrack)) {
                _context147.next = 2;
                break;
              }
              return _context147.abrupt("return");
            case 2:
              if (!this.currentRecordingDeviceID) {
                _context147.next = 8;
                break;
              }
              _context147.next = 5;
              return QNRTC$1.createMicrophoneAudioTrack({
                microphoneId: this.currentRecordingDeviceID
              });
            case 5:
              this.recordingDeviceTrack = _context147.sent;
              _context147.next = 11;
              break;
            case 8:
              _context147.next = 10;
              return QNRTC$1.createMicrophoneAudioTrack();
            case 10:
              this.recordingDeviceTrack = _context147.sent;
            case 11:
              if (playback) {
                this.recordingDeviceTrack.setEarMonitorEnabled(true);
              }
              emitTestRcordingDeviceVolume = function emitTestRcordingDeviceVolume() {
                var volume = _this103.recordingDeviceTrack ? _this103.recordingDeviceTrack.getVolumeLevel() : 0;
                _this103.emit("test-recording-device-volume", volume);
              };
              this.recordingDeviceTimer = setInterval(function () {
                emitTestRcordingDeviceVolume();
              }, interval);
              emitTestRcordingDeviceVolume();
            case 15:
            case "end":
              return _context147.stop();
          }
        }, _callee141, this);
      }));
    }
    /**
     * 结束麦克风测试
     */
  }, {
    key: "stopRecordingDeviceTest",
    value: function stopRecordingDeviceTest() {
      clearInterval(this.recordingDeviceTimer);
      this.recordingDeviceTrack && this.recordingDeviceTrack.destroy();
      this.recordingDeviceTrack = null;
    }
    /**
     * 开始扬声器测试
     * @param file_path 扬声器播放文件路径
     */
  }, {
    key: "startPlaybackDeviceTest",
    value: function startPlaybackDeviceTest(file_path) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee142() {
        var source;
        return _regeneratorRuntime().wrap(function _callee142$(_context148) {
          while (1) switch (_context148.prev = _context148.next) {
            case 0:
              if (!(this.playbackDeviceTrack instanceof QNBufferSourceAudioTrack)) {
                _context148.next = 2;
                break;
              }
              return _context148.abrupt("return");
            case 2:
              source = file_path instanceof Blob ? URL.createObjectURL(file_path) : file_path;
              _context148.next = 5;
              return QNRTC$1.createBufferSourceAudioTrack({
                source: source
              });
            case 5:
              this.playbackDeviceTrack = _context148.sent;
              this.playbackDeviceEl = document.createElement("div");
              document.body.append(this.playbackDeviceEl);
              this.playbackDeviceTrack.start();
              this.playbackDeviceTrack.play(this.playbackDeviceEl);
              if (this.currentPlaybackDeviceID) {
                this.playbackDeviceTrack.mediaElement.setSinkId(this.currentPlaybackDeviceID);
              }
            case 11:
            case "end":
              return _context148.stop();
          }
        }, _callee142, this);
      }));
    }
    /**
     * 结束扬声器测试
     */
  }, {
    key: "stopPlaybackDeviceTest",
    value: function stopPlaybackDeviceTest() {
      this.playbackDeviceTrack && this.playbackDeviceTrack.destroy();
      this.playbackDeviceTrack = null;
      this.playbackDeviceEl.remove();
    }
    /**
     * 枚举可用的视频输入设备，比如摄像头
     */
  }, {
    key: "getCameraDevices",
    value: function getCameraDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee143() {
        return _regeneratorRuntime().wrap(function _callee143$(_context149) {
          while (1) switch (_context149.prev = _context149.next) {
            case 0:
              return _context149.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "cameras"));
            case 1:
            case "end":
              return _context149.stop();
          }
        }, _callee143);
      }));
    }
    /**
     * 枚举可用的音频输入设备，比如麦克风
     */
  }, {
    key: "getRecordingDevices",
    value: function getRecordingDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee144() {
        return _regeneratorRuntime().wrap(function _callee144$(_context150) {
          while (1) switch (_context150.prev = _context150.next) {
            case 0:
              return _context150.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "microphones"));
            case 1:
            case "end":
              return _context150.stop();
          }
        }, _callee144);
      }));
    }
    /**
     * 枚举可用的音频播放设备，比如扬声器
     */
  }, {
    key: "getPlaybackDevices",
    value: function getPlaybackDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee145() {
        return _regeneratorRuntime().wrap(function _callee145$(_context151) {
          while (1) switch (_context151.prev = _context151.next) {
            case 0:
              return _context151.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "playback"));
            case 1:
            case "end":
              return _context151.stop();
          }
        }, _callee145);
      }));
    }
    /**
     * 枚举可用的媒体输入和输出设备，比如麦克风、摄像头、耳机等
     */
  }, {
    key: "getDevices",
    value: function getDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee146() {
        return _regeneratorRuntime().wrap(function _callee146$(_context152) {
          while (1) switch (_context152.prev = _context152.next) {
            case 0:
              return _context152.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "all"));
            case 1:
            case "end":
              return _context152.stop();
          }
        }, _callee146);
      }));
    }
    /**
     * 处理 device 类事件
     */
  }, {
    key: "handleDeviceManager",
    value: function handleDeviceManager() {
      var _this104 = this;
      deviceManager.on("device-changed", function (deviceInfo) {
        switch (deviceInfo.device.kind) {
          case "audioinput":
            _this104.emit("recording-device-changed", deviceInfo.device, deviceInfo.state);
            break;
          case "audiooutput":
            _this104.emit("playback-device-changed", deviceInfo.device, deviceInfo.state);
            break;
          case "videoinput":
            _this104.emit("camera-device-changed", deviceInfo.device, deviceInfo.state);
            break;
        }
      });
    }
  }]);
  return QNDeviceManager;
}(EventEmitter);
var QNAudioMusicMixer = /*#__PURE__*/function (_EventEmitter11) {
  _inherits(QNAudioMusicMixer, _EventEmitter11);
  /**
   * @param mixingTrack 混音 Track
   * @param source 音频数据源类型
   * @param playbackEngine 耳返控制器实例
   */
  function QNAudioMusicMixer(source) {
    var _this105;
    _classCallCheck(this, QNAudioMusicMixer);
    _this105 = _possibleConstructorReturn(this, _getPrototypeOf(QNAudioMusicMixer).call(this));
    _this105.source = source;
    /**
     * 对外输出的音频轨列表
     */
    _this105.outTrackList = [];
    /**
     * 混音参数
     */
    _this105.musicOption = {
      loop: false,
      volume: 1
    };
    /**
     * 音乐音量
     */
    _this105.musicVolume = 1;
    /**
     * 耳放引擎
     */
    _this105.playbackEngine = new AudioPlaybackEngine();
    /**
     * 是否开启耳放
     */
    _this105.playback = true;
    return _this105;
  }
  /**
   * 音乐混音增益节点
   */
  _createClass(QNAudioMusicMixer, [{
    key: "add",
    /**
     * 添加需要被混音的 track
     * @param track 混音 Track
     */
    value: function add(track) {
      var existTrack = this.outTrackList.find(function (outTrack) {
        return outTrack === track;
      });
      if (!existTrack) {
        this.outTrackList.push(track);
        if (this.musicTrack) {
          track.appendAudioSource(this.musicTrack);
        }
      }
    }
    /**
     * 移除不被需要的 track
     * @param mixingTrack 混音 Track
     */
  }, {
    key: "remove",
    value: function remove(track) {
      var index = this.outTrackList.findIndex(function (item) {
        return item === track;
      });
      if (index >= 0) {
        this.outTrackList.splice(index, 1);
      }
      this.musicTrack && track.removeAudioSource(this.musicTrack);
    }
    /**
     * 开始混音并播放
     * @remarks
     * 混音开始后会触发 QNAudioMusicMixerListener.onStateChanged 回调
     * 并回调 QNAudioMusicMixerState.MIXING 状态
     * 混音过程中会回调 QNAudioMusicMixerListener.onMixing 方法
     * @param loopCount 循环次数 混音次数，-1 为无限循环，0 则不做混音，其他则为指定次数的混音，默认一次混音
     */
  }, {
    key: "start",
    value: function start() {
      var loopCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee147() {
        return _regeneratorRuntime().wrap(function _callee147$(_context153) {
          while (1) switch (_context153.prev = _context153.next) {
            case 0:
              this._start(loopCount);
            case 1:
            case "end":
              return _context153.stop();
          }
        }, _callee147, this);
      }));
    }
    /**
     * 停止混音操作
     * @remarks 混音停止后会触发 QNAudioMusicMixerListener.onStateChanged 回调，并回调 QNAudioMusicMixerState.STOPPED 状态
     */
  }, {
    key: "stop",
    value: function stop() {
      this.loopCount = 1;
      this.stopMusicMixing();
    }
    /**
     * 恢复混音操作
     * @remarks 混音恢复后会触发 QNAudioMusicMixerListener.onStateChanged 回调，并回调 QNAudioMusicMixerState.MIXING 状态
     */
  }, {
    key: "resume",
    value: function resume() {
      if (!this.musicTrack) {
        log.warning("can not find target music, please run startAudioMixing");
      } else {
        this.musicTrack.resumeAudioSource();
      }
    }
    /**
     * 暂停混音操作
     * @remarks 混音暂停后会触发 QNAudioMusicMixerListener.onStateChanged 回调，并回调 QNAudioMusicMixerState.PAUSED 状态
     */
  }, {
    key: "pause",
    value: function pause() {
      if (!this.musicTrack) {
        log.warning("can not find target music, please run startAudioMixing");
      } else {
        this.musicTrack.pauseAudioSource();
      }
    }
    /**
     * 获取指定音频文件的总时长
     * @remarks 单位：ms
     * 该接口为同步方法，对于在线音频文件，获取时长会存在一定的耗时
     * @returns 音频文件总时长，单位：ms
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.musicTrack ? this.musicTrack.getDuration() : 0;
    }
    /**
     * 获取当前音频混音的位置
     * @remarks 单位: ms
     * @returns 当前音频混音的位置，单位: ms
     */
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.musicTrack ? this.musicTrack.getCurrentTime() : 0;
    }
    /**
     * 跳到指定位置混音
     * @remarks 成功跳到指定位置混音后会触发 QNAudioMusicMixerListener.onStateChanged 回调，并回调 QNAudioMusicMixerState.MIXING 状态
     * @param position 指定位置的时间戳，单位: ms
     */
  }, {
    key: "seekTo",
    value: function seekTo(position) {
      this.musicTrack && this.musicTrack.setCurrentTime(position);
      if (this.musicTrack && !this.musicTrack.audioManager.audioSource) throw ERROR_FATAL("can not find audio source");
    }
    /**
     * 获取背景音乐混音的音量
     * @returns 背景音乐混音的音量
     */
  }, {
    key: "getMixingVolume",
    value: function getMixingVolume() {
      return this.musicVolume;
    }
    /**
     * 设置背景音乐的混音音量
     * @remarks 初始默认音量为 1.0
     * 若想修改混音中麦克风采集音频的音量，可通过 QNMicrophoneAudioTrack.setVolume 接口实现
     * @param musicVolume 背景音乐混音音量
     */
  }, {
    key: "setMixingVolume",
    value: function setMixingVolume(musicVolume) {
      var volume = Number(musicVolume);
      volume = isNaN(volume) ? 0 : volume;
      this.musicVolume = volume;
      this.setMusicOption({
        volume: this.musicVolume
      });
    }
    /**
     * 释放混音资源
     */
  }, {
    key: "release",
    value: function release() {
      this.loopCount = 1;
      this.stopMusicMixing();
    }
    /**
     * 开始混音并播放
     * @param loopCount 循环次数 混音次数，-1 为无限循环，0 则不做混音，其他则为指定次数的混音，默认一次混音
     * @param noStopEmit 是否会在播放前调用 stop 从而触发 STATE_CHANGED STOPPED
     */
  }, {
    key: "_start",
    value: function _start() {
      var loopCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var noStopEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee148() {
        return _regeneratorRuntime().wrap(function _callee148$(_context154) {
          while (1) switch (_context154.prev = _context154.next) {
            case 0:
              this.loopCount = Math.max(-1, Number(loopCount));
              this.setMusicOption({
                loop: this.loopCount === -1,
                volume: this.musicVolume
              });
              if (!(this.loopCount !== 0)) {
                _context154.next = 5;
                break;
              }
              _context154.next = 5;
              return this.startMusicMixing(this.source, noStopEmit);
            case 5:
            case "end":
              return _context154.stop();
          }
        }, _callee148, this);
      }));
    }
    /**
     * 开始音乐混音
     * @param source 音乐的源文件，支持本地文件对象或者在线音乐地址
     */
  }, {
    key: "startMusicMixing",
    value: function startMusicMixing(source) {
      var noStopEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee149() {
        var _this106 = this;
        return _regeneratorRuntime().wrap(function _callee149$(_context155) {
          while (1) switch (_context155.prev = _context155.next) {
            case 0:
              if (!this.musicTrack) {
                _context155.next = 5;
                break;
              }
              this.stopMusicMixing(noStopEmit);
              _context155.next = 4;
              return this.startMusicMixing(source);
            case 4:
              return _context155.abrupt("return", _context155.sent);
            case 5:
              _context155.prev = 5;
              _context155.next = 8;
              return AudioUtils.createAudioTrackFromSource(source);
            case 8:
              this.musicTrack = _context155.sent;
              this.outTrackList.forEach(function (mixingTrack) {
                return mixingTrack.appendAudioSource(_this106.musicTrack);
              });
              this.setMusicOption({});
              if (this.musicTrack.audioManager.audioSource) {
                _context155.next = 13;
                break;
              }
              throw ERROR_FATAL("can not find audio source");
            case 13:
              if (this.playback && this.audioNode) {
                this.playbackEngine.addAudioNode(this.audioNode);
              }
              this.musicTrack.on("audio-state-change", function (state) {
                switch (state) {
                  case AudioSourceState.IDLE:
                    _this106.emit(QNAudioMusicMixer.STATE_CHANGED, QNAudioSourceState.IDLE);
                    break;
                  case AudioSourceState.LOADING:
                    break;
                  case AudioSourceState.PLAY:
                    _this106.emit(QNAudioMusicMixer.STATE_CHANGED, QNAudioSourceState.MIXING);
                    break;
                  case AudioSourceState.PAUSE:
                    _this106.emit(QNAudioMusicMixer.STATE_CHANGED, QNAudioSourceState.PAUSED);
                    break;
                  case AudioSourceState.END:
                    if (_this106.loopCount > 1) {
                      --_this106.loopCount;
                      _this106._start(_this106.loopCount, true);
                    } else {
                      _this106.emit(QNAudioMusicMixer.STATE_CHANGED, QNAudioSourceState.COMPLETED);
                    }
                    break;
                  case AudioSourceState.STOP:
                    _this106.emit(QNAudioMusicMixer.STATE_CHANGED, QNAudioSourceState.STOPPED);
                    break;
                }
              });
              this.musicTrack.startAudioSource();
              _context155.next = 23;
              break;
            case 18:
              _context155.prev = 18;
              _context155.t0 = _context155["catch"](5);
              if (!(_context155.t0 instanceof QNRTCError)) {
                _context155.next = 23;
                break;
              }
              this.emit(QNAudioMusicMixer.ERROR, _context155.t0);
              throw _context155.t0;
            case 23:
            case "end":
              return _context155.stop();
          }
        }, _callee149, this, [[5, 18]]);
      }));
    }
    /**
     * 停止音乐混音
     */
  }, {
    key: "stopMusicMixing",
    value: function stopMusicMixing() {
      var _this107 = this;
      var noStopEmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.musicTrack) {
        return;
      }
      this.musicTrack.stopAudioSource(noStopEmit);
      this.outTrackList.forEach(function (mixingTrack) {
        return mixingTrack.removeAudioSource(_this107.musicTrack);
      });
      this.musicTrack.release();
      this.musicTrack = undefined;
    }
    /**
     * 更新背景音乐混音的各种参数，支持在混音中途更新
     * @param option Partical<AudioMusicOption>
     */
  }, {
    key: "setMusicOption",
    value: function setMusicOption(option) {
      this.musicOption = Object.assign(this.musicOption, option);
      if (this.musicTrack) {
        this.musicTrack.setVolume(this.musicOption.volume);
        this.musicTrack.setLoop(this.musicOption.loop);
      }
    }
  }, {
    key: "audioNode",
    get: function get() {
      if (!this.musicTrack) return null;
      return this.musicTrack.audioManager.gainNode;
    }
  }]);
  return QNAudioMusicMixer;
}(EventEmitter);
/**
 * 音频源处理状态变化
 * @event
 */
QNAudioMusicMixer.STATE_CHANGED = "state-changed";
/**
 * 混音操作发生错误时会触发此回调
 * @event
 */
QNAudioMusicMixer.ERROR = "error";

/**
 * 音效混音配置类，可通过 QNAudioEffectMixer.createAudioEffect 接口进行创建
 */
var QNAudioEffect = /*#__PURE__*/function (_EventEmitter12) {
  _inherits(QNAudioEffect, _EventEmitter12);
  /**
   * @internal @param playbackEngine 耳返控制器实例
   * @internal @param effectID 音效 ID
   */
  function QNAudioEffect(playbackEngine, effectID) {
    var _this108;
    _classCallCheck(this, QNAudioEffect);
    _this108 = _possibleConstructorReturn(this, _getPrototypeOf(QNAudioEffect).call(this));
    _this108.playbackEngine = playbackEngine;
    _this108.effectID = effectID;
    /** @inrernal */
    _this108.playback = true;
    /**
     * 循环次数
     */
    _this108.loopCount = 1;
    return _this108;
  }
  /**
   * 获取指定音效文件的时长
   * @remarks 获取播放总时长，对于在线音乐 只有当 audio-state-change 第一次触发 PLAY 后才能获取到
   * @returns 音效文件的时长，单位：ms
   */
  _createClass(QNAudioEffect, [{
    key: "getDuration",
    value: function getDuration() {
      var audioTrack = this.getValidateAudioTrack();
      return audioTrack.getDuration();
    }
    /**
     * 获取音效文件的唯一标识符
     * @returns 音效文件的唯一标识符
     */
  }, {
    key: "getID",
    value: function getID() {
      return this.effectID;
    }
    /**
     * 获取音效文件的路径
     * @returns 音效文件的路径
     */
  }, {
    key: "getFilePath",
    value: function getFilePath() {
      return this._filePath;
    }
    /**
     * 设置音效混音的循环次数
     * @param loopCount 循环次数，-1 为无限循环，0 则不做混音，其他则为指定次数的混音，默认 1
     */
  }, {
    key: "setLoopCount",
    value: function setLoopCount(loopCount) {
      this.loopCount = loopCount === -1 ? Number.MAX_SAFE_INTEGER : Math.max(0, Number(loopCount));
      if (this.loopCount === 0) {
        this.stopEffect();
      }
    }
    /**
     * 获取音效循环次数
     * @returns 循环次数
     */
  }, {
    key: "getLoopCount",
    value: function getLoopCount() {
      return this.loopCount === Number.MAX_SAFE_INTEGER ? -1 : this.loopCount;
    }
    /**
     * 播放音效
     * @internal
     * @param volume 音量值 {@link https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/setValueAtTime}
     */
  }, {
    key: "playEffect",
    value: function playEffect(volume) {
      if (this.loopCount > 0) {
        var audioTrack = this.getValidateAudioTrack();
        volume && audioTrack.setVolume(volume);
        if (this.playback && audioTrack.audioManager.audioSource) {
          this.playbackEngine.addAudioNode(audioTrack.audioManager.gainNode);
        }
        audioTrack.startAudioSource();
      }
    }
    /**
     * 停止音效
     * @internal
     */
  }, {
    key: "stopEffect",
    value: function stopEffect() {
      var audioTrack = this.getValidateAudioTrack();
      this.loopCount = 1;
      audioTrack.stopAudioSource();
    }
    /**
     * 暂停音效
     * @internal
     */
  }, {
    key: "resumeEffect",
    value: function resumeEffect() {
      var audioTrack = this.getValidateAudioTrack();
      audioTrack.resumeAudioSource();
    }
    /**
     * 恢复音效
     * @internal
     */
  }, {
    key: "pauseEffect",
    value: function pauseEffect() {
      var audioTrack = this.getValidateAudioTrack();
      audioTrack.pauseAudioSource();
    }
    /**
     * 获取指定音效混音的位置
     * @internal
     */
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      var audioTrack = this.getValidateAudioTrack();
      return audioTrack.getCurrentTime();
    }
    /**
     * 添加音效
     * @internal
     * @param source 音效的源文件，支持本地 File 文件或者在线音乐地址
     */
  }, {
    key: "addEffectSource",
    value: function addEffectSource(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee150() {
        return _regeneratorRuntime().wrap(function _callee150$(_context156) {
          while (1) switch (_context156.prev = _context156.next) {
            case 0:
              _context156.prev = 0;
              _context156.next = 3;
              return AudioUtils.createAudioTrackFromSource(source);
            case 3:
              this.audioTrack = _context156.sent;
              if (typeof source === "string") {
                this._filePath = source;
              } else {
                this._filePath = URL.createObjectURL(source);
              }
              this.handleAudioTrack();
              _context156.next = 11;
              break;
            case 8:
              _context156.prev = 8;
              _context156.t0 = _context156["catch"](0);
              if (_context156.t0 instanceof QNRTCError) {
                this.emit(QNAudioEffect.ERROR, _context156.t0);
              }
            case 11:
            case "end":
              return _context156.stop();
          }
        }, _callee150, this, [[0, 8]]);
      }));
    }
    /**
     * 为音频轨添加音效
     * @internal
     * @param track 音频轨
     */
  }, {
    key: "appendAudioSource",
    value: function appendAudioSource(track) {
      this.audioTrack && track.appendAudioSource(this.audioTrack);
    }
    /**
    * 为音频轨移除音效
    * @internal
    * @param track 音频轨
    */
  }, {
    key: "removeAudioSource",
    value: function removeAudioSource(track) {
      this.audioTrack && track.removeAudioSource(this.audioTrack);
    }
    /**
     * 释放资源
     * @internal
     * @remarks
     * audioNode 去除音效 Track
     * 音效 Track 资源释放
     * 初始化对象状态
     */
  }, {
    key: "release",
    value: function release() {
      if (this.audioTrack !== undefined) {
        this.audioTrack.release();
        this.audioTrack = undefined;
      }
    }
    /**
     * 获取音频 Track
     * @internal
     * @throws {@link ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND} 需要使用到 audioTrack 时，但是 audioTrack 不存在
     */
  }, {
    key: "getValidateAudioTrack",
    value: function getValidateAudioTrack() {
      if (this.audioTrack === undefined) {
        var _error11 = ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND();
        this.emit(QNAudioEffect.ERROR, _error11);
        throw _error11;
      } else {
        return this.audioTrack;
      }
    }
    /**
     * 音频轨事件处理
     */
  }, {
    key: "handleAudioTrack",
    value: function handleAudioTrack() {
      var _this109 = this;
      this.audioTrack && this.audioTrack.on("audio-state-change", function (state) {
        switch (state) {
          case AudioSourceState.END:
            if (_this109.loopCount > 1) {
              _this109.loopCount = _this109.loopCount === Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : _this109.loopCount - 1;
              _this109.playEffect(_this109.loopCount);
            } else {
              _this109.emit(QNAudioEffect.FINISHED);
            }
        }
      });
    }
  }]);
  return QNAudioEffect;
}(EventEmitter);
/**
 * 音效混音完成时触发此回调
 * @event
 * @internal
 */
QNAudioEffect.FINISHED = "finished";
/**
 * 音效混音完发生错误触发此回调
 * @event
 * @internal
 */
QNAudioEffect.ERROR = "error";

/**
 * 音效混音控制类，提供了控制音效混音的一系列方法
 * @see {@link https://developer.qiniu.com/rtc/9066/WebQNAudioMixer} 旧版混音模块
 * @remarks
 * 1. 当前仅支持基于 QNMicrophoneAudioTrack 的音效混音操作
 * 2. 混音需要加入房间并且成功发布后才会生效，因此，需要注意调用的时机
 */
var QNAudioEffectMixer = /*#__PURE__*/function (_EventEmitter13) {
  _inherits(QNAudioEffectMixer, _EventEmitter13);
  function QNAudioEffectMixer() {
    var _this110;
    _classCallCheck(this, QNAudioEffectMixer);
    _this110 = _possibleConstructorReturn(this, _getPrototypeOf(QNAudioEffectMixer).apply(this, arguments));
    /**
     * 对外输出的音频轨列表
     */
    _this110.outTrackList = [];
    /**
     * 音效列表 HashMap
     */
    _this110.audioEffectMap = new Map();
    /**
     * 是否初始化列表
     * @remarks 修复未开始播放 currentTime 时间问题
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext/currentTime}
     */
    _this110.startedList = new Map();
    /**
     * 耳放引擎
     */
    _this110.playbackEngine = new AudioPlaybackEngine();
    return _this110;
  }
  /**
   * 添加需要被混音的 track
   * @param mixingTrack 混音 Track
   */
  _createClass(QNAudioEffectMixer, [{
    key: "add",
    value: function add(track) {
      var existTrack = this.outTrackList.find(function (outTrack) {
        return outTrack === track;
      });
      if (!existTrack) {
        this.outTrackList.push(track);
        this.audioEffectMap.forEach(function (audioEffect) {
          audioEffect.appendAudioSource(track);
        });
      }
    }
    /**
     * 移除不被需要的 track
     * @param mixingTrack 混音 Track
     */
  }, {
    key: "remove",
    value: function remove(track) {
      var index = this.outTrackList.findIndex(function (item) {
        return item === track;
      });
      if (index >= 0) {
        this.outTrackList.splice(index, 1);
      }
      this.audioEffectMap.forEach(function (value) {
        value.removeAudioSource(track);
      });
    }
    /**
     * 创建音效混音配置类实例
     * @remarks 每一路参与混音的音效都需要对应一个 QNAudioEffect 实例
     * @param effectID 音效文件的唯一标识符，需自行生成并维护，且确保唯一
     * @param filePath 音效文件地址，支持本地文件和在线文件
     * @throws {@link ERROR_EFFECT_ID_IS_EXIST} 已经存在 effectID，无法创建音效控制器
     */
  }, {
    key: "createAudioEffect",
    value: function createAudioEffect(effectID, filePath) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee151() {
        var _error12, audioEffect;
        return _regeneratorRuntime().wrap(function _callee151$(_context157) {
          while (1) switch (_context157.prev = _context157.next) {
            case 0:
              if (!this.audioEffectMap.has(effectID)) {
                _context157.next = 6;
                break;
              }
              _error12 = ERROR_EFFECT_ID_IS_EXIST();
              this.emit(QNAudioEffectMixer.ERROR, _error12);
              throw _error12;
            case 6:
              audioEffect = new QNAudioEffect(this.playbackEngine, effectID);
              this.handleAudioEffect(effectID, audioEffect);
              _context157.next = 10;
              return audioEffect.addEffectSource(filePath);
            case 10:
              this.outTrackList.forEach(function (track) {
                return audioEffect.appendAudioSource(track);
              });
              this.audioEffectMap.set(effectID, audioEffect);
              return _context157.abrupt("return", audioEffect);
            case 13:
            case "end":
              return _context157.stop();
          }
        }, _callee151, this);
      }));
    }
    /**
     * 开始音效混音
     * @remarks 默认初始化音量增益值为 1
     * 混音结束时会触发 QNAudioEffectMixerListener.onFinished
     * 回调混音出错会触发 QNAudioEffectMixerListener.onError 回调
     * @privateRemarks 增益值详情可见文档 {@link https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/setValueAtTime}
     * @param effectID 音效文件的唯一标识符
     */
  }, {
    key: "start",
    value: function start(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      audioEffect.playEffect(1);
      this.startedList.set(effectID, true);
    }
    /**
     * 停止音效混音
     * @param effectID 音效文件的唯一标识符
     */
  }, {
    key: "stop",
    value: function stop(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      audioEffect.stopEffect();
    }
    /**
     * 暂停音效混音
     * @param effectID 音效文件的唯一标识符
     */
  }, {
    key: "pause",
    value: function pause(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      audioEffect.pauseEffect();
    }
    /**
     * 恢复音效混音
     * @param effectID 音效文件的唯一标识符
     */
  }, {
    key: "resume",
    value: function resume(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      audioEffect.resumeEffect();
    }
    /**
     * 停止所有正在混音的音效
     */
  }, {
    key: "stopAll",
    value: function stopAll() {
      this.audioEffectMap.forEach(function (value) {
        value.stopEffect();
      });
    }
    /**
     * 暂停所有正在混音的音效
     */
  }, {
    key: "pauseAll",
    value: function pauseAll() {
      this.audioEffectMap.forEach(function (value) {
        value.pauseEffect();
      });
    }
    /**
     * 恢复所有暂停混音的音效
     */
  }, {
    key: "resumeAll",
    value: function resumeAll() {
      this.audioEffectMap.forEach(function (value) {
        value.resumeEffect();
      });
    }
    /**
     * 获取指定音效混音的位置
     * @remarks 单位: ms
     * @param effectID 音效文件的唯一标识符
     * @returns 指定音效混音的位置，单位: ms
     */
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      return this.startedList.get(effectID) ? Math.floor(audioEffect.getCurrentPosition() * 1000) : 0;
    }
    /**
     * 设置指定音效的混音音量
     * @remarks 默认音量为 1.0
     * 若想修改混音中麦克风采集音频的音量，可通过 QNMicrophoneAudioTrack.setVolume 接口实现
     * @param effectID 音效文件的唯一标识符
     * @param volume 音效的混音音量
     */
  }, {
    key: "setVolume",
    value: function setVolume(effectID, volume) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      var audioTrack = audioEffect.getValidateAudioTrack();
      audioTrack.setVolume(volume);
    }
    /**
     * 获取指定音效的混音音量
     * @param effectID 音效文件的唯一标识符
     * @returns 指定音效的混音音量
     */
  }, {
    key: "getVolume",
    value: function getVolume(effectID) {
      var audioEffect = this.getValidateAudioEffect(effectID);
      var audioTrack = audioEffect.getValidateAudioTrack();
      return audioTrack.getVolume();
    }
    /**
     * 设置所有正在混音的音效的混音音量
     * @param volume 音效的混音音量，默认音量均为 1.0
     */
  }, {
    key: "setAllEffectsVolume",
    value: function setAllEffectsVolume(volume) {
      this.audioEffectMap.forEach(function (value) {
        var audioTrack = value.getValidateAudioTrack();
        audioTrack.setVolume(volume);
      });
    }
    /**
     * 释放所有音效资源
     */
  }, {
    key: "release",
    value: function release() {
      var _this111 = this;
      this.audioEffectMap.forEach(function (value) {
        value.release();
        _this111.outTrackList.forEach(function (track) {
          return value.removeAudioSource(track);
        });
      });
      this.audioEffectMap.clear();
    }
    /**
     * 获取 effectID 对应的 effect
     * @param effectID 音效文件的唯一标识符
     * @throws {@link ERROR_EFFECT_ID_IS_NOT_EXIST} 如果传入的 effectID 不存在于 audioEffectMap，无法开始音效混音
     */
  }, {
    key: "getValidateAudioEffect",
    value: function getValidateAudioEffect(effectID) {
      var audioEffect = this.audioEffectMap.get(effectID);
      if (audioEffect === undefined) {
        var _error13 = ERROR_EFFECT_ID_IS_NOT_EXIST();
        this.emit(QNAudioEffectMixer.ERROR, _error13);
        throw _error13;
      } else {
        return audioEffect;
      }
    }
    /**
     * 音效事件处理
     * @throws {@link ERROR_AUDIO_MIXING_IO_EXCEPTION} 混音源错误
     * @throws {@link ERROR_AUDIO_MIXING_AUDIO_NOT_FOUND} 混音源没有找到有效音轨
     */
  }, {
    key: "handleAudioEffect",
    value: function handleAudioEffect(effectID, audioEffect) {
      var _this112 = this;
      audioEffect.on(QNAudioEffect.FINISHED, function () {
        _this112.emit(QNAudioEffectMixer.FINISHED, effectID);
      });
      audioEffect.on(QNAudioEffect.ERROR, function (error) {
        _this112.emit(QNAudioEffectMixer.ERROR, error);
        throw error;
      });
    }
  }]);
  return QNAudioEffectMixer;
}(EventEmitter);
/**
 * 音效混音完成时触发此回调
 * @event
 */
QNAudioEffectMixer.FINISHED = "finished";
/**
 * 混音操作发生错误时会触发此回调
 * @event
 */
QNAudioEffectMixer.ERROR = "error";
var isSafari151 = (browser.name === "safari" || browser.name === "ios") && navigator.userAgent.includes("15_1");
if (isSafari151) {
  log.warning("QNRTC: iOS 15.1 has a bug causing the SDK to crash. Please upgrade to iOS 15.2 or later.", browser);
}
/**
 * @public
 */
var QNRTC = /*#__PURE__*/function () {
  function QNRTC() {
    _classCallCheck(this, QNRTC);
  }
  _createClass(QNRTC, null, [{
    key: "isBrowserSupported",
    /**
     * 获取浏览器兼容报告
     */
    value: function isBrowserSupported() {
      return browserReport.support;
    }
    /**
     * 系统兼容检测(约需30s-60s)
     */
  }, {
    key: "checkSystemRequirements",
    value: function checkSystemRequirements() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee152() {
        return _regeneratorRuntime().wrap(function _callee152$(_context158) {
          while (1) switch (_context158.prev = _context158.next) {
            case 0:
              _context158.next = 2;
              return _checkSystemRequirements();
            case 2:
              return _context158.abrupt("return", _context158.sent);
            case 3:
            case "end":
              return _context158.stop();
          }
        }, _callee152);
      }));
    }
    /**
     * 设置日志打印等级
     */
  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      switch (level) {
        case QNLogLevel.VERBOSE:
          log.setLevel("log");
          break;
        case QNLogLevel.INFO:
          log.setLevel("debug");
          break;
        case QNLogLevel.WARNING:
        case QNLogLevel.ERROR:
          log.setLevel("warning");
          break;
        case QNLogLevel.NONE:
          log.setLevel("disable");
          break;
      }
    }
    /**
     * 检查 Chrome 浏览器插件是否按安装
     */
  }, {
    key: "isChromeExtensionAvailable",
    value: function isChromeExtensionAvailable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee153() {
        return _regeneratorRuntime().wrap(function _callee153$(_context159) {
          while (1) switch (_context159.prev = _context159.next) {
            case 0:
              _context159.next = 2;
              return _isChromeExtensionAvailable();
            case 2:
              return _context159.abrupt("return", _context159.sent);
            case 3:
            case "end":
              return _context159.stop();
          }
        }, _callee153);
      }));
    }
    /**
     * 创建 QNRTCClient 对象
     */
  }, {
    key: "createClient",
    value: function createClient() {
      var client = new QNRTCClient(this._config);
      QNRTC._clients.push(client);
      return client;
    }
    /**
     * 枚举可用的视频输入设备，比如摄像头
     */
  }, {
    key: "getCameras",
    value: function getCameras() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee154() {
        return _regeneratorRuntime().wrap(function _callee154$(_context160) {
          while (1) switch (_context160.prev = _context160.next) {
            case 0:
              return _context160.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "cameras"));
            case 1:
            case "end":
              return _context160.stop();
          }
        }, _callee154);
      }));
    }
    /**
     * 枚举可用的音频输入设备，比如麦克风
     */
  }, {
    key: "getMicrophones",
    value: function getMicrophones() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee155() {
        return _regeneratorRuntime().wrap(function _callee155$(_context161) {
          while (1) switch (_context161.prev = _context161.next) {
            case 0:
              return _context161.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "microphones"));
            case 1:
            case "end":
              return _context161.stop();
          }
        }, _callee155);
      }));
    }
    /**
     * 枚举可用的音频播放设备，比如扬声器
     */
  }, {
    key: "getPlaybackDevices",
    value: function getPlaybackDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee156() {
        return _regeneratorRuntime().wrap(function _callee156$(_context162) {
          while (1) switch (_context162.prev = _context162.next) {
            case 0:
              return _context162.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "playback"));
            case 1:
            case "end":
              return _context162.stop();
          }
        }, _callee156);
      }));
    }
    /**
     * 枚举可用的媒体输入和输出设备，比如麦克风、摄像头、耳机等
     */
  }, {
    key: "getDevices",
    value: function getDevices() {
      var skipPermissionCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee157() {
        return _regeneratorRuntime().wrap(function _callee157$(_context163) {
          while (1) switch (_context163.prev = _context163.next) {
            case 0:
              return _context163.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "all"));
            case 1:
            case "end":
              return _context163.stop();
          }
        }, _callee157);
      }));
    }
    /**
     * 创建背景音乐混音控制器对象
     * @since 4.3.0
     * @param source 音频数据源类型
     * @remarks
     * 1. 背景音乐混音仅支持同时混合一路背景音乐，若需要切换背景音乐，重新调用本接口创建 QNAudioMusicMixer 即可
     * 2. 建议使用本地文件进行混音，以避免网络环境差引起的混音异常
     * 3. 若您希望在混合背景音乐的同时添加音效，可参考音效混音相关接口(QNAudioEffectMixer)
     */
  }, {
    key: "createAudioMusicMixer",
    value: function createAudioMusicMixer(source) {
      if (!this.audioMusicMixer) {
        this.audioMusicMixer = new QNAudioMusicMixer(source);
      }
      return this.audioMusicMixer;
    }
    /**
     * 销毁背景音乐混音控制器对象
     * @since 4.3.0
     */
  }, {
    key: "destroyAudioMusicMixer",
    value: function destroyAudioMusicMixer() {
      this.audioMusicMixer && this.audioMusicMixer.release();
    }
    /**
     * 创建背景音效混音控制器对象
     * @since 4.3.0
     */
  }, {
    key: "createAudioEffectMixer",
    value: function createAudioEffectMixer() {
      if (!this.audioEffectMixer) {
        this.audioEffectMixer = new QNAudioEffectMixer();
      }
      return this.audioEffectMixer;
    }
    /**
     * 销毁背景音效混音控制对象
     * @since 4.3.0
     */
  }, {
    key: "destroyAudioEffectMixer",
    value: function destroyAudioEffectMixer() {
      this.audioEffectMixer && this.audioEffectMixer.release();
    }
    /**
     * 通过摄像头采集的视频创建一个视频轨道
     */
  }, {
    key: "createCameraVideoTrack",
    value: function createCameraVideoTrack(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee158() {
        var encoderConfig, videoTrackConfig, tracks, videoTrack, qntrack;
        return _regeneratorRuntime().wrap(function _callee158$(_context164) {
          while (1) switch (_context164.prev = _context164.next) {
            case 0:
              log.log("createCameraVideoTrack start", config);
              if (!(!config || !config.encoderConfig)) {
                _context164.next = 5;
                break;
              }
              encoderConfig = defaultVideoEncoderConfiguration;
              _context164.next = 12;
              break;
            case 5:
              if (!(typeof config.encoderConfig === "string")) {
                _context164.next = 11;
                break;
              }
              encoderConfig = SUPPORT_VIDEO_ENCODER_CONFIG_LIST[config.encoderConfig];
              if (encoderConfig) {
                _context164.next = 9;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 9:
              _context164.next = 12;
              break;
            case 11:
              encoderConfig = Object.assign(Object.assign({}, defaultVideoEncoderConfiguration), config.encoderConfig);
            case 12:
              videoTrackConfig = removeUndefinedKey({
                enabled: true,
                width: encoderConfig.width,
                height: encoderConfig.height,
                frameRate: encoderConfig.frameRate,
                bitrate: encoderConfig.bitrate,
                tag: config && config.tag,
                facingMode: config && config.facingMode,
                optimizationMode: config && config.optimizationMode,
                deviceId: config && config.cameraId && {
                  exact: config.cameraId
                }
              });
              if (!videoTrackConfig.deviceId && QNRTC.deviceManager && QNRTC.deviceManager.currentCameraDeviceID) {
                videoTrackConfig.deviceId = {
                  exact: QNRTC.deviceManager.currentCameraDeviceID
                };
              }
              _context164.next = 16;
              return deviceManager.getLocalTracks({
                video: videoTrackConfig
              });
            case 16:
              tracks = _context164.sent;
              videoTrack = tracks[0];
              if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
              }
              qntrack = new QNCameraVideoTrack(videoTrack);
              if (encoderConfig.isMultiProfileEnabled !== undefined) {
                qntrack.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
              }
              log.log("createCameraVideoTrack end", qntrack);
              return _context164.abrupt("return", qntrack);
            case 23:
            case "end":
              return _context164.stop();
          }
        }, _callee158);
      }));
    }
    /**
     * 通过麦克风采集的音频创建一个音频轨道
     */
  }, {
    key: "createMicrophoneAudioTrack",
    value: function createMicrophoneAudioTrack(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee159() {
        var encoderConfig, audioTrackConfig, tracks, qntrack;
        return _regeneratorRuntime().wrap(function _callee159$(_context165) {
          while (1) switch (_context165.prev = _context165.next) {
            case 0:
              log.log("createMicrophoneAudioTrack start", config);
              if (!(!config || !config.encoderConfig)) {
                _context165.next = 5;
                break;
              }
              encoderConfig = defaultAudioEncoderConfiguration;
              _context165.next = 12;
              break;
            case 5:
              if (!(typeof config.encoderConfig === "string")) {
                _context165.next = 11;
                break;
              }
              encoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[config.encoderConfig];
              if (encoderConfig) {
                _context165.next = 9;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 9:
              _context165.next = 12;
              break;
            case 11:
              encoderConfig = Object.assign(Object.assign({}, defaultAudioEncoderConfiguration), config.encoderConfig);
            case 12:
              audioTrackConfig = removeUndefinedKey({
                enabled: true,
                bitrate: encoderConfig.bitrate,
                sampleRate: encoderConfig.sampleRate,
                sampleSize: encoderConfig.sampleSize,
                channelCount: encoderConfig.stereo ? 2 : 1,
                autoGainControl: config && config.AGC !== undefined ? config.AGC : true,
                noiseSuppression: config && config.ANS !== undefined ? config.ANS : true,
                echoCancellation: config && config.AEC !== undefined ? config.AEC : true,
                deviceId: config && config.microphoneId && {
                  exact: config.microphoneId
                },
                tag: config && config.tag
              });
              if (!audioTrackConfig.deviceId && QNRTC.deviceManager && QNRTC.deviceManager.currentRecordingDeviceID) {
                audioTrackConfig.deviceId = QNRTC.deviceManager.currentRecordingDeviceID;
              }
              _context165.next = 16;
              return deviceManager.getLocalTracks({
                audio: audioTrackConfig
              });
            case 16:
              tracks = _context165.sent;
              qntrack = new QNMicrophoneAudioTrack(tracks[0]);
              log.log("createMicrophoneAudioTrack end", qntrack);
              return _context165.abrupt("return", qntrack);
            case 20:
            case "end":
              return _context165.stop();
          }
        }, _callee159);
      }));
    }
  }, {
    key: "createScreenVideoTrack",
    value: function createScreenVideoTrack(config, withAudio) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee160() {
        var encoderConfig, tracks, screenConfig, videoTrack, qnt, audioTrack, _videoTrack, qnat, qnvt;
        return _regeneratorRuntime().wrap(function _callee160$(_context166) {
          while (1) switch (_context166.prev = _context166.next) {
            case 0:
              log.log("createScreenVideoTrack start", config, withAudio);
              if (!(!config || !config.encoderConfig)) {
                _context166.next = 5;
                break;
              }
              encoderConfig = defaultScreenEncoderConfiguration;
              _context166.next = 12;
              break;
            case 5:
              if (!(typeof config.encoderConfig === "string")) {
                _context166.next = 11;
                break;
              }
              encoderConfig = SUPPORT_SCREEN_ENCODER_CONFIG_LIST[config.encoderConfig];
              if (encoderConfig) {
                _context166.next = 9;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 9:
              _context166.next = 12;
              break;
            case 11:
              encoderConfig = Object.assign(Object.assign({}, defaultScreenEncoderConfiguration), config.encoderConfig);
            case 12:
              tracks = [];
              if (!isElectron) {
                _context166.next = 19;
                break;
              }
              _context166.next = 16;
              return deviceManager.createElectronScreenTrack(removeUndefinedKey({
                sourceID: config && config.electronScreenSourceID,
                screenBitrate: encoderConfig.bitrate,
                width: encoderConfig.width,
                height: encoderConfig.height,
                optimizationMode: config && config.optimizationMode,
                tag: config && config.screenVideoTag,
                audio: withAudio && ["enable", "auto"].includes(withAudio) ? true : undefined,
                audioTag: config && config.screenAudioTag
              }));
            case 16:
              tracks = _context166.sent;
              _context166.next = 31;
              break;
            case 19:
              screenConfig = removeUndefinedKey({
                enabled: true,
                width: encoderConfig.width,
                height: encoderConfig.height,
                frameRate: encoderConfig.frameRate,
                bitrate: encoderConfig.bitrate,
                optimizationMode: config && config.optimizationMode,
                tag: config && config.screenVideoTag,
                audio: withAudio && ["enable", "auto"].includes(withAudio) ? true : undefined,
                audioTag: config && config.screenAudioTag
              });
              if (!(config && config.chromeExtensionSourceType)) {
                _context166.next = 28;
                break;
              }
              _context166.t0 = config.chromeExtensionSourceType;
              _context166.next = _context166.t0 === QNChromeExtensionSourceType.ALL ? 24 : _context166.t0 === QNChromeExtensionSourceType.SCREEN ? 26 : _context166.t0 === QNChromeExtensionSourceType.WINDOW ? 26 : 28;
              break;
            case 24:
              screenConfig = Object.assign(Object.assign({}, screenConfig), {
                forceChromePlugin: true
              });
              return _context166.abrupt("break", 28);
            case 26:
              screenConfig = Object.assign(Object.assign({}, screenConfig), {
                forceChromePlugin: true,
                source: config.chromeExtensionSourceType
              });
              return _context166.abrupt("break", 28);
            case 28:
              _context166.next = 30;
              return deviceManager.getLocalTracks({
                screen: screenConfig
              });
            case 30:
              tracks = _context166.sent;
            case 31:
              if (!(tracks.length === 1 && tracks[0].info.kind === "video" && withAudio === "enable")) {
                _context166.next = 34;
                break;
              }
              tracks[0].release();
              throw CREATE_SCREEN_AUDIO_ERROR();
            case 34:
              if (!(tracks.length === 1 && tracks[0].info.kind === "video")) {
                _context166.next = 43;
                break;
              }
              videoTrack = tracks[0];
              if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
              }
              qnt = new QNScreenVideoTrack(videoTrack);
              if (encoderConfig.isMultiProfileEnabled !== undefined) {
                qnt.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
              }
              log.log("createScreenVideoTrack end", qnt);
              return _context166.abrupt("return", qnt);
            case 43:
              audioTrack = tracks.filter(function (t) {
                return t.info.kind === "audio";
              })[0];
              _videoTrack = tracks.filter(function (t) {
                return t.info.kind === "video";
              })[0];
              if (!(!audioTrack || !_videoTrack)) {
                _context166.next = 47;
                break;
              }
              throw ERROR_FATAL("createScreenVideoTrack error, audioTrack: ".concat(audioTrack, ", videoTrack: ").concat(_videoTrack));
            case 47:
              if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                _videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
              }
              qnat = new QNLocalAudioTrack(audioTrack);
              qnvt = new QNScreenVideoTrack(_videoTrack);
              if (encoderConfig.isMultiProfileEnabled !== undefined) {
                qnvt.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
              }
              log.log("createScreenVideoTrack end", [qnvt, qnat]);
              return _context166.abrupt("return", [qnvt, qnat]);
            case 53:
            case "end":
              return _context166.stop();
          }
        }, _callee160);
      }));
    }
    /**
     * 同时采集麦克风音频和摄像头视频轨道
     */
  }, {
    key: "createMicrophoneAndCameraTracks",
    value: function createMicrophoneAndCameraTracks(audioConfig, videoConfig) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee161() {
        var audioEncoderConfig, videoEncoderConfig, audioTrackConfig, videoTrackConfig, tracks, audioTrack, videoTrack, qnat, qnvt;
        return _regeneratorRuntime().wrap(function _callee161$(_context167) {
          while (1) switch (_context167.prev = _context167.next) {
            case 0:
              log.log("createMicrophoneAndCameraTracks start", audioConfig, videoConfig);
              if (!(!audioConfig || !audioConfig.encoderConfig)) {
                _context167.next = 5;
                break;
              }
              audioEncoderConfig = defaultAudioEncoderConfiguration;
              _context167.next = 12;
              break;
            case 5:
              if (!(typeof audioConfig.encoderConfig === "string")) {
                _context167.next = 11;
                break;
              }
              audioEncoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[audioConfig.encoderConfig];
              if (audioEncoderConfig) {
                _context167.next = 9;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 9:
              _context167.next = 12;
              break;
            case 11:
              audioEncoderConfig = Object.assign(Object.assign({}, defaultAudioEncoderConfiguration), audioConfig.encoderConfig);
            case 12:
              if (!(!videoConfig || !videoConfig.encoderConfig)) {
                _context167.next = 16;
                break;
              }
              videoEncoderConfig = defaultVideoEncoderConfiguration;
              _context167.next = 23;
              break;
            case 16:
              if (!(typeof videoConfig.encoderConfig === "string")) {
                _context167.next = 22;
                break;
              }
              videoEncoderConfig = SUPPORT_VIDEO_ENCODER_CONFIG_LIST[videoConfig.encoderConfig];
              if (videoEncoderConfig) {
                _context167.next = 20;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 20:
              _context167.next = 23;
              break;
            case 22:
              videoEncoderConfig = Object.assign(Object.assign({}, defaultVideoEncoderConfiguration), videoConfig.encoderConfig);
            case 23:
              audioTrackConfig = removeUndefinedKey({
                enabled: true,
                bitrate: audioEncoderConfig.bitrate,
                sampleRate: audioEncoderConfig.sampleRate,
                sampleSize: audioEncoderConfig.sampleSize,
                channelCount: audioEncoderConfig.stereo ? 2 : 1,
                autoGainControl: audioConfig && audioConfig.AGC !== undefined ? audioConfig.AGC : true,
                noiseSuppression: audioConfig && audioConfig.ANS !== undefined ? audioConfig.ANS : true,
                echoCancellation: audioConfig && audioConfig.AEC !== undefined ? audioConfig.AEC : true,
                deviceId: audioConfig && audioConfig.microphoneId && {
                  exact: audioConfig.microphoneId
                },
                tag: audioConfig && audioConfig.tag
              });
              if (!audioTrackConfig.deviceId && QNRTC.deviceManager && QNRTC.deviceManager.currentRecordingDeviceID) {
                audioTrackConfig.deviceId = QNRTC.deviceManager.currentRecordingDeviceID;
              }
              videoTrackConfig = removeUndefinedKey({
                enabled: true,
                width: videoEncoderConfig.width,
                height: videoEncoderConfig.height,
                frameRate: videoEncoderConfig.frameRate,
                bitrate: videoEncoderConfig.bitrate,
                tag: videoConfig && videoConfig.tag,
                facingMode: videoConfig && videoConfig.facingMode,
                deviceId: videoConfig && videoConfig.cameraId && {
                  exact: videoConfig.cameraId
                }
              });
              if (!videoTrackConfig.deviceId && QNRTC.deviceManager && QNRTC.deviceManager.currentCameraDeviceID) {
                videoTrackConfig.deviceId = {
                  exact: QNRTC.deviceManager.currentCameraDeviceID
                };
              }
              _context167.next = 29;
              return deviceManager.getLocalTracks({
                audio: audioTrackConfig,
                video: videoTrackConfig
              });
            case 29:
              tracks = _context167.sent;
              audioTrack = tracks.filter(function (t) {
                return t.info.kind === "audio";
              })[0];
              videoTrack = tracks.filter(function (t) {
                return t.info.kind === "video";
              })[0];
              if (!(!audioTrack || !videoTrack)) {
                _context167.next = 34;
                break;
              }
              throw ERROR_FATAL("createMicrophoneAndCameraTracks error, audioTrack: ".concat(audioTrack, ", videoTrack: ").concat(videoTrack));
            case 34:
              if (videoConfig && videoConfig.encoderConfig && typeof videoConfig.encoderConfig !== "string" && videoConfig.encoderConfig.lowStreamConfig) {
                videoTrack.lowStreamConfig = videoConfig.encoderConfig.lowStreamConfig;
              }
              qnat = new QNMicrophoneAudioTrack(audioTrack);
              qnvt = new QNCameraVideoTrack(videoTrack);
              if (videoEncoderConfig.isMultiProfileEnabled !== undefined) {
                qnvt.isMultiProfileEnabled = videoEncoderConfig.isMultiProfileEnabled;
              }
              log.log("createMicrophoneAndCameraTracks end", [qnat, qnvt]);
              return _context167.abrupt("return", [qnat, qnvt]);
            case 40:
            case "end":
              return _context167.stop();
          }
        }, _callee161);
      }));
    }
    /**
     * 通过音频文件或者 AudioBuffer 对象创建一个音频轨道
     */
  }, {
    key: "createBufferSourceAudioTrack",
    value: function createBufferSourceAudioTrack(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee162() {
        var encoderConfig, tracks, qntrack;
        return _regeneratorRuntime().wrap(function _callee162$(_context168) {
          while (1) switch (_context168.prev = _context168.next) {
            case 0:
              log.log("createBufferSourceAudioTrack start", config);
              if (!(!config || !config.encoderConfig)) {
                _context168.next = 5;
                break;
              }
              encoderConfig = defaultAudioEncoderConfiguration;
              _context168.next = 12;
              break;
            case 5:
              if (!(typeof config.encoderConfig === "string")) {
                _context168.next = 11;
                break;
              }
              encoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[config.encoderConfig];
              if (encoderConfig) {
                _context168.next = 9;
                break;
              }
              throw PRESET_NOT_FOUND();
            case 9:
              _context168.next = 12;
              break;
            case 11:
              encoderConfig = Object.assign(Object.assign({}, defaultAudioEncoderConfiguration), config.encoderConfig);
            case 12:
              _context168.next = 14;
              return deviceManager.getLocalTracks({
                audio: removeUndefinedKey({
                  enabled: true,
                  source: config.source,
                  bitrate: encoderConfig.bitrate,
                  sampleRate: encoderConfig.sampleRate,
                  sampleSize: encoderConfig.sampleSize,
                  channelCount: encoderConfig.stereo ? 2 : 1,
                  tag: config && config.tag
                })
              });
            case 14:
              tracks = _context168.sent;
              qntrack = new QNBufferSourceAudioTrack(tracks[0], config.source);
              log.log("createBufferSourceAudioTrack end", qntrack);
              return _context168.abrupt("return", qntrack);
            case 18:
            case "end":
              return _context168.stop();
          }
        }, _callee162);
      }));
    }
    /**
     * 创建 canvas video track
     */
  }, {
    key: "createCanvasVideoTrack",
    value: function createCanvasVideoTrack(config) {
      var canvas = document.createElement("canvas");
      canvas.width = config.width;
      canvas.height = config.height;
      var frameRate = 15; // 图片 track，暂定默认帧率 15
      var ctx = canvas.getContext("2d");
      if (ctx === null) {
        throw ERROR_NOT_SUPPORT("get context error, canvas track not supported");
      }
      var stream;
      if (canvas.captureStream) {
        stream = canvas.captureStream(frameRate);
      } else if (canvas.mozCaptureStream) {
        stream = canvas.mozCaptureStream(frameRate);
      } else {
        throw ERROR_NOT_SUPPORT("capture stream error, canvas track not supported");
      }
      var mediaStreamTrack = stream.getTracks()[0];
      if (config.optimizationMode && "contentHint" in mediaStreamTrack) {
        mediaStreamTrack.contentHint = config.optimizationMode;
      }
      var track = createCustomTrack(mediaStreamTrack, config.tag);
      var qntrack = new QNCanvasVideoTrack(track, canvas, ctx, config.sources);
      return qntrack;
    }
    /**
     * 创建一个自定义的音频轨道
     */
  }, {
    key: "createCustomAudioTrack",
    value: function createCustomAudioTrack(config) {
      var track = createCustomTrack(config.mediaStreamTrack, config.tag, config.bitrate);
      var qntrack = new QNCustomAudioTrack(track);
      return qntrack;
    }
    /**
     * 创建一个自定义的视频轨道
     */
  }, {
    key: "createCustomVideoTrack",
    value: function createCustomVideoTrack(config) {
      if (config.optimizationMode && "contentHint" in config.mediaStreamTrack) {
        config.mediaStreamTrack.contentHint = config.optimizationMode;
      }
      var track = createCustomTrack(config.mediaStreamTrack, config.tag, config.bitrate);
      var qntrack = new QNCustomVideoTrack(track);
      return qntrack;
    }
    /**
     * 设置传输模式
     */
  }, {
    key: "setTransportPolicy",
    value: function setTransportPolicy(policy) {
      var _this113 = this;
      if (policy === QNTransportPolicy.FORCE_TCP) {
        this._config.transportPolicy = "forceTcp";
      }
      if (policy === QNTransportPolicy.FORCE_UDP) {
        this._config.transportPolicy = "forceUdp";
      }
      this._clients.forEach(function (client) {
        return client.setTransportPolicy(_this113._config.transportPolicy);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(config) {
      // overall config
      this._config = Object.assign(Object.assign({}, this._config), config);
      if (config.mcuServerHosts) {
        customServerHosts.splice.apply(customServerHosts, [0, customServerHosts.length].concat(_toConsumableArray(config.mcuServerHosts)));
      }
      // instance config
      this._clients.forEach(function (client) {
        client.config = Object.assign(Object.assign({}, client.config), config);
      });
      log.debug("setConfig", config);
    }
    /**
     * 检测音频轨道是否活跃。
     * 在一定时间内检测音频轨道声音是否有变化或者是否低于正常值。
     * 可以在开始通话前对音频输入设备进行可用性检测。
     * sdk 最低检测事件为200 ms，若传入值小于60，则 sdk 会自动调整为 200ms。
     */
  }, {
    key: "checkAudioTrackIsActive",
    value: function checkAudioTrackIsActive(track) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee163() {
        var _timer;
        return _regeneratorRuntime().wrap(function _callee163$(_context169) {
          while (1) switch (_context169.prev = _context169.next) {
            case 0:
              _timer = Math.min(200, timeout);
              return _context169.abrupt("return", new Promise(function (resolve, reject) {
                if (track.isAudio()) {
                  // 最低异常声音阀值
                  var minLevel = 0.01;
                  // 定时间隔
                  var interval = 200;
                  // 上一次检测音量值
                  var lastLevel = track.getVolumeLevel() || 0;
                  // 当前检测音量值
                  var curLevel = track.getVolumeLevel() || 0;
                  // 低音量异常
                  var lowVolume = curLevel <= minLevel;
                  // 音量无变化异常
                  var equalVolume = true;
                  // 被静音的话直接返回 false
                  if (track.isMuted()) {
                    resolve(false);
                  } else {
                    var timer = setInterval(function () {
                      // 中途被静音的话，直接返回 false
                      if (track.isMuted()) {
                        resolve(false);
                        clearInterval(timer);
                      } else {
                        lastLevel = curLevel;
                        curLevel = track.getVolumeLevel() || 0;
                        // 只要有一次音量大于阀值，则无低音量异常
                        curLevel > minLevel && (lowVolume = false);
                        // 只要有一次前后间隔音量不同，则无音量无变化异常
                        curLevel !== lastLevel && (equalVolume = false);
                      }
                    }, interval);
                    setTimeout(function () {
                      return setTimeout(function () {
                        timer && (clearInterval(timer), resolve(!lowVolume && !equalVolume));
                      }, 0);
                    }, _timer);
                  }
                } else {
                  reject(ERROR_FATAL("only support audio track"));
                }
              }));
            case 2:
            case "end":
              return _context169.stop();
          }
        }, _callee163);
      }));
    }
    /**
     * 检测视频轨道是否活跃。
     * 在一定时间内检测视频轨道画面是否有变化。
     * 可以在开始通话前对视频输入设备进行可用性检测。
     * 当视频轨被 muted 的时候返回 false。
     * sdk 最低检测事件为60 ms，若传入值小于60，则 sdk 会自动调整为 60ms。
     */
  }, {
    key: "checkVideoTrackIsActive",
    value: function checkVideoTrackIsActive(track) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee164() {
        return _regeneratorRuntime().wrap(function _callee164$(_context170) {
          while (1) switch (_context170.prev = _context170.next) {
            case 0:
              return _context170.abrupt("return", new Promise(function (resolve, reject) {
                if (track.isVideo()) {
                  var mediaStreamTrack = track.getMediaStreamTrack();
                  if (track.isMuted()) {
                    resolve(false);
                  }
                  if (mediaStreamTrack === undefined) {
                    reject(ERROR_FATAL("cannot find mediaStreamTrack"));
                  } else {
                    // 插入 video 标签并播放 track
                    var video = document.createElement("video");
                    video.style.width = "1px";
                    video.style.height = "1px";
                    video.setAttribute("muted", "");
                    video.muted = true;
                    video.setAttribute("playsinline", "");
                    video.controls = false;
                    video.style.opacity = "0.01";
                    video.style.position = "fixed";
                    video.style.left = "0";
                    video.style.top = "0";
                    document.body.appendChild(video);
                    video.srcObject = new MediaStream([mediaStreamTrack]);
                    video.play();
                    // 通过 canvas 绘制 video 获取对应的 imageData
                    var canvas = document.createElement("canvas");
                    canvas.width = 160;
                    canvas.height = 120;
                    var canvasCtx = canvas.getContext("2d");
                    if (canvasCtx) {
                      var active = false;
                      var data = null;
                      var timer = setInterval(function () {
                        if (track.isMuted()) {
                          timer && (clearInterval(timer), resolve(false));
                          video && video.remove();
                        }
                        canvasCtx.drawImage(video, 0, 0, 160, 120);
                        var imageData = canvasCtx.getImageData(0, 0, canvas.width, canvas.height);
                        // 随机取样图片数据，判断前后图片数据是否一致，只要有一次不一致即认为视频轨是活动的
                        var result = Math.floor(imageData.data.length / 3);
                        if (data) {
                          for (var _i15 = 0; _i15 < result; _i15 += 3) {
                            if (imageData.data[_i15] !== data[_i15]) {
                              active = true;
                              break;
                            }
                          }
                        } else {
                          data = imageData.data;
                        }
                      }, 30);
                      // 一定时间后停止采样，并返回结果
                      setTimeout(function () {
                        setTimeout(function () {
                          timer && (clearInterval(timer), resolve(active));
                          video && video.remove();
                        }, 0);
                      }, timeout);
                    } else {
                      reject(ERROR_FATAL("can not get canvas 2d context"));
                    }
                  }
                } else {
                  reject(ERROR_FATAL("only support video track"));
                }
              }));
            case 1:
            case "end":
              return _context170.stop();
          }
        }, _callee164);
      }));
    }
    /**
     * 在 Electron 环境下获取屏幕共享源
     */
  }, {
    key: "getElectronScreenSources",
    value: function getElectronScreenSources(type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee165() {
        return _regeneratorRuntime().wrap(function _callee165$(_context171) {
          while (1) switch (_context171.prev = _context171.next) {
            case 0:
              return _context171.abrupt("return", deviceManager.getElectronScreenSources(type));
            case 1:
            case "end":
              return _context171.stop();
          }
        }, _callee165);
      }));
    }
    /**
     * 创建录制模块
     */
  }, {
    key: "createMediaRecorder",
    value: function createMediaRecorder(source, config) {
      return new QNMediaRecorder(source, config);
    } /** 设置日志参数 */
  }, {
    key: "setLogConfig",
    value: function setLogConfig(config) {
      savedLog.setLogConfig(config);
      switch (config.level) {
        case QNLogLevel.VERBOSE:
          log.setSavedLevel("log");
          break;
        case QNLogLevel.INFO:
          log.setSavedLevel("debug");
          break;
        case QNLogLevel.WARNING:
        case QNLogLevel.ERROR:
          log.setSavedLevel("warning");
          break;
        case QNLogLevel.NONE:
          log.setSavedLevel("disable");
          break;
        default:
          log.setSavedLevel("log");
      }
      log.removeAllListeners();
      log.addListener("log", function (type, message) {
        savedLog.addLog(type, message);
      });
    }
  }, {
    key: "uploadLog",
    value: function uploadLog() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee166() {
        return _regeneratorRuntime().wrap(function _callee166$(_context172) {
          while (1) switch (_context172.prev = _context172.next) {
            case 0:
              return _context172.abrupt("return", savedLog.uploadLog());
            case 1:
            case "end":
              return _context172.stop();
          }
        }, _callee166);
      }));
    }
    /**
     * 创建设备管理类
     */
  }, {
    key: "createDeviceManger",
    value: function createDeviceManger() {
      if (!QNRTC.deviceManager) {
        QNRTC.deviceManager = new QNDeviceManager();
      }
      return QNRTC.deviceManager;
    }
  }, {
    key: "VERSION",
    /**
     * 获取 SDK 版本号
     */
    get: function get() {
      return version;
    }
  }]);
  return QNRTC;
}();
/** @internal */
QNRTC.audioMusicMixer = null;
/** @internal */
QNRTC.audioEffectMixer = null;
// @internal
QNRTC._clients = [];
// @internal
QNRTC._config = Object.assign({}, DEFAULT_CONFIG);
deviceManager.on("device-changed", function (deviceInfo) {
  switch (deviceInfo.device.kind) {
    case "audioinput":
      if (QNRTC.onMicrophoneChanged) QNRTC.onMicrophoneChanged(deviceInfo);
      break;
    case "audiooutput":
      if (QNRTC.onPlaybackDeviceChanged) QNRTC.onPlaybackDeviceChanged(deviceInfo);
      break;
    case "videoinput":
      if (QNRTC.onCameraChanged) QNRTC.onCameraChanged(deviceInfo);
      break;
  }
});
var QNRTC$1 = QNRTC;
var QNAudioFilter = function QNAudioFilter() {
  _classCallCheck(this, QNAudioFilter);
};
log.debug("SDK VERSION", QNRTC$1.VERSION);
log.debug("BROWSER VERSION", adapter.browserDetails);
export { AUDIO_ENCODER_CONFIG_SETTINGS, AudioSourceState, NetworkGrade, PermissionNameCode, PermissionStateCode, QNAudioEffect, QNAudioEffectMixer, QNAudioFilter, AudioMixingTrack as QNAudioMixingTrack, QNAudioMusicMixer, QNAudioSourceState, QNBufferSourceAudioTrack, QNCameraVideoTrack, QNCanvasVideoTrack, QNChromeExtensionSourceType, QNClientMode, QNClientRole, QNConnectionDisconnectedReason, QNConnectionState, QNCustomAudioTrack, QNCustomVideoTrack, QNDeviceState, QNElectronScreenSourceType, QNEventCategory, QNEventGrade, QNLiveStreamingState, QNLocalAudioTrack, QNLocalTrack, QNLocalVideoTrack, QNLogLevel, QNMediaRecorder, QNMediaRelayState, QNMicrophoneAudioTrack, QNNetworkQuality, QNRTCClient, QNRecorderState, QNRemoteAudioTrack, QNRemoteTrack, QNRemoteUser, QNRemoteVideoTrack, QNRenderMode, QNScreenVideoTrack, QNTrack, QNTrackProfile, QNTransportPolicy, QNVideoOptimizationMode, QosEventType, REC_AUDIO_ENABLE, REC_SCREEN_ENABLE, REC_VIDEO_ENABLE, SUPPORT_SCREEN_ENCODER_CONFIG_LIST, SUPPORT_VIDEO_ENCODER_CONFIG_LIST, TrackConnectStatus, TrackSourceType, QNRTC$1 as default, defaultAudioEncoderConfiguration, defaultMergeJob, defaultScreenEncoderConfiguration, defaultVideoEncoderConfiguration, isDefined };